/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EmailArticle
// ====================================================

export interface EmailArticle {
  emailRawArticle: boolean;
}

export interface EmailArticleVariables {
  rawArticle: string;
  recipients: string[];
  comment?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EmailSubject
// ====================================================

export interface EmailSubject {
  emailSubject: boolean;
}

export interface EmailSubjectVariables {
  subject: string;
  recipients: string[];
  comment?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ExportToCentshare
// ====================================================

export interface ExportToCentshare_exportToCentshare {
  __typename: "ExportToCenshareResultType";
  message: string;
}

export interface ExportToCentshare {
  /**
   * Photo photos to censhare
   */
  exportToCentshare: ExportToCentshare_exportToCentshare;
}

export interface ExportToCentshareVariables {
  assignment: string;
  issue: string;
  subject: string;
  brand: string;
  photos?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateAssignmentPageNumber
// ====================================================

export interface updateAssignmentPageNumber_updateAssignment {
  __typename: "UpdateAssignmentResult";
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface updateAssignmentPageNumber {
  /**
   * Update one "assignment".
   */
  updateAssignment: updateAssignmentPageNumber_updateAssignment | null;
}

export interface updateAssignmentPageNumberVariables {
  assignmentId: string;
  pageNumber: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAssignment
// ====================================================

export interface UpdateAssignment_updateAssignment_result {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
}

export interface UpdateAssignment_updateAssignment {
  __typename: "UpdateAssignmentResult";
  result: UpdateAssignment_updateAssignment_result | null;
}

export interface UpdateAssignment {
  /**
   * Update one "assignment".
   */
  updateAssignment: UpdateAssignment_updateAssignment | null;
}

export interface UpdateAssignmentVariables {
  where: AssignmentNodeSelectionInput;
  data: UpdateAssignmentDataInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAssignment
// ====================================================

export interface GetAssignment_assignment_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetAssignment_assignment_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetAssignment_assignment_subject_unit {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetAssignment_assignment_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  unit: GetAssignment_assignment_subject_unit;
}

export interface GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields_page_coordinates;
}

export interface GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields_paragraphStyles[];
  characterStyles: GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields_characterStyles[];
  coordinates: GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields_coordinates;
  page: GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields_page;
}

export interface GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_createdBy {
  __typename: "User";
  name: string;
}

export interface GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_updatedBy {
  __typename: "User";
  name: string;
}

export interface GetAssignment_assignment_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * associated S3 object id
   */
  S3ObjectId: string;
  /**
   * template label
   */
  label: string;
  /**
   * InDesign file name
   */
  filename: string;
  /**
   * template type
   */
  type: TemplateType | null;
  /**
   * InDesign file size
   */
  filesize: number;
  /**
   * Template page count
   */
  pageCount: number | null;
  /**
   * KAMI extension version
   */
  extVersion: string | null;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_fields | null)[];
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  /**
   * The user who created the PrintTemplate
   */
  createdBy: GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_createdBy | null;
  /**
   * The last user who updated the PrintTemplate
   */
  updatedBy: GetAssignment_assignment_printHeading_PrintTemplate_printTemplate_updatedBy | null;
}

export interface GetAssignment_assignment_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  printTemplate: GetAssignment_assignment_printHeading_PrintTemplate_printTemplate;
}

export interface GetAssignment_assignment_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetAssignment_assignment_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: GetAssignment_assignment_printHeading_printIssue_printPublication;
}

export interface GetAssignment_assignment_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: GetAssignment_assignment_printHeading_PrintTemplate[];
  printIssue: GetAssignment_assignment_printHeading_printIssue;
}

export interface GetAssignment_assignment {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printTemplate: GetAssignment_assignment_printTemplate | null;
  printPublication: GetAssignment_assignment_printPublication | null;
  subject: GetAssignment_assignment_subject;
  printHeading: GetAssignment_assignment_printHeading | null;
}

export interface GetAssignment {
  /**
   * Get one "assignment" by one of its unique fields.
   */
  assignment: GetAssignment_assignment | null;
}

export interface GetAssignmentVariables {
  assignmentId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrintHeadingByPrintIssue
// ====================================================

export interface GetPrintHeadingByPrintIssue_printIssue_printHeadings_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * template type
   */
  type: TemplateType | null;
}

export interface GetPrintHeadingByPrintIssue_printIssue_printHeadings_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  printTemplate: GetPrintHeadingByPrintIssue_printIssue_printHeadings_PrintTemplate_printTemplate;
}

export interface GetPrintHeadingByPrintIssue_printIssue_printHeadings {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: GetPrintHeadingByPrintIssue_printIssue_printHeadings_PrintTemplate[];
}

export interface GetPrintHeadingByPrintIssue_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintHeading.printIssue"'s inverse relation
   */
  printHeadings: GetPrintHeadingByPrintIssue_printIssue_printHeadings[];
}

export interface GetPrintHeadingByPrintIssue {
  /**
   * Get one "printissue" by one of its unique fields.
   */
  printIssue: GetPrintHeadingByPrintIssue_printIssue | null;
}

export interface GetPrintHeadingByPrintIssueVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrintIssuesByPrintPublication
// ====================================================

export interface GetPrintIssuesByPrintPublication_printPublication_printIssues {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetPrintIssuesByPrintPublication_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintIssue.printPublication"'s inverse relation
   */
  printIssues: GetPrintIssuesByPrintPublication_printPublication_printIssues[];
}

export interface GetPrintIssuesByPrintPublication {
  /**
   * Get one "printpublication" by one of its unique fields.
   */
  printPublication: GetPrintIssuesByPrintPublication_printPublication | null;
}

export interface GetPrintIssuesByPrintPublicationVariables {
  id: string;
  excludeIds?: (string | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrintPublicationByUnit
// ====================================================

export interface GetPrintPublicationByUnit_units_brands_printPublications {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetPrintPublicationByUnit_units_brands_websites {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
}

export interface GetPrintPublicationByUnit_units_brands {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintPublication.brand"'s inverse relation
   */
  printPublications: GetPrintPublicationByUnit_units_brands_printPublications[];
  /**
   * "Website.brand"'s inverse relation
   */
  websites: GetPrintPublicationByUnit_units_brands_websites[];
}

export interface GetPrintPublicationByUnit_units {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "Brand.unit"'s inverse relation
   */
  brands: GetPrintPublicationByUnit_units_brands[];
}

export interface GetPrintPublicationByUnit {
  /**
   * Find many "units"
   */
  units: GetPrintPublicationByUnit_units[];
}

export interface GetPrintPublicationByUnitVariables {
  unitId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrintHeadingById
// ====================================================

export interface GetPrintHeadingById_printHeading_assignments_articleTemplate {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetPrintHeadingById_printHeading_assignments_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetPrintHeadingById_printHeading_assignments_rawArticle_lastVersion {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  lead: string | null;
  body: string | null;
  signature: string | null;
  /**
   * An array of left over Draft content
   */
  leftOver: string | null;
  status: RawArticleStatus;
  textIsReadOnly: boolean;
}

export interface GetPrintHeadingById_printHeading_assignments_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  lastVersion: GetPrintHeadingById_printHeading_assignments_rawArticle_lastVersion | null;
}

export interface GetPrintHeadingById_printHeading_assignments {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  articleTemplate: GetPrintHeadingById_printHeading_assignments_articleTemplate | null;
  subject: GetPrintHeadingById_printHeading_assignments_subject;
  rawArticle: GetPrintHeadingById_printHeading_assignments_rawArticle | null;
}

export interface GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_fields_page_coordinates;
}

export interface GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  data: string;
  enabled: boolean | null;
  page: GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_fields_page;
}

export interface GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_assignments_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_assignments_rawArticle_lastVersion {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  status: RawArticleStatus;
  body: string | null;
}

export interface GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_assignments_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  lastVersion: GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_assignments_rawArticle_lastVersion | null;
}

export interface GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_assignments {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  subject: GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_assignments_subject;
  rawArticle: GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_assignments_rawArticle | null;
}

export interface GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * The article template label
   */
  label: string | null;
  /**
   * The raw datas
   */
  block: string | null;
  fields: (GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_fields | null)[];
  /**
   * "Assignment.articleTemplate"'s inverse relation
   */
  assignments: GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates_assignments[];
}

export interface GetPrintHeadingById_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * template label
   */
  label: string;
  /**
   * template type
   */
  type: TemplateType | null;
  /**
   * "ArticleTemplate.printTemplate"'s inverse relation
   */
  articleTemplates: GetPrintHeadingById_printHeading_PrintTemplate_printTemplate_articleTemplates[];
}

export interface GetPrintHeadingById_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  printTemplate: GetPrintHeadingById_printHeading_PrintTemplate_printTemplate;
}

export interface GetPrintHeadingById_printHeading {
  __typename: "PrintHeading";
  title: string;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * "Assignment.printHeading"'s inverse relation
   */
  assignments: GetPrintHeadingById_printHeading_assignments[];
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: GetPrintHeadingById_printHeading_PrintTemplate[];
}

export interface GetPrintHeadingById {
  /**
   * Get one "printheading" by one of its unique fields.
   */
  printHeading: GetPrintHeadingById_printHeading | null;
}

export interface GetPrintHeadingByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreatePrintTemplate
// ====================================================

export interface CreatePrintTemplate_createPrintTemplate_result_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface CreatePrintTemplate_createPrintTemplate_result_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface CreatePrintTemplate_createPrintTemplate_result_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface CreatePrintTemplate_createPrintTemplate_result_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface CreatePrintTemplate_createPrintTemplate_result_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: CreatePrintTemplate_createPrintTemplate_result_fields_page_coordinates;
}

export interface CreatePrintTemplate_createPrintTemplate_result_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: CreatePrintTemplate_createPrintTemplate_result_fields_paragraphStyles[];
  characterStyles: CreatePrintTemplate_createPrintTemplate_result_fields_characterStyles[];
  coordinates: CreatePrintTemplate_createPrintTemplate_result_fields_coordinates;
  page: CreatePrintTemplate_createPrintTemplate_result_fields_page;
}

export interface CreatePrintTemplate_createPrintTemplate_result_PrintHeading_printHeading_printIssue_printPublication_brand {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface CreatePrintTemplate_createPrintTemplate_result_PrintHeading_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  brand: CreatePrintTemplate_createPrintTemplate_result_PrintHeading_printHeading_printIssue_printPublication_brand;
}

export interface CreatePrintTemplate_createPrintTemplate_result_PrintHeading_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: CreatePrintTemplate_createPrintTemplate_result_PrintHeading_printHeading_printIssue_printPublication;
}

export interface CreatePrintTemplate_createPrintTemplate_result_PrintHeading_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printIssue: CreatePrintTemplate_createPrintTemplate_result_PrintHeading_printHeading_printIssue;
}

export interface CreatePrintTemplate_createPrintTemplate_result_PrintHeading {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  printHeading: CreatePrintTemplate_createPrintTemplate_result_PrintHeading_printHeading;
}

export interface CreatePrintTemplate_createPrintTemplate_result_createdBy {
  __typename: "User";
  name: string;
}

export interface CreatePrintTemplate_createPrintTemplate_result_updatedBy {
  __typename: "User";
  name: string;
}

export interface CreatePrintTemplate_createPrintTemplate_result {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * associated S3 object id
   */
  S3ObjectId: string;
  /**
   * template label
   */
  label: string;
  /**
   * InDesign file name
   */
  filename: string;
  /**
   * template type
   */
  type: TemplateType | null;
  /**
   * InDesign file size
   */
  filesize: number;
  /**
   * Template page count
   */
  pageCount: number | null;
  /**
   * KAMI extension version
   */
  extVersion: string | null;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (CreatePrintTemplate_createPrintTemplate_result_fields | null)[];
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  /**
   * "PrintHeadingPrintTemplate.printTemplate"'s inverse relation
   */
  PrintHeading: CreatePrintTemplate_createPrintTemplate_result_PrintHeading[];
  /**
   * The user who created the PrintTemplate
   */
  createdBy: CreatePrintTemplate_createPrintTemplate_result_createdBy | null;
  /**
   * The last user who updated the PrintTemplate
   */
  updatedBy: CreatePrintTemplate_createPrintTemplate_result_updatedBy | null;
}

export interface CreatePrintTemplate_createPrintTemplate {
  __typename: "CreatePrintTemplateResult";
  result: CreatePrintTemplate_createPrintTemplate_result | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface CreatePrintTemplate {
  /**
   * Create one "printtemplates".
   */
  createPrintTemplate: CreatePrintTemplate_createPrintTemplate | null;
}

export interface CreatePrintTemplateVariables {
  data: CreatePrintTemplateDataInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePrintTemplate
// ====================================================

export interface UpdatePrintTemplate_updatePrintTemplate_result_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: UpdatePrintTemplate_updatePrintTemplate_result_fields_page_coordinates;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: UpdatePrintTemplate_updatePrintTemplate_result_fields_paragraphStyles[];
  characterStyles: UpdatePrintTemplate_updatePrintTemplate_result_fields_characterStyles[];
  coordinates: UpdatePrintTemplate_updatePrintTemplate_result_fields_coordinates;
  page: UpdatePrintTemplate_updatePrintTemplate_result_fields_page;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_PrintHeading_printHeading_printIssue_printPublication_brand {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_PrintHeading_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  brand: UpdatePrintTemplate_updatePrintTemplate_result_PrintHeading_printHeading_printIssue_printPublication_brand;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_PrintHeading_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: UpdatePrintTemplate_updatePrintTemplate_result_PrintHeading_printHeading_printIssue_printPublication;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_PrintHeading_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printIssue: UpdatePrintTemplate_updatePrintTemplate_result_PrintHeading_printHeading_printIssue;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_PrintHeading {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  printHeading: UpdatePrintTemplate_updatePrintTemplate_result_PrintHeading_printHeading;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_createdBy {
  __typename: "User";
  name: string;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result_updatedBy {
  __typename: "User";
  name: string;
}

export interface UpdatePrintTemplate_updatePrintTemplate_result {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * associated S3 object id
   */
  S3ObjectId: string;
  /**
   * template label
   */
  label: string;
  /**
   * InDesign file name
   */
  filename: string;
  /**
   * template type
   */
  type: TemplateType | null;
  /**
   * InDesign file size
   */
  filesize: number;
  /**
   * Template page count
   */
  pageCount: number | null;
  /**
   * KAMI extension version
   */
  extVersion: string | null;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (UpdatePrintTemplate_updatePrintTemplate_result_fields | null)[];
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  /**
   * "PrintHeadingPrintTemplate.printTemplate"'s inverse relation
   */
  PrintHeading: UpdatePrintTemplate_updatePrintTemplate_result_PrintHeading[];
  /**
   * The user who created the PrintTemplate
   */
  createdBy: UpdatePrintTemplate_updatePrintTemplate_result_createdBy | null;
  /**
   * The last user who updated the PrintTemplate
   */
  updatedBy: UpdatePrintTemplate_updatePrintTemplate_result_updatedBy | null;
}

export interface UpdatePrintTemplate_updatePrintTemplate {
  __typename: "UpdatePrintTemplateResult";
  result: UpdatePrintTemplate_updatePrintTemplate_result | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface UpdatePrintTemplate {
  /**
   * Update one "printtemplate".
   */
  updatePrintTemplate: UpdatePrintTemplate_updatePrintTemplate | null;
}

export interface UpdatePrintTemplateVariables {
  data: UpdatePrintTemplateDataInput;
  where: PrintTemplateNodeSelectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DetachPrintTemplate
// ====================================================

export interface DetachPrintTemplate_deletePrintHeadingPrintTemplate {
  __typename: "DeletePrintHeadingPrintTemplateResult";
  result: boolean | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface DetachPrintTemplate {
  /**
   * Delete one "printheadingprinttemplate".
   */
  deletePrintHeadingPrintTemplate: DetachPrintTemplate_deletePrintHeadingPrintTemplate | null;
}

export interface DetachPrintTemplateVariables {
  id_eq?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePrintHeadingPrintTemplate
// ====================================================

export interface UpdatePrintHeadingPrintTemplate_updatePrintHeadingPrintTemplate_result {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
}

export interface UpdatePrintHeadingPrintTemplate_updatePrintHeadingPrintTemplate {
  __typename: "UpdatePrintHeadingPrintTemplateResult";
  result: UpdatePrintHeadingPrintTemplate_updatePrintHeadingPrintTemplate_result | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface UpdatePrintHeadingPrintTemplate {
  /**
   * Update one "printheadingprinttemplate".
   */
  updatePrintHeadingPrintTemplate: UpdatePrintHeadingPrintTemplate_updatePrintHeadingPrintTemplate | null;
}

export interface UpdatePrintHeadingPrintTemplateVariables {
  data: UpdatePrintHeadingPrintTemplateDataInput;
  where: PrintHeadingPrintTemplateNodeSelectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrintHeading
// ====================================================

export interface GetPrintHeading_printHeading_printIssue_printPublication_brand_unit {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetPrintHeading_printHeading_printIssue_printPublication_brand {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  unit: GetPrintHeading_printHeading_printIssue_printPublication_brand_unit;
}

export interface GetPrintHeading_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  brand: GetPrintHeading_printHeading_printIssue_printPublication_brand;
}

export interface GetPrintHeading_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: GetPrintHeading_printHeading_printIssue_printPublication;
}

export interface GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields_page_coordinates;
}

export interface GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields_paragraphStyles[];
  characterStyles: GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields_characterStyles[];
  coordinates: GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields_coordinates;
  page: GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields_page;
}

export interface GetPrintHeading_printHeading_PrintTemplate_printTemplate_createdBy {
  __typename: "User";
  name: string;
}

export interface GetPrintHeading_printHeading_PrintTemplate_printTemplate_updatedBy {
  __typename: "User";
  name: string;
}

export interface GetPrintHeading_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * associated S3 object id
   */
  S3ObjectId: string;
  /**
   * template label
   */
  label: string;
  /**
   * InDesign file name
   */
  filename: string;
  /**
   * template type
   */
  type: TemplateType | null;
  /**
   * InDesign file size
   */
  filesize: number;
  /**
   * Template page count
   */
  pageCount: number | null;
  /**
   * KAMI extension version
   */
  extVersion: string | null;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (GetPrintHeading_printHeading_PrintTemplate_printTemplate_fields | null)[];
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  /**
   * The user who created the PrintTemplate
   */
  createdBy: GetPrintHeading_printHeading_PrintTemplate_printTemplate_createdBy | null;
  /**
   * The last user who updated the PrintTemplate
   */
  updatedBy: GetPrintHeading_printHeading_PrintTemplate_printTemplate_updatedBy | null;
}

export interface GetPrintHeading_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  printTemplate: GetPrintHeading_printHeading_PrintTemplate_printTemplate;
}

export interface GetPrintHeading_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  order: number;
  legacyId: number | null;
  hasAutomaticSubject: boolean | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  printIssue: GetPrintHeading_printHeading_printIssue;
  PrintTemplateCount: number;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: GetPrintHeading_printHeading_PrintTemplate[];
}

export interface GetPrintHeading {
  /**
   * Get one "printheading" by one of its unique fields.
   */
  printHeading: GetPrintHeading_printHeading | null;
}

export interface GetPrintHeadingVariables {
  id_eq?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrintTemplateDownloadUrl
// ====================================================

export interface GetPrintTemplateDownloadUrl_printTemplateDownload {
  __typename: "PrintTemplateDownloadResultType";
  id: string;
  url: string;
}

export interface GetPrintTemplateDownloadUrl {
  /**
   * print Template download signed url
   */
  printTemplateDownload: GetPrintTemplateDownloadUrl_printTemplateDownload;
}

export interface GetPrintTemplateDownloadUrlVariables {
  printTemplateId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrintTemplateUploadUrl
// ====================================================

export interface GetPrintTemplateUploadUrl_printTemplateUpload {
  __typename: "PrintTemplateUploadResultType";
  id: string;
  url: string;
}

export interface GetPrintTemplateUploadUrl {
  /**
   * print Template upload signed url
   */
  printTemplateUpload: GetPrintTemplateUploadUrl_printTemplateUpload;
}

export interface GetPrintTemplateUploadUrlVariables {
  S3ObjectId: string;
  filename: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrintTemplatePreviewUrls
// ====================================================

export interface GetPrintTemplatePreviewUrls {
  /**
   * print Template preview signed urls
   */
  printTemplatePreviewUrls: string[];
}

export interface GetPrintTemplatePreviewUrlsVariables {
  printTemplateId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRawArticle
// ====================================================

export interface GetRawArticle_rawArticle_versions_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface GetRawArticle_rawArticle_versions {
  __typename: "RawArticleVersion";
  allowedStatuses: RawArticleStatus[];
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  lead: string | null;
  body: string | null;
  signature: string | null;
  /**
   * An array of left over Draft content
   */
  leftOver: string | null;
  status: RawArticleStatus;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: GetRawArticle_rawArticle_versions_editor | null;
  textIsReadOnly: boolean;
}

export interface GetRawArticle_rawArticle_versionList_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface GetRawArticle_rawArticle_versionList {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  status: RawArticleStatus;
  /**
   * The user assigned to the version
   */
  editorId: string;
  editor: GetRawArticle_rawArticle_versionList_editor | null;
}

export interface GetRawArticle_rawArticle_assignment_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetRawArticle_rawArticle_assignment_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetRawArticle_rawArticle_assignment_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: GetRawArticle_rawArticle_assignment_printIssue_printPublication;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_page_coordinates;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_paragraphStyles[];
  characterStyles: GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_characterStyles[];
  coordinates: GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_coordinates;
  page: GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_page;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_createdBy {
  __typename: "User";
  name: string;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_updatedBy {
  __typename: "User";
  name: string;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * associated S3 object id
   */
  S3ObjectId: string;
  /**
   * template label
   */
  label: string;
  /**
   * InDesign file name
   */
  filename: string;
  /**
   * template type
   */
  type: TemplateType | null;
  /**
   * InDesign file size
   */
  filesize: number;
  /**
   * Template page count
   */
  pageCount: number | null;
  /**
   * KAMI extension version
   */
  extVersion: string | null;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields | null)[];
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  /**
   * The user who created the PrintTemplate
   */
  createdBy: GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_createdBy | null;
  /**
   * The last user who updated the PrintTemplate
   */
  updatedBy: GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate_updatedBy | null;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  printTemplate: GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate_printTemplate;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetRawArticle_rawArticle_assignment_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: GetRawArticle_rawArticle_assignment_printHeading_printIssue_printPublication;
}

export interface GetRawArticle_rawArticle_assignment_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: GetRawArticle_rawArticle_assignment_printHeading_PrintTemplate[];
  printIssue: GetRawArticle_rawArticle_assignment_printHeading_printIssue;
}

export interface GetRawArticle_rawArticle_assignment_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
}

export interface GetRawArticle_rawArticle_assignment_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  height: number | null;
  width: number | null;
  rotation: number | null;
}

export interface GetRawArticle_rawArticle_assignment_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  coordinates: GetRawArticle_rawArticle_assignment_printTemplate_fields_page_coordinates;
}

export interface GetRawArticle_rawArticle_assignment_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetRawArticle_rawArticle_assignment_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetRawArticle_rawArticle_assignment_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  page: GetRawArticle_rawArticle_assignment_printTemplate_fields_page;
  data: string;
  typeVariation: string;
  paragraphStyles: GetRawArticle_rawArticle_assignment_printTemplate_fields_paragraphStyles[];
  characterStyles: GetRawArticle_rawArticle_assignment_printTemplate_fields_characterStyles[];
}

export interface GetRawArticle_rawArticle_assignment_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * template label
   */
  label: string;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (GetRawArticle_rawArticle_assignment_printTemplate_fields | null)[];
}

export interface GetRawArticle_rawArticle_assignment_subject_unit {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetRawArticle_rawArticle_assignment_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  synopsis: string | null;
  unit: GetRawArticle_rawArticle_assignment_subject_unit;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: GetRawArticle_rawArticle_assignment_articleTemplate_fields_page_coordinates;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: GetRawArticle_rawArticle_assignment_articleTemplate_fields_paragraphStyles[];
  characterStyles: GetRawArticle_rawArticle_assignment_articleTemplate_fields_characterStyles[];
  coordinates: GetRawArticle_rawArticle_assignment_articleTemplate_fields_coordinates;
  page: GetRawArticle_rawArticle_assignment_articleTemplate_fields_page;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  height: number | null;
  width: number | null;
  rotation: number | null;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  coordinates: GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate_fields_page_coordinates;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  page: GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate_fields_page;
  data: string;
  typeVariation: string;
  paragraphStyles: GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate_fields_paragraphStyles[];
  characterStyles: GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate_fields_characterStyles[];
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * template type
   */
  type: TemplateType | null;
  fields: (GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate_fields | null)[];
}

export interface GetRawArticle_rawArticle_assignment_articleTemplate {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * The article template label
   */
  label: string | null;
  /**
   * The raw datas
   */
  block: string | null;
  fields: (GetRawArticle_rawArticle_assignment_articleTemplate_fields | null)[];
  printTemplate: GetRawArticle_rawArticle_assignment_articleTemplate_printTemplate | null;
}

export interface GetRawArticle_rawArticle_assignment {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printPublication: GetRawArticle_rawArticle_assignment_printPublication | null;
  printIssue: GetRawArticle_rawArticle_assignment_printIssue | null;
  printHeading: GetRawArticle_rawArticle_assignment_printHeading | null;
  website: GetRawArticle_rawArticle_assignment_website | null;
  printTemplate: GetRawArticle_rawArticle_assignment_printTemplate | null;
  subject: GetRawArticle_rawArticle_assignment_subject;
  articleTemplate: GetRawArticle_rawArticle_assignment_articleTemplate | null;
}

export interface GetRawArticle_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: GetRawArticle_rawArticle_versions[];
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versionList: GetRawArticle_rawArticle_versionList[];
  /**
   * "Assignment.rawArticle"'s inverse relation
   */
  assignment: GetRawArticle_rawArticle_assignment | null;
}

export interface GetRawArticle {
  /**
   * Get one "rawarticle" by one of its unique fields.
   */
  rawArticle: GetRawArticle_rawArticle | null;
}

export interface GetRawArticleVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUnits
// ====================================================

export interface GetUnits_units {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetUnits {
  /**
   * Find many "units"
   */
  units: GetUnits_units[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getDownloadUrlAttachment
// ====================================================

export interface getDownloadUrlAttachment_attachment {
  __typename: "Attachment";
  downloadUrl: string | null;
}

export interface getDownloadUrlAttachment {
  /**
   * Get one "attachment" by one of its unique fields.
   */
  attachment: getDownloadUrlAttachment_attachment | null;
}

export interface getDownloadUrlAttachmentVariables {
  id?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSubjectForMediaStatusDialog
// ====================================================

export interface GetSubjectForMediaStatusDialog_subject_assignments_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_articleTemplate {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_rawArticle_versions_editor {
  __typename: "User";
  id: string;
  name: string;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_rawArticle_versions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  status: RawArticleStatus;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: GetSubjectForMediaStatusDialog_subject_assignments_rawArticle_versions_editor | null;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: GetSubjectForMediaStatusDialog_subject_assignments_rawArticle_versions[];
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * template type
   */
  type: TemplateType | null;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  printTemplate: GetSubjectForMediaStatusDialog_subject_assignments_printHeading_PrintTemplate_printTemplate;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: GetSubjectForMediaStatusDialog_subject_assignments_printHeading_printIssue_printPublication;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: GetSubjectForMediaStatusDialog_subject_assignments_printHeading_PrintTemplate[];
  printIssue: GetSubjectForMediaStatusDialog_subject_assignments_printHeading_printIssue;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: GetSubjectForMediaStatusDialog_subject_assignments_printIssue_printPublication;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetSubjectForMediaStatusDialog_subject_assignments {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printTemplate: GetSubjectForMediaStatusDialog_subject_assignments_printTemplate | null;
  articleTemplate: GetSubjectForMediaStatusDialog_subject_assignments_articleTemplate | null;
  mediaSearchStatus: MediaSearchStatus;
  rawArticle: GetSubjectForMediaStatusDialog_subject_assignments_rawArticle | null;
  printHeading: GetSubjectForMediaStatusDialog_subject_assignments_printHeading | null;
  printIssue: GetSubjectForMediaStatusDialog_subject_assignments_printIssue | null;
  printPublication: GetSubjectForMediaStatusDialog_subject_assignments_printPublication | null;
  website: GetSubjectForMediaStatusDialog_subject_assignments_website | null;
  subject: GetSubjectForMediaStatusDialog_subject_assignments_subject;
}

export interface GetSubjectForMediaStatusDialog_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "Assignment.subject"'s inverse relation
   */
  assignments: GetSubjectForMediaStatusDialog_subject_assignments[];
}

export interface GetSubjectForMediaStatusDialog {
  /**
   * Get one "subject" by one of its unique fields.
   */
  subject: GetSubjectForMediaStatusDialog_subject | null;
}

export interface GetSubjectForMediaStatusDialogVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAssignmentMediaSearchStatus
// ====================================================

export interface UpdateAssignmentMediaSearchStatus_updateAssignment_result {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  mediaSearchStatus: MediaSearchStatus;
}

export interface UpdateAssignmentMediaSearchStatus_updateAssignment {
  __typename: "UpdateAssignmentResult";
  result: UpdateAssignmentMediaSearchStatus_updateAssignment_result | null;
}

export interface UpdateAssignmentMediaSearchStatus {
  /**
   * Update one "assignment".
   */
  updateAssignment: UpdateAssignmentMediaSearchStatus_updateAssignment | null;
}

export interface UpdateAssignmentMediaSearchStatusVariables {
  assignmentId: string;
  status: MediaSearchStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteSubjectUser
// ====================================================

export interface DeleteSubjectUser_deleteSubjectUser {
  __typename: "DeleteSubjectUserResult";
  result: boolean | null;
}

export interface DeleteSubjectUser {
  /**
   * Delete one "subjectuser".
   */
  deleteSubjectUser: DeleteSubjectUser_deleteSubjectUser | null;
}

export interface DeleteSubjectUserVariables {
  userId: string;
  subjectId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSubjectUsers
// ====================================================

export interface GetSubjectUsers_subject_subjectUsers_user {
  __typename: "User";
  email: string;
  name: string;
  avatarUrl: string | null;
}

export interface GetSubjectUsers_subject_subjectUsers {
  __typename: "SubjectUser";
  /**
   * The user who has access to the subject
   */
  userId: string;
  user: GetSubjectUsers_subject_subjectUsers_user | null;
}

export interface GetSubjectUsers_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "SubjectUser.subject"'s inverse relation
   */
  subjectUsers: GetSubjectUsers_subject_subjectUsers[];
}

export interface GetSubjectUsers {
  /**
   * Get one "subject" by one of its unique fields.
   */
  subject: GetSubjectUsers_subject | null;
}

export interface GetSubjectUsersVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ShareSubject
// ====================================================

export interface ShareSubject_shareSubject {
  __typename: "UpdateSubjectResult";
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface ShareSubject {
  shareSubject: ShareSubject_shareSubject | null;
}

export interface ShareSubjectVariables {
  subject: string;
  userIds: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UnitSpeedDial_GetUnits
// ====================================================

export interface UnitSpeedDial_GetUnits_units {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface UnitSpeedDial_GetUnits {
  /**
   * Find many "units"
   */
  units: UnitSpeedDial_GetUnits_units[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteSubject
// ====================================================

export interface DeleteSubject_deleteSubject {
  __typename: "DeleteSubjectResult";
  result: boolean | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface DeleteSubject {
  /**
   * Delete one "subject".
   */
  deleteSubject: DeleteSubject_deleteSubject | null;
}

export interface DeleteSubjectVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrintTemplateDraft
// ====================================================

export interface GetPrintTemplateDraft_printTemplateDrafts_artifacts {
  __typename: "PrintTemplateDraftArtifactType";
  page: number;
  url: string;
}

export interface GetPrintTemplateDraft_printTemplateDrafts {
  __typename: "PrintTemplateDraftsResultType";
  draftId: string;
  artifacts: GetPrintTemplateDraft_printTemplateDrafts_artifacts[];
}

export interface GetPrintTemplateDraft {
  /**
   * generate print Template drafts
   */
  printTemplateDrafts: GetPrintTemplateDraft_printTemplateDrafts;
}

export interface GetPrintTemplateDraftVariables {
  printHeadingId: string;
  printTemplateId?: string | null;
  format: PrintTemplateDraftFormatType;
  pages?: number[] | null;
  fieldsData?: (PrintTemplateDraftFieldsDataType | null)[] | null;
  embedRessources?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAssignmentByRawArticleId
// ====================================================

export interface GetAssignmentByRawArticleId_assignment_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetAssignmentByRawArticleId_assignment_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetAssignmentByRawArticleId_assignment_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: GetAssignmentByRawArticleId_assignment_printIssue_printPublication;
}

export interface GetAssignmentByRawArticleId_assignment_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetAssignmentByRawArticleId_assignment_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: GetAssignmentByRawArticleId_assignment_printHeading_printIssue_printPublication;
}

export interface GetAssignmentByRawArticleId_assignment_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printIssue: GetAssignmentByRawArticleId_assignment_printHeading_printIssue;
}

export interface GetAssignmentByRawArticleId_assignment {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printPublication: GetAssignmentByRawArticleId_assignment_printPublication | null;
  printIssue: GetAssignmentByRawArticleId_assignment_printIssue | null;
  printHeading: GetAssignmentByRawArticleId_assignment_printHeading | null;
}

export interface GetAssignmentByRawArticleId {
  /**
   * Get one "assignment" by one of its unique fields.
   */
  assignment: GetAssignmentByRawArticleId_assignment | null;
}

export interface GetAssignmentByRawArticleIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAssignmentByArticle
// ====================================================

export interface UpdateAssignmentByArticle_updateAssignment {
  __typename: "UpdateAssignmentResult";
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface UpdateAssignmentByArticle {
  /**
   * Update one "assignment".
   */
  updateAssignment: UpdateAssignmentByArticle_updateAssignment | null;
}

export interface UpdateAssignmentByArticleVariables {
  id: string;
  data: UpdateAssignmentDataInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpsertRawArticle
// ====================================================

export interface UpsertRawArticle_upsertRawArticle_result_versions_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface UpsertRawArticle_upsertRawArticle_result_versions {
  __typename: "RawArticleVersion";
  allowedStatuses: RawArticleStatus[];
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  lead: string | null;
  body: string | null;
  signature: string | null;
  /**
   * An array of left over Draft content
   */
  leftOver: string | null;
  status: RawArticleStatus;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: UpsertRawArticle_upsertRawArticle_result_versions_editor | null;
  textIsReadOnly: boolean;
}

export interface UpsertRawArticle_upsertRawArticle_result_versionList_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface UpsertRawArticle_upsertRawArticle_result_versionList {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  status: RawArticleStatus;
  /**
   * The user assigned to the version
   */
  editorId: string;
  editor: UpsertRawArticle_upsertRawArticle_result_versionList_editor | null;
}

export interface UpsertRawArticle_upsertRawArticle_result {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: UpsertRawArticle_upsertRawArticle_result_versions[];
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versionList: UpsertRawArticle_upsertRawArticle_result_versionList[];
}

export interface UpsertRawArticle_upsertRawArticle {
  __typename: "UpsertRawArticleResult";
  result: UpsertRawArticle_upsertRawArticle_result | null;
}

export interface UpsertRawArticle {
  /**
   * Create or update one "rawarticles".
   */
  upsertRawArticle: UpsertRawArticle_upsertRawArticle | null;
}

export interface UpsertRawArticleVariables {
  create: CreateRawArticleDataInput;
  update: UpdateRawArticleDataInput;
  where: RawArticleNodeSelectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateRawArticleVersionEditorTransfer
// ====================================================

export interface CreateRawArticleVersionEditorTransfer_createRawArticleVersion_result_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface CreateRawArticleVersionEditorTransfer_createRawArticleVersion_result {
  __typename: "RawArticleVersion";
  allowedStatuses: RawArticleStatus[];
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  lead: string | null;
  body: string | null;
  signature: string | null;
  /**
   * An array of left over Draft content
   */
  leftOver: string | null;
  status: RawArticleStatus;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: CreateRawArticleVersionEditorTransfer_createRawArticleVersion_result_editor | null;
  textIsReadOnly: boolean;
  /**
   * The user assigned to the version
   */
  editorId: string;
}

export interface CreateRawArticleVersionEditorTransfer_createRawArticleVersion {
  __typename: "CreateRawArticleVersionResult";
  result: CreateRawArticleVersionEditorTransfer_createRawArticleVersion_result | null;
}

export interface CreateRawArticleVersionEditorTransfer {
  /**
   * Create one "rawarticleversions".
   */
  createRawArticleVersion: CreateRawArticleVersionEditorTransfer_createRawArticleVersion | null;
}

export interface CreateRawArticleVersionEditorTransferVariables {
  data: CreateRawArticleVersionDataInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserBySearch
// ====================================================

export interface GetUserBySearch_rawArticleVersion_allowedTransfers {
  __typename: "User";
  id: string;
  name: string;
}

export interface GetUserBySearch_rawArticleVersion {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * Returns a list of users for whom the transfer is possible
   */
  allowedTransfers: GetUserBySearch_rawArticleVersion_allowedTransfers[];
}

export interface GetUserBySearch {
  /**
   * Get one "rawarticleversion" by one of its unique fields.
   */
  rawArticleVersion: GetUserBySearch_rawArticleVersion | null;
}

export interface GetUserBySearchVariables {
  id: string;
  search: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRawArticleVersionArticleHistory
// ====================================================

export interface GetRawArticleVersionArticleHistory_rawArticleVersion_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface GetRawArticleVersionArticleHistory_rawArticleVersion_rawArticle_lastVersion {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetRawArticleVersionArticleHistory_rawArticleVersion_rawArticle_assignment_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
}

export interface GetRawArticleVersionArticleHistory_rawArticleVersion_rawArticle_assignment_printTemplate {
  __typename: "PrintTemplate";
  fields: (GetRawArticleVersionArticleHistory_rawArticleVersion_rawArticle_assignment_printTemplate_fields | null)[];
}

export interface GetRawArticleVersionArticleHistory_rawArticleVersion_rawArticle_assignment {
  __typename: "Assignment";
  printTemplate: GetRawArticleVersionArticleHistory_rawArticleVersion_rawArticle_assignment_printTemplate | null;
}

export interface GetRawArticleVersionArticleHistory_rawArticleVersion_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  lastVersion: GetRawArticleVersionArticleHistory_rawArticleVersion_rawArticle_lastVersion | null;
  /**
   * "Assignment.rawArticle"'s inverse relation
   */
  assignment: GetRawArticleVersionArticleHistory_rawArticleVersion_rawArticle_assignment | null;
}

export interface GetRawArticleVersionArticleHistory_rawArticleVersion {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  lead: string | null;
  body: string | null;
  signature: string | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  status: RawArticleStatus;
  editor: GetRawArticleVersionArticleHistory_rawArticleVersion_editor | null;
  rawArticle: GetRawArticleVersionArticleHistory_rawArticleVersion_rawArticle;
}

export interface GetRawArticleVersionArticleHistory {
  /**
   * Get one "rawarticleversion" by one of its unique fields.
   */
  rawArticleVersion: GetRawArticleVersionArticleHistory_rawArticleVersion | null;
}

export interface GetRawArticleVersionArticleHistoryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRawArticleMajorVersions
// ====================================================

export interface GetRawArticleMajorVersions_rawArticle_majorVersions_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface GetRawArticleMajorVersions_rawArticle_majorVersions_previousMinorVersions_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface GetRawArticleMajorVersions_rawArticle_majorVersions_previousMinorVersions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  editor: GetRawArticleMajorVersions_rawArticle_majorVersions_previousMinorVersions_editor | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
}

export interface GetRawArticleMajorVersions_rawArticle_majorVersions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  status: RawArticleStatus;
  title: string | null;
  lead: string | null;
  body: string | null;
  signature: string | null;
  /**
   * An array of left over Draft content
   */
  leftOver: string | null;
  /**
   * The user assigned to the version
   */
  editorId: string;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: GetRawArticleMajorVersions_rawArticle_majorVersions_editor | null;
  previousMinorVersions: GetRawArticleMajorVersions_rawArticle_majorVersions_previousMinorVersions[];
}

export interface GetRawArticleMajorVersions_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  majorVersions: GetRawArticleMajorVersions_rawArticle_majorVersions[];
}

export interface GetRawArticleMajorVersions {
  /**
   * Get one "rawarticle" by one of its unique fields.
   */
  rawArticle: GetRawArticleMajorVersions_rawArticle | null;
}

export interface GetRawArticleMajorVersionsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePrintHeading
// ====================================================

export interface UpdatePrintHeading_updatePrintHeading_result_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface UpdatePrintHeading_updatePrintHeading_result_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  printTemplate: UpdatePrintHeading_updatePrintHeading_result_PrintTemplate_printTemplate;
}

export interface UpdatePrintHeading_updatePrintHeading_result {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  order: number;
  hasAutomaticSubject: boolean | null;
  autoPrototype: boolean | null;
  PrintTemplateCount: number;
  assignmentCount: number;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: UpdatePrintHeading_updatePrintHeading_result_PrintTemplate[];
}

export interface UpdatePrintHeading_updatePrintHeading {
  __typename: "UpdatePrintHeadingResult";
  result: UpdatePrintHeading_updatePrintHeading_result | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface UpdatePrintHeading {
  /**
   * Update one "printheading".
   */
  updatePrintHeading: UpdatePrintHeading_updatePrintHeading | null;
}

export interface UpdatePrintHeadingVariables {
  data: UpdatePrintHeadingDataInput;
  where: PrintHeadingNodeSelectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LocationPage_GetSubjectsFromPrintHeading
// ====================================================

export interface LocationPage_GetSubjectsFromPrintHeading_subjects_subjectCategory_parent {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface LocationPage_GetSubjectsFromPrintHeading_subjects_subjectCategory {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  parent: LocationPage_GetSubjectsFromPrintHeading_subjects_subjectCategory_parent | null;
}

export interface LocationPage_GetSubjectsFromPrintHeading_subjects_flatAssignment_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface LocationPage_GetSubjectsFromPrintHeading_subjects_flatAssignment {
  __typename: "FlatAssignment";
  printHeading: LocationPage_GetSubjectsFromPrintHeading_subjects_flatAssignment_printHeading | null;
}

export interface LocationPage_GetSubjectsFromPrintHeading_subjects {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  isAuto: boolean | null;
  subjectCategory: LocationPage_GetSubjectsFromPrintHeading_subjects_subjectCategory | null;
  /**
   * "FlatAssignment.subject"'s inverse relation
   */
  flatAssignment: LocationPage_GetSubjectsFromPrintHeading_subjects_flatAssignment[];
}

export interface LocationPage_GetSubjectsFromPrintHeading {
  /**
   * Find many "subjects"
   */
  subjects: LocationPage_GetSubjectsFromPrintHeading_subjects[];
}

export interface LocationPage_GetSubjectsFromPrintHeadingVariables {
  where?: SubjectsWhereInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LocationPage_DeletePrintHeading
// ====================================================

export interface LocationPage_DeletePrintHeading_deletePrintHeading {
  __typename: "DeletePrintHeadingResult";
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface LocationPage_DeletePrintHeading {
  /**
   * Delete one "printheading".
   */
  deletePrintHeading: LocationPage_DeletePrintHeading_deletePrintHeading | null;
}

export interface LocationPage_DeletePrintHeadingVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LocationPage_GetPrintHeadingDeleteInformation
// ====================================================

export interface LocationPage_GetPrintHeadingDeleteInformation_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  title: string;
}

export interface LocationPage_GetPrintHeadingDeleteInformation_printHeading_printIssue {
  __typename: "PrintIssue";
  title: string;
  printPublication: LocationPage_GetPrintHeadingDeleteInformation_printHeading_printIssue_printPublication;
}

export interface LocationPage_GetPrintHeadingDeleteInformation_printHeading_assignments_subject {
  __typename: "Subject";
  title: string;
}

export interface LocationPage_GetPrintHeadingDeleteInformation_printHeading_assignments {
  __typename: "Assignment";
  subject: LocationPage_GetPrintHeadingDeleteInformation_printHeading_assignments_subject;
}

export interface LocationPage_GetPrintHeadingDeleteInformation_printHeading {
  __typename: "PrintHeading";
  title: string;
  printIssue: LocationPage_GetPrintHeadingDeleteInformation_printHeading_printIssue;
  /**
   * "Assignment.printHeading"'s inverse relation
   */
  assignments: LocationPage_GetPrintHeadingDeleteInformation_printHeading_assignments[];
}

export interface LocationPage_GetPrintHeadingDeleteInformation {
  /**
   * Get one "printheading" by one of its unique fields.
   */
  printHeading: LocationPage_GetPrintHeadingDeleteInformation_printHeading | null;
}

export interface LocationPage_GetPrintHeadingDeleteInformationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LocationPage_GetPrintHeadingByPrintIssue
// ====================================================

export interface LocationPage_GetPrintHeadingByPrintIssue_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  key: string;
}

export interface LocationPage_GetPrintHeadingByPrintIssue_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: LocationPage_GetPrintHeadingByPrintIssue_printIssue_printPublication;
}

export interface LocationPage_GetPrintHeadingByPrintIssue_printHeadings_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface LocationPage_GetPrintHeadingByPrintIssue_printHeadings_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  printTemplate: LocationPage_GetPrintHeadingByPrintIssue_printHeadings_PrintTemplate_printTemplate;
}

export interface LocationPage_GetPrintHeadingByPrintIssue_printHeadings {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  order: number;
  hasAutomaticSubject: boolean | null;
  autoPrototype: boolean | null;
  PrintTemplateCount: number;
  assignmentCount: number;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: LocationPage_GetPrintHeadingByPrintIssue_printHeadings_PrintTemplate[];
}

export interface LocationPage_GetPrintHeadingByPrintIssue {
  /**
   * Get one "printissue" by one of its unique fields.
   */
  printIssue: LocationPage_GetPrintHeadingByPrintIssue_printIssue | null;
  /**
   * Find many "printheadings"
   */
  printHeadings: LocationPage_GetPrintHeadingByPrintIssue_printHeadings[];
}

export interface LocationPage_GetPrintHeadingByPrintIssueVariables {
  printIssueId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LocationPage_UpsertPrintHeading
// ====================================================

export interface LocationPage_UpsertPrintHeading_upsertPrintHeading_result_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface LocationPage_UpsertPrintHeading_upsertPrintHeading_result_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  printTemplate: LocationPage_UpsertPrintHeading_upsertPrintHeading_result_PrintTemplate_printTemplate;
}

export interface LocationPage_UpsertPrintHeading_upsertPrintHeading_result {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  order: number;
  hasAutomaticSubject: boolean | null;
  autoPrototype: boolean | null;
  PrintTemplateCount: number;
  assignmentCount: number;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: LocationPage_UpsertPrintHeading_upsertPrintHeading_result_PrintTemplate[];
}

export interface LocationPage_UpsertPrintHeading_upsertPrintHeading {
  __typename: "UpsertPrintHeadingResult";
  result: LocationPage_UpsertPrintHeading_upsertPrintHeading_result | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface LocationPage_UpsertPrintHeading {
  /**
   * Create or update one "printheadings".
   */
  upsertPrintHeading: LocationPage_UpsertPrintHeading_upsertPrintHeading | null;
}

export interface LocationPage_UpsertPrintHeadingVariables {
  create: CreatePrintHeadingDataInput;
  update: UpdatePrintHeadingDataInput;
  where: PrintHeadingNodeSelectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LocationPage_DeletePrintIssue
// ====================================================

export interface LocationPage_DeletePrintIssue_deletePrintIssue {
  __typename: "DeletePrintIssueResult";
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface LocationPage_DeletePrintIssue {
  /**
   * Delete one "printissue".
   */
  deletePrintIssue: LocationPage_DeletePrintIssue_deletePrintIssue | null;
}

export interface LocationPage_DeletePrintIssueVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LocationPage_GetDeletePrintIssueInformation
// ====================================================

export interface LocationPage_GetDeletePrintIssueInformation_printIssue_printHeadings {
  __typename: "PrintHeading";
  title: string;
  assignmentCount: number;
}

export interface LocationPage_GetDeletePrintIssueInformation_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface LocationPage_GetDeletePrintIssueInformation_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  assignmentCount: number;
  title: string;
  /**
   * "PrintHeading.printIssue"'s inverse relation
   */
  printHeadings: LocationPage_GetDeletePrintIssueInformation_printIssue_printHeadings[];
  printPublication: LocationPage_GetDeletePrintIssueInformation_printIssue_printPublication;
}

export interface LocationPage_GetDeletePrintIssueInformation {
  /**
   * Get one "printissue" by one of its unique fields.
   */
  printIssue: LocationPage_GetDeletePrintIssueInformation_printIssue | null;
}

export interface LocationPage_GetDeletePrintIssueInformationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LocationPage_GetPrintIssuesByPrintPublication
// ====================================================

export interface LocationPage_GetPrintIssuesByPrintPublication_printIssues {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface LocationPage_GetPrintIssuesByPrintPublication_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface LocationPage_GetPrintIssuesByPrintPublication {
  /**
   * Find many "printissues"
   */
  printIssues: LocationPage_GetPrintIssuesByPrintPublication_printIssues[];
  /**
   * Get one "printpublication" by one of its unique fields.
   */
  printPublication: LocationPage_GetPrintIssuesByPrintPublication_printPublication | null;
}

export interface LocationPage_GetPrintIssuesByPrintPublicationVariables {
  printPublicationId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LocationPage_GetPrintPublicationKey
// ====================================================

export interface LocationPage_GetPrintPublicationKey_printPublication {
  __typename: "PrintPublication";
  key: string;
}

export interface LocationPage_GetPrintPublicationKey {
  /**
   * Get one "printpublication" by one of its unique fields.
   */
  printPublication: LocationPage_GetPrintPublicationKey_printPublication | null;
}

export interface LocationPage_GetPrintPublicationKeyVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LocationPage_UpsertPrintIssue
// ====================================================

export interface LocationPage_UpsertPrintIssue_upsertPrintIssue_result_printHeadings {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  order: number;
  hasAutomaticSubject: boolean | null;
}

export interface LocationPage_UpsertPrintIssue_upsertPrintIssue_result {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintHeading.printIssue"'s inverse relation
   */
  printHeadings: LocationPage_UpsertPrintIssue_upsertPrintIssue_result_printHeadings[];
}

export interface LocationPage_UpsertPrintIssue_upsertPrintIssue {
  __typename: "UpsertPrintIssueResult";
  result: LocationPage_UpsertPrintIssue_upsertPrintIssue_result | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface LocationPage_UpsertPrintIssue {
  /**
   * Create or update one "printissues".
   */
  upsertPrintIssue: LocationPage_UpsertPrintIssue_upsertPrintIssue | null;
}

export interface LocationPage_UpsertPrintIssueVariables {
  create: CreatePrintIssueDataInput;
  update: UpdatePrintIssueDataInput;
  where: PrintIssueNodeSelectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LocationPage_GetPrintPublicationsByUnit
// ====================================================

export interface LocationPage_GetPrintPublicationsByUnit_unit_brands_printPublications_brand {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
}

export interface LocationPage_GetPrintPublicationsByUnit_unit_brands_printPublications {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
  brand: LocationPage_GetPrintPublicationsByUnit_unit_brands_printPublications_brand;
}

export interface LocationPage_GetPrintPublicationsByUnit_unit_brands {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintPublication.brand"'s inverse relation
   */
  printPublications: LocationPage_GetPrintPublicationsByUnit_unit_brands_printPublications[];
}

export interface LocationPage_GetPrintPublicationsByUnit_unit {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "Brand.unit"'s inverse relation
   */
  brands: LocationPage_GetPrintPublicationsByUnit_unit_brands[];
}

export interface LocationPage_GetPrintPublicationsByUnit {
  /**
   * Get one "unit" by one of its unique fields.
   */
  unit: LocationPage_GetPrintPublicationsByUnit_unit | null;
}

export interface LocationPage_GetPrintPublicationsByUnitVariables {
  unitId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LocationPage_UpsertPrintPublication
// ====================================================

export interface LocationPage_UpsertPrintPublication_upsertPrintPublication_result_brand {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
}

export interface LocationPage_UpsertPrintPublication_upsertPrintPublication_result {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
  brand: LocationPage_UpsertPrintPublication_upsertPrintPublication_result_brand;
}

export interface LocationPage_UpsertPrintPublication_upsertPrintPublication {
  __typename: "UpsertPrintPublicationResult";
  result: LocationPage_UpsertPrintPublication_upsertPrintPublication_result | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface LocationPage_UpsertPrintPublication {
  /**
   * Create or update one "printpublications".
   */
  upsertPrintPublication: LocationPage_UpsertPrintPublication_upsertPrintPublication | null;
}

export interface LocationPage_UpsertPrintPublicationVariables {
  create: CreatePrintPublicationDataInput;
  update: UpdatePrintPublicationDataInput;
  where: PrintPublicationNodeSelectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LocationPage_UpdatePrintHeadingOrder
// ====================================================

export interface LocationPage_UpdatePrintHeadingOrder_updatePrintIssue_result_printHeadings {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  order: number;
  hasAutomaticSubject: boolean | null;
}

export interface LocationPage_UpdatePrintHeadingOrder_updatePrintIssue_result {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintHeading.printIssue"'s inverse relation
   */
  printHeadings: LocationPage_UpdatePrintHeadingOrder_updatePrintIssue_result_printHeadings[];
}

export interface LocationPage_UpdatePrintHeadingOrder_updatePrintIssue {
  __typename: "UpdatePrintIssueResult";
  result: LocationPage_UpdatePrintHeadingOrder_updatePrintIssue_result | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface LocationPage_UpdatePrintHeadingOrder {
  /**
   * Update one "printissue".
   */
  updatePrintIssue: LocationPage_UpdatePrintHeadingOrder_updatePrintIssue | null;
}

export interface LocationPage_UpdatePrintHeadingOrderVariables {
  id: string;
  data: UpdatePrintIssueDataInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SubjectForm_DeleteAssignment
// ====================================================

export interface SubjectForm_DeleteAssignment_deleteAssignment {
  __typename: "DeleteAssignmentResult";
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
  result: boolean | null;
}

export interface SubjectForm_DeleteAssignment {
  /**
   * Delete one "assignment".
   */
  deleteAssignment: SubjectForm_DeleteAssignment_deleteAssignment | null;
}

export interface SubjectForm_DeleteAssignmentVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateAttachment
// ====================================================

export interface CreateAttachment_createAttachment_result {
  __typename: "Attachment";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * get presigned url from S3
   */
  uploadUrl: string | null;
}

export interface CreateAttachment_createAttachment {
  __typename: "CreateAttachmentResult";
  result: CreateAttachment_createAttachment_result | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface CreateAttachment {
  /**
   * Create one "attachments".
   */
  createAttachment: CreateAttachment_createAttachment | null;
}

export interface CreateAttachmentVariables {
  data: CreateAttachmentDataInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteAttachment
// ====================================================

export interface DeleteAttachment_deleteAttachment {
  __typename: "DeleteAttachmentResult";
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface DeleteAttachment {
  /**
   * Delete one "attachment".
   */
  deleteAttachment: DeleteAttachment_deleteAttachment | null;
}

export interface DeleteAttachmentVariables {
  id?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAttachment
// ====================================================

export interface UpdateAttachment_updateAttachment_result_createdBy {
  __typename: "User";
  name: string;
}

export interface UpdateAttachment_updateAttachment_result {
  __typename: "Attachment";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * send from the front
   */
  filename: string | null;
  /**
   * update from S3
   */
  filesize: number | null;
  /**
   * update from S3
   */
  contentType: string | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The user who created the Attachment
   */
  createdBy: UpdateAttachment_updateAttachment_result_createdBy | null;
}

export interface UpdateAttachment_updateAttachment {
  __typename: "UpdateAttachmentResult";
  result: UpdateAttachment_updateAttachment_result | null;
  /**
   * Either the mutation have succeed or failed.
   */
  status: MutationResultStatus;
}

export interface UpdateAttachment {
  /**
   * Update one "attachment".
   */
  updateAttachment: UpdateAttachment_updateAttachment | null;
}

export interface UpdateAttachmentVariables {
  data: UpdateAttachmentDataInput;
  where: AttachmentNodeSelectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateRawArticle
// ====================================================

export interface CreateRawArticle_createRawArticle_result {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
}

export interface CreateRawArticle_createRawArticle {
  __typename: "CreateRawArticleResult";
  result: CreateRawArticle_createRawArticle_result | null;
}

export interface CreateRawArticle {
  /**
   * Create one "rawarticles".
   */
  createRawArticle: CreateRawArticle_createRawArticle | null;
}

export interface CreateRawArticleVariables {
  data: CreateRawArticleDataInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpsertSubject
// ====================================================

export interface UpsertSubject_upsertSubject_result {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  comment: string | null;
  synopsis: string | null;
  mediaRequest: string | null;
}

export interface UpsertSubject_upsertSubject {
  __typename: "UpsertSubjectResult";
  result: UpsertSubject_upsertSubject_result | null;
}

export interface UpsertSubject {
  /**
   * Create or update one "subjects".
   */
  upsertSubject: UpsertSubject_upsertSubject | null;
}

export interface UpsertSubjectVariables {
  create: CreateSubjectDataInput;
  update: UpdateSubjectDataInput;
  where: SubjectNodeSelectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSubject
// ====================================================

export interface GetSubject_subject_createdBy {
  __typename: "User";
  name: string;
}

export interface GetSubject_subject_unit {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  photoArchiveId: number | null;
}

export interface GetSubject_subject_subjectCategory_parent {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetSubject_subject_subjectCategory {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  parent: GetSubject_subject_subjectCategory_parent | null;
}

export interface GetSubject_subject_assignments_assignment_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetSubject_subject_assignments_assignment_articleTemplate {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetSubject_subject_assignments_assignment {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printTemplate: GetSubject_subject_assignments_assignment_printTemplate | null;
  articleTemplate: GetSubject_subject_assignments_assignment_articleTemplate | null;
  mediaSearchStatus: MediaSearchStatus;
  pageNumber: number | null;
}

export interface GetSubject_subject_assignments_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  key: string;
  title: string;
}

export interface GetSubject_subject_assignments_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetSubject_subject_assignments_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * template type
   */
  type: TemplateType | null;
}

export interface GetSubject_subject_assignments_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  printTemplate: GetSubject_subject_assignments_printHeading_PrintTemplate_printTemplate;
}

export interface GetSubject_subject_assignments_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: GetSubject_subject_assignments_printHeading_PrintTemplate[];
}

export interface GetSubject_subject_assignments_rawArticle_versions_editor {
  __typename: "User";
  id: string;
  name: string;
}

export interface GetSubject_subject_assignments_rawArticle_versions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  status: RawArticleStatus;
  title: string | null;
  editor: GetSubject_subject_assignments_rawArticle_versions_editor | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
}

export interface GetSubject_subject_assignments_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: GetSubject_subject_assignments_rawArticle_versions[];
}

export interface GetSubject_subject_assignments_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  key: string;
  title: string;
}

export interface GetSubject_subject_assignments {
  __typename: "FlatAssignment";
  assignment: GetSubject_subject_assignments_assignment | null;
  printPublication: GetSubject_subject_assignments_printPublication | null;
  printIssue: GetSubject_subject_assignments_printIssue | null;
  printHeading: GetSubject_subject_assignments_printHeading | null;
  rawArticle: GetSubject_subject_assignments_rawArticle | null;
  website: GetSubject_subject_assignments_website | null;
}

export interface GetSubject_subject_subjectUsers_user {
  __typename: "User";
  email: string;
  name: string;
  avatarUrl: string | null;
}

export interface GetSubject_subject_subjectUsers {
  __typename: "SubjectUser";
  /**
   * The user who has access to the subject
   */
  userId: string;
  user: GetSubject_subject_subjectUsers_user | null;
}

export interface GetSubject_subject_attachments_createdBy {
  __typename: "User";
  name: string;
}

export interface GetSubject_subject_attachments {
  __typename: "Attachment";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * send from the front
   */
  filename: string | null;
  /**
   * update from S3
   */
  filesize: number | null;
  /**
   * update from S3
   */
  contentType: string | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The user who created the Attachment
   */
  createdBy: GetSubject_subject_attachments_createdBy | null;
}

export interface GetSubject_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  synopsis: string | null;
  comment: string | null;
  mediaRequest: string | null;
  /**
   * The user who created the Subject
   */
  createdBy: GetSubject_subject_createdBy | null;
  unit: GetSubject_subject_unit;
  subjectCategory: GetSubject_subject_subjectCategory | null;
  /**
   * "FlatAssignment.subject"'s inverse relation
   */
  assignments: GetSubject_subject_assignments[];
  photosCount: number | null;
  isClassified: boolean | null;
  /**
   * "SubjectUser.subject"'s inverse relation
   */
  subjectUsers: GetSubject_subject_subjectUsers[];
  /**
   * "Attachment.subject"'s inverse relation
   */
  attachments: GetSubject_subject_attachments[];
  /**
   * Indicate if title is writable if none of article version has had "Mockup" status
   */
  isTitleWritable: boolean;
}

export interface GetSubject {
  /**
   * Get one "subject" by one of its unique fields.
   */
  subject: GetSubject_subject | null;
}

export interface GetSubjectVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrintSubject
// ====================================================

export interface GetPrintSubject_subject_subjectCategory_parent {
  __typename: "SubjectCategory";
  title: string;
}

export interface GetPrintSubject_subject_subjectCategory {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  parent: GetPrintSubject_subject_subjectCategory_parent | null;
}

export interface GetPrintSubject_subject_assignments_assignment {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  mediaSearchStatus: MediaSearchStatus;
}

export interface GetPrintSubject_subject_assignments_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetPrintSubject_subject_assignments_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetPrintSubject_subject_assignments_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetPrintSubject_subject_assignments_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  key: string;
  title: string;
}

export interface GetPrintSubject_subject_assignments {
  __typename: "FlatAssignment";
  assignment: GetPrintSubject_subject_assignments_assignment | null;
  printPublication: GetPrintSubject_subject_assignments_printPublication | null;
  printIssue: GetPrintSubject_subject_assignments_printIssue | null;
  printHeading: GetPrintSubject_subject_assignments_printHeading | null;
  website: GetPrintSubject_subject_assignments_website | null;
}

export interface GetPrintSubject_subject {
  __typename: "Subject";
  title: string;
  synopsis: string | null;
  comment: string | null;
  mediaRequest: string | null;
  subjectCategory: GetPrintSubject_subject_subjectCategory | null;
  /**
   * "FlatAssignment.subject"'s inverse relation
   */
  assignments: GetPrintSubject_subject_assignments[];
}

export interface GetPrintSubject {
  /**
   * Get one "subject" by one of its unique fields.
   */
  subject: GetPrintSubject_subject | null;
}

export interface GetPrintSubjectVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSubjectCategory
// ====================================================

export interface GetSubjectCategory_subjectCategories_parent {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetSubjectCategory_subjectCategories_children {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetSubjectCategory_subjectCategories {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  parent: GetSubjectCategory_subjectCategories_parent | null;
  /**
   * "SubjectCategory.parent"'s inverse relation
   */
  children: GetSubjectCategory_subjectCategories_children[];
}

export interface GetSubjectCategory {
  /**
   * Find many "subjectcategories"
   */
  subjectCategories: GetSubjectCategory_subjectCategories[];
}

export interface GetSubjectCategoryVariables {
  unitId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SubjectListPage_GetCategoryTree
// ====================================================

export interface SubjectListPage_GetCategoryTree_subjectCategories_children {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface SubjectListPage_GetCategoryTree_subjectCategories {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "SubjectCategory.parent"'s inverse relation
   */
  children: SubjectListPage_GetCategoryTree_subjectCategories_children[];
}

export interface SubjectListPage_GetCategoryTree {
  /**
   * Find many "subjectcategories"
   */
  subjectCategories: SubjectListPage_GetCategoryTree_subjectCategories[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SubjectListPage_GetFilteredCategoryTree
// ====================================================

export interface SubjectListPage_GetFilteredCategoryTree_subjectCategories_children {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface SubjectListPage_GetFilteredCategoryTree_subjectCategories {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "SubjectCategory.parent"'s inverse relation
   */
  children: SubjectListPage_GetFilteredCategoryTree_subjectCategories_children[];
}

export interface SubjectListPage_GetFilteredCategoryTree {
  /**
   * Find many "subjectcategories"
   */
  subjectCategories: SubjectListPage_GetFilteredCategoryTree_subjectCategories[];
}

export interface SubjectListPage_GetFilteredCategoryTreeVariables {
  where: SubjectCategories1WhereInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SubjectListPage_GetFilteredLocationTree
// ====================================================

export interface SubjectListPage_GetFilteredLocationTree_brands_printPublications_printIssues {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface SubjectListPage_GetFilteredLocationTree_brands_printPublications {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintIssue.printPublication"'s inverse relation
   */
  printIssues: SubjectListPage_GetFilteredLocationTree_brands_printPublications_printIssues[];
}

export interface SubjectListPage_GetFilteredLocationTree_brands_websites {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
}

export interface SubjectListPage_GetFilteredLocationTree_brands {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintPublication.brand"'s inverse relation
   */
  printPublications: SubjectListPage_GetFilteredLocationTree_brands_printPublications[];
  /**
   * "Website.brand"'s inverse relation
   */
  websites: SubjectListPage_GetFilteredLocationTree_brands_websites[];
}

export interface SubjectListPage_GetFilteredLocationTree {
  /**
   * Find many "brands"
   */
  brands: SubjectListPage_GetFilteredLocationTree_brands[];
}

export interface SubjectListPage_GetFilteredLocationTreeVariables {
  searchString: string;
  where: Brands1WhereInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SubjectListPage_GetLocationTree
// ====================================================

export interface SubjectListPage_GetLocationTree_brands_printPublications_printIssues {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface SubjectListPage_GetLocationTree_brands_printPublications {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintIssue.printPublication"'s inverse relation
   */
  printIssues: SubjectListPage_GetLocationTree_brands_printPublications_printIssues[];
}

export interface SubjectListPage_GetLocationTree_brands_websites {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
}

export interface SubjectListPage_GetLocationTree_brands {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintPublication.brand"'s inverse relation
   */
  printPublications: SubjectListPage_GetLocationTree_brands_printPublications[];
  /**
   * "Website.brand"'s inverse relation
   */
  websites: SubjectListPage_GetLocationTree_brands_websites[];
}

export interface SubjectListPage_GetLocationTree {
  /**
   * Find many "brands"
   */
  brands: SubjectListPage_GetLocationTree_brands[];
}

export interface SubjectListPage_GetLocationTreeVariables {
  where: BrandsWhereInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSubjects
// ====================================================

export interface GetSubjects_subjects_assignments_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetSubjects_subjects_assignments_articleTemplate {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetSubjects_subjects_assignments_rawArticle_versions_editor {
  __typename: "User";
  id: string;
  name: string;
}

export interface GetSubjects_subjects_assignments_rawArticle_versions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  status: RawArticleStatus;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: GetSubjects_subjects_assignments_rawArticle_versions_editor | null;
}

export interface GetSubjects_subjects_assignments_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: GetSubjects_subjects_assignments_rawArticle_versions[];
}

export interface GetSubjects_subjects_assignments_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * template type
   */
  type: TemplateType | null;
}

export interface GetSubjects_subjects_assignments_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  printTemplate: GetSubjects_subjects_assignments_printHeading_PrintTemplate_printTemplate;
}

export interface GetSubjects_subjects_assignments_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetSubjects_subjects_assignments_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: GetSubjects_subjects_assignments_printHeading_printIssue_printPublication;
}

export interface GetSubjects_subjects_assignments_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: GetSubjects_subjects_assignments_printHeading_PrintTemplate[];
  printIssue: GetSubjects_subjects_assignments_printHeading_printIssue;
}

export interface GetSubjects_subjects_assignments_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetSubjects_subjects_assignments_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: GetSubjects_subjects_assignments_printIssue_printPublication;
}

export interface GetSubjects_subjects_assignments_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetSubjects_subjects_assignments_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
}

export interface GetSubjects_subjects_assignments_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetSubjects_subjects_assignments {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printTemplate: GetSubjects_subjects_assignments_printTemplate | null;
  articleTemplate: GetSubjects_subjects_assignments_articleTemplate | null;
  mediaSearchStatus: MediaSearchStatus;
  rawArticle: GetSubjects_subjects_assignments_rawArticle | null;
  printHeading: GetSubjects_subjects_assignments_printHeading | null;
  printIssue: GetSubjects_subjects_assignments_printIssue | null;
  printPublication: GetSubjects_subjects_assignments_printPublication | null;
  website: GetSubjects_subjects_assignments_website | null;
  subject: GetSubjects_subjects_assignments_subject;
}

export interface GetSubjects_subjects_subjectCategory_parent {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetSubjects_subjects_subjectCategory {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  parent: GetSubjects_subjects_subjectCategory_parent | null;
}

export interface GetSubjects_subjects_unit_brands {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetSubjects_subjects_unit {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  photoArchiveId: number | null;
  /**
   * "Brand.unit"'s inverse relation
   */
  brands: GetSubjects_subjects_unit_brands[];
}

export interface GetSubjects_subjects {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  comment: string | null;
  /**
   * "Assignment.subject"'s inverse relation
   */
  assignments: GetSubjects_subjects_assignments[];
  assignmentCount: number;
  subjectCategory: GetSubjects_subjects_subjectCategory | null;
  unit: GetSubjects_subjects_unit;
  isClassified: boolean | null;
}

export interface GetSubjects {
  /**
   * Find many "subjects"
   */
  subjects: GetSubjects_subjects[];
}

export interface GetSubjectsVariables {
  where: SubjectsWhereInput;
  offset: number;
  assignments_some: Assignments1WhereInput;
  limit?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUnfilteredSubjectListByIssue
// ====================================================

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * template type
   */
  type: TemplateType | null;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  printTemplate: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_PrintTemplate_printTemplate;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_subjectCategory_parent {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_subjectCategory {
  __typename: "SubjectCategory";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  parent: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_subjectCategory_parent | null;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_assignment_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_assignment_articleTemplate {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_assignment {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printTemplate: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_assignment_printTemplate | null;
  articleTemplate: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_assignment_articleTemplate | null;
  mediaSearchStatus: MediaSearchStatus;
  pageNumber: number | null;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  key: string;
  title: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * template type
   */
  type: TemplateType | null;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  printTemplate: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_printHeading_PrintTemplate_printTemplate;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_printHeading_PrintTemplate[];
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_rawArticle_versions_editor {
  __typename: "User";
  id: string;
  name: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_rawArticle_versions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  status: RawArticleStatus;
  title: string | null;
  editor: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_rawArticle_versions_editor | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_rawArticle_versions[];
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  key: string;
  title: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments {
  __typename: "FlatAssignment";
  assignment: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_assignment | null;
  printPublication: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_printPublication | null;
  printIssue: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_printIssue | null;
  printHeading: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_printHeading | null;
  rawArticle: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_rawArticle | null;
  website: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments_website | null;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  comment: string | null;
  subjectCategory: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_subjectCategory | null;
  isClassified: boolean | null;
  /**
   * "FlatAssignment.subject"'s inverse relation
   */
  assignments: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject_assignments[];
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_rawArticle_versions_editor {
  __typename: "User";
  id: string;
  name: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_rawArticle_versions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  status: RawArticleStatus;
  title: string | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_rawArticle_versions_editor | null;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_rawArticle_versions[];
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_articleTemplate {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printTemplate: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_printTemplate | null;
  mediaSearchStatus: MediaSearchStatus;
  pageNumber: number | null;
  subject: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_subject;
  website: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_website | null;
  rawArticle: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_rawArticle | null;
  articleTemplate: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments_articleTemplate | null;
}

export interface GetUnfilteredSubjectListByIssue_printIssue_printHeadings {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_PrintTemplate[];
  /**
   * "Assignment.printHeading"'s inverse relation
   */
  assignments: GetUnfilteredSubjectListByIssue_printIssue_printHeadings_assignments[];
}

export interface GetUnfilteredSubjectListByIssue_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintHeading.printIssue"'s inverse relation
   */
  printHeadings: GetUnfilteredSubjectListByIssue_printIssue_printHeadings[];
}

export interface GetUnfilteredSubjectListByIssue {
  /**
   * Get one "printissue" by one of its unique fields.
   */
  printIssue: GetUnfilteredSubjectListByIssue_printIssue | null;
}

export interface GetUnfilteredSubjectListByIssueVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SubjectListPage_GetPrintPublicationsByUnit
// ====================================================

export interface SubjectListPage_GetPrintPublicationsByUnit_units_brands_printPublications {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface SubjectListPage_GetPrintPublicationsByUnit_units_brands {
  __typename: "Brand";
  title: string;
  /**
   * "PrintPublication.brand"'s inverse relation
   */
  printPublications: SubjectListPage_GetPrintPublicationsByUnit_units_brands_printPublications[];
}

export interface SubjectListPage_GetPrintPublicationsByUnit_units {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "Brand.unit"'s inverse relation
   */
  brands: SubjectListPage_GetPrintPublicationsByUnit_units_brands[];
}

export interface SubjectListPage_GetPrintPublicationsByUnit {
  /**
   * Find many "units"
   */
  units: SubjectListPage_GetPrintPublicationsByUnit_units[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: printTemplate
// ====================================================

export interface printTemplate_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface printTemplate_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface printTemplate_printTemplate_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface printTemplate_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface printTemplate_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: printTemplate_printTemplate_fields_page_coordinates;
}

export interface printTemplate_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: printTemplate_printTemplate_fields_paragraphStyles[];
  characterStyles: printTemplate_printTemplate_fields_characterStyles[];
  coordinates: printTemplate_printTemplate_fields_coordinates;
  page: printTemplate_printTemplate_fields_page;
}

export interface printTemplate_printTemplate_createdBy {
  __typename: "User";
  name: string;
}

export interface printTemplate_printTemplate_updatedBy {
  __typename: "User";
  name: string;
}

export interface printTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * associated S3 object id
   */
  S3ObjectId: string;
  /**
   * template label
   */
  label: string;
  /**
   * InDesign file name
   */
  filename: string;
  /**
   * template type
   */
  type: TemplateType | null;
  /**
   * InDesign file size
   */
  filesize: number;
  /**
   * Template page count
   */
  pageCount: number | null;
  /**
   * KAMI extension version
   */
  extVersion: string | null;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (printTemplate_printTemplate_fields | null)[];
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  /**
   * The user who created the PrintTemplate
   */
  createdBy: printTemplate_printTemplate_createdBy | null;
  /**
   * The last user who updated the PrintTemplate
   */
  updatedBy: printTemplate_printTemplate_updatedBy | null;
}

export interface printTemplate {
  __typename: "PrintHeadingPrintTemplate";
  printTemplate: printTemplate_printTemplate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PrintTemplate
// ====================================================

export interface PrintTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface PrintTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface PrintTemplate_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface PrintTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface PrintTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: PrintTemplate_fields_page_coordinates;
}

export interface PrintTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: PrintTemplate_fields_paragraphStyles[];
  characterStyles: PrintTemplate_fields_characterStyles[];
  coordinates: PrintTemplate_fields_coordinates;
  page: PrintTemplate_fields_page;
}

export interface PrintTemplate_PrintHeading_printHeading_printIssue_printPublication_brand {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface PrintTemplate_PrintHeading_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  brand: PrintTemplate_PrintHeading_printHeading_printIssue_printPublication_brand;
}

export interface PrintTemplate_PrintHeading_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: PrintTemplate_PrintHeading_printHeading_printIssue_printPublication;
}

export interface PrintTemplate_PrintHeading_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printIssue: PrintTemplate_PrintHeading_printHeading_printIssue;
}

export interface PrintTemplate_PrintHeading {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  printHeading: PrintTemplate_PrintHeading_printHeading;
}

export interface PrintTemplate_createdBy {
  __typename: "User";
  name: string;
}

export interface PrintTemplate_updatedBy {
  __typename: "User";
  name: string;
}

export interface PrintTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * associated S3 object id
   */
  S3ObjectId: string;
  /**
   * template label
   */
  label: string;
  /**
   * InDesign file name
   */
  filename: string;
  /**
   * template type
   */
  type: TemplateType | null;
  /**
   * InDesign file size
   */
  filesize: number;
  /**
   * Template page count
   */
  pageCount: number | null;
  /**
   * KAMI extension version
   */
  extVersion: string | null;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (PrintTemplate_fields | null)[];
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  /**
   * "PrintHeadingPrintTemplate.printTemplate"'s inverse relation
   */
  PrintHeading: PrintTemplate_PrintHeading[];
  /**
   * The user who created the PrintTemplate
   */
  createdBy: PrintTemplate_createdBy | null;
  /**
   * The last user who updated the PrintTemplate
   */
  updatedBy: PrintTemplate_updatedBy | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PrintTemplateAssignment
// ====================================================

export interface PrintTemplateAssignment_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  height: number | null;
  width: number | null;
  rotation: number | null;
}

export interface PrintTemplateAssignment_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  coordinates: PrintTemplateAssignment_printTemplate_fields_page_coordinates;
}

export interface PrintTemplateAssignment_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface PrintTemplateAssignment_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface PrintTemplateAssignment_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  page: PrintTemplateAssignment_printTemplate_fields_page;
  data: string;
  typeVariation: string;
  paragraphStyles: PrintTemplateAssignment_printTemplate_fields_paragraphStyles[];
  characterStyles: PrintTemplateAssignment_printTemplate_fields_characterStyles[];
}

export interface PrintTemplateAssignment_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * template label
   */
  label: string;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (PrintTemplateAssignment_printTemplate_fields | null)[];
}

export interface PrintTemplateAssignment {
  __typename: "Assignment";
  printTemplate: PrintTemplateAssignment_printTemplate | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ArticleForm_Assignment
// ====================================================

export interface ArticleForm_Assignment_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface ArticleForm_Assignment_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface ArticleForm_Assignment_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: ArticleForm_Assignment_printIssue_printPublication;
}

export interface ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields_page_coordinates;
}

export interface ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields_paragraphStyles[];
  characterStyles: ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields_characterStyles[];
  coordinates: ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields_coordinates;
  page: ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields_page;
}

export interface ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_createdBy {
  __typename: "User";
  name: string;
}

export interface ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_updatedBy {
  __typename: "User";
  name: string;
}

export interface ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * associated S3 object id
   */
  S3ObjectId: string;
  /**
   * template label
   */
  label: string;
  /**
   * InDesign file name
   */
  filename: string;
  /**
   * template type
   */
  type: TemplateType | null;
  /**
   * InDesign file size
   */
  filesize: number;
  /**
   * Template page count
   */
  pageCount: number | null;
  /**
   * KAMI extension version
   */
  extVersion: string | null;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_fields | null)[];
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  /**
   * The user who created the PrintTemplate
   */
  createdBy: ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_createdBy | null;
  /**
   * The last user who updated the PrintTemplate
   */
  updatedBy: ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate_updatedBy | null;
}

export interface ArticleForm_Assignment_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  printTemplate: ArticleForm_Assignment_printHeading_PrintTemplate_printTemplate;
}

export interface ArticleForm_Assignment_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface ArticleForm_Assignment_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: ArticleForm_Assignment_printHeading_printIssue_printPublication;
}

export interface ArticleForm_Assignment_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: ArticleForm_Assignment_printHeading_PrintTemplate[];
  printIssue: ArticleForm_Assignment_printHeading_printIssue;
}

export interface ArticleForm_Assignment_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
}

export interface ArticleForm_Assignment {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printPublication: ArticleForm_Assignment_printPublication | null;
  printIssue: ArticleForm_Assignment_printIssue | null;
  printHeading: ArticleForm_Assignment_printHeading | null;
  website: ArticleForm_Assignment_website | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ArticleForm_RawArticle
// ====================================================

export interface ArticleForm_RawArticle_versions_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface ArticleForm_RawArticle_versions {
  __typename: "RawArticleVersion";
  allowedStatuses: RawArticleStatus[];
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  lead: string | null;
  body: string | null;
  signature: string | null;
  /**
   * An array of left over Draft content
   */
  leftOver: string | null;
  status: RawArticleStatus;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: ArticleForm_RawArticle_versions_editor | null;
  textIsReadOnly: boolean;
}

export interface ArticleForm_RawArticle_versionList_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface ArticleForm_RawArticle_versionList {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  status: RawArticleStatus;
  /**
   * The user assigned to the version
   */
  editorId: string;
  editor: ArticleForm_RawArticle_versionList_editor | null;
}

export interface ArticleForm_RawArticle_assignment_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface ArticleForm_RawArticle_assignment_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface ArticleForm_RawArticle_assignment_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: ArticleForm_RawArticle_assignment_printIssue_printPublication;
}

export interface ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_page_coordinates;
}

export interface ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_paragraphStyles[];
  characterStyles: ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_characterStyles[];
  coordinates: ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_coordinates;
  page: ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields_page;
}

export interface ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_createdBy {
  __typename: "User";
  name: string;
}

export interface ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_updatedBy {
  __typename: "User";
  name: string;
}

export interface ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * associated S3 object id
   */
  S3ObjectId: string;
  /**
   * template label
   */
  label: string;
  /**
   * InDesign file name
   */
  filename: string;
  /**
   * template type
   */
  type: TemplateType | null;
  /**
   * InDesign file size
   */
  filesize: number;
  /**
   * Template page count
   */
  pageCount: number | null;
  /**
   * KAMI extension version
   */
  extVersion: string | null;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_fields | null)[];
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  /**
   * The user who created the PrintTemplate
   */
  createdBy: ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_createdBy | null;
  /**
   * The last user who updated the PrintTemplate
   */
  updatedBy: ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate_updatedBy | null;
}

export interface ArticleForm_RawArticle_assignment_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  printTemplate: ArticleForm_RawArticle_assignment_printHeading_PrintTemplate_printTemplate;
}

export interface ArticleForm_RawArticle_assignment_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface ArticleForm_RawArticle_assignment_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: ArticleForm_RawArticle_assignment_printHeading_printIssue_printPublication;
}

export interface ArticleForm_RawArticle_assignment_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: ArticleForm_RawArticle_assignment_printHeading_PrintTemplate[];
  printIssue: ArticleForm_RawArticle_assignment_printHeading_printIssue;
}

export interface ArticleForm_RawArticle_assignment_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
}

export interface ArticleForm_RawArticle_assignment_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  height: number | null;
  width: number | null;
  rotation: number | null;
}

export interface ArticleForm_RawArticle_assignment_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  coordinates: ArticleForm_RawArticle_assignment_printTemplate_fields_page_coordinates;
}

export interface ArticleForm_RawArticle_assignment_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface ArticleForm_RawArticle_assignment_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface ArticleForm_RawArticle_assignment_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  page: ArticleForm_RawArticle_assignment_printTemplate_fields_page;
  data: string;
  typeVariation: string;
  paragraphStyles: ArticleForm_RawArticle_assignment_printTemplate_fields_paragraphStyles[];
  characterStyles: ArticleForm_RawArticle_assignment_printTemplate_fields_characterStyles[];
}

export interface ArticleForm_RawArticle_assignment_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * template label
   */
  label: string;
  /**
   * KAMI extension data
   */
  data: string | null;
  fields: (ArticleForm_RawArticle_assignment_printTemplate_fields | null)[];
}

export interface ArticleForm_RawArticle_assignment_subject_unit {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface ArticleForm_RawArticle_assignment_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  synopsis: string | null;
  unit: ArticleForm_RawArticle_assignment_subject_unit;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_fields_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  width: number | null;
  height: number | null;
  rotation: number | null;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  number: string;
  coordinates: ArticleForm_RawArticle_assignment_articleTemplate_fields_page_coordinates;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  enabled: boolean | null;
  data: string;
  typeVariation: string;
  paragraphStyles: ArticleForm_RawArticle_assignment_articleTemplate_fields_paragraphStyles[];
  characterStyles: ArticleForm_RawArticle_assignment_articleTemplate_fields_characterStyles[];
  coordinates: ArticleForm_RawArticle_assignment_articleTemplate_fields_coordinates;
  page: ArticleForm_RawArticle_assignment_articleTemplate_fields_page;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_printTemplate_fields_page_coordinates {
  __typename: "PrintTemplateObjectCoords";
  x: number | null;
  y: number | null;
  height: number | null;
  width: number | null;
  rotation: number | null;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_printTemplate_fields_page {
  __typename: "PrintTemplatePage";
  offset: number;
  coordinates: ArticleForm_RawArticle_assignment_articleTemplate_printTemplate_fields_page_coordinates;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_printTemplate_fields_paragraphStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_printTemplate_fields_characterStyles {
  __typename: "PrintTemplateFieldStyle";
  id: string;
  name: string;
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_printTemplate_fields {
  __typename: "PrintTemplateField";
  id: number;
  name: string;
  type: PrintTemplateFieldType;
  page: ArticleForm_RawArticle_assignment_articleTemplate_printTemplate_fields_page;
  data: string;
  typeVariation: string;
  paragraphStyles: ArticleForm_RawArticle_assignment_articleTemplate_printTemplate_fields_paragraphStyles[];
  characterStyles: ArticleForm_RawArticle_assignment_articleTemplate_printTemplate_fields_characterStyles[];
}

export interface ArticleForm_RawArticle_assignment_articleTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * template type
   */
  type: TemplateType | null;
  fields: (ArticleForm_RawArticle_assignment_articleTemplate_printTemplate_fields | null)[];
}

export interface ArticleForm_RawArticle_assignment_articleTemplate {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * The article template label
   */
  label: string | null;
  /**
   * The raw datas
   */
  block: string | null;
  fields: (ArticleForm_RawArticle_assignment_articleTemplate_fields | null)[];
  printTemplate: ArticleForm_RawArticle_assignment_articleTemplate_printTemplate | null;
}

export interface ArticleForm_RawArticle_assignment {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printPublication: ArticleForm_RawArticle_assignment_printPublication | null;
  printIssue: ArticleForm_RawArticle_assignment_printIssue | null;
  printHeading: ArticleForm_RawArticle_assignment_printHeading | null;
  website: ArticleForm_RawArticle_assignment_website | null;
  printTemplate: ArticleForm_RawArticle_assignment_printTemplate | null;
  subject: ArticleForm_RawArticle_assignment_subject;
  articleTemplate: ArticleForm_RawArticle_assignment_articleTemplate | null;
}

export interface ArticleForm_RawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: ArticleForm_RawArticle_versions[];
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versionList: ArticleForm_RawArticle_versionList[];
  /**
   * "Assignment.rawArticle"'s inverse relation
   */
  assignment: ArticleForm_RawArticle_assignment | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RawArticleItem
// ====================================================

export interface RawArticleItem_versions_editor {
  __typename: "User";
  id: string;
  name: string;
}

export interface RawArticleItem_versions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  status: RawArticleStatus;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: RawArticleItem_versions_editor | null;
}

export interface RawArticleItem {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: RawArticleItem_versions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AssignmentItem
// ====================================================

export interface AssignmentItem_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface AssignmentItem_articleTemplate {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface AssignmentItem_rawArticle_versions_editor {
  __typename: "User";
  id: string;
  name: string;
}

export interface AssignmentItem_rawArticle_versions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  status: RawArticleStatus;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: AssignmentItem_rawArticle_versions_editor | null;
}

export interface AssignmentItem_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: AssignmentItem_rawArticle_versions[];
}

export interface AssignmentItem_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * template type
   */
  type: TemplateType | null;
}

export interface AssignmentItem_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  printTemplate: AssignmentItem_printHeading_PrintTemplate_printTemplate;
}

export interface AssignmentItem_printHeading_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface AssignmentItem_printHeading_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: AssignmentItem_printHeading_printIssue_printPublication;
}

export interface AssignmentItem_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: AssignmentItem_printHeading_PrintTemplate[];
  printIssue: AssignmentItem_printHeading_printIssue;
}

export interface AssignmentItem_printIssue_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface AssignmentItem_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  printPublication: AssignmentItem_printIssue_printPublication;
}

export interface AssignmentItem_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface AssignmentItem_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
}

export interface AssignmentItem_subject {
  __typename: "Subject";
  /**
   * The document's public id.
   */
  id: string;
}

export interface AssignmentItem {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printTemplate: AssignmentItem_printTemplate | null;
  articleTemplate: AssignmentItem_articleTemplate | null;
  mediaSearchStatus: MediaSearchStatus;
  rawArticle: AssignmentItem_rawArticle | null;
  printHeading: AssignmentItem_printHeading | null;
  printIssue: AssignmentItem_printIssue | null;
  printPublication: AssignmentItem_printPublication | null;
  website: AssignmentItem_website | null;
  subject: AssignmentItem_subject;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SubjectUser
// ====================================================

export interface SubjectUser_user {
  __typename: "User";
  email: string;
  name: string;
  avatarUrl: string | null;
}

export interface SubjectUser {
  __typename: "SubjectUser";
  /**
   * The user who has access to the subject
   */
  userId: string;
  user: SubjectUser_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UnitSpeedDial_Fragment
// ====================================================

export interface UnitSpeedDial_Fragment {
  __typename: "Unit";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ArticleForm_RawArticleVersionFragment
// ====================================================

export interface ArticleForm_RawArticleVersionFragment_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface ArticleForm_RawArticleVersionFragment {
  __typename: "RawArticleVersion";
  allowedStatuses: RawArticleStatus[];
  /**
   * The document's public id.
   */
  id: string;
  title: string | null;
  lead: string | null;
  body: string | null;
  signature: string | null;
  /**
   * An array of left over Draft content
   */
  leftOver: string | null;
  status: RawArticleStatus;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: ArticleForm_RawArticleVersionFragment_editor | null;
  textIsReadOnly: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ArticleHistory_MajorVersion
// ====================================================

export interface ArticleHistory_MajorVersion_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface ArticleHistory_MajorVersion_previousMinorVersions_editor {
  __typename: "User";
  id: string;
  name: string;
  avatarUrl: string | null;
}

export interface ArticleHistory_MajorVersion_previousMinorVersions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  editor: ArticleHistory_MajorVersion_previousMinorVersions_editor | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
}

export interface ArticleHistory_MajorVersion {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  status: RawArticleStatus;
  title: string | null;
  lead: string | null;
  body: string | null;
  signature: string | null;
  /**
   * An array of left over Draft content
   */
  leftOver: string | null;
  /**
   * The user assigned to the version
   */
  editorId: string;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  editor: ArticleHistory_MajorVersion_editor | null;
  previousMinorVersions: ArticleHistory_MajorVersion_previousMinorVersions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PrintHeadingFragment
// ====================================================

export interface PrintHeadingFragment_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface PrintHeadingFragment_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  active: boolean | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update.
   */
  updatedAt: GraphQL$DateTime;
  printTemplate: PrintHeadingFragment_PrintTemplate_printTemplate;
}

export interface PrintHeadingFragment {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  order: number;
  hasAutomaticSubject: boolean | null;
  autoPrototype: boolean | null;
  PrintTemplateCount: number;
  assignmentCount: number;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: PrintHeadingFragment_PrintTemplate[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PrintIssueFragment
// ====================================================

export interface PrintIssueFragment_printHeadings {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  order: number;
  hasAutomaticSubject: boolean | null;
}

export interface PrintIssueFragment {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  /**
   * "PrintHeading.printIssue"'s inverse relation
   */
  printHeadings: PrintIssueFragment_printHeadings[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PrintPublicationFragment
// ====================================================

export interface PrintPublicationFragment_brand {
  __typename: "Brand";
  /**
   * The document's public id.
   */
  id: string;
}

export interface PrintPublicationFragment {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  key: string;
  brand: PrintPublicationFragment_brand;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AttachmentFragment
// ====================================================

export interface AttachmentFragment_createdBy {
  __typename: "User";
  name: string;
}

export interface AttachmentFragment {
  __typename: "Attachment";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * send from the front
   */
  filename: string | null;
  /**
   * update from S3
   */
  filesize: number | null;
  /**
   * update from S3
   */
  contentType: string | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
  /**
   * The user who created the Attachment
   */
  createdBy: AttachmentFragment_createdBy | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CreateAttachmentFragment
// ====================================================

export interface CreateAttachmentFragment {
  __typename: "Attachment";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * get presigned url from S3
   */
  uploadUrl: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DownloadAttachmentFragment
// ====================================================

export interface DownloadAttachmentFragment {
  __typename: "Attachment";
  downloadUrl: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SubjectForm_FlatAssignment
// ====================================================

export interface SubjectForm_FlatAssignment_assignment_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface SubjectForm_FlatAssignment_assignment_articleTemplate {
  __typename: "ArticleTemplate";
  /**
   * The document's public id.
   */
  id: string;
}

export interface SubjectForm_FlatAssignment_assignment {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  printTemplate: SubjectForm_FlatAssignment_assignment_printTemplate | null;
  articleTemplate: SubjectForm_FlatAssignment_assignment_articleTemplate | null;
  mediaSearchStatus: MediaSearchStatus;
  pageNumber: number | null;
}

export interface SubjectForm_FlatAssignment_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  key: string;
  title: string;
}

export interface SubjectForm_FlatAssignment_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface SubjectForm_FlatAssignment_printHeading_PrintTemplate_printTemplate {
  __typename: "PrintTemplate";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * template type
   */
  type: TemplateType | null;
}

export interface SubjectForm_FlatAssignment_printHeading_PrintTemplate {
  __typename: "PrintHeadingPrintTemplate";
  printTemplate: SubjectForm_FlatAssignment_printHeading_PrintTemplate_printTemplate;
}

export interface SubjectForm_FlatAssignment_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
  autoPrototype: boolean | null;
  /**
   * "PrintHeadingPrintTemplate.printHeading"'s inverse relation
   */
  PrintTemplate: SubjectForm_FlatAssignment_printHeading_PrintTemplate[];
}

export interface SubjectForm_FlatAssignment_rawArticle_versions_editor {
  __typename: "User";
  id: string;
  name: string;
}

export interface SubjectForm_FlatAssignment_rawArticle_versions {
  __typename: "RawArticleVersion";
  /**
   * The document's public id.
   */
  id: string;
  status: RawArticleStatus;
  title: string | null;
  editor: SubjectForm_FlatAssignment_rawArticle_versions_editor | null;
  /**
   * The date, fixed, of the document's creation.
   */
  createdAt: GraphQL$DateTime;
}

export interface SubjectForm_FlatAssignment_rawArticle {
  __typename: "RawArticle";
  /**
   * The document's public id.
   */
  id: string;
  /**
   * "RawArticleVersion.rawArticle"'s inverse relation
   */
  versions: SubjectForm_FlatAssignment_rawArticle_versions[];
}

export interface SubjectForm_FlatAssignment_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  key: string;
  title: string;
}

export interface SubjectForm_FlatAssignment {
  __typename: "FlatAssignment";
  assignment: SubjectForm_FlatAssignment_assignment | null;
  printPublication: SubjectForm_FlatAssignment_printPublication | null;
  printIssue: SubjectForm_FlatAssignment_printIssue | null;
  printHeading: SubjectForm_FlatAssignment_printHeading | null;
  rawArticle: SubjectForm_FlatAssignment_rawArticle | null;
  website: SubjectForm_FlatAssignment_website | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PrintSubject_FlatAssignment
// ====================================================

export interface PrintSubject_FlatAssignment_assignment {
  __typename: "Assignment";
  /**
   * The document's public id.
   */
  id: string;
  mediaSearchStatus: MediaSearchStatus;
}

export interface PrintSubject_FlatAssignment_printPublication {
  __typename: "PrintPublication";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface PrintSubject_FlatAssignment_printIssue {
  __typename: "PrintIssue";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface PrintSubject_FlatAssignment_printHeading {
  __typename: "PrintHeading";
  /**
   * The document's public id.
   */
  id: string;
  title: string;
}

export interface PrintSubject_FlatAssignment_website {
  __typename: "Website";
  /**
   * The document's public id.
   */
  id: string;
  key: string;
  title: string;
}

export interface PrintSubject_FlatAssignment {
  __typename: "FlatAssignment";
  assignment: PrintSubject_FlatAssignment_assignment | null;
  printPublication: PrintSubject_FlatAssignment_printPublication | null;
  printIssue: PrintSubject_FlatAssignment_printIssue | null;
  printHeading: PrintSubject_FlatAssignment_printHeading | null;
  website: PrintSubject_FlatAssignment_website | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum MediaSearchStatus {
  Ready = "Ready",
  Sent = "Sent",
  Started = "Started",
  Waiting = "Waiting",
}

export enum MutationResultStatus {
  KO = "KO",
  OK = "OK",
}

export enum PrintTemplateDraftFormatType {
  INDD = "INDD",
  PDF = "PDF",
  PNG = "PNG",
}

export enum PrintTemplateFieldType {
  GRAPHIC_TYPE = "GRAPHIC_TYPE",
  TEXT_TYPE = "TEXT_TYPE",
  UNASSIGNED = "UNASSIGNED",
}

export enum RawArticleStatus {
  Correcting = "Correcting",
  Correction = "Correction",
  Editing = "Editing",
  Mockup = "Mockup",
  Validating = "Validating",
  Validation = "Validation",
}

export enum TemplateType {
  ARTICLE_TEMPLATE = "ARTICLE_TEMPLATE",
  GAME_TEMPLATE = "GAME_TEMPLATE",
  MULTIPLE_ARTICLE_TEMPLATE = "MULTIPLE_ARTICLE_TEMPLATE",
}

export interface ArticleTemplateFromArticleTemplateNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface ArticleTemplateFromPrintTemplateNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface ArticleTemplateNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface ArticleTemplates2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  label_exists?: boolean | null;
  block_eq?: string | null;
  block_ne?: string | null;
  block_in?: (string | null)[] | null;
  block_nin?: (string | null)[] | null;
  block_contains?: string | null;
  block_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates3WhereInput | null;
  assignments_some?: Assignments3WhereInput | null;
  AND?: (ArticleTemplates3WhereInput | null)[] | null;
  NOT?: ArticleTemplates3WhereInput | null;
  OR?: (ArticleTemplates3WhereInput | null)[] | null;
}

export interface ArticleTemplates3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  label_exists?: boolean | null;
  block_eq?: string | null;
  block_ne?: string | null;
  block_in?: (string | null)[] | null;
  block_nin?: (string | null)[] | null;
  block_contains?: string | null;
  block_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates4WhereInput | null;
  assignments_some?: Assignments4WhereInput | null;
  AND?: (ArticleTemplates4WhereInput | null)[] | null;
  NOT?: ArticleTemplates4WhereInput | null;
  OR?: (ArticleTemplates4WhereInput | null)[] | null;
}

export interface ArticleTemplates4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  label_exists?: boolean | null;
  block_eq?: string | null;
  block_ne?: string | null;
  block_in?: (string | null)[] | null;
  block_nin?: (string | null)[] | null;
  block_contains?: string | null;
  block_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates5WhereInput | null;
  assignments_some?: Assignments5WhereInput | null;
  AND?: (ArticleTemplates5WhereInput | null)[] | null;
  NOT?: ArticleTemplates5WhereInput | null;
  OR?: (ArticleTemplates5WhereInput | null)[] | null;
}

export interface ArticleTemplates5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  label_exists?: boolean | null;
  block_eq?: string | null;
  block_ne?: string | null;
  block_in?: (string | null)[] | null;
  block_nin?: (string | null)[] | null;
  block_contains?: string | null;
  block_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates6WhereInput | null;
  assignments_some?: Assignments6WhereInput | null;
  AND?: (ArticleTemplates6WhereInput | null)[] | null;
  NOT?: ArticleTemplates6WhereInput | null;
  OR?: (ArticleTemplates6WhereInput | null)[] | null;
}

export interface ArticleTemplates6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  label_exists?: boolean | null;
  block_eq?: string | null;
  block_ne?: string | null;
  block_in?: (string | null)[] | null;
  block_nin?: (string | null)[] | null;
  block_contains?: string | null;
  block_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates7WhereInput | null;
  assignments_some?: Assignments7WhereInput | null;
  AND?: (ArticleTemplates7WhereInput | null)[] | null;
  NOT?: ArticleTemplates7WhereInput | null;
  OR?: (ArticleTemplates7WhereInput | null)[] | null;
}

export interface ArticleTemplates7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  label_exists?: boolean | null;
  block_eq?: string | null;
  block_ne?: string | null;
  block_in?: (string | null)[] | null;
  block_nin?: (string | null)[] | null;
  block_contains?: string | null;
  block_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates8WhereInput | null;
  assignments_some?: Assignments8WhereInput | null;
  AND?: (ArticleTemplates8WhereInput | null)[] | null;
  NOT?: ArticleTemplates8WhereInput | null;
  OR?: (ArticleTemplates8WhereInput | null)[] | null;
}

export interface ArticleTemplates8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  label_exists?: boolean | null;
  block_eq?: string | null;
  block_ne?: string | null;
  block_in?: (string | null)[] | null;
  block_nin?: (string | null)[] | null;
  block_contains?: string | null;
  block_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface AssignmentFromArticleTemplateNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  legacyId_eq?: number | null;
  subject_eq?: Subject1NodeSelectionInput | null;
  rawArticle_eq?: RawArticle1NodeSelectionInput | null;
}

export interface AssignmentFromAssignmentNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  legacyId_eq?: number | null;
  subject_eq?: Subject1NodeSelectionInput | null;
  rawArticle_eq?: RawArticle1NodeSelectionInput | null;
}

export interface AssignmentFromPrintHeadingNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  legacyId_eq?: number | null;
  subject_eq?: Subject1NodeSelectionInput | null;
  rawArticle_eq?: RawArticle1NodeSelectionInput | null;
}

export interface AssignmentFromPrintIssueNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  legacyId_eq?: number | null;
  subject_eq?: Subject1NodeSelectionInput | null;
  rawArticle_eq?: RawArticle1NodeSelectionInput | null;
}

export interface AssignmentFromPrintPublicationNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  legacyId_eq?: number | null;
  subject_eq?: Subject1NodeSelectionInput | null;
  rawArticle_eq?: RawArticle1NodeSelectionInput | null;
}

export interface AssignmentFromPrintTemplateNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  legacyId_eq?: number | null;
  subject_eq?: Subject1NodeSelectionInput | null;
  rawArticle_eq?: RawArticle1NodeSelectionInput | null;
}

export interface AssignmentFromRawArticleNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  legacyId_eq?: number | null;
  subject_eq?: Subject1NodeSelectionInput | null;
}

export interface AssignmentFromSubjectNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  legacyId_eq?: number | null;
  rawArticle_eq?: RawArticle1NodeSelectionInput | null;
}

export interface AssignmentFromWebsiteNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  legacyId_eq?: number | null;
  subject_eq?: Subject1NodeSelectionInput | null;
  rawArticle_eq?: RawArticle1NodeSelectionInput | null;
}

export interface AssignmentNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  legacyId_eq?: number | null;
  subject_eq?: Subject1NodeSelectionInput | null;
  rawArticle_eq?: RawArticle1NodeSelectionInput | null;
}

export interface Assignments1WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  mediaSearchStatus_eq?: MediaSearchStatus | null;
  mediaSearchStatus_ne?: MediaSearchStatus | null;
  mediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  mediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  pageNumber_eq?: number | null;
  pageNumber_ne?: number | null;
  pageNumber_in?: (number | null)[] | null;
  pageNumber_nin?: (number | null)[] | null;
  pageNumber_gt?: number | null;
  pageNumber_gte?: number | null;
  pageNumber_lt?: number | null;
  pageNumber_lte?: number | null;
  pageNumber_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications2WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues2WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings2WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites2WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles2WhereInput | null;
  subject_eq?: Subjects2WhereInput | null;
  articleTemplate_exists?: boolean | null;
  articleTemplate_eq?: ArticleTemplates2WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates2WhereInput | null;
  flatAssignment_some?: FlatAssignments2WhereInput | null;
  AND?: (Assignments2WhereInput | null)[] | null;
  NOT?: Assignments2WhereInput | null;
  OR?: (Assignments2WhereInput | null)[] | null;
}

export interface Assignments2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  mediaSearchStatus_eq?: MediaSearchStatus | null;
  mediaSearchStatus_ne?: MediaSearchStatus | null;
  mediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  mediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  pageNumber_eq?: number | null;
  pageNumber_ne?: number | null;
  pageNumber_in?: (number | null)[] | null;
  pageNumber_nin?: (number | null)[] | null;
  pageNumber_gt?: number | null;
  pageNumber_gte?: number | null;
  pageNumber_lt?: number | null;
  pageNumber_lte?: number | null;
  pageNumber_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications3WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues3WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings3WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites3WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles3WhereInput | null;
  subject_eq?: Subjects3WhereInput | null;
  articleTemplate_exists?: boolean | null;
  articleTemplate_eq?: ArticleTemplates3WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates3WhereInput | null;
  flatAssignment_some?: FlatAssignments3WhereInput | null;
  AND?: (Assignments3WhereInput | null)[] | null;
  NOT?: Assignments3WhereInput | null;
  OR?: (Assignments3WhereInput | null)[] | null;
}

export interface Assignments3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  mediaSearchStatus_eq?: MediaSearchStatus | null;
  mediaSearchStatus_ne?: MediaSearchStatus | null;
  mediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  mediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  pageNumber_eq?: number | null;
  pageNumber_ne?: number | null;
  pageNumber_in?: (number | null)[] | null;
  pageNumber_nin?: (number | null)[] | null;
  pageNumber_gt?: number | null;
  pageNumber_gte?: number | null;
  pageNumber_lt?: number | null;
  pageNumber_lte?: number | null;
  pageNumber_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications4WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues4WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings4WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites4WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles4WhereInput | null;
  subject_eq?: Subjects4WhereInput | null;
  articleTemplate_exists?: boolean | null;
  articleTemplate_eq?: ArticleTemplates4WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates4WhereInput | null;
  flatAssignment_some?: FlatAssignments4WhereInput | null;
  AND?: (Assignments4WhereInput | null)[] | null;
  NOT?: Assignments4WhereInput | null;
  OR?: (Assignments4WhereInput | null)[] | null;
}

export interface Assignments4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  mediaSearchStatus_eq?: MediaSearchStatus | null;
  mediaSearchStatus_ne?: MediaSearchStatus | null;
  mediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  mediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  pageNumber_eq?: number | null;
  pageNumber_ne?: number | null;
  pageNumber_in?: (number | null)[] | null;
  pageNumber_nin?: (number | null)[] | null;
  pageNumber_gt?: number | null;
  pageNumber_gte?: number | null;
  pageNumber_lt?: number | null;
  pageNumber_lte?: number | null;
  pageNumber_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications5WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues5WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings5WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites5WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles5WhereInput | null;
  subject_eq?: Subjects5WhereInput | null;
  articleTemplate_exists?: boolean | null;
  articleTemplate_eq?: ArticleTemplates5WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates5WhereInput | null;
  flatAssignment_some?: FlatAssignments5WhereInput | null;
  AND?: (Assignments5WhereInput | null)[] | null;
  NOT?: Assignments5WhereInput | null;
  OR?: (Assignments5WhereInput | null)[] | null;
}

export interface Assignments5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  mediaSearchStatus_eq?: MediaSearchStatus | null;
  mediaSearchStatus_ne?: MediaSearchStatus | null;
  mediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  mediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  pageNumber_eq?: number | null;
  pageNumber_ne?: number | null;
  pageNumber_in?: (number | null)[] | null;
  pageNumber_nin?: (number | null)[] | null;
  pageNumber_gt?: number | null;
  pageNumber_gte?: number | null;
  pageNumber_lt?: number | null;
  pageNumber_lte?: number | null;
  pageNumber_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications6WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues6WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings6WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites6WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles6WhereInput | null;
  subject_eq?: Subjects6WhereInput | null;
  articleTemplate_exists?: boolean | null;
  articleTemplate_eq?: ArticleTemplates6WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates6WhereInput | null;
  flatAssignment_some?: FlatAssignments6WhereInput | null;
  AND?: (Assignments6WhereInput | null)[] | null;
  NOT?: Assignments6WhereInput | null;
  OR?: (Assignments6WhereInput | null)[] | null;
}

export interface Assignments6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  mediaSearchStatus_eq?: MediaSearchStatus | null;
  mediaSearchStatus_ne?: MediaSearchStatus | null;
  mediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  mediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  pageNumber_eq?: number | null;
  pageNumber_ne?: number | null;
  pageNumber_in?: (number | null)[] | null;
  pageNumber_nin?: (number | null)[] | null;
  pageNumber_gt?: number | null;
  pageNumber_gte?: number | null;
  pageNumber_lt?: number | null;
  pageNumber_lte?: number | null;
  pageNumber_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications7WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues7WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings7WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites7WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles7WhereInput | null;
  subject_eq?: Subjects7WhereInput | null;
  articleTemplate_exists?: boolean | null;
  articleTemplate_eq?: ArticleTemplates7WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates7WhereInput | null;
  flatAssignment_some?: FlatAssignments7WhereInput | null;
  AND?: (Assignments7WhereInput | null)[] | null;
  NOT?: Assignments7WhereInput | null;
  OR?: (Assignments7WhereInput | null)[] | null;
}

export interface Assignments7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  mediaSearchStatus_eq?: MediaSearchStatus | null;
  mediaSearchStatus_ne?: MediaSearchStatus | null;
  mediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  mediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  pageNumber_eq?: number | null;
  pageNumber_ne?: number | null;
  pageNumber_in?: (number | null)[] | null;
  pageNumber_nin?: (number | null)[] | null;
  pageNumber_gt?: number | null;
  pageNumber_gte?: number | null;
  pageNumber_lt?: number | null;
  pageNumber_lte?: number | null;
  pageNumber_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications8WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues8WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings8WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites8WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles8WhereInput | null;
  subject_eq?: Subjects8WhereInput | null;
  articleTemplate_exists?: boolean | null;
  articleTemplate_eq?: ArticleTemplates8WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates8WhereInput | null;
  flatAssignment_some?: FlatAssignments8WhereInput | null;
  AND?: (Assignments8WhereInput | null)[] | null;
  NOT?: Assignments8WhereInput | null;
  OR?: (Assignments8WhereInput | null)[] | null;
}

export interface Assignments8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  mediaSearchStatus_eq?: MediaSearchStatus | null;
  mediaSearchStatus_ne?: MediaSearchStatus | null;
  mediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  mediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  pageNumber_eq?: number | null;
  pageNumber_ne?: number | null;
  pageNumber_in?: (number | null)[] | null;
  pageNumber_nin?: (number | null)[] | null;
  pageNumber_gt?: number | null;
  pageNumber_gte?: number | null;
  pageNumber_lt?: number | null;
  pageNumber_lte?: number | null;
  pageNumber_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface AttachmentFromSubjectNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface AttachmentNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface Attachments1WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filename_exists?: boolean | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  filesize_exists?: boolean | null;
  contentType_eq?: string | null;
  contentType_ne?: string | null;
  contentType_in?: (string | null)[] | null;
  contentType_nin?: (string | null)[] | null;
  contentType_contains?: string | null;
  contentType_exists?: boolean | null;
  etag_eq?: string | null;
  etag_ne?: string | null;
  etag_in?: (string | null)[] | null;
  etag_nin?: (string | null)[] | null;
  etag_contains?: string | null;
  etag_exists?: boolean | null;
  versionId_eq?: string | null;
  versionId_ne?: string | null;
  versionId_in?: (string | null)[] | null;
  versionId_nin?: (string | null)[] | null;
  versionId_contains?: string | null;
  versionId_exists?: boolean | null;
  isUploaded_eq?: boolean | null;
  isUploaded_ne?: boolean | null;
  isUploaded_in?: (boolean | null)[] | null;
  isUploaded_nin?: (boolean | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects2WhereInput | null;
  AND?: (Attachments2WhereInput | null)[] | null;
  NOT?: Attachments2WhereInput | null;
  OR?: (Attachments2WhereInput | null)[] | null;
}

export interface Attachments2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filename_exists?: boolean | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  filesize_exists?: boolean | null;
  contentType_eq?: string | null;
  contentType_ne?: string | null;
  contentType_in?: (string | null)[] | null;
  contentType_nin?: (string | null)[] | null;
  contentType_contains?: string | null;
  contentType_exists?: boolean | null;
  etag_eq?: string | null;
  etag_ne?: string | null;
  etag_in?: (string | null)[] | null;
  etag_nin?: (string | null)[] | null;
  etag_contains?: string | null;
  etag_exists?: boolean | null;
  versionId_eq?: string | null;
  versionId_ne?: string | null;
  versionId_in?: (string | null)[] | null;
  versionId_nin?: (string | null)[] | null;
  versionId_contains?: string | null;
  versionId_exists?: boolean | null;
  isUploaded_eq?: boolean | null;
  isUploaded_ne?: boolean | null;
  isUploaded_in?: (boolean | null)[] | null;
  isUploaded_nin?: (boolean | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects3WhereInput | null;
  AND?: (Attachments3WhereInput | null)[] | null;
  NOT?: Attachments3WhereInput | null;
  OR?: (Attachments3WhereInput | null)[] | null;
}

export interface Attachments3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filename_exists?: boolean | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  filesize_exists?: boolean | null;
  contentType_eq?: string | null;
  contentType_ne?: string | null;
  contentType_in?: (string | null)[] | null;
  contentType_nin?: (string | null)[] | null;
  contentType_contains?: string | null;
  contentType_exists?: boolean | null;
  etag_eq?: string | null;
  etag_ne?: string | null;
  etag_in?: (string | null)[] | null;
  etag_nin?: (string | null)[] | null;
  etag_contains?: string | null;
  etag_exists?: boolean | null;
  versionId_eq?: string | null;
  versionId_ne?: string | null;
  versionId_in?: (string | null)[] | null;
  versionId_nin?: (string | null)[] | null;
  versionId_contains?: string | null;
  versionId_exists?: boolean | null;
  isUploaded_eq?: boolean | null;
  isUploaded_ne?: boolean | null;
  isUploaded_in?: (boolean | null)[] | null;
  isUploaded_nin?: (boolean | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects4WhereInput | null;
  AND?: (Attachments4WhereInput | null)[] | null;
  NOT?: Attachments4WhereInput | null;
  OR?: (Attachments4WhereInput | null)[] | null;
}

export interface Attachments4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filename_exists?: boolean | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  filesize_exists?: boolean | null;
  contentType_eq?: string | null;
  contentType_ne?: string | null;
  contentType_in?: (string | null)[] | null;
  contentType_nin?: (string | null)[] | null;
  contentType_contains?: string | null;
  contentType_exists?: boolean | null;
  etag_eq?: string | null;
  etag_ne?: string | null;
  etag_in?: (string | null)[] | null;
  etag_nin?: (string | null)[] | null;
  etag_contains?: string | null;
  etag_exists?: boolean | null;
  versionId_eq?: string | null;
  versionId_ne?: string | null;
  versionId_in?: (string | null)[] | null;
  versionId_nin?: (string | null)[] | null;
  versionId_contains?: string | null;
  versionId_exists?: boolean | null;
  isUploaded_eq?: boolean | null;
  isUploaded_ne?: boolean | null;
  isUploaded_in?: (boolean | null)[] | null;
  isUploaded_nin?: (boolean | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects5WhereInput | null;
  AND?: (Attachments5WhereInput | null)[] | null;
  NOT?: Attachments5WhereInput | null;
  OR?: (Attachments5WhereInput | null)[] | null;
}

export interface Attachments5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filename_exists?: boolean | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  filesize_exists?: boolean | null;
  contentType_eq?: string | null;
  contentType_ne?: string | null;
  contentType_in?: (string | null)[] | null;
  contentType_nin?: (string | null)[] | null;
  contentType_contains?: string | null;
  contentType_exists?: boolean | null;
  etag_eq?: string | null;
  etag_ne?: string | null;
  etag_in?: (string | null)[] | null;
  etag_nin?: (string | null)[] | null;
  etag_contains?: string | null;
  etag_exists?: boolean | null;
  versionId_eq?: string | null;
  versionId_ne?: string | null;
  versionId_in?: (string | null)[] | null;
  versionId_nin?: (string | null)[] | null;
  versionId_contains?: string | null;
  versionId_exists?: boolean | null;
  isUploaded_eq?: boolean | null;
  isUploaded_ne?: boolean | null;
  isUploaded_in?: (boolean | null)[] | null;
  isUploaded_nin?: (boolean | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects6WhereInput | null;
  AND?: (Attachments6WhereInput | null)[] | null;
  NOT?: Attachments6WhereInput | null;
  OR?: (Attachments6WhereInput | null)[] | null;
}

export interface Attachments6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filename_exists?: boolean | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  filesize_exists?: boolean | null;
  contentType_eq?: string | null;
  contentType_ne?: string | null;
  contentType_in?: (string | null)[] | null;
  contentType_nin?: (string | null)[] | null;
  contentType_contains?: string | null;
  contentType_exists?: boolean | null;
  etag_eq?: string | null;
  etag_ne?: string | null;
  etag_in?: (string | null)[] | null;
  etag_nin?: (string | null)[] | null;
  etag_contains?: string | null;
  etag_exists?: boolean | null;
  versionId_eq?: string | null;
  versionId_ne?: string | null;
  versionId_in?: (string | null)[] | null;
  versionId_nin?: (string | null)[] | null;
  versionId_contains?: string | null;
  versionId_exists?: boolean | null;
  isUploaded_eq?: boolean | null;
  isUploaded_ne?: boolean | null;
  isUploaded_in?: (boolean | null)[] | null;
  isUploaded_nin?: (boolean | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects7WhereInput | null;
  AND?: (Attachments7WhereInput | null)[] | null;
  NOT?: Attachments7WhereInput | null;
  OR?: (Attachments7WhereInput | null)[] | null;
}

export interface Attachments7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filename_exists?: boolean | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  filesize_exists?: boolean | null;
  contentType_eq?: string | null;
  contentType_ne?: string | null;
  contentType_in?: (string | null)[] | null;
  contentType_nin?: (string | null)[] | null;
  contentType_contains?: string | null;
  contentType_exists?: boolean | null;
  etag_eq?: string | null;
  etag_ne?: string | null;
  etag_in?: (string | null)[] | null;
  etag_nin?: (string | null)[] | null;
  etag_contains?: string | null;
  etag_exists?: boolean | null;
  versionId_eq?: string | null;
  versionId_ne?: string | null;
  versionId_in?: (string | null)[] | null;
  versionId_nin?: (string | null)[] | null;
  versionId_contains?: string | null;
  versionId_exists?: boolean | null;
  isUploaded_eq?: boolean | null;
  isUploaded_ne?: boolean | null;
  isUploaded_in?: (boolean | null)[] | null;
  isUploaded_nin?: (boolean | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects8WhereInput | null;
  AND?: (Attachments8WhereInput | null)[] | null;
  NOT?: Attachments8WhereInput | null;
  OR?: (Attachments8WhereInput | null)[] | null;
}

export interface Attachments8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filename_exists?: boolean | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  filesize_exists?: boolean | null;
  contentType_eq?: string | null;
  contentType_ne?: string | null;
  contentType_in?: (string | null)[] | null;
  contentType_nin?: (string | null)[] | null;
  contentType_contains?: string | null;
  contentType_exists?: boolean | null;
  etag_eq?: string | null;
  etag_ne?: string | null;
  etag_in?: (string | null)[] | null;
  etag_nin?: (string | null)[] | null;
  etag_contains?: string | null;
  etag_exists?: boolean | null;
  versionId_eq?: string | null;
  versionId_ne?: string | null;
  versionId_in?: (string | null)[] | null;
  versionId_nin?: (string | null)[] | null;
  versionId_contains?: string | null;
  versionId_exists?: boolean | null;
  isUploaded_eq?: boolean | null;
  isUploaded_ne?: boolean | null;
  isUploaded_in?: (boolean | null)[] | null;
  isUploaded_nin?: (boolean | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface Brand1NodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
}

export interface BrandFromBrandNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
}

export interface BrandFromUnitNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
}

export interface BrandNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
}

export interface Brands1WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_eq?: Units2WhereInput | null;
  flatAssignment_some?: FlatAssignments2WhereInput | null;
  printPublications_some?: PrintPublications2WhereInput | null;
  websites_some?: Websites2WhereInput | null;
  AND?: (Brands2WhereInput | null)[] | null;
  NOT?: Brands2WhereInput | null;
  OR?: (Brands2WhereInput | null)[] | null;
}

export interface Brands2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_eq?: Units3WhereInput | null;
  flatAssignment_some?: FlatAssignments3WhereInput | null;
  printPublications_some?: PrintPublications3WhereInput | null;
  websites_some?: Websites3WhereInput | null;
  AND?: (Brands3WhereInput | null)[] | null;
  NOT?: Brands3WhereInput | null;
  OR?: (Brands3WhereInput | null)[] | null;
}

export interface Brands3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_eq?: Units4WhereInput | null;
  flatAssignment_some?: FlatAssignments4WhereInput | null;
  printPublications_some?: PrintPublications4WhereInput | null;
  websites_some?: Websites4WhereInput | null;
  AND?: (Brands4WhereInput | null)[] | null;
  NOT?: Brands4WhereInput | null;
  OR?: (Brands4WhereInput | null)[] | null;
}

export interface Brands4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_eq?: Units5WhereInput | null;
  flatAssignment_some?: FlatAssignments5WhereInput | null;
  printPublications_some?: PrintPublications5WhereInput | null;
  websites_some?: Websites5WhereInput | null;
  AND?: (Brands5WhereInput | null)[] | null;
  NOT?: Brands5WhereInput | null;
  OR?: (Brands5WhereInput | null)[] | null;
}

export interface Brands5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_eq?: Units6WhereInput | null;
  flatAssignment_some?: FlatAssignments6WhereInput | null;
  printPublications_some?: PrintPublications6WhereInput | null;
  websites_some?: Websites6WhereInput | null;
  AND?: (Brands6WhereInput | null)[] | null;
  NOT?: Brands6WhereInput | null;
  OR?: (Brands6WhereInput | null)[] | null;
}

export interface Brands6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_eq?: Units7WhereInput | null;
  flatAssignment_some?: FlatAssignments7WhereInput | null;
  printPublications_some?: PrintPublications7WhereInput | null;
  websites_some?: Websites7WhereInput | null;
  AND?: (Brands7WhereInput | null)[] | null;
  NOT?: Brands7WhereInput | null;
  OR?: (Brands7WhereInput | null)[] | null;
}

export interface Brands7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_eq?: Units8WhereInput | null;
  flatAssignment_some?: FlatAssignments8WhereInput | null;
  printPublications_some?: PrintPublications8WhereInput | null;
  websites_some?: Websites8WhereInput | null;
  AND?: (Brands8WhereInput | null)[] | null;
  NOT?: Brands8WhereInput | null;
  OR?: (Brands8WhereInput | null)[] | null;
}

export interface Brands8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface BrandsWhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_eq?: Units1WhereInput | null;
  flatAssignment_some?: FlatAssignments1WhereInput | null;
  printPublications_some?: PrintPublications1WhereInput | null;
  websites_some?: Websites1WhereInput | null;
  AND?: (Brands1WhereInput | null)[] | null;
  NOT?: Brands1WhereInput | null;
  OR?: (Brands1WhereInput | null)[] | null;
}

export interface CreateArticleTemplateFromArticleTemplateAssignments1DataInput {
  id?: string | null;
  label?: string | null;
  block?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printTemplate?: CreateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate1DataInput | null;
}

export interface CreateArticleTemplateFromArticleTemplateAssignments1Input {
  data: CreateArticleTemplateFromArticleTemplateAssignments1DataInput;
}

export interface CreateArticleTemplateFromArticleTemplateAssignments2DataInput {
  id?: string | null;
  label?: string | null;
  block?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printTemplate?: CreateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate2DataInput | null;
}

export interface CreateArticleTemplateFromArticleTemplateAssignments2Input {
  data: CreateArticleTemplateFromArticleTemplateAssignments2DataInput;
}

export interface CreateArticleTemplateFromArticleTemplateAssignments3DataInput {
  id?: string | null;
  label?: string | null;
  block?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printTemplate?: CreateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate3DataInput | null;
}

export interface CreateArticleTemplateFromArticleTemplateAssignments3Input {
  data: CreateArticleTemplateFromArticleTemplateAssignments3DataInput;
}

export interface CreateArticleTemplateFromArticleTemplateAssignments4DataInput {
  id?: string | null;
  label?: string | null;
  block?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printTemplate?: CreateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate4DataInput | null;
}

export interface CreateArticleTemplateFromArticleTemplateAssignments4Input {
  data: CreateArticleTemplateFromArticleTemplateAssignments4DataInput;
}

export interface CreateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateArticleTemplateFromPrintTemplateArticleTemplates1DataInput {
  id?: string | null;
  label?: string | null;
  block?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments1Input | null;
}

export interface CreateArticleTemplateFromPrintTemplateArticleTemplates1Input {
  data: CreateArticleTemplateFromPrintTemplateArticleTemplates1DataInput;
}

export interface CreateArticleTemplateFromPrintTemplateArticleTemplates3DataInput {
  id?: string | null;
  label?: string | null;
  block?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments3Input | null;
}

export interface CreateArticleTemplateFromPrintTemplateArticleTemplates3Input {
  data: CreateArticleTemplateFromPrintTemplateArticleTemplates3DataInput;
}

export interface CreateArticleTemplateFromPrintTemplateArticleTemplates4DataInput {
  id?: string | null;
  label?: string | null;
  block?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments4Input | null;
}

export interface CreateArticleTemplateFromPrintTemplateArticleTemplates4Input {
  data: CreateArticleTemplateFromPrintTemplateArticleTemplates4DataInput;
}

export interface CreateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments1Input {
  connect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  create?: CreateAssignmentFromArticleTemplateAssignments2Input[] | null;
  delete?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromArticleTemplateAssignments2Input[] | null;
  upsert?: UpsertAssignmentFromArticleTemplateAssignments2Input[] | null;
}

export interface CreateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments3Input {
  connect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  create?: CreateAssignmentFromArticleTemplateAssignments4Input[] | null;
  delete?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromArticleTemplateAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromArticleTemplateAssignments4Input[] | null;
}

export interface CreateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments4Input {
  connect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  delete?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
}

export interface CreateAssignmentFromArticleTemplateAssignments2DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintPublication2DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintIssue2DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintHeading2DataInput | null;
  website?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForWebsite2DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForRawArticle2DataInput | null;
  subject: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForSubject2DataInput;
  printTemplate?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintTemplate2DataInput | null;
  flatAssignment?: CreateAssignmentFromArticleTemplateAssignmentsNestedActionsForFlatAssignment2Input | null;
}

export interface CreateAssignmentFromArticleTemplateAssignments2Input {
  data: CreateAssignmentFromArticleTemplateAssignments2DataInput;
}

export interface CreateAssignmentFromArticleTemplateAssignments4DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintPublication4DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintIssue4DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintHeading4DataInput | null;
  website?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForWebsite4DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForRawArticle4DataInput | null;
  subject: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForSubject4DataInput;
  printTemplate?: CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintTemplate4DataInput | null;
}

export interface CreateAssignmentFromArticleTemplateAssignments4Input {
  data: CreateAssignmentFromArticleTemplateAssignments4DataInput;
}

export interface CreateAssignmentFromArticleTemplateAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment3Input[] | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentArticleTemplateNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentFlatAssignment2DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication2DataInput | null;
  printIssue?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue2DataInput | null;
  printHeading?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading2DataInput | null;
  website?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite2DataInput | null;
  rawArticle?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle2DataInput | null;
  subject: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject2DataInput;
  articleTemplate?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate2DataInput | null;
  printTemplate?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate2DataInput | null;
}

export interface CreateAssignmentFromAssignmentFlatAssignment2Input {
  data: CreateAssignmentFromAssignmentFlatAssignment2DataInput;
}

export interface CreateAssignmentFromAssignmentFlatAssignment3DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication3DataInput | null;
  printIssue?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue3DataInput | null;
  printHeading?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading3DataInput | null;
  website?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite3DataInput | null;
  rawArticle?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle3DataInput | null;
  subject: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject3DataInput;
  articleTemplate?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate3DataInput | null;
}

export interface CreateAssignmentFromAssignmentFlatAssignment3Input {
  data: CreateAssignmentFromAssignmentFlatAssignment3DataInput;
}

export interface CreateAssignmentFromAssignmentFlatAssignment4DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication4DataInput | null;
  printIssue?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue4DataInput | null;
  printHeading?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading4DataInput | null;
  website?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite4DataInput | null;
  rawArticle?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle4DataInput | null;
  subject: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject4DataInput;
  articleTemplate?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate4DataInput | null;
  printTemplate?: CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate4DataInput | null;
}

export interface CreateAssignmentFromAssignmentFlatAssignment4Input {
  data: CreateAssignmentFromAssignmentFlatAssignment4DataInput;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate2DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments3Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments3Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate2DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments3Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments3Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintPublicationNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate2DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments3Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments3Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentRawArticleNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentRawArticleNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentRawArticleNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentRawArticleNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentRawArticleNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentRawArticleNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentRawArticleNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentSubjectNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateAssignmentFromAssignmentWebsiteNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate2DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments3Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments3Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments3Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateAssignmentFromPrintHeadingAssignments1DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication1DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue1DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite1DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle1DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject1DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate1DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate1DataInput | null;
  flatAssignment?: CreateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface CreateAssignmentFromPrintHeadingAssignments1Input {
  data: CreateAssignmentFromPrintHeadingAssignments1DataInput;
}

export interface CreateAssignmentFromPrintHeadingAssignments2DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication2DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue2DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite2DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle2DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject2DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate2DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate2DataInput | null;
  flatAssignment?: CreateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment2Input | null;
}

export interface CreateAssignmentFromPrintHeadingAssignments2Input {
  data: CreateAssignmentFromPrintHeadingAssignments2DataInput;
}

export interface CreateAssignmentFromPrintHeadingAssignments3DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication3DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue3DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite3DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle3DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject3DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate3DataInput | null;
  flatAssignment?: CreateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface CreateAssignmentFromPrintHeadingAssignments3Input {
  data: CreateAssignmentFromPrintHeadingAssignments3DataInput;
}

export interface CreateAssignmentFromPrintHeadingAssignments4DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication4DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue4DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite4DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle4DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject4DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate4DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate4DataInput | null;
}

export interface CreateAssignmentFromPrintHeadingAssignments4Input {
  data: CreateAssignmentFromPrintHeadingAssignments4DataInput;
}

export interface CreateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface CreateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment3Input[] | null;
}

export interface CreateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment4Input[] | null;
}

export interface CreateAssignmentFromPrintIssueAssignments1DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication1DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading1DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite1DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle1DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintIssueNestedActionsForSubject1DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate1DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate1DataInput | null;
  flatAssignment?: CreateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface CreateAssignmentFromPrintIssueAssignments1Input {
  data: CreateAssignmentFromPrintIssueAssignments1DataInput;
}

export interface CreateAssignmentFromPrintIssueAssignments2DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication2DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading2DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite2DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle2DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintIssueNestedActionsForSubject2DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate2DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate2DataInput | null;
  flatAssignment?: CreateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment2Input | null;
}

export interface CreateAssignmentFromPrintIssueAssignments2Input {
  data: CreateAssignmentFromPrintIssueAssignments2DataInput;
}

export interface CreateAssignmentFromPrintIssueAssignments3DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication3DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading3DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite3DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle3DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintIssueNestedActionsForSubject3DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate3DataInput | null;
  flatAssignment?: CreateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface CreateAssignmentFromPrintIssueAssignments3Input {
  data: CreateAssignmentFromPrintIssueAssignments3DataInput;
}

export interface CreateAssignmentFromPrintIssueAssignments4DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication4DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading4DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite4DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle4DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintIssueNestedActionsForSubject4DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate4DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate4DataInput | null;
}

export interface CreateAssignmentFromPrintIssueAssignments4Input {
  data: CreateAssignmentFromPrintIssueAssignments4DataInput;
}

export interface CreateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface CreateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment3Input[] | null;
}

export interface CreateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment4Input[] | null;
}

export interface CreateAssignmentFromPrintPublicationAssignments1DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printIssue?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintIssue1DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintHeading1DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForWebsite1DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForRawArticle1DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForSubject1DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForArticleTemplate1DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintTemplate1DataInput | null;
  flatAssignment?: CreateAssignmentFromPrintPublicationAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface CreateAssignmentFromPrintPublicationAssignments1Input {
  data: CreateAssignmentFromPrintPublicationAssignments1DataInput;
}

export interface CreateAssignmentFromPrintPublicationAssignments3DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printIssue?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintIssue3DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintHeading3DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForWebsite3DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForRawArticle3DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForSubject3DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintTemplate3DataInput | null;
  flatAssignment?: CreateAssignmentFromPrintPublicationAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface CreateAssignmentFromPrintPublicationAssignments3Input {
  data: CreateAssignmentFromPrintPublicationAssignments3DataInput;
}

export interface CreateAssignmentFromPrintPublicationAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface CreateAssignmentFromPrintPublicationAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment4Input[] | null;
}

export interface CreateAssignmentFromPrintTemplateAssignments1DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication1DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue1DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading1DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite1DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle1DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject1DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate1DataInput | null;
  flatAssignment?: CreateAssignmentFromPrintTemplateAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface CreateAssignmentFromPrintTemplateAssignments1Input {
  data: CreateAssignmentFromPrintTemplateAssignments1DataInput;
}

export interface CreateAssignmentFromPrintTemplateAssignments2DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication2DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue2DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading2DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite2DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle2DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject2DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate2DataInput | null;
  flatAssignment?: CreateAssignmentFromPrintTemplateAssignmentsNestedActionsForFlatAssignment2Input | null;
}

export interface CreateAssignmentFromPrintTemplateAssignments2Input {
  data: CreateAssignmentFromPrintTemplateAssignments2DataInput;
}

export interface CreateAssignmentFromPrintTemplateAssignments4DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication4DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue4DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading4DataInput | null;
  website?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite4DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle4DataInput | null;
  subject: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject4DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate4DataInput | null;
}

export interface CreateAssignmentFromPrintTemplateAssignments4Input {
  data: CreateAssignmentFromPrintTemplateAssignments4DataInput;
}

export interface CreateAssignmentFromPrintTemplateAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface CreateAssignmentFromPrintTemplateAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment3Input[] | null;
}

export interface CreateAssignmentFromRawArticleAssignment1DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentRawArticleNestedActionsForPrintPublication1DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentRawArticleNestedActionsForPrintIssue1DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentRawArticleNestedActionsForPrintHeading1DataInput | null;
  website?: CreateAssignmentFromAssignmentRawArticleNestedActionsForWebsite1DataInput | null;
  subject: CreateAssignmentFromAssignmentRawArticleNestedActionsForSubject1DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentRawArticleNestedActionsForArticleTemplate1DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentRawArticleNestedActionsForPrintTemplate1DataInput | null;
  flatAssignment?: CreateAssignmentFromRawArticleAssignmentNestedActionsForFlatAssignment1Input | null;
}

export interface CreateAssignmentFromRawArticleAssignment1Input {
  data: CreateAssignmentFromRawArticleAssignment1DataInput;
}

export interface CreateAssignmentFromRawArticleAssignmentNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface CreateAssignmentFromSubjectAssignments1DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication1DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue1DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading1DataInput | null;
  website?: CreateAssignmentFromAssignmentSubjectNestedActionsForWebsite1DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentSubjectNestedActionsForRawArticle1DataInput | null;
  articleTemplate?: CreateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate1DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate1DataInput | null;
  flatAssignment?: CreateAssignmentFromSubjectAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface CreateAssignmentFromSubjectAssignments1Input {
  data: CreateAssignmentFromSubjectAssignments1DataInput;
}

export interface CreateAssignmentFromSubjectAssignments3DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication3DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue3DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading3DataInput | null;
  website?: CreateAssignmentFromAssignmentSubjectNestedActionsForWebsite3DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentSubjectNestedActionsForRawArticle3DataInput | null;
  articleTemplate?: CreateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate3DataInput | null;
  flatAssignment?: CreateAssignmentFromSubjectAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface CreateAssignmentFromSubjectAssignments3Input {
  data: CreateAssignmentFromSubjectAssignments3DataInput;
}

export interface CreateAssignmentFromSubjectAssignments4DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication4DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue4DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading4DataInput | null;
  website?: CreateAssignmentFromAssignmentSubjectNestedActionsForWebsite4DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentSubjectNestedActionsForRawArticle4DataInput | null;
  articleTemplate?: CreateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate4DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate4DataInput | null;
}

export interface CreateAssignmentFromSubjectAssignments4Input {
  data: CreateAssignmentFromSubjectAssignments4DataInput;
}

export interface CreateAssignmentFromSubjectAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface CreateAssignmentFromSubjectAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment4Input[] | null;
}

export interface CreateAssignmentFromWebsiteAssignments3DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintPublication3DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintIssue3DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintHeading3DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentWebsiteNestedActionsForRawArticle3DataInput | null;
  subject: CreateAssignmentFromAssignmentWebsiteNestedActionsForSubject3DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentWebsiteNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintTemplate3DataInput | null;
  flatAssignment?: CreateAssignmentFromWebsiteAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface CreateAssignmentFromWebsiteAssignments3Input {
  data: CreateAssignmentFromWebsiteAssignments3DataInput;
}

export interface CreateAssignmentFromWebsiteAssignments4DataInput {
  id?: string | null;
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication?: CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintPublication4DataInput | null;
  printIssue?: CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintIssue4DataInput | null;
  printHeading?: CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintHeading4DataInput | null;
  rawArticle?: CreateAssignmentFromAssignmentWebsiteNestedActionsForRawArticle4DataInput | null;
  subject: CreateAssignmentFromAssignmentWebsiteNestedActionsForSubject4DataInput;
  articleTemplate?: CreateAssignmentFromAssignmentWebsiteNestedActionsForArticleTemplate4DataInput | null;
  printTemplate?: CreateAssignmentFromAssignmentWebsiteNestedActionsForPrintTemplate4DataInput | null;
}

export interface CreateAssignmentFromWebsiteAssignments4Input {
  data: CreateAssignmentFromWebsiteAssignments4DataInput;
}

export interface CreateAssignmentFromWebsiteAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment4Input[] | null;
}

export interface CreateAttachmentDataInput {
  id?: string | null;
  filename?: string | null;
  filesize?: number | null;
  contentType?: string | null;
  etag?: string | null;
  versionId?: string | null;
  isUploaded: boolean;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subject: CreateAttachmentNestedActionsForSubjectDataInput;
}

export interface CreateAttachmentFromSubjectAttachments1DataInput {
  id?: string | null;
  filename?: string | null;
  filesize?: number | null;
  contentType?: string | null;
  etag?: string | null;
  versionId?: string | null;
  isUploaded: boolean;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateAttachmentFromSubjectAttachments1Input {
  data: CreateAttachmentFromSubjectAttachments1DataInput;
}

export interface CreateAttachmentFromSubjectAttachments2DataInput {
  id?: string | null;
  filename?: string | null;
  filesize?: number | null;
  contentType?: string | null;
  etag?: string | null;
  versionId?: string | null;
  isUploaded: boolean;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateAttachmentFromSubjectAttachments2Input {
  data: CreateAttachmentFromSubjectAttachments2DataInput;
}

export interface CreateAttachmentFromSubjectAttachments3DataInput {
  id?: string | null;
  filename?: string | null;
  filesize?: number | null;
  contentType?: string | null;
  etag?: string | null;
  versionId?: string | null;
  isUploaded: boolean;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateAttachmentFromSubjectAttachments3Input {
  data: CreateAttachmentFromSubjectAttachments3DataInput;
}

export interface CreateAttachmentFromSubjectAttachments4DataInput {
  id?: string | null;
  filename?: string | null;
  filesize?: number | null;
  contentType?: string | null;
  etag?: string | null;
  versionId?: string | null;
  isUploaded: boolean;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateAttachmentFromSubjectAttachments4Input {
  data: CreateAttachmentFromSubjectAttachments4DataInput;
}

export interface CreateAttachmentNestedActionsForSubjectDataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments1Input | null;
  update?: UpdateSubjectFromSubjectAssignments1Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments1Input | null;
}

export interface CreateBrandFromBrandFlatAssignment1DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit: CreateBrandFromFlatAssignmentBrandNestedActionsForUnit1DataInput;
  printPublications?: CreateBrandFromBrandFlatAssignmentNestedActionsForPrintPublications1Input | null;
  websites?: CreateBrandFromBrandFlatAssignmentNestedActionsForWebsites1Input | null;
}

export interface CreateBrandFromBrandFlatAssignment1Input {
  data: CreateBrandFromBrandFlatAssignment1DataInput;
}

export interface CreateBrandFromBrandFlatAssignment3DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit: CreateBrandFromFlatAssignmentBrandNestedActionsForUnit3DataInput;
  printPublications?: CreateBrandFromBrandFlatAssignmentNestedActionsForPrintPublications3Input | null;
  websites?: CreateBrandFromBrandFlatAssignmentNestedActionsForWebsites3Input | null;
}

export interface CreateBrandFromBrandFlatAssignment3Input {
  data: CreateBrandFromBrandFlatAssignment3DataInput;
}

export interface CreateBrandFromBrandFlatAssignmentNestedActionsForPrintPublications1Input {
  connect?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  create?: CreatePrintPublicationFromBrandPrintPublications2Input[] | null;
  delete?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  update?: UpdatePrintPublicationFromBrandPrintPublications2Input[] | null;
  upsert?: UpsertPrintPublicationFromBrandPrintPublications2Input[] | null;
}

export interface CreateBrandFromBrandFlatAssignmentNestedActionsForPrintPublications3Input {
  connect?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  create?: CreatePrintPublicationFromBrandPrintPublications4Input[] | null;
  delete?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  update?: UpdatePrintPublicationFromBrandPrintPublications4Input[] | null;
  upsert?: UpsertPrintPublicationFromBrandPrintPublications4Input[] | null;
}

export interface CreateBrandFromBrandFlatAssignmentNestedActionsForWebsites1Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  create?: CreateWebsiteFromBrandWebsites2Input[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
  update?: UpdateWebsiteFromBrandWebsites2Input[] | null;
  upsert?: UpsertWebsiteFromBrandWebsites2Input[] | null;
}

export interface CreateBrandFromBrandFlatAssignmentNestedActionsForWebsites3Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  create?: CreateWebsiteFromBrandWebsites4Input[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
  update?: UpdateWebsiteFromBrandWebsites4Input[] | null;
  upsert?: UpsertWebsiteFromBrandWebsites4Input[] | null;
}

export interface CreateBrandFromBrandPrintPublications2DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit: CreateBrandFromPrintPublicationBrandNestedActionsForUnit2DataInput;
  flatAssignment?: CreateBrandFromBrandPrintPublicationsNestedActionsForFlatAssignment2Input | null;
  websites?: CreateBrandFromBrandPrintPublicationsNestedActionsForWebsites2Input | null;
}

export interface CreateBrandFromBrandPrintPublications2Input {
  data: CreateBrandFromBrandPrintPublications2DataInput;
}

export interface CreateBrandFromBrandPrintPublications4DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit: CreateBrandFromPrintPublicationBrandNestedActionsForUnit4DataInput;
  websites?: CreateBrandFromBrandPrintPublicationsNestedActionsForWebsites4Input | null;
}

export interface CreateBrandFromBrandPrintPublications4Input {
  data: CreateBrandFromBrandPrintPublications4DataInput;
}

export interface CreateBrandFromBrandPrintPublicationsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromBrandFlatAssignment3Input[] | null;
}

export interface CreateBrandFromBrandPrintPublicationsNestedActionsForWebsites2Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  create?: CreateWebsiteFromBrandWebsites3Input[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
  update?: UpdateWebsiteFromBrandWebsites3Input[] | null;
  upsert?: UpsertWebsiteFromBrandWebsites3Input[] | null;
}

export interface CreateBrandFromBrandPrintPublicationsNestedActionsForWebsites4Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
}

export interface CreateBrandFromFlatAssignmentBrandNestedActionsForUnit1DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects2Input | null;
  update?: UpdateUnitFromUnitSubjects2Input | null;
  upsert?: UpsertUnitFromUnitSubjects2Input | null;
}

export interface CreateBrandFromFlatAssignmentBrandNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface CreateBrandFromPrintPublicationBrandNestedActionsForUnit2DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects3Input | null;
  update?: UpdateUnitFromUnitSubjects3Input | null;
  upsert?: UpsertUnitFromUnitSubjects3Input | null;
}

export interface CreateBrandFromPrintPublicationBrandNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface CreateBrandFromUnitBrands3DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  flatAssignment?: CreateBrandFromUnitBrandsNestedActionsForFlatAssignment3Input | null;
  printPublications?: CreateBrandFromUnitBrandsNestedActionsForPrintPublications3Input | null;
  websites?: CreateBrandFromUnitBrandsNestedActionsForWebsites3Input | null;
}

export interface CreateBrandFromUnitBrands3Input {
  data: CreateBrandFromUnitBrands3DataInput;
}

export interface CreateBrandFromUnitBrands4DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublications?: CreateBrandFromUnitBrandsNestedActionsForPrintPublications4Input | null;
  websites?: CreateBrandFromUnitBrandsNestedActionsForWebsites4Input | null;
}

export interface CreateBrandFromUnitBrands4Input {
  data: CreateBrandFromUnitBrands4DataInput;
}

export interface CreateBrandFromUnitBrandsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromBrandFlatAssignment4Input[] | null;
}

export interface CreateBrandFromUnitBrandsNestedActionsForPrintPublications3Input {
  connect?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  create?: CreatePrintPublicationFromBrandPrintPublications4Input[] | null;
  delete?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  update?: UpdatePrintPublicationFromBrandPrintPublications4Input[] | null;
  upsert?: UpsertPrintPublicationFromBrandPrintPublications4Input[] | null;
}

export interface CreateBrandFromUnitBrandsNestedActionsForPrintPublications4Input {
  connect?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  delete?: PrintPublicationFromBrandNodeSelectionInput[] | null;
}

export interface CreateBrandFromUnitBrandsNestedActionsForWebsites3Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  create?: CreateWebsiteFromBrandWebsites4Input[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
  update?: UpdateWebsiteFromBrandWebsites4Input[] | null;
  upsert?: UpsertWebsiteFromBrandWebsites4Input[] | null;
}

export interface CreateBrandFromUnitBrandsNestedActionsForWebsites4Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
}

export interface CreateFlatAssignmentFromAssignmentFlatAssignment1DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject1DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle1DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading1DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue1DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication1DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate1DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite1DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForBrand1DataInput | null;
}

export interface CreateFlatAssignmentFromAssignmentFlatAssignment1Input {
  data: CreateFlatAssignmentFromAssignmentFlatAssignment1DataInput;
}

export interface CreateFlatAssignmentFromAssignmentFlatAssignment2DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject2DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle2DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading2DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue2DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication2DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate2DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite2DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForBrand2DataInput | null;
}

export interface CreateFlatAssignmentFromAssignmentFlatAssignment2Input {
  data: CreateFlatAssignmentFromAssignmentFlatAssignment2DataInput;
}

export interface CreateFlatAssignmentFromAssignmentFlatAssignment3DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject3DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle3DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading3DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue3DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication3DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate3DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite3DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForBrand3DataInput | null;
}

export interface CreateFlatAssignmentFromAssignmentFlatAssignment3Input {
  data: CreateFlatAssignmentFromAssignmentFlatAssignment3DataInput;
}

export interface CreateFlatAssignmentFromAssignmentFlatAssignment4DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject4DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle4DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading4DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue4DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication4DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate4DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite4DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForBrand4DataInput | null;
}

export interface CreateFlatAssignmentFromAssignmentFlatAssignment4Input {
  data: CreateFlatAssignmentFromAssignmentFlatAssignment4DataInput;
}

export interface CreateFlatAssignmentFromBrandFlatAssignment3DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForAssignment3DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForSubject3DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForRawArticle3DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintHeading3DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintIssue3DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintPublication3DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintTemplate3DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForWebsite3DataInput | null;
}

export interface CreateFlatAssignmentFromBrandFlatAssignment3Input {
  data: CreateFlatAssignmentFromBrandFlatAssignment3DataInput;
}

export interface CreateFlatAssignmentFromBrandFlatAssignment4DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForAssignment4DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForSubject4DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForRawArticle4DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintHeading4DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintIssue4DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintPublication4DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintTemplate4DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForWebsite4DataInput | null;
}

export interface CreateFlatAssignmentFromBrandFlatAssignment4Input {
  data: CreateFlatAssignmentFromBrandFlatAssignment4DataInput;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForAssignment3DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment4Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment4Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForAssignment4DataInput {
  connect?: AssignmentNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentBrandNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForAssignment1DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment2Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment2Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForAssignment2DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment3Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment3Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForAssignment3DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment4Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment4Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForAssignment4DataInput {
  connect?: AssignmentNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForAssignment1DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment2Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment2Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForAssignment2DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment3Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment3Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForAssignment3DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment4Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment4Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForAssignment4DataInput {
  connect?: AssignmentNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForAssignment1DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment2Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment2Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForAssignment2DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment3Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment3Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForAssignment3DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment4Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment4Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForAssignment4DataInput {
  connect?: AssignmentNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForAssignment1DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment2Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment2Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForAssignment2DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment3Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment3Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForAssignment3DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment4Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment4Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForAssignment1DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment2Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment2Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForAssignment2DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment3Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment3Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForAssignment3DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment4Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment4Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForAssignment4DataInput {
  connect?: AssignmentNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForAssignment1DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment2Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment2Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForAssignment2DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment3Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment3Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForAssignment3DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment4Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment4Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForAssignment4DataInput {
  connect?: AssignmentNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForAssignment2DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment3Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment3Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForAssignment3DataInput {
  connect?: AssignmentNodeSelectionInput | null;
  create?: CreateAssignmentFromAssignmentFlatAssignment4Input | null;
  update?: UpdateAssignmentFromAssignmentFlatAssignment4Input | null;
  upsert?: UpsertAssignmentFromAssignmentFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForAssignment4DataInput {
  connect?: AssignmentNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface CreateFlatAssignmentFromPrintHeadingFlatAssignment1DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForAssignment1DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForSubject1DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForRawArticle1DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue1DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintPublication1DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintTemplate1DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForWebsite1DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForBrand1DataInput | null;
}

export interface CreateFlatAssignmentFromPrintHeadingFlatAssignment1Input {
  data: CreateFlatAssignmentFromPrintHeadingFlatAssignment1DataInput;
}

export interface CreateFlatAssignmentFromPrintHeadingFlatAssignment2DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForAssignment2DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForSubject2DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForRawArticle2DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue2DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintPublication2DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintTemplate2DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForWebsite2DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForBrand2DataInput | null;
}

export interface CreateFlatAssignmentFromPrintHeadingFlatAssignment2Input {
  data: CreateFlatAssignmentFromPrintHeadingFlatAssignment2DataInput;
}

export interface CreateFlatAssignmentFromPrintHeadingFlatAssignment3DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForAssignment3DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForSubject3DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForRawArticle3DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue3DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintPublication3DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintTemplate3DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForWebsite3DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForBrand3DataInput | null;
}

export interface CreateFlatAssignmentFromPrintHeadingFlatAssignment3Input {
  data: CreateFlatAssignmentFromPrintHeadingFlatAssignment3DataInput;
}

export interface CreateFlatAssignmentFromPrintHeadingFlatAssignment4DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForAssignment4DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForSubject4DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForRawArticle4DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue4DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintPublication4DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForPrintTemplate4DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForWebsite4DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintHeadingNestedActionsForBrand4DataInput | null;
}

export interface CreateFlatAssignmentFromPrintHeadingFlatAssignment4Input {
  data: CreateFlatAssignmentFromPrintHeadingFlatAssignment4DataInput;
}

export interface CreateFlatAssignmentFromPrintIssueFlatAssignment1DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForAssignment1DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForSubject1DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForRawArticle1DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintHeading1DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintPublication1DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintTemplate1DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForWebsite1DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForBrand1DataInput | null;
}

export interface CreateFlatAssignmentFromPrintIssueFlatAssignment1Input {
  data: CreateFlatAssignmentFromPrintIssueFlatAssignment1DataInput;
}

export interface CreateFlatAssignmentFromPrintIssueFlatAssignment2DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForAssignment2DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForSubject2DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForRawArticle2DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintHeading2DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintPublication2DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintTemplate2DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForWebsite2DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForBrand2DataInput | null;
}

export interface CreateFlatAssignmentFromPrintIssueFlatAssignment2Input {
  data: CreateFlatAssignmentFromPrintIssueFlatAssignment2DataInput;
}

export interface CreateFlatAssignmentFromPrintIssueFlatAssignment3DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForAssignment3DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForSubject3DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForRawArticle3DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintHeading3DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintPublication3DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintTemplate3DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForWebsite3DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForBrand3DataInput | null;
}

export interface CreateFlatAssignmentFromPrintIssueFlatAssignment3Input {
  data: CreateFlatAssignmentFromPrintIssueFlatAssignment3DataInput;
}

export interface CreateFlatAssignmentFromPrintIssueFlatAssignment4DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForAssignment4DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForSubject4DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForRawArticle4DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintHeading4DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintPublication4DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForPrintTemplate4DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForWebsite4DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintIssueNestedActionsForBrand4DataInput | null;
}

export interface CreateFlatAssignmentFromPrintIssueFlatAssignment4Input {
  data: CreateFlatAssignmentFromPrintIssueFlatAssignment4DataInput;
}

export interface CreateFlatAssignmentFromPrintPublicationFlatAssignment1DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForAssignment1DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForSubject1DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForRawArticle1DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintHeading1DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintIssue1DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintTemplate1DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForWebsite1DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForBrand1DataInput | null;
}

export interface CreateFlatAssignmentFromPrintPublicationFlatAssignment1Input {
  data: CreateFlatAssignmentFromPrintPublicationFlatAssignment1DataInput;
}

export interface CreateFlatAssignmentFromPrintPublicationFlatAssignment2DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForAssignment2DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForSubject2DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForRawArticle2DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintHeading2DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintIssue2DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintTemplate2DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForWebsite2DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForBrand2DataInput | null;
}

export interface CreateFlatAssignmentFromPrintPublicationFlatAssignment2Input {
  data: CreateFlatAssignmentFromPrintPublicationFlatAssignment2DataInput;
}

export interface CreateFlatAssignmentFromPrintPublicationFlatAssignment3DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForAssignment3DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForSubject3DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForRawArticle3DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintHeading3DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintIssue3DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintTemplate3DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForWebsite3DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForBrand3DataInput | null;
}

export interface CreateFlatAssignmentFromPrintPublicationFlatAssignment3Input {
  data: CreateFlatAssignmentFromPrintPublicationFlatAssignment3DataInput;
}

export interface CreateFlatAssignmentFromPrintPublicationFlatAssignment4DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForAssignment4DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForSubject4DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForRawArticle4DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintHeading4DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintIssue4DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForPrintTemplate4DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForWebsite4DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintPublicationNestedActionsForBrand4DataInput | null;
}

export interface CreateFlatAssignmentFromPrintPublicationFlatAssignment4Input {
  data: CreateFlatAssignmentFromPrintPublicationFlatAssignment4DataInput;
}

export interface CreateFlatAssignmentFromPrintTemplateFlatAssignment1DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForAssignment1DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForSubject1DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForRawArticle1DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintHeading1DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintIssue1DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintPublication1DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForWebsite1DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForBrand1DataInput | null;
}

export interface CreateFlatAssignmentFromPrintTemplateFlatAssignment1Input {
  data: CreateFlatAssignmentFromPrintTemplateFlatAssignment1DataInput;
}

export interface CreateFlatAssignmentFromPrintTemplateFlatAssignment2DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForAssignment2DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForSubject2DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForRawArticle2DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintHeading2DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintIssue2DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintPublication2DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForWebsite2DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForBrand2DataInput | null;
}

export interface CreateFlatAssignmentFromPrintTemplateFlatAssignment2Input {
  data: CreateFlatAssignmentFromPrintTemplateFlatAssignment2DataInput;
}

export interface CreateFlatAssignmentFromPrintTemplateFlatAssignment3DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForAssignment3DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForSubject3DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForRawArticle3DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintHeading3DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintIssue3DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForPrintPublication3DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForWebsite3DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentPrintTemplateNestedActionsForBrand3DataInput | null;
}

export interface CreateFlatAssignmentFromPrintTemplateFlatAssignment3Input {
  data: CreateFlatAssignmentFromPrintTemplateFlatAssignment3DataInput;
}

export interface CreateFlatAssignmentFromRawArticleFlatAssignment1DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForAssignment1DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForSubject1DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintHeading1DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintIssue1DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintPublication1DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintTemplate1DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForWebsite1DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForBrand1DataInput | null;
}

export interface CreateFlatAssignmentFromRawArticleFlatAssignment1Input {
  data: CreateFlatAssignmentFromRawArticleFlatAssignment1DataInput;
}

export interface CreateFlatAssignmentFromRawArticleFlatAssignment2DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForAssignment2DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForSubject2DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintHeading2DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintIssue2DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintPublication2DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintTemplate2DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForWebsite2DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForBrand2DataInput | null;
}

export interface CreateFlatAssignmentFromRawArticleFlatAssignment2Input {
  data: CreateFlatAssignmentFromRawArticleFlatAssignment2DataInput;
}

export interface CreateFlatAssignmentFromRawArticleFlatAssignment3DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForAssignment3DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForSubject3DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintHeading3DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintIssue3DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintPublication3DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintTemplate3DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForWebsite3DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForBrand3DataInput | null;
}

export interface CreateFlatAssignmentFromRawArticleFlatAssignment3Input {
  data: CreateFlatAssignmentFromRawArticleFlatAssignment3DataInput;
}

export interface CreateFlatAssignmentFromRawArticleFlatAssignment4DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForAssignment4DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForSubject4DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintHeading4DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintIssue4DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintPublication4DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForPrintTemplate4DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForWebsite4DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentRawArticleNestedActionsForBrand4DataInput | null;
}

export interface CreateFlatAssignmentFromRawArticleFlatAssignment4Input {
  data: CreateFlatAssignmentFromRawArticleFlatAssignment4DataInput;
}

export interface CreateFlatAssignmentFromSubjectFlatAssignment1DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForAssignment1DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForRawArticle1DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintHeading1DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintIssue1DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintPublication1DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintTemplate1DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForWebsite1DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForBrand1DataInput | null;
}

export interface CreateFlatAssignmentFromSubjectFlatAssignment1Input {
  data: CreateFlatAssignmentFromSubjectFlatAssignment1DataInput;
}

export interface CreateFlatAssignmentFromSubjectFlatAssignment2DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForAssignment2DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForRawArticle2DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintHeading2DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintIssue2DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintPublication2DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintTemplate2DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForWebsite2DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForBrand2DataInput | null;
}

export interface CreateFlatAssignmentFromSubjectFlatAssignment2Input {
  data: CreateFlatAssignmentFromSubjectFlatAssignment2DataInput;
}

export interface CreateFlatAssignmentFromSubjectFlatAssignment3DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForAssignment3DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForRawArticle3DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintHeading3DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintIssue3DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintPublication3DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintTemplate3DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForWebsite3DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForBrand3DataInput | null;
}

export interface CreateFlatAssignmentFromSubjectFlatAssignment3Input {
  data: CreateFlatAssignmentFromSubjectFlatAssignment3DataInput;
}

export interface CreateFlatAssignmentFromSubjectFlatAssignment4DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForAssignment4DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForRawArticle4DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintHeading4DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintIssue4DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintPublication4DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForPrintTemplate4DataInput | null;
  website?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForWebsite4DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentSubjectNestedActionsForBrand4DataInput | null;
}

export interface CreateFlatAssignmentFromSubjectFlatAssignment4Input {
  data: CreateFlatAssignmentFromSubjectFlatAssignment4DataInput;
}

export interface CreateFlatAssignmentFromWebsiteFlatAssignment2DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForAssignment2DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForSubject2DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForRawArticle2DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintHeading2DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintIssue2DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintPublication2DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintTemplate2DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForBrand2DataInput | null;
}

export interface CreateFlatAssignmentFromWebsiteFlatAssignment2Input {
  data: CreateFlatAssignmentFromWebsiteFlatAssignment2DataInput;
}

export interface CreateFlatAssignmentFromWebsiteFlatAssignment3DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForAssignment3DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForSubject3DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForRawArticle3DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintHeading3DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintIssue3DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintPublication3DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintTemplate3DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForBrand3DataInput | null;
}

export interface CreateFlatAssignmentFromWebsiteFlatAssignment3Input {
  data: CreateFlatAssignmentFromWebsiteFlatAssignment3DataInput;
}

export interface CreateFlatAssignmentFromWebsiteFlatAssignment4DataInput {
  location?: string | null;
  assignmentPageNumber?: number | null;
  assignmentMediaSearchStatus?: MediaSearchStatus | null;
  assignmentIntId?: number | null;
  assignment?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForAssignment4DataInput | null;
  subject?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForSubject4DataInput | null;
  rawArticle?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForRawArticle4DataInput | null;
  printHeading?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintHeading4DataInput | null;
  printIssue?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintIssue4DataInput | null;
  printPublication?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintPublication4DataInput | null;
  printTemplate?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForPrintTemplate4DataInput | null;
  brand?: CreateFlatAssignmentFromFlatAssignmentWebsiteNestedActionsForBrand4DataInput | null;
}

export interface CreateFlatAssignmentFromWebsiteFlatAssignment4Input {
  data: CreateFlatAssignmentFromWebsiteFlatAssignment4DataInput;
}

export interface CreateFolderFromFolderFolders3DataInput {
  id?: string | null;
  title: string;
  isShared: boolean;
  level?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit?: CreateFolderFromFolderParentNestedActionsForUnit3DataInput | null;
  pins?: CreateFolderFromFolderFoldersNestedActionsForPins3Input | null;
}

export interface CreateFolderFromFolderFolders3Input {
  data: CreateFolderFromFolderFolders3DataInput;
}

export interface CreateFolderFromFolderFolders4DataInput {
  id?: string | null;
  title: string;
  isShared: boolean;
  level?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit?: CreateFolderFromFolderParentNestedActionsForUnit4DataInput | null;
  pins?: CreateFolderFromFolderFoldersNestedActionsForPins4Input | null;
}

export interface CreateFolderFromFolderFolders4Input {
  data: CreateFolderFromFolderFolders4DataInput;
}

export interface CreateFolderFromFolderFoldersNestedActionsForPins3Input {
  connect?: PinFromFolderNodeSelectionInput[] | null;
  create?: CreatePinFromFolderPins4Input[] | null;
  delete?: PinFromFolderNodeSelectionInput[] | null;
  disconnect?: PinFromFolderNodeSelectionInput[] | null;
  update?: UpdatePinFromFolderPins4Input[] | null;
  upsert?: UpsertPinFromFolderPins4Input[] | null;
}

export interface CreateFolderFromFolderFoldersNestedActionsForPins4Input {
  connect?: PinFromFolderNodeSelectionInput[] | null;
  delete?: PinFromFolderNodeSelectionInput[] | null;
  disconnect?: PinFromFolderNodeSelectionInput[] | null;
}

export interface CreateFolderFromFolderParentNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface CreateFolderFromFolderParentNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface CreateFolderFromFolderUnitNestedActionsForParent2DataInput {
  connect?: FolderNodeSelectionInput | null;
  create?: CreateFolderFromFolderFolders3Input | null;
  update?: UpdateFolderFromFolderFolders3Input | null;
  upsert?: UpsertFolderFromFolderFolders3Input | null;
}

export interface CreateFolderFromFolderUnitNestedActionsForParent3DataInput {
  connect?: FolderNodeSelectionInput | null;
  create?: CreateFolderFromFolderFolders4Input | null;
  update?: UpdateFolderFromFolderFolders4Input | null;
  upsert?: UpsertFolderFromFolderFolders4Input | null;
}

export interface CreateFolderFromFolderUnitNestedActionsForParent4DataInput {
  connect?: FolderNodeSelectionInput | null;
}

export interface CreateFolderFromUnitFolders2DataInput {
  id?: string | null;
  title: string;
  isShared: boolean;
  level?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  parent?: CreateFolderFromFolderUnitNestedActionsForParent2DataInput | null;
  folders?: CreateFolderFromUnitFoldersNestedActionsForFolders2Input | null;
  pins?: CreateFolderFromUnitFoldersNestedActionsForPins2Input | null;
}

export interface CreateFolderFromUnitFolders2Input {
  data: CreateFolderFromUnitFolders2DataInput;
}

export interface CreateFolderFromUnitFolders3DataInput {
  id?: string | null;
  title: string;
  isShared: boolean;
  level?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  parent?: CreateFolderFromFolderUnitNestedActionsForParent3DataInput | null;
  folders?: CreateFolderFromUnitFoldersNestedActionsForFolders3Input | null;
  pins?: CreateFolderFromUnitFoldersNestedActionsForPins3Input | null;
}

export interface CreateFolderFromUnitFolders3Input {
  data: CreateFolderFromUnitFolders3DataInput;
}

export interface CreateFolderFromUnitFolders4DataInput {
  id?: string | null;
  title: string;
  isShared: boolean;
  level?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  parent?: CreateFolderFromFolderUnitNestedActionsForParent4DataInput | null;
  folders?: CreateFolderFromUnitFoldersNestedActionsForFolders4Input | null;
  pins?: CreateFolderFromUnitFoldersNestedActionsForPins4Input | null;
}

export interface CreateFolderFromUnitFolders4Input {
  data: CreateFolderFromUnitFolders4DataInput;
}

export interface CreateFolderFromUnitFoldersNestedActionsForFolders2Input {
  connect?: FolderFromParentNodeSelectionInput[] | null;
  create?: CreateFolderFromFolderFolders3Input[] | null;
  delete?: FolderFromParentNodeSelectionInput[] | null;
  disconnect?: FolderFromParentNodeSelectionInput[] | null;
  update?: UpdateFolderFromFolderFolders3Input[] | null;
  upsert?: UpsertFolderFromFolderFolders3Input[] | null;
}

export interface CreateFolderFromUnitFoldersNestedActionsForFolders3Input {
  connect?: FolderFromParentNodeSelectionInput[] | null;
  create?: CreateFolderFromFolderFolders4Input[] | null;
  delete?: FolderFromParentNodeSelectionInput[] | null;
  disconnect?: FolderFromParentNodeSelectionInput[] | null;
  update?: UpdateFolderFromFolderFolders4Input[] | null;
  upsert?: UpsertFolderFromFolderFolders4Input[] | null;
}

export interface CreateFolderFromUnitFoldersNestedActionsForFolders4Input {
  connect?: FolderFromParentNodeSelectionInput[] | null;
  delete?: FolderFromParentNodeSelectionInput[] | null;
  disconnect?: FolderFromParentNodeSelectionInput[] | null;
}

export interface CreateFolderFromUnitFoldersNestedActionsForPins2Input {
  connect?: PinFromFolderNodeSelectionInput[] | null;
  create?: CreatePinFromFolderPins3Input[] | null;
  delete?: PinFromFolderNodeSelectionInput[] | null;
  disconnect?: PinFromFolderNodeSelectionInput[] | null;
  update?: UpdatePinFromFolderPins3Input[] | null;
  upsert?: UpsertPinFromFolderPins3Input[] | null;
}

export interface CreateFolderFromUnitFoldersNestedActionsForPins3Input {
  connect?: PinFromFolderNodeSelectionInput[] | null;
  create?: CreatePinFromFolderPins4Input[] | null;
  delete?: PinFromFolderNodeSelectionInput[] | null;
  disconnect?: PinFromFolderNodeSelectionInput[] | null;
  update?: UpdatePinFromFolderPins4Input[] | null;
  upsert?: UpsertPinFromFolderPins4Input[] | null;
}

export interface CreateFolderFromUnitFoldersNestedActionsForPins4Input {
  connect?: PinFromFolderNodeSelectionInput[] | null;
  delete?: PinFromFolderNodeSelectionInput[] | null;
  disconnect?: PinFromFolderNodeSelectionInput[] | null;
}

export interface CreatePinFromFolderPins3DataInput {
  id?: string | null;
  order?: number | null;
  photoId: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreatePinFromFolderPins3Input {
  data: CreatePinFromFolderPins3DataInput;
}

export interface CreatePinFromFolderPins4DataInput {
  id?: string | null;
  order?: number | null;
  photoId: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreatePinFromFolderPins4Input {
  data: CreatePinFromFolderPins4DataInput;
}

export interface CreatePrintHeadingDataInput {
  id?: string | null;
  title: string;
  order: number;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printIssue: CreatePrintHeadingNestedActionsForPrintIssueDataInput;
  assignments?: CreatePrintHeadingNestedActionsForAssignmentsInput | null;
  flatAssignment?: CreatePrintHeadingNestedActionsForFlatAssignmentInput | null;
  PrintTemplate?: CreatePrintHeadingNestedActionsForPrintTemplateInput | null;
}

export interface CreatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface CreatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface CreatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface CreatePrintHeadingFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface CreatePrintHeadingFromPrintHeadingAssignments1DataInput {
  id?: string | null;
  title: string;
  order: number;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printIssue: CreatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue1DataInput;
  flatAssignment?: CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment1Input | null;
  PrintTemplate?: CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate1Input | null;
}

export interface CreatePrintHeadingFromPrintHeadingAssignments1Input {
  data: CreatePrintHeadingFromPrintHeadingAssignments1DataInput;
}

export interface CreatePrintHeadingFromPrintHeadingAssignments2DataInput {
  id?: string | null;
  title: string;
  order: number;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printIssue: CreatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue2DataInput;
  flatAssignment?: CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment2Input | null;
  PrintTemplate?: CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate2Input | null;
}

export interface CreatePrintHeadingFromPrintHeadingAssignments2Input {
  data: CreatePrintHeadingFromPrintHeadingAssignments2DataInput;
}

export interface CreatePrintHeadingFromPrintHeadingAssignments3DataInput {
  id?: string | null;
  title: string;
  order: number;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printIssue: CreatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue3DataInput;
  flatAssignment?: CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment3Input | null;
  PrintTemplate?: CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate3Input | null;
}

export interface CreatePrintHeadingFromPrintHeadingAssignments3Input {
  data: CreatePrintHeadingFromPrintHeadingAssignments3DataInput;
}

export interface CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment2Input[] | null;
}

export interface CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment3Input[] | null;
}

export interface CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment4Input[] | null;
}

export interface CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate1Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
}

export interface CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate2Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
}

export interface CreatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate3Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
}

export interface CreatePrintHeadingFromPrintHeadingFlatAssignment4DataInput {
  id?: string | null;
  title: string;
  order: number;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printIssue: CreatePrintHeadingFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue4DataInput;
  assignments?: CreatePrintHeadingFromPrintHeadingFlatAssignmentNestedActionsForAssignments4Input | null;
  PrintTemplate?: CreatePrintHeadingFromPrintHeadingFlatAssignmentNestedActionsForPrintTemplate4Input | null;
}

export interface CreatePrintHeadingFromPrintHeadingFlatAssignment4Input {
  data: CreatePrintHeadingFromPrintHeadingFlatAssignment4DataInput;
}

export interface CreatePrintHeadingFromPrintHeadingFlatAssignmentNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
}

export interface CreatePrintHeadingFromPrintHeadingFlatAssignmentNestedActionsForPrintTemplate4Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadings1DataInput {
  id?: string | null;
  title: string;
  order: number;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments1Input | null;
  flatAssignment?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment1Input | null;
  PrintTemplate?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate1Input | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadings1Input {
  data: CreatePrintHeadingFromPrintIssuePrintHeadings1DataInput;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadings2DataInput {
  id?: string | null;
  title: string;
  order: number;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments2Input | null;
  flatAssignment?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment2Input | null;
  PrintTemplate?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate2Input | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadings2Input {
  data: CreatePrintHeadingFromPrintIssuePrintHeadings2DataInput;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadings3DataInput {
  id?: string | null;
  title: string;
  order: number;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments3Input | null;
  flatAssignment?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment3Input | null;
  PrintTemplate?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate3Input | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadings3Input {
  data: CreatePrintHeadingFromPrintIssuePrintHeadings3DataInput;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadings4DataInput {
  id?: string | null;
  title: string;
  order: number;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments4Input | null;
  PrintTemplate?: CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate4Input | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadings4Input {
  data: CreatePrintHeadingFromPrintIssuePrintHeadings4DataInput;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments1Input {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintHeadingAssignments2Input[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintHeadingAssignments2Input[] | null;
  upsert?: UpsertAssignmentFromPrintHeadingAssignments2Input[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments2Input {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintHeadingAssignments3Input[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintHeadingAssignments3Input[] | null;
  upsert?: UpsertAssignmentFromPrintHeadingAssignments3Input[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments3Input {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintHeadingAssignments4Input[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintHeadingAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromPrintHeadingAssignments4Input[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment2Input[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment3Input[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment4Input[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate1Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate2Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate3Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
}

export interface CreatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate4Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
}

export interface CreatePrintHeadingNestedActionsForAssignmentsInput {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintHeadingAssignments1Input[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintHeadingAssignments1Input[] | null;
  upsert?: UpsertAssignmentFromPrintHeadingAssignments1Input[] | null;
}

export interface CreatePrintHeadingNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment1Input[] | null;
}

export interface CreatePrintHeadingNestedActionsForPrintIssueDataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments1Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments1Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments1Input | null;
}

export interface CreatePrintHeadingNestedActionsForPrintTemplateInput {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1Input[] | null;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1DataInput {
  id?: string | null;
  active?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printTemplate: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate1DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1Input {
  data: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2DataInput {
  id?: string | null;
  active?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printTemplate: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate2DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input {
  data: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3DataInput {
  id?: string | null;
  active?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printTemplate: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate3DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input {
  data: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4DataInput {
  id?: string | null;
  active?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printTemplate: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate4DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input {
  data: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1DataInput {
  id?: string | null;
  active?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printHeading: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading1DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1Input {
  data: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2DataInput {
  id?: string | null;
  active?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printHeading: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading2DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2Input {
  data: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3DataInput {
  id?: string | null;
  active?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printHeading: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading3DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3Input {
  data: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4DataInput {
  id?: string | null;
  active?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printHeading: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading4DataInput;
}

export interface CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4Input {
  data: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4DataInput;
}

export interface CreatePrintIssueDataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication: CreatePrintIssueNestedActionsForPrintPublicationDataInput;
  assignments?: CreatePrintIssueNestedActionsForAssignmentsInput | null;
  flatAssignment?: CreatePrintIssueNestedActionsForFlatAssignmentInput | null;
  printHeadings?: CreatePrintIssueNestedActionsForPrintHeadingsInput | null;
}

export interface CreatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface CreatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface CreatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface CreatePrintIssueFromPrintHeadingPrintIssueNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface CreatePrintIssueFromPrintIssueAssignments1DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication: CreatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication1DataInput;
  flatAssignment?: CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment1Input | null;
  printHeadings?: CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings1Input | null;
}

export interface CreatePrintIssueFromPrintIssueAssignments1Input {
  data: CreatePrintIssueFromPrintIssueAssignments1DataInput;
}

export interface CreatePrintIssueFromPrintIssueAssignments2DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication: CreatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication2DataInput;
  flatAssignment?: CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment2Input | null;
  printHeadings?: CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings2Input | null;
}

export interface CreatePrintIssueFromPrintIssueAssignments2Input {
  data: CreatePrintIssueFromPrintIssueAssignments2DataInput;
}

export interface CreatePrintIssueFromPrintIssueAssignments3DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication: CreatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication3DataInput;
  flatAssignment?: CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment3Input | null;
  printHeadings?: CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings3Input | null;
}

export interface CreatePrintIssueFromPrintIssueAssignments3Input {
  data: CreatePrintIssueFromPrintIssueAssignments3DataInput;
}

export interface CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment2Input[] | null;
}

export interface CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment3Input[] | null;
}

export interface CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment4Input[] | null;
}

export interface CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings1Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
}

export interface CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings2Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
}

export interface CreatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings3Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
}

export interface CreatePrintIssueFromPrintIssuePrintHeadings4DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  printPublication: CreatePrintIssueFromPrintHeadingPrintIssueNestedActionsForPrintPublication4DataInput;
  assignments?: CreatePrintIssueFromPrintIssuePrintHeadingsNestedActionsForAssignments4Input | null;
}

export interface CreatePrintIssueFromPrintIssuePrintHeadings4Input {
  data: CreatePrintIssueFromPrintIssuePrintHeadings4DataInput;
}

export interface CreatePrintIssueFromPrintIssuePrintHeadingsNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssues1DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments1Input | null;
  flatAssignment?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment1Input | null;
  printHeadings?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings1Input | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssues1Input {
  data: CreatePrintIssueFromPrintPublicationPrintIssues1DataInput;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssues2DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments2Input | null;
  flatAssignment?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment2Input | null;
  printHeadings?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings2Input | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssues2Input {
  data: CreatePrintIssueFromPrintPublicationPrintIssues2DataInput;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssues3DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments3Input | null;
  flatAssignment?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment3Input | null;
  printHeadings?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings3Input | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssues3Input {
  data: CreatePrintIssueFromPrintPublicationPrintIssues3DataInput;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssues4DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments4Input | null;
  printHeadings?: CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings4Input | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssues4Input {
  data: CreatePrintIssueFromPrintPublicationPrintIssues4DataInput;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments1Input {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintIssueAssignments2Input[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintIssueAssignments2Input[] | null;
  upsert?: UpsertAssignmentFromPrintIssueAssignments2Input[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments2Input {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintIssueAssignments3Input[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintIssueAssignments3Input[] | null;
  upsert?: UpsertAssignmentFromPrintIssueAssignments3Input[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments3Input {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintIssueAssignments4Input[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintIssueAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromPrintIssueAssignments4Input[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment2Input[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment3Input[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment4Input[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings1Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings2Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings3Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
}

export interface CreatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings4Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
}

export interface CreatePrintIssueNestedActionsForAssignmentsInput {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintIssueAssignments1Input[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintIssueAssignments1Input[] | null;
  upsert?: UpsertAssignmentFromPrintIssueAssignments1Input[] | null;
}

export interface CreatePrintIssueNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment1Input[] | null;
}

export interface CreatePrintIssueNestedActionsForPrintHeadingsInput {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings1Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings1Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings1Input[] | null;
}

export interface CreatePrintIssueNestedActionsForPrintPublicationDataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments1Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments1Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments1Input | null;
}

export interface CreatePrintPublicationDataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brand: CreatePrintPublicationNestedActionsForBrandDataInput;
  assignments?: CreatePrintPublicationNestedActionsForAssignmentsInput | null;
  flatAssignment?: CreatePrintPublicationNestedActionsForFlatAssignmentInput | null;
  printIssues?: CreatePrintPublicationNestedActionsForPrintIssuesInput | null;
}

export interface CreatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface CreatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface CreatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface CreatePrintPublicationFromBrandPrintPublications2DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintPublicationFromBrandPrintPublicationsNestedActionsForAssignments2Input | null;
  flatAssignment?: CreatePrintPublicationFromBrandPrintPublicationsNestedActionsForFlatAssignment2Input | null;
  printIssues?: CreatePrintPublicationFromBrandPrintPublicationsNestedActionsForPrintIssues2Input | null;
}

export interface CreatePrintPublicationFromBrandPrintPublications2Input {
  data: CreatePrintPublicationFromBrandPrintPublications2DataInput;
}

export interface CreatePrintPublicationFromBrandPrintPublications4DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintPublicationFromBrandPrintPublicationsNestedActionsForAssignments4Input | null;
  printIssues?: CreatePrintPublicationFromBrandPrintPublicationsNestedActionsForPrintIssues4Input | null;
}

export interface CreatePrintPublicationFromBrandPrintPublications4Input {
  data: CreatePrintPublicationFromBrandPrintPublications4DataInput;
}

export interface CreatePrintPublicationFromBrandPrintPublicationsNestedActionsForAssignments2Input {
  connect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintPublicationAssignments3Input[] | null;
  delete?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintPublicationAssignments3Input[] | null;
  upsert?: UpsertAssignmentFromPrintPublicationAssignments3Input[] | null;
}

export interface CreatePrintPublicationFromBrandPrintPublicationsNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
}

export interface CreatePrintPublicationFromBrandPrintPublicationsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintPublicationFlatAssignment3Input[] | null;
}

export interface CreatePrintPublicationFromBrandPrintPublicationsNestedActionsForPrintIssues2Input {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreatePrintIssueFromPrintPublicationPrintIssues3Input[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdatePrintIssueFromPrintPublicationPrintIssues3Input[] | null;
  upsert?: UpsertPrintIssueFromPrintPublicationPrintIssues3Input[] | null;
}

export interface CreatePrintPublicationFromBrandPrintPublicationsNestedActionsForPrintIssues4Input {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
}

export interface CreatePrintPublicationFromPrintIssuePrintPublicationNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface CreatePrintPublicationFromPrintPublicationAssignments1DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brand: CreatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand1DataInput;
  flatAssignment?: CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment1Input | null;
  printIssues?: CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues1Input | null;
}

export interface CreatePrintPublicationFromPrintPublicationAssignments1Input {
  data: CreatePrintPublicationFromPrintPublicationAssignments1DataInput;
}

export interface CreatePrintPublicationFromPrintPublicationAssignments2DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brand: CreatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand2DataInput;
  flatAssignment?: CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment2Input | null;
  printIssues?: CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues2Input | null;
}

export interface CreatePrintPublicationFromPrintPublicationAssignments2Input {
  data: CreatePrintPublicationFromPrintPublicationAssignments2DataInput;
}

export interface CreatePrintPublicationFromPrintPublicationAssignments3DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brand: CreatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand3DataInput;
  flatAssignment?: CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment3Input | null;
  printIssues?: CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues3Input | null;
}

export interface CreatePrintPublicationFromPrintPublicationAssignments3Input {
  data: CreatePrintPublicationFromPrintPublicationAssignments3DataInput;
}

export interface CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintPublicationFlatAssignment2Input[] | null;
}

export interface CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintPublicationFlatAssignment3Input[] | null;
}

export interface CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromPrintPublicationFlatAssignment4Input[] | null;
}

export interface CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues1Input {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreatePrintIssueFromPrintPublicationPrintIssues2Input[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdatePrintIssueFromPrintPublicationPrintIssues2Input[] | null;
  upsert?: UpsertPrintIssueFromPrintPublicationPrintIssues2Input[] | null;
}

export interface CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues2Input {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreatePrintIssueFromPrintPublicationPrintIssues3Input[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdatePrintIssueFromPrintPublicationPrintIssues3Input[] | null;
  upsert?: UpsertPrintIssueFromPrintPublicationPrintIssues3Input[] | null;
}

export interface CreatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues3Input {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreatePrintIssueFromPrintPublicationPrintIssues4Input[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdatePrintIssueFromPrintPublicationPrintIssues4Input[] | null;
  upsert?: UpsertPrintIssueFromPrintPublicationPrintIssues4Input[] | null;
}

export interface CreatePrintPublicationFromPrintPublicationPrintIssues4DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brand: CreatePrintPublicationFromPrintIssuePrintPublicationNestedActionsForBrand4DataInput;
  assignments?: CreatePrintPublicationFromPrintPublicationPrintIssuesNestedActionsForAssignments4Input | null;
}

export interface CreatePrintPublicationFromPrintPublicationPrintIssues4Input {
  data: CreatePrintPublicationFromPrintPublicationPrintIssues4DataInput;
}

export interface CreatePrintPublicationFromPrintPublicationPrintIssuesNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
}

export interface CreatePrintPublicationNestedActionsForAssignmentsInput {
  connect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintPublicationAssignments1Input[] | null;
  delete?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintPublicationAssignments1Input[] | null;
  upsert?: UpsertAssignmentFromPrintPublicationAssignments1Input[] | null;
}

export interface CreatePrintPublicationNestedActionsForBrandDataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment1Input | null;
  update?: UpdateBrandFromBrandFlatAssignment1Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment1Input | null;
}

export interface CreatePrintPublicationNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromPrintPublicationFlatAssignment1Input[] | null;
}

export interface CreatePrintPublicationNestedActionsForPrintIssuesInput {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreatePrintIssueFromPrintPublicationPrintIssues1Input[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdatePrintIssueFromPrintPublicationPrintIssues1Input[] | null;
  upsert?: UpsertPrintIssueFromPrintPublicationPrintIssues1Input[] | null;
}

export interface CreatePrintTemplateDataInput {
  id?: string | null;
  S3ObjectId: string;
  label: string;
  filename: string;
  filesize: number;
  type?: TemplateType | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  articleTemplates?: CreatePrintTemplateNestedActionsForArticleTemplatesInput | null;
  assignments?: CreatePrintTemplateNestedActionsForAssignmentsInput | null;
  flatAssignment?: CreatePrintTemplateNestedActionsForFlatAssignmentInput | null;
  PrintHeading?: CreatePrintTemplateNestedActionsForPrintHeadingInput | null;
}

export interface CreatePrintTemplateFromPrintTemplateArticleTemplates1DataInput {
  id?: string | null;
  S3ObjectId: string;
  label: string;
  filename: string;
  filesize: number;
  type?: TemplateType | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments1Input | null;
  flatAssignment?: CreatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForFlatAssignment1Input | null;
  PrintHeading?: CreatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForPrintHeading1Input | null;
}

export interface CreatePrintTemplateFromPrintTemplateArticleTemplates1Input {
  data: CreatePrintTemplateFromPrintTemplateArticleTemplates1DataInput;
}

export interface CreatePrintTemplateFromPrintTemplateArticleTemplates4DataInput {
  id?: string | null;
  S3ObjectId: string;
  label: string;
  filename: string;
  filesize: number;
  type?: TemplateType | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments4Input | null;
  PrintHeading?: CreatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForPrintHeading4Input | null;
}

export interface CreatePrintTemplateFromPrintTemplateArticleTemplates4Input {
  data: CreatePrintTemplateFromPrintTemplateArticleTemplates4DataInput;
}

export interface CreatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments1Input {
  connect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintTemplateAssignments2Input[] | null;
  delete?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintTemplateAssignments2Input[] | null;
  upsert?: UpsertAssignmentFromPrintTemplateAssignments2Input[] | null;
}

export interface CreatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
}

export interface CreatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintTemplateFlatAssignment2Input[] | null;
}

export interface CreatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForPrintHeading1Input {
  connect?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading2Input[] | null;
}

export interface CreatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForPrintHeading4Input {
  connect?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
}

export interface CreatePrintTemplateFromPrintTemplateAssignments2DataInput {
  id?: string | null;
  S3ObjectId: string;
  label: string;
  filename: string;
  filesize: number;
  type?: TemplateType | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  articleTemplates?: CreatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForArticleTemplates2Input | null;
  flatAssignment?: CreatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForFlatAssignment2Input | null;
  PrintHeading?: CreatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForPrintHeading2Input | null;
}

export interface CreatePrintTemplateFromPrintTemplateAssignments2Input {
  data: CreatePrintTemplateFromPrintTemplateAssignments2DataInput;
}

export interface CreatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForArticleTemplates2Input {
  connect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateArticleTemplateFromPrintTemplateArticleTemplates3Input[] | null;
  delete?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateArticleTemplateFromPrintTemplateArticleTemplates3Input[] | null;
  upsert?: UpsertArticleTemplateFromPrintTemplateArticleTemplates3Input[] | null;
}

export interface CreatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintTemplateFlatAssignment3Input[] | null;
}

export interface CreatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForPrintHeading2Input {
  connect?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading3Input[] | null;
}

export interface CreatePrintTemplateFromPrintTemplateFlatAssignment3DataInput {
  id?: string | null;
  S3ObjectId: string;
  label: string;
  filename: string;
  filesize: number;
  type?: TemplateType | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  articleTemplates?: CreatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForArticleTemplates3Input | null;
  assignments?: CreatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForAssignments3Input | null;
  PrintHeading?: CreatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForPrintHeading3Input | null;
}

export interface CreatePrintTemplateFromPrintTemplateFlatAssignment3Input {
  data: CreatePrintTemplateFromPrintTemplateFlatAssignment3DataInput;
}

export interface CreatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForArticleTemplates3Input {
  connect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateArticleTemplateFromPrintTemplateArticleTemplates4Input[] | null;
  delete?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateArticleTemplateFromPrintTemplateArticleTemplates4Input[] | null;
  upsert?: UpsertArticleTemplateFromPrintTemplateArticleTemplates4Input[] | null;
}

export interface CreatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForAssignments3Input {
  connect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintTemplateAssignments4Input[] | null;
  delete?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintTemplateAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromPrintTemplateAssignments4Input[] | null;
}

export interface CreatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForPrintHeading3Input {
  connect?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading4Input[] | null;
}

export interface CreatePrintTemplateNestedActionsForArticleTemplatesInput {
  connect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateArticleTemplateFromPrintTemplateArticleTemplates1Input[] | null;
  delete?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateArticleTemplateFromPrintTemplateArticleTemplates1Input[] | null;
  upsert?: UpsertArticleTemplateFromPrintTemplateArticleTemplates1Input[] | null;
}

export interface CreatePrintTemplateNestedActionsForAssignmentsInput {
  connect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintTemplateAssignments1Input[] | null;
  delete?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintTemplateAssignments1Input[] | null;
  upsert?: UpsertAssignmentFromPrintTemplateAssignments1Input[] | null;
}

export interface CreatePrintTemplateNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromPrintTemplateFlatAssignment1Input[] | null;
}

export interface CreatePrintTemplateNestedActionsForPrintHeadingInput {
  connect?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading1Input[] | null;
}

export interface CreateRawArticleDataInput {
  id?: string | null;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignment?: CreateRawArticleNestedActionsForAssignmentInput | null;
  flatAssignment?: CreateRawArticleNestedActionsForFlatAssignmentInput | null;
  versions?: CreateRawArticleNestedActionsForVersionsInput | null;
}

export interface CreateRawArticleFromRawArticleAssignment1DataInput {
  id?: string | null;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  flatAssignment?: CreateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment1Input | null;
  versions?: CreateRawArticleFromRawArticleAssignmentNestedActionsForVersions1Input | null;
}

export interface CreateRawArticleFromRawArticleAssignment1Input {
  data: CreateRawArticleFromRawArticleAssignment1DataInput;
}

export interface CreateRawArticleFromRawArticleAssignment2DataInput {
  id?: string | null;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  flatAssignment?: CreateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment2Input | null;
  versions?: CreateRawArticleFromRawArticleAssignmentNestedActionsForVersions2Input | null;
}

export interface CreateRawArticleFromRawArticleAssignment2Input {
  data: CreateRawArticleFromRawArticleAssignment2DataInput;
}

export interface CreateRawArticleFromRawArticleAssignment3DataInput {
  id?: string | null;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  flatAssignment?: CreateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment3Input | null;
  versions?: CreateRawArticleFromRawArticleAssignmentNestedActionsForVersions3Input | null;
}

export interface CreateRawArticleFromRawArticleAssignment3Input {
  data: CreateRawArticleFromRawArticleAssignment3DataInput;
}

export interface CreateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromRawArticleFlatAssignment2Input | null;
}

export interface CreateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromRawArticleFlatAssignment3Input | null;
}

export interface CreateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromRawArticleFlatAssignment4Input | null;
}

export interface CreateRawArticleFromRawArticleAssignmentNestedActionsForVersions1Input {
  create?: CreateRawArticleVersionFromRawArticleVersions2Input[] | null;
}

export interface CreateRawArticleFromRawArticleAssignmentNestedActionsForVersions2Input {
  create?: CreateRawArticleVersionFromRawArticleVersions3Input[] | null;
}

export interface CreateRawArticleFromRawArticleAssignmentNestedActionsForVersions3Input {
  create?: CreateRawArticleVersionFromRawArticleVersions4Input[] | null;
}

export interface CreateRawArticleFromRawArticleFlatAssignment4DataInput {
  id?: string | null;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignment?: CreateRawArticleFromRawArticleFlatAssignmentNestedActionsForAssignment4Input | null;
}

export interface CreateRawArticleFromRawArticleFlatAssignment4Input {
  data: CreateRawArticleFromRawArticleFlatAssignment4DataInput;
}

export interface CreateRawArticleFromRawArticleFlatAssignmentNestedActionsForAssignment4Input {
  connect?: AssignmentFromRawArticleNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface CreateRawArticleNestedActionsForAssignmentInput {
  connect?: AssignmentFromRawArticleNodeSelectionInput | null;
  create?: CreateAssignmentFromRawArticleAssignment1Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateAssignmentFromRawArticleAssignment1Input | null;
  upsert?: UpsertAssignmentFromRawArticleAssignment1Input | null;
}

export interface CreateRawArticleNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromRawArticleFlatAssignment1Input | null;
}

export interface CreateRawArticleNestedActionsForVersionsInput {
  create?: CreateRawArticleVersionFromRawArticleVersions1Input[] | null;
}

export interface CreateRawArticleVersionDataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  rawArticle: CreateRawArticleVersionNestedActionsForRawArticleDataInput;
  previousVersion?: CreateRawArticleVersionNestedActionsForPreviousVersionDataInput | null;
  forkOf?: CreateRawArticleVersionNestedActionsForForkOfDataInput | null;
  nextVersion?: CreateRawArticleVersionNestedActionsForNextVersionInput | null;
  rawArticleVersions?: CreateRawArticleVersionNestedActionsForRawArticleVersionsInput | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForPreviousVersion1DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForPreviousVersion2DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForPreviousVersion3DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion4Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForPreviousVersion4DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersion1DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  rawArticle: CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForRawArticle1DataInput;
  forkOf?: CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForForkOf1DataInput | null;
  rawArticleVersions?: CreateRawArticleVersionFromRawArticleVersionNextVersionNestedActionsForRawArticleVersions1Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersion1Input {
  data: CreateRawArticleVersionFromRawArticleVersionNextVersion1DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersion2DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  rawArticle: CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForRawArticle2DataInput;
  forkOf?: CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForForkOf2DataInput | null;
  rawArticleVersions?: CreateRawArticleVersionFromRawArticleVersionNextVersionNestedActionsForRawArticleVersions2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersion2Input {
  data: CreateRawArticleVersionFromRawArticleVersionNextVersion2DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersion3DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  rawArticle: CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForRawArticle3DataInput;
  forkOf?: CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForForkOf3DataInput | null;
  rawArticleVersions?: CreateRawArticleVersionFromRawArticleVersionNextVersionNestedActionsForRawArticleVersions3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersion3Input {
  data: CreateRawArticleVersionFromRawArticleVersionNextVersion3DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersion4DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  rawArticle: CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForRawArticle4DataInput;
  forkOf?: CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForForkOf4DataInput | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersion4Input {
  data: CreateRawArticleVersionFromRawArticleVersionNextVersion4DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersionNestedActionsForRawArticleVersions1Input {
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions2Input[] | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersionNestedActionsForRawArticleVersions2Input {
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions3Input[] | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionNextVersionNestedActionsForRawArticleVersions3Input {
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions4Input[] | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForForkOf1DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForForkOf2DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForForkOf3DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions4Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForForkOf4DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionPreviousVersionNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForForkOf1DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForForkOf2DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForForkOf3DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions4Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForForkOf4DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForPreviousVersion1DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForPreviousVersion2DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForPreviousVersion3DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion4Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForPreviousVersion4DataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersions1DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  rawArticle: CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForRawArticle1DataInput;
  previousVersion?: CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForPreviousVersion1DataInput | null;
  nextVersion?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersionsNestedActionsForNextVersion1Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersions1Input {
  data: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions1DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersions2DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  rawArticle: CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForRawArticle2DataInput;
  previousVersion?: CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForPreviousVersion2DataInput | null;
  nextVersion?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersionsNestedActionsForNextVersion2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersions2Input {
  data: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions2DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersions3DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  rawArticle: CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForRawArticle3DataInput;
  previousVersion?: CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForPreviousVersion3DataInput | null;
  nextVersion?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersionsNestedActionsForNextVersion3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersions3Input {
  data: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions3DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersions4DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  rawArticle: CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForRawArticle4DataInput;
  previousVersion?: CreateRawArticleVersionFromRawArticleVersionForkOfNestedActionsForPreviousVersion4DataInput | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersions4Input {
  data: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions4DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersionsNestedActionsForNextVersion1Input {
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersionsNestedActionsForNextVersion2Input {
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionRawArticleVersionsNestedActionsForNextVersion3Input {
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion4Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersions1DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  previousVersion?: CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForPreviousVersion1DataInput | null;
  forkOf?: CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForForkOf1DataInput | null;
  nextVersion?: CreateRawArticleVersionFromRawArticleVersionsNestedActionsForNextVersion1Input | null;
  rawArticleVersions?: CreateRawArticleVersionFromRawArticleVersionsNestedActionsForRawArticleVersions1Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersions1Input {
  data: CreateRawArticleVersionFromRawArticleVersions1DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersions2DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  previousVersion?: CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForPreviousVersion2DataInput | null;
  forkOf?: CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForForkOf2DataInput | null;
  nextVersion?: CreateRawArticleVersionFromRawArticleVersionsNestedActionsForNextVersion2Input | null;
  rawArticleVersions?: CreateRawArticleVersionFromRawArticleVersionsNestedActionsForRawArticleVersions2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersions2Input {
  data: CreateRawArticleVersionFromRawArticleVersions2DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersions3DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  previousVersion?: CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForPreviousVersion3DataInput | null;
  forkOf?: CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForForkOf3DataInput | null;
  nextVersion?: CreateRawArticleVersionFromRawArticleVersionsNestedActionsForNextVersion3Input | null;
  rawArticleVersions?: CreateRawArticleVersionFromRawArticleVersionsNestedActionsForRawArticleVersions3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersions3Input {
  data: CreateRawArticleVersionFromRawArticleVersions3DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersions4DataInput {
  id?: string | null;
  editorId?: string | null;
  title?: string | null;
  lead?: string | null;
  body?: string | null;
  signature?: string | null;
  status?: RawArticleStatus | null;
  comment?: string | null;
  leftOver?: string | null;
  createdAt?: GraphQL$DateTime | null;
  previousVersion?: CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForPreviousVersion4DataInput | null;
  forkOf?: CreateRawArticleVersionFromRawArticleVersionRawArticleNestedActionsForForkOf4DataInput | null;
}

export interface CreateRawArticleVersionFromRawArticleVersions4Input {
  data: CreateRawArticleVersionFromRawArticleVersions4DataInput;
}

export interface CreateRawArticleVersionFromRawArticleVersionsNestedActionsForNextVersion1Input {
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion2Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionsNestedActionsForNextVersion2Input {
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion3Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionsNestedActionsForNextVersion3Input {
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion4Input | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionsNestedActionsForRawArticleVersions1Input {
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions2Input[] | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionsNestedActionsForRawArticleVersions2Input {
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions3Input[] | null;
}

export interface CreateRawArticleVersionFromRawArticleVersionsNestedActionsForRawArticleVersions3Input {
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions4Input[] | null;
}

export interface CreateRawArticleVersionNestedActionsForForkOfDataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions1Input | null;
}

export interface CreateRawArticleVersionNestedActionsForNextVersionInput {
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion1Input | null;
}

export interface CreateRawArticleVersionNestedActionsForPreviousVersionDataInput {
  connect?: RawArticleVersionNodeSelectionInput | null;
  create?: CreateRawArticleVersionFromRawArticleVersionNextVersion1Input | null;
}

export interface CreateRawArticleVersionNestedActionsForRawArticleDataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment1Input | null;
  update?: UpdateRawArticleFromRawArticleAssignment1Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment1Input | null;
}

export interface CreateRawArticleVersionNestedActionsForRawArticleVersionsInput {
  create?: CreateRawArticleVersionFromRawArticleVersionRawArticleVersions1Input[] | null;
}

export interface CreateSubSubjectFromSubjectSubSubjects1DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubSubjectFromSubjectSubSubjects1Input {
  data: CreateSubSubjectFromSubjectSubSubjects1DataInput;
}

export interface CreateSubSubjectFromSubjectSubSubjects2DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubSubjectFromSubjectSubSubjects2Input {
  data: CreateSubSubjectFromSubjectSubSubjects2DataInput;
}

export interface CreateSubSubjectFromSubjectSubSubjects3DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubSubjectFromSubjectSubSubjects3Input {
  data: CreateSubSubjectFromSubjectSubSubjects3DataInput;
}

export interface CreateSubSubjectFromSubjectSubSubjects4DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubSubjectFromSubjectSubSubjects4Input {
  data: CreateSubSubjectFromSubjectSubSubjects4DataInput;
}

export interface CreateSubjectCategoryFromSubjectCategoryChildren2DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit: CreateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit2DataInput;
  subjects?: CreateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects2Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryChildren2Input {
  data: CreateSubjectCategoryFromSubjectCategoryChildren2DataInput;
}

export interface CreateSubjectCategoryFromSubjectCategoryChildren3DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit: CreateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit3DataInput;
  subjects?: CreateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects3Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryChildren3Input {
  data: CreateSubjectCategoryFromSubjectCategoryChildren3DataInput;
}

export interface CreateSubjectCategoryFromSubjectCategoryChildren4DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit: CreateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit4DataInput;
  subjects?: CreateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects4Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryChildren4Input {
  data: CreateSubjectCategoryFromSubjectCategoryChildren4DataInput;
}

export interface CreateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects2Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  create?: CreateSubjectFromSubjectCategorySubjects3Input[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  update?: UpdateSubjectFromSubjectCategorySubjects3Input[] | null;
  upsert?: UpsertSubjectFromSubjectCategorySubjects3Input[] | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects3Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  create?: CreateSubjectFromSubjectCategorySubjects4Input[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  update?: UpdateSubjectFromSubjectCategorySubjects4Input[] | null;
  upsert?: UpsertSubjectFromSubjectCategorySubjects4Input[] | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects4Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit2DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects3Input | null;
  update?: UpdateUnitFromUnitSubjects3Input | null;
  upsert?: UpsertUnitFromUnitSubjects3Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjects1DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  parent?: CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent1DataInput | null;
  unit: CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit1DataInput;
  children?: CreateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren1Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjects1Input {
  data: CreateSubjectCategoryFromSubjectCategorySubjects1DataInput;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjects2DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  parent?: CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent2DataInput | null;
  unit: CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit2DataInput;
  children?: CreateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren2Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjects2Input {
  data: CreateSubjectCategoryFromSubjectCategorySubjects2DataInput;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjects3DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  parent?: CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent3DataInput | null;
  unit: CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit3DataInput;
  children?: CreateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren3Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjects3Input {
  data: CreateSubjectCategoryFromSubjectCategorySubjects3DataInput;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjects4DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  parent?: CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent4DataInput | null;
  unit: CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit4DataInput;
  children?: CreateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren4Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjects4Input {
  data: CreateSubjectCategoryFromSubjectCategorySubjects4DataInput;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren1Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren2Input[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren2Input[] | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren2Input[] | null;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren2Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren3Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
}

export interface CreateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren4Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent2DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren3Input | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren3Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren3Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent3DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren4Input | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren4Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren4Input | null;
}

export interface CreateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent4DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
}

export interface CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent1DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren2Input | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren2Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren2Input | null;
}

export interface CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent2DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren3Input | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren3Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren3Input | null;
}

export interface CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent3DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren4Input | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren4Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren4Input | null;
}

export interface CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent4DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
}

export interface CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit1DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects2Input | null;
  update?: UpdateUnitFromUnitSubjects2Input | null;
  upsert?: UpsertUnitFromUnitSubjects2Input | null;
}

export interface CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit2DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects3Input | null;
  update?: UpdateUnitFromUnitSubjects3Input | null;
  upsert?: UpsertUnitFromUnitSubjects3Input | null;
}

export interface CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface CreateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface CreateSubjectCategoryFromUnitSubjectCategories2DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  parent?: CreateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent2DataInput | null;
  subjects?: CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects2Input | null;
  children?: CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren2Input | null;
}

export interface CreateSubjectCategoryFromUnitSubjectCategories2Input {
  data: CreateSubjectCategoryFromUnitSubjectCategories2DataInput;
}

export interface CreateSubjectCategoryFromUnitSubjectCategories3DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  parent?: CreateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent3DataInput | null;
  subjects?: CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects3Input | null;
  children?: CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren3Input | null;
}

export interface CreateSubjectCategoryFromUnitSubjectCategories3Input {
  data: CreateSubjectCategoryFromUnitSubjectCategories3DataInput;
}

export interface CreateSubjectCategoryFromUnitSubjectCategories4DataInput {
  id?: string | null;
  title: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  parent?: CreateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent4DataInput | null;
  subjects?: CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects4Input | null;
  children?: CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren4Input | null;
}

export interface CreateSubjectCategoryFromUnitSubjectCategories4Input {
  data: CreateSubjectCategoryFromUnitSubjectCategories4DataInput;
}

export interface CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren2Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
}

export interface CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren3Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
}

export interface CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren4Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
}

export interface CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects2Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  create?: CreateSubjectFromSubjectCategorySubjects3Input[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  update?: UpdateSubjectFromSubjectCategorySubjects3Input[] | null;
  upsert?: UpsertSubjectFromSubjectCategorySubjects3Input[] | null;
}

export interface CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects3Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  create?: CreateSubjectFromSubjectCategorySubjects4Input[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  update?: UpdateSubjectFromSubjectCategorySubjects4Input[] | null;
  upsert?: UpsertSubjectFromSubjectCategorySubjects4Input[] | null;
}

export interface CreateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects4Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
}

export interface CreateSubjectDataInput {
  id?: string | null;
  title: string;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subjectCategory?: CreateSubjectNestedActionsForSubjectCategoryDataInput | null;
  unit: CreateSubjectNestedActionsForUnitDataInput;
  assignments?: CreateSubjectNestedActionsForAssignmentsInput | null;
  attachments?: CreateSubjectNestedActionsForAttachmentsInput | null;
  flatAssignment?: CreateSubjectNestedActionsForFlatAssignmentInput | null;
  subSubjects?: CreateSubjectNestedActionsForSubSubjectsInput | null;
  subjectTags?: CreateSubjectNestedActionsForSubjectTagsInput | null;
  subjectUsers?: CreateSubjectNestedActionsForSubjectUsersInput | null;
}

export interface CreateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory1DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategorySubjects2Input | null;
  update?: UpdateSubjectCategoryFromSubjectCategorySubjects2Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategorySubjects2Input | null;
}

export interface CreateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory2DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategorySubjects3Input | null;
  update?: UpdateSubjectCategoryFromSubjectCategorySubjects3Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategorySubjects3Input | null;
}

export interface CreateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory3DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategorySubjects4Input | null;
  update?: UpdateSubjectCategoryFromSubjectCategorySubjects4Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategorySubjects4Input | null;
}

export interface CreateSubjectFromAssignmentSubjectNestedActionsForUnit1DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects2Input | null;
  update?: UpdateUnitFromUnitSubjects2Input | null;
  upsert?: UpsertUnitFromUnitSubjects2Input | null;
}

export interface CreateSubjectFromAssignmentSubjectNestedActionsForUnit2DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects3Input | null;
  update?: UpdateUnitFromUnitSubjects3Input | null;
  upsert?: UpsertUnitFromUnitSubjects3Input | null;
}

export interface CreateSubjectFromAssignmentSubjectNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface CreateSubjectFromFlatAssignmentSubjectNestedActionsForSubjectCategory4DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
}

export interface CreateSubjectFromFlatAssignmentSubjectNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface CreateSubjectFromSubjectAssignments1DataInput {
  id?: string | null;
  title: string;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subjectCategory?: CreateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory1DataInput | null;
  unit: CreateSubjectFromAssignmentSubjectNestedActionsForUnit1DataInput;
  attachments?: CreateSubjectFromSubjectAssignmentsNestedActionsForAttachments1Input | null;
  flatAssignment?: CreateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment1Input | null;
  subSubjects?: CreateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects1Input | null;
  subjectTags?: CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags1Input | null;
  subjectUsers?: CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers1Input | null;
}

export interface CreateSubjectFromSubjectAssignments1Input {
  data: CreateSubjectFromSubjectAssignments1DataInput;
}

export interface CreateSubjectFromSubjectAssignments2DataInput {
  id?: string | null;
  title: string;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subjectCategory?: CreateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory2DataInput | null;
  unit: CreateSubjectFromAssignmentSubjectNestedActionsForUnit2DataInput;
  attachments?: CreateSubjectFromSubjectAssignmentsNestedActionsForAttachments2Input | null;
  flatAssignment?: CreateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment2Input | null;
  subSubjects?: CreateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects2Input | null;
  subjectTags?: CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags2Input | null;
  subjectUsers?: CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers2Input | null;
}

export interface CreateSubjectFromSubjectAssignments2Input {
  data: CreateSubjectFromSubjectAssignments2DataInput;
}

export interface CreateSubjectFromSubjectAssignments3DataInput {
  id?: string | null;
  title: string;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subjectCategory?: CreateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory3DataInput | null;
  unit: CreateSubjectFromAssignmentSubjectNestedActionsForUnit3DataInput;
  attachments?: CreateSubjectFromSubjectAssignmentsNestedActionsForAttachments3Input | null;
  flatAssignment?: CreateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment3Input | null;
  subSubjects?: CreateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects3Input | null;
  subjectTags?: CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags3Input | null;
  subjectUsers?: CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers3Input | null;
}

export interface CreateSubjectFromSubjectAssignments3Input {
  data: CreateSubjectFromSubjectAssignments3DataInput;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForAttachments1Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments2Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments2Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments2Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForAttachments2Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments3Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments3Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments3Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForAttachments3Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments4Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments4Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments4Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment2Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment3Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment4Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects1Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects2Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects2Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects2Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects2Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects3Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects3Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects3Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects3Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects4Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects4Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects4Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags1Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags2Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags2Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags2Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags2Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags3Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers1Input {
  create?: CreateSubjectUserFromSubjectSubjectUsers2Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers2Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers2Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers2Input {
  create?: CreateSubjectUserFromSubjectSubjectUsers3Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers3Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers3Input[] | null;
}

export interface CreateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers3Input {
  create?: CreateSubjectUserFromSubjectSubjectUsers4Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers4Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers4Input[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjects3DataInput {
  id?: string | null;
  title: string;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit: CreateSubjectFromSubjectSubjectCategoryNestedActionsForUnit3DataInput;
  assignments?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForAssignments3Input | null;
  attachments?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForAttachments3Input | null;
  flatAssignment?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForFlatAssignment3Input | null;
  subSubjects?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubSubjects3Input | null;
  subjectTags?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectTags3Input | null;
  subjectUsers?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectUsers3Input | null;
}

export interface CreateSubjectFromSubjectCategorySubjects3Input {
  data: CreateSubjectFromSubjectCategorySubjects3DataInput;
}

export interface CreateSubjectFromSubjectCategorySubjects4DataInput {
  id?: string | null;
  title: string;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  unit: CreateSubjectFromSubjectSubjectCategoryNestedActionsForUnit4DataInput;
  assignments?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForAssignments4Input | null;
  attachments?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForAttachments4Input | null;
  subSubjects?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubSubjects4Input | null;
  subjectTags?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectTags4Input | null;
  subjectUsers?: CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectUsers4Input | null;
}

export interface CreateSubjectFromSubjectCategorySubjects4Input {
  data: CreateSubjectFromSubjectCategorySubjects4DataInput;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForAssignments3Input {
  connect?: AssignmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAssignmentFromSubjectAssignments4Input[] | null;
  delete?: AssignmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromSubjectAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromSubjectAssignments4Input[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForAssignments4Input {
  connect?: AssignmentFromSubjectNodeSelectionInput[] | null;
  delete?: AssignmentFromSubjectNodeSelectionInput[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForAttachments3Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments4Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments4Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments4Input[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForAttachments4Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment4Input[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubSubjects3Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects4Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects4Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects4Input[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubSubjects4Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectTags3Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectTags4Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectUsers3Input {
  create?: CreateSubjectUserFromSubjectSubjectUsers4Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers4Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers4Input[] | null;
}

export interface CreateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectUsers4Input {
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
}

export interface CreateSubjectFromSubjectFlatAssignment4DataInput {
  id?: string | null;
  title: string;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subjectCategory?: CreateSubjectFromFlatAssignmentSubjectNestedActionsForSubjectCategory4DataInput | null;
  unit: CreateSubjectFromFlatAssignmentSubjectNestedActionsForUnit4DataInput;
  assignments?: CreateSubjectFromSubjectFlatAssignmentNestedActionsForAssignments4Input | null;
  attachments?: CreateSubjectFromSubjectFlatAssignmentNestedActionsForAttachments4Input | null;
  subSubjects?: CreateSubjectFromSubjectFlatAssignmentNestedActionsForSubSubjects4Input | null;
  subjectTags?: CreateSubjectFromSubjectFlatAssignmentNestedActionsForSubjectTags4Input | null;
  subjectUsers?: CreateSubjectFromSubjectFlatAssignmentNestedActionsForSubjectUsers4Input | null;
}

export interface CreateSubjectFromSubjectFlatAssignment4Input {
  data: CreateSubjectFromSubjectFlatAssignment4DataInput;
}

export interface CreateSubjectFromSubjectFlatAssignmentNestedActionsForAssignments4Input {
  connect?: AssignmentFromSubjectNodeSelectionInput[] | null;
  delete?: AssignmentFromSubjectNodeSelectionInput[] | null;
}

export interface CreateSubjectFromSubjectFlatAssignmentNestedActionsForAttachments4Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
}

export interface CreateSubjectFromSubjectFlatAssignmentNestedActionsForSubSubjects4Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
}

export interface CreateSubjectFromSubjectFlatAssignmentNestedActionsForSubjectTags4Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
}

export interface CreateSubjectFromSubjectFlatAssignmentNestedActionsForSubjectUsers4Input {
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
}

export interface CreateSubjectFromSubjectSubjectCategoryNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface CreateSubjectFromSubjectSubjectCategoryNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface CreateSubjectFromSubjectUnitNestedActionsForSubjectCategory2DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategorySubjects3Input | null;
  update?: UpdateSubjectCategoryFromSubjectCategorySubjects3Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategorySubjects3Input | null;
}

export interface CreateSubjectFromUnitSubjects2DataInput {
  id?: string | null;
  title: string;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subjectCategory?: CreateSubjectFromSubjectUnitNestedActionsForSubjectCategory2DataInput | null;
  assignments?: CreateSubjectFromUnitSubjectsNestedActionsForAssignments2Input | null;
  attachments?: CreateSubjectFromUnitSubjectsNestedActionsForAttachments2Input | null;
  flatAssignment?: CreateSubjectFromUnitSubjectsNestedActionsForFlatAssignment2Input | null;
  subSubjects?: CreateSubjectFromUnitSubjectsNestedActionsForSubSubjects2Input | null;
  subjectTags?: CreateSubjectFromUnitSubjectsNestedActionsForSubjectTags2Input | null;
  subjectUsers?: CreateSubjectFromUnitSubjectsNestedActionsForSubjectUsers2Input | null;
}

export interface CreateSubjectFromUnitSubjects2Input {
  data: CreateSubjectFromUnitSubjects2DataInput;
}

export interface CreateSubjectFromUnitSubjectsNestedActionsForAssignments2Input {
  connect?: AssignmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAssignmentFromSubjectAssignments3Input[] | null;
  delete?: AssignmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromSubjectAssignments3Input[] | null;
  upsert?: UpsertAssignmentFromSubjectAssignments3Input[] | null;
}

export interface CreateSubjectFromUnitSubjectsNestedActionsForAttachments2Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments3Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments3Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments3Input[] | null;
}

export interface CreateSubjectFromUnitSubjectsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment3Input[] | null;
}

export interface CreateSubjectFromUnitSubjectsNestedActionsForSubSubjects2Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects3Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects3Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects3Input[] | null;
}

export interface CreateSubjectFromUnitSubjectsNestedActionsForSubjectTags2Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
}

export interface CreateSubjectFromUnitSubjectsNestedActionsForSubjectUsers2Input {
  create?: CreateSubjectUserFromSubjectSubjectUsers3Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers3Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers3Input[] | null;
}

export interface CreateSubjectNestedActionsForAssignmentsInput {
  connect?: AssignmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAssignmentFromSubjectAssignments1Input[] | null;
  delete?: AssignmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromSubjectAssignments1Input[] | null;
  upsert?: UpsertAssignmentFromSubjectAssignments1Input[] | null;
}

export interface CreateSubjectNestedActionsForAttachmentsInput {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments1Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments1Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments1Input[] | null;
}

export interface CreateSubjectNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment1Input[] | null;
}

export interface CreateSubjectNestedActionsForSubSubjectsInput {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects1Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects1Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects1Input[] | null;
}

export interface CreateSubjectNestedActionsForSubjectCategoryDataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategorySubjects1Input | null;
  update?: UpdateSubjectCategoryFromSubjectCategorySubjects1Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategorySubjects1Input | null;
}

export interface CreateSubjectNestedActionsForSubjectTagsInput {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags1Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags1Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags1Input[] | null;
}

export interface CreateSubjectNestedActionsForSubjectUsersInput {
  create?: CreateSubjectUserFromSubjectSubjectUsers1Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers1Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers1Input[] | null;
}

export interface CreateSubjectNestedActionsForUnitDataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitBrands1Input | null;
  update?: UpdateUnitFromUnitBrands1Input | null;
  upsert?: UpsertUnitFromUnitBrands1Input | null;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag1DataInput {
  connect?: SubjectTagNodeSelectionInput | null;
  create?: CreateSubjectTagFromSubjectTagSubjects2Input | null;
  update?: UpdateSubjectTagFromSubjectTagSubjects2Input | null;
  upsert?: UpsertSubjectTagFromSubjectTagSubjects2Input | null;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag2DataInput {
  connect?: SubjectTagNodeSelectionInput | null;
  create?: CreateSubjectTagFromSubjectTagSubjects3Input | null;
  update?: UpdateSubjectTagFromSubjectTagSubjects3Input | null;
  upsert?: UpsertSubjectTagFromSubjectTagSubjects3Input | null;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag3DataInput {
  connect?: SubjectTagNodeSelectionInput | null;
  create?: CreateSubjectTagFromSubjectTagSubjects4Input | null;
  update?: UpdateSubjectTagFromSubjectTagSubjects4Input | null;
  upsert?: UpsertSubjectTagFromSubjectTagSubjects4Input | null;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag4DataInput {
  connect?: SubjectTagNodeSelectionInput | null;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTags1DataInput {
  id?: string | null;
  order?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subjectTag: CreateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag1DataInput;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTags1Input {
  data: CreateSubjectSubjectTagFromSubjectSubjectTags1DataInput;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTags2DataInput {
  id?: string | null;
  order?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subjectTag: CreateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag2DataInput;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTags2Input {
  data: CreateSubjectSubjectTagFromSubjectSubjectTags2DataInput;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTags3DataInput {
  id?: string | null;
  order?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subjectTag: CreateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag3DataInput;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTags3Input {
  data: CreateSubjectSubjectTagFromSubjectSubjectTags3DataInput;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTags4DataInput {
  id?: string | null;
  order?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  subjectTag: CreateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag4DataInput;
}

export interface CreateSubjectSubjectTagFromSubjectSubjectTags4Input {
  data: CreateSubjectSubjectTagFromSubjectSubjectTags4DataInput;
}

export interface CreateSubjectTagFromSubjectTagSubjects2DataInput {
  id?: string | null;
  slug: string;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubjectTagFromSubjectTagSubjects2Input {
  data: CreateSubjectTagFromSubjectTagSubjects2DataInput;
}

export interface CreateSubjectTagFromSubjectTagSubjects3DataInput {
  id?: string | null;
  slug: string;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubjectTagFromSubjectTagSubjects3Input {
  data: CreateSubjectTagFromSubjectTagSubjects3DataInput;
}

export interface CreateSubjectTagFromSubjectTagSubjects4DataInput {
  id?: string | null;
  slug: string;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubjectTagFromSubjectTagSubjects4Input {
  data: CreateSubjectTagFromSubjectTagSubjects4DataInput;
}

export interface CreateSubjectUserFromSubjectSubjectUsers1DataInput {
  userId?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubjectUserFromSubjectSubjectUsers1Input {
  data: CreateSubjectUserFromSubjectSubjectUsers1DataInput;
}

export interface CreateSubjectUserFromSubjectSubjectUsers2DataInput {
  userId?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubjectUserFromSubjectSubjectUsers2Input {
  data: CreateSubjectUserFromSubjectSubjectUsers2DataInput;
}

export interface CreateSubjectUserFromSubjectSubjectUsers3DataInput {
  userId?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubjectUserFromSubjectSubjectUsers3Input {
  data: CreateSubjectUserFromSubjectSubjectUsers3DataInput;
}

export interface CreateSubjectUserFromSubjectSubjectUsers4DataInput {
  userId?: string | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
}

export interface CreateSubjectUserFromSubjectSubjectUsers4Input {
  data: CreateSubjectUserFromSubjectSubjectUsers4DataInput;
}

export interface CreateUnitFromUnitBrands1DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  folders?: CreateUnitFromUnitBrandsNestedActionsForFolders1Input | null;
  subjects?: CreateUnitFromUnitBrandsNestedActionsForSubjects1Input | null;
  subjectCategories?: CreateUnitFromUnitBrandsNestedActionsForSubjectCategories1Input | null;
}

export interface CreateUnitFromUnitBrands1Input {
  data: CreateUnitFromUnitBrands1DataInput;
}

export interface CreateUnitFromUnitBrandsNestedActionsForFolders1Input {
  connect?: FolderFromUnitNodeSelectionInput[] | null;
  create?: CreateFolderFromUnitFolders2Input[] | null;
  delete?: FolderFromUnitNodeSelectionInput[] | null;
  disconnect?: FolderFromUnitNodeSelectionInput[] | null;
  update?: UpdateFolderFromUnitFolders2Input[] | null;
  upsert?: UpsertFolderFromUnitFolders2Input[] | null;
}

export interface CreateUnitFromUnitBrandsNestedActionsForSubjectCategories1Input {
  connect?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromUnitSubjectCategories2Input[] | null;
  delete?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromUnitSubjectCategories2Input[] | null;
  upsert?: UpsertSubjectCategoryFromUnitSubjectCategories2Input[] | null;
}

export interface CreateUnitFromUnitBrandsNestedActionsForSubjects1Input {
  connect?: SubjectFromUnitNodeSelectionInput[] | null;
  create?: CreateSubjectFromUnitSubjects2Input[] | null;
  delete?: SubjectFromUnitNodeSelectionInput[] | null;
  update?: UpdateSubjectFromUnitSubjects2Input[] | null;
  upsert?: UpsertSubjectFromUnitSubjects2Input[] | null;
}

export interface CreateUnitFromUnitSubjects2DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brands?: CreateUnitFromUnitSubjectsNestedActionsForBrands2Input | null;
  folders?: CreateUnitFromUnitSubjectsNestedActionsForFolders2Input | null;
  subjectCategories?: CreateUnitFromUnitSubjectsNestedActionsForSubjectCategories2Input | null;
}

export interface CreateUnitFromUnitSubjects2Input {
  data: CreateUnitFromUnitSubjects2DataInput;
}

export interface CreateUnitFromUnitSubjects3DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brands?: CreateUnitFromUnitSubjectsNestedActionsForBrands3Input | null;
  folders?: CreateUnitFromUnitSubjectsNestedActionsForFolders3Input | null;
  subjectCategories?: CreateUnitFromUnitSubjectsNestedActionsForSubjectCategories3Input | null;
}

export interface CreateUnitFromUnitSubjects3Input {
  data: CreateUnitFromUnitSubjects3DataInput;
}

export interface CreateUnitFromUnitSubjects4DataInput {
  id?: string | null;
  title: string;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brands?: CreateUnitFromUnitSubjectsNestedActionsForBrands4Input | null;
  folders?: CreateUnitFromUnitSubjectsNestedActionsForFolders4Input | null;
  subjectCategories?: CreateUnitFromUnitSubjectsNestedActionsForSubjectCategories4Input | null;
}

export interface CreateUnitFromUnitSubjects4Input {
  data: CreateUnitFromUnitSubjects4DataInput;
}

export interface CreateUnitFromUnitSubjectsNestedActionsForBrands2Input {
  connect?: BrandFromUnitNodeSelectionInput[] | null;
  create?: CreateBrandFromUnitBrands3Input[] | null;
  delete?: BrandFromUnitNodeSelectionInput[] | null;
  update?: UpdateBrandFromUnitBrands3Input[] | null;
  upsert?: UpsertBrandFromUnitBrands3Input[] | null;
}

export interface CreateUnitFromUnitSubjectsNestedActionsForBrands3Input {
  connect?: BrandFromUnitNodeSelectionInput[] | null;
  create?: CreateBrandFromUnitBrands4Input[] | null;
  delete?: BrandFromUnitNodeSelectionInput[] | null;
  update?: UpdateBrandFromUnitBrands4Input[] | null;
  upsert?: UpsertBrandFromUnitBrands4Input[] | null;
}

export interface CreateUnitFromUnitSubjectsNestedActionsForBrands4Input {
  connect?: BrandFromUnitNodeSelectionInput[] | null;
  delete?: BrandFromUnitNodeSelectionInput[] | null;
}

export interface CreateUnitFromUnitSubjectsNestedActionsForFolders2Input {
  connect?: FolderFromUnitNodeSelectionInput[] | null;
  create?: CreateFolderFromUnitFolders3Input[] | null;
  delete?: FolderFromUnitNodeSelectionInput[] | null;
  disconnect?: FolderFromUnitNodeSelectionInput[] | null;
  update?: UpdateFolderFromUnitFolders3Input[] | null;
  upsert?: UpsertFolderFromUnitFolders3Input[] | null;
}

export interface CreateUnitFromUnitSubjectsNestedActionsForFolders3Input {
  connect?: FolderFromUnitNodeSelectionInput[] | null;
  create?: CreateFolderFromUnitFolders4Input[] | null;
  delete?: FolderFromUnitNodeSelectionInput[] | null;
  disconnect?: FolderFromUnitNodeSelectionInput[] | null;
  update?: UpdateFolderFromUnitFolders4Input[] | null;
  upsert?: UpsertFolderFromUnitFolders4Input[] | null;
}

export interface CreateUnitFromUnitSubjectsNestedActionsForFolders4Input {
  connect?: FolderFromUnitNodeSelectionInput[] | null;
  delete?: FolderFromUnitNodeSelectionInput[] | null;
  disconnect?: FolderFromUnitNodeSelectionInput[] | null;
}

export interface CreateUnitFromUnitSubjectsNestedActionsForSubjectCategories2Input {
  connect?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromUnitSubjectCategories3Input[] | null;
  delete?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromUnitSubjectCategories3Input[] | null;
  upsert?: UpsertSubjectCategoryFromUnitSubjectCategories3Input[] | null;
}

export interface CreateUnitFromUnitSubjectsNestedActionsForSubjectCategories3Input {
  connect?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromUnitSubjectCategories4Input[] | null;
  delete?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromUnitSubjectCategories4Input[] | null;
  upsert?: UpsertSubjectCategoryFromUnitSubjectCategories4Input[] | null;
}

export interface CreateUnitFromUnitSubjectsNestedActionsForSubjectCategories4Input {
  connect?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  delete?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
}

export interface CreateWebsiteFromAssignmentWebsiteNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface CreateWebsiteFromAssignmentWebsiteNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface CreateWebsiteFromAssignmentWebsiteNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface CreateWebsiteFromBrandWebsites2DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreateWebsiteFromBrandWebsitesNestedActionsForAssignments2Input | null;
  flatAssignment?: CreateWebsiteFromBrandWebsitesNestedActionsForFlatAssignment2Input | null;
}

export interface CreateWebsiteFromBrandWebsites2Input {
  data: CreateWebsiteFromBrandWebsites2DataInput;
}

export interface CreateWebsiteFromBrandWebsites3DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreateWebsiteFromBrandWebsitesNestedActionsForAssignments3Input | null;
  flatAssignment?: CreateWebsiteFromBrandWebsitesNestedActionsForFlatAssignment3Input | null;
}

export interface CreateWebsiteFromBrandWebsites3Input {
  data: CreateWebsiteFromBrandWebsites3DataInput;
}

export interface CreateWebsiteFromBrandWebsites4DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  assignments?: CreateWebsiteFromBrandWebsitesNestedActionsForAssignments4Input | null;
}

export interface CreateWebsiteFromBrandWebsites4Input {
  data: CreateWebsiteFromBrandWebsites4DataInput;
}

export interface CreateWebsiteFromBrandWebsitesNestedActionsForAssignments2Input {
  connect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  create?: CreateAssignmentFromWebsiteAssignments3Input[] | null;
  delete?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  disconnect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromWebsiteAssignments3Input[] | null;
  upsert?: UpsertAssignmentFromWebsiteAssignments3Input[] | null;
}

export interface CreateWebsiteFromBrandWebsitesNestedActionsForAssignments3Input {
  connect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  create?: CreateAssignmentFromWebsiteAssignments4Input[] | null;
  delete?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  disconnect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromWebsiteAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromWebsiteAssignments4Input[] | null;
}

export interface CreateWebsiteFromBrandWebsitesNestedActionsForAssignments4Input {
  connect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  delete?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  disconnect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
}

export interface CreateWebsiteFromBrandWebsitesNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromWebsiteFlatAssignment3Input[] | null;
}

export interface CreateWebsiteFromBrandWebsitesNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromWebsiteFlatAssignment4Input[] | null;
}

export interface CreateWebsiteFromFlatAssignmentWebsiteNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface CreateWebsiteFromWebsiteAssignments1DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brand: CreateWebsiteFromAssignmentWebsiteNestedActionsForBrand1DataInput;
  flatAssignment?: CreateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface CreateWebsiteFromWebsiteAssignments1Input {
  data: CreateWebsiteFromWebsiteAssignments1DataInput;
}

export interface CreateWebsiteFromWebsiteAssignments2DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brand: CreateWebsiteFromAssignmentWebsiteNestedActionsForBrand2DataInput;
  flatAssignment?: CreateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment2Input | null;
}

export interface CreateWebsiteFromWebsiteAssignments2Input {
  data: CreateWebsiteFromWebsiteAssignments2DataInput;
}

export interface CreateWebsiteFromWebsiteAssignments3DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brand: CreateWebsiteFromAssignmentWebsiteNestedActionsForBrand3DataInput;
  flatAssignment?: CreateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface CreateWebsiteFromWebsiteAssignments3Input {
  data: CreateWebsiteFromWebsiteAssignments3DataInput;
}

export interface CreateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromWebsiteFlatAssignment2Input[] | null;
}

export interface CreateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromWebsiteFlatAssignment3Input[] | null;
}

export interface CreateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromWebsiteFlatAssignment4Input[] | null;
}

export interface CreateWebsiteFromWebsiteFlatAssignment4DataInput {
  id?: string | null;
  title: string;
  key: string;
  legacyId?: number | null;
  createdAt?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  brand: CreateWebsiteFromFlatAssignmentWebsiteNestedActionsForBrand4DataInput;
  assignments?: CreateWebsiteFromWebsiteFlatAssignmentNestedActionsForAssignments4Input | null;
}

export interface CreateWebsiteFromWebsiteFlatAssignment4Input {
  data: CreateWebsiteFromWebsiteFlatAssignment4DataInput;
}

export interface CreateWebsiteFromWebsiteFlatAssignmentNestedActionsForAssignments4Input {
  connect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  delete?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  disconnect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
}

export interface FlatAssignments1WhereInput {
  location_eq?: string | null;
  location_ne?: string | null;
  location_in?: (string | null)[] | null;
  location_nin?: (string | null)[] | null;
  location_contains?: string | null;
  assignmentPageNumber_eq?: number | null;
  assignmentPageNumber_ne?: number | null;
  assignmentPageNumber_in?: (number | null)[] | null;
  assignmentPageNumber_nin?: (number | null)[] | null;
  assignmentPageNumber_gt?: number | null;
  assignmentPageNumber_gte?: number | null;
  assignmentPageNumber_lt?: number | null;
  assignmentPageNumber_lte?: number | null;
  assignmentPageNumber_exists?: boolean | null;
  assignmentMediaSearchStatus_eq?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_ne?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  assignmentMediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  assignmentIntId_eq?: number | null;
  assignmentIntId_ne?: number | null;
  assignmentIntId_in?: (number | null)[] | null;
  assignmentIntId_nin?: (number | null)[] | null;
  assignmentIntId_gt?: number | null;
  assignmentIntId_gte?: number | null;
  assignmentIntId_lt?: number | null;
  assignmentIntId_lte?: number | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments2WhereInput | null;
  subject_exists?: boolean | null;
  subject_eq?: Subjects2WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles2WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings2WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues2WhereInput | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications2WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates2WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites2WhereInput | null;
  brand_exists?: boolean | null;
  brand_eq?: Brands2WhereInput | null;
  AND?: (FlatAssignments2WhereInput | null)[] | null;
  NOT?: FlatAssignments2WhereInput | null;
  OR?: (FlatAssignments2WhereInput | null)[] | null;
}

export interface FlatAssignments2WhereInput {
  location_eq?: string | null;
  location_ne?: string | null;
  location_in?: (string | null)[] | null;
  location_nin?: (string | null)[] | null;
  location_contains?: string | null;
  assignmentPageNumber_eq?: number | null;
  assignmentPageNumber_ne?: number | null;
  assignmentPageNumber_in?: (number | null)[] | null;
  assignmentPageNumber_nin?: (number | null)[] | null;
  assignmentPageNumber_gt?: number | null;
  assignmentPageNumber_gte?: number | null;
  assignmentPageNumber_lt?: number | null;
  assignmentPageNumber_lte?: number | null;
  assignmentPageNumber_exists?: boolean | null;
  assignmentMediaSearchStatus_eq?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_ne?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  assignmentMediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  assignmentIntId_eq?: number | null;
  assignmentIntId_ne?: number | null;
  assignmentIntId_in?: (number | null)[] | null;
  assignmentIntId_nin?: (number | null)[] | null;
  assignmentIntId_gt?: number | null;
  assignmentIntId_gte?: number | null;
  assignmentIntId_lt?: number | null;
  assignmentIntId_lte?: number | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments3WhereInput | null;
  subject_exists?: boolean | null;
  subject_eq?: Subjects3WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles3WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings3WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues3WhereInput | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications3WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates3WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites3WhereInput | null;
  brand_exists?: boolean | null;
  brand_eq?: Brands3WhereInput | null;
  AND?: (FlatAssignments3WhereInput | null)[] | null;
  NOT?: FlatAssignments3WhereInput | null;
  OR?: (FlatAssignments3WhereInput | null)[] | null;
}

export interface FlatAssignments3WhereInput {
  location_eq?: string | null;
  location_ne?: string | null;
  location_in?: (string | null)[] | null;
  location_nin?: (string | null)[] | null;
  location_contains?: string | null;
  assignmentPageNumber_eq?: number | null;
  assignmentPageNumber_ne?: number | null;
  assignmentPageNumber_in?: (number | null)[] | null;
  assignmentPageNumber_nin?: (number | null)[] | null;
  assignmentPageNumber_gt?: number | null;
  assignmentPageNumber_gte?: number | null;
  assignmentPageNumber_lt?: number | null;
  assignmentPageNumber_lte?: number | null;
  assignmentPageNumber_exists?: boolean | null;
  assignmentMediaSearchStatus_eq?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_ne?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  assignmentMediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  assignmentIntId_eq?: number | null;
  assignmentIntId_ne?: number | null;
  assignmentIntId_in?: (number | null)[] | null;
  assignmentIntId_nin?: (number | null)[] | null;
  assignmentIntId_gt?: number | null;
  assignmentIntId_gte?: number | null;
  assignmentIntId_lt?: number | null;
  assignmentIntId_lte?: number | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments4WhereInput | null;
  subject_exists?: boolean | null;
  subject_eq?: Subjects4WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles4WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings4WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues4WhereInput | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications4WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates4WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites4WhereInput | null;
  brand_exists?: boolean | null;
  brand_eq?: Brands4WhereInput | null;
  AND?: (FlatAssignments4WhereInput | null)[] | null;
  NOT?: FlatAssignments4WhereInput | null;
  OR?: (FlatAssignments4WhereInput | null)[] | null;
}

export interface FlatAssignments4WhereInput {
  location_eq?: string | null;
  location_ne?: string | null;
  location_in?: (string | null)[] | null;
  location_nin?: (string | null)[] | null;
  location_contains?: string | null;
  assignmentPageNumber_eq?: number | null;
  assignmentPageNumber_ne?: number | null;
  assignmentPageNumber_in?: (number | null)[] | null;
  assignmentPageNumber_nin?: (number | null)[] | null;
  assignmentPageNumber_gt?: number | null;
  assignmentPageNumber_gte?: number | null;
  assignmentPageNumber_lt?: number | null;
  assignmentPageNumber_lte?: number | null;
  assignmentPageNumber_exists?: boolean | null;
  assignmentMediaSearchStatus_eq?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_ne?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  assignmentMediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  assignmentIntId_eq?: number | null;
  assignmentIntId_ne?: number | null;
  assignmentIntId_in?: (number | null)[] | null;
  assignmentIntId_nin?: (number | null)[] | null;
  assignmentIntId_gt?: number | null;
  assignmentIntId_gte?: number | null;
  assignmentIntId_lt?: number | null;
  assignmentIntId_lte?: number | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments5WhereInput | null;
  subject_exists?: boolean | null;
  subject_eq?: Subjects5WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles5WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings5WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues5WhereInput | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications5WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates5WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites5WhereInput | null;
  brand_exists?: boolean | null;
  brand_eq?: Brands5WhereInput | null;
  AND?: (FlatAssignments5WhereInput | null)[] | null;
  NOT?: FlatAssignments5WhereInput | null;
  OR?: (FlatAssignments5WhereInput | null)[] | null;
}

export interface FlatAssignments5WhereInput {
  location_eq?: string | null;
  location_ne?: string | null;
  location_in?: (string | null)[] | null;
  location_nin?: (string | null)[] | null;
  location_contains?: string | null;
  assignmentPageNumber_eq?: number | null;
  assignmentPageNumber_ne?: number | null;
  assignmentPageNumber_in?: (number | null)[] | null;
  assignmentPageNumber_nin?: (number | null)[] | null;
  assignmentPageNumber_gt?: number | null;
  assignmentPageNumber_gte?: number | null;
  assignmentPageNumber_lt?: number | null;
  assignmentPageNumber_lte?: number | null;
  assignmentPageNumber_exists?: boolean | null;
  assignmentMediaSearchStatus_eq?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_ne?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  assignmentMediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  assignmentIntId_eq?: number | null;
  assignmentIntId_ne?: number | null;
  assignmentIntId_in?: (number | null)[] | null;
  assignmentIntId_nin?: (number | null)[] | null;
  assignmentIntId_gt?: number | null;
  assignmentIntId_gte?: number | null;
  assignmentIntId_lt?: number | null;
  assignmentIntId_lte?: number | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments6WhereInput | null;
  subject_exists?: boolean | null;
  subject_eq?: Subjects6WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles6WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings6WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues6WhereInput | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications6WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates6WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites6WhereInput | null;
  brand_exists?: boolean | null;
  brand_eq?: Brands6WhereInput | null;
  AND?: (FlatAssignments6WhereInput | null)[] | null;
  NOT?: FlatAssignments6WhereInput | null;
  OR?: (FlatAssignments6WhereInput | null)[] | null;
}

export interface FlatAssignments6WhereInput {
  location_eq?: string | null;
  location_ne?: string | null;
  location_in?: (string | null)[] | null;
  location_nin?: (string | null)[] | null;
  location_contains?: string | null;
  assignmentPageNumber_eq?: number | null;
  assignmentPageNumber_ne?: number | null;
  assignmentPageNumber_in?: (number | null)[] | null;
  assignmentPageNumber_nin?: (number | null)[] | null;
  assignmentPageNumber_gt?: number | null;
  assignmentPageNumber_gte?: number | null;
  assignmentPageNumber_lt?: number | null;
  assignmentPageNumber_lte?: number | null;
  assignmentPageNumber_exists?: boolean | null;
  assignmentMediaSearchStatus_eq?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_ne?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  assignmentMediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  assignmentIntId_eq?: number | null;
  assignmentIntId_ne?: number | null;
  assignmentIntId_in?: (number | null)[] | null;
  assignmentIntId_nin?: (number | null)[] | null;
  assignmentIntId_gt?: number | null;
  assignmentIntId_gte?: number | null;
  assignmentIntId_lt?: number | null;
  assignmentIntId_lte?: number | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments7WhereInput | null;
  subject_exists?: boolean | null;
  subject_eq?: Subjects7WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles7WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings7WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues7WhereInput | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications7WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates7WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites7WhereInput | null;
  brand_exists?: boolean | null;
  brand_eq?: Brands7WhereInput | null;
  AND?: (FlatAssignments7WhereInput | null)[] | null;
  NOT?: FlatAssignments7WhereInput | null;
  OR?: (FlatAssignments7WhereInput | null)[] | null;
}

export interface FlatAssignments7WhereInput {
  location_eq?: string | null;
  location_ne?: string | null;
  location_in?: (string | null)[] | null;
  location_nin?: (string | null)[] | null;
  location_contains?: string | null;
  assignmentPageNumber_eq?: number | null;
  assignmentPageNumber_ne?: number | null;
  assignmentPageNumber_in?: (number | null)[] | null;
  assignmentPageNumber_nin?: (number | null)[] | null;
  assignmentPageNumber_gt?: number | null;
  assignmentPageNumber_gte?: number | null;
  assignmentPageNumber_lt?: number | null;
  assignmentPageNumber_lte?: number | null;
  assignmentPageNumber_exists?: boolean | null;
  assignmentMediaSearchStatus_eq?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_ne?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  assignmentMediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  assignmentIntId_eq?: number | null;
  assignmentIntId_ne?: number | null;
  assignmentIntId_in?: (number | null)[] | null;
  assignmentIntId_nin?: (number | null)[] | null;
  assignmentIntId_gt?: number | null;
  assignmentIntId_gte?: number | null;
  assignmentIntId_lt?: number | null;
  assignmentIntId_lte?: number | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments8WhereInput | null;
  subject_exists?: boolean | null;
  subject_eq?: Subjects8WhereInput | null;
  rawArticle_exists?: boolean | null;
  rawArticle_eq?: RawArticles8WhereInput | null;
  printHeading_exists?: boolean | null;
  printHeading_eq?: PrintHeadings8WhereInput | null;
  printIssue_exists?: boolean | null;
  printIssue_eq?: PrintIssues8WhereInput | null;
  printPublication_exists?: boolean | null;
  printPublication_eq?: PrintPublications8WhereInput | null;
  printTemplate_exists?: boolean | null;
  printTemplate_eq?: PrintTemplates8WhereInput | null;
  website_exists?: boolean | null;
  website_eq?: Websites8WhereInput | null;
  brand_exists?: boolean | null;
  brand_eq?: Brands8WhereInput | null;
  AND?: (FlatAssignments8WhereInput | null)[] | null;
  NOT?: FlatAssignments8WhereInput | null;
  OR?: (FlatAssignments8WhereInput | null)[] | null;
}

export interface FlatAssignments8WhereInput {
  location_eq?: string | null;
  location_ne?: string | null;
  location_in?: (string | null)[] | null;
  location_nin?: (string | null)[] | null;
  location_contains?: string | null;
  assignmentPageNumber_eq?: number | null;
  assignmentPageNumber_ne?: number | null;
  assignmentPageNumber_in?: (number | null)[] | null;
  assignmentPageNumber_nin?: (number | null)[] | null;
  assignmentPageNumber_gt?: number | null;
  assignmentPageNumber_gte?: number | null;
  assignmentPageNumber_lt?: number | null;
  assignmentPageNumber_lte?: number | null;
  assignmentPageNumber_exists?: boolean | null;
  assignmentMediaSearchStatus_eq?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_ne?: MediaSearchStatus | null;
  assignmentMediaSearchStatus_in?: (MediaSearchStatus | null)[] | null;
  assignmentMediaSearchStatus_nin?: (MediaSearchStatus | null)[] | null;
  assignmentIntId_eq?: number | null;
  assignmentIntId_ne?: number | null;
  assignmentIntId_in?: (number | null)[] | null;
  assignmentIntId_nin?: (number | null)[] | null;
  assignmentIntId_gt?: number | null;
  assignmentIntId_gte?: number | null;
  assignmentIntId_lt?: number | null;
  assignmentIntId_lte?: number | null;
}

export interface FolderFromParentNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface FolderFromUnitNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface FolderNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface Folders2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  isShared_eq?: boolean | null;
  isShared_ne?: boolean | null;
  isShared_in?: (boolean | null)[] | null;
  isShared_nin?: (boolean | null)[] | null;
  level_eq?: number | null;
  level_ne?: number | null;
  level_in?: (number | null)[] | null;
  level_nin?: (number | null)[] | null;
  level_gt?: number | null;
  level_gte?: number | null;
  level_lt?: number | null;
  level_lte?: number | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_exists?: boolean | null;
  unit_eq?: Units3WhereInput | null;
  parent_exists?: boolean | null;
  parent_eq?: Folders3WhereInput | null;
  folders_some?: Folders3WhereInput | null;
  pins_some?: Pins3WhereInput | null;
  AND?: (Folders3WhereInput | null)[] | null;
  NOT?: Folders3WhereInput | null;
  OR?: (Folders3WhereInput | null)[] | null;
}

export interface Folders3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  isShared_eq?: boolean | null;
  isShared_ne?: boolean | null;
  isShared_in?: (boolean | null)[] | null;
  isShared_nin?: (boolean | null)[] | null;
  level_eq?: number | null;
  level_ne?: number | null;
  level_in?: (number | null)[] | null;
  level_nin?: (number | null)[] | null;
  level_gt?: number | null;
  level_gte?: number | null;
  level_lt?: number | null;
  level_lte?: number | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_exists?: boolean | null;
  unit_eq?: Units4WhereInput | null;
  parent_exists?: boolean | null;
  parent_eq?: Folders4WhereInput | null;
  folders_some?: Folders4WhereInput | null;
  pins_some?: Pins4WhereInput | null;
  AND?: (Folders4WhereInput | null)[] | null;
  NOT?: Folders4WhereInput | null;
  OR?: (Folders4WhereInput | null)[] | null;
}

export interface Folders4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  isShared_eq?: boolean | null;
  isShared_ne?: boolean | null;
  isShared_in?: (boolean | null)[] | null;
  isShared_nin?: (boolean | null)[] | null;
  level_eq?: number | null;
  level_ne?: number | null;
  level_in?: (number | null)[] | null;
  level_nin?: (number | null)[] | null;
  level_gt?: number | null;
  level_gte?: number | null;
  level_lt?: number | null;
  level_lte?: number | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_exists?: boolean | null;
  unit_eq?: Units5WhereInput | null;
  parent_exists?: boolean | null;
  parent_eq?: Folders5WhereInput | null;
  folders_some?: Folders5WhereInput | null;
  pins_some?: Pins5WhereInput | null;
  AND?: (Folders5WhereInput | null)[] | null;
  NOT?: Folders5WhereInput | null;
  OR?: (Folders5WhereInput | null)[] | null;
}

export interface Folders5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  isShared_eq?: boolean | null;
  isShared_ne?: boolean | null;
  isShared_in?: (boolean | null)[] | null;
  isShared_nin?: (boolean | null)[] | null;
  level_eq?: number | null;
  level_ne?: number | null;
  level_in?: (number | null)[] | null;
  level_nin?: (number | null)[] | null;
  level_gt?: number | null;
  level_gte?: number | null;
  level_lt?: number | null;
  level_lte?: number | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_exists?: boolean | null;
  unit_eq?: Units6WhereInput | null;
  parent_exists?: boolean | null;
  parent_eq?: Folders6WhereInput | null;
  folders_some?: Folders6WhereInput | null;
  pins_some?: Pins6WhereInput | null;
  AND?: (Folders6WhereInput | null)[] | null;
  NOT?: Folders6WhereInput | null;
  OR?: (Folders6WhereInput | null)[] | null;
}

export interface Folders6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  isShared_eq?: boolean | null;
  isShared_ne?: boolean | null;
  isShared_in?: (boolean | null)[] | null;
  isShared_nin?: (boolean | null)[] | null;
  level_eq?: number | null;
  level_ne?: number | null;
  level_in?: (number | null)[] | null;
  level_nin?: (number | null)[] | null;
  level_gt?: number | null;
  level_gte?: number | null;
  level_lt?: number | null;
  level_lte?: number | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_exists?: boolean | null;
  unit_eq?: Units7WhereInput | null;
  parent_exists?: boolean | null;
  parent_eq?: Folders7WhereInput | null;
  folders_some?: Folders7WhereInput | null;
  pins_some?: Pins7WhereInput | null;
  AND?: (Folders7WhereInput | null)[] | null;
  NOT?: Folders7WhereInput | null;
  OR?: (Folders7WhereInput | null)[] | null;
}

export interface Folders7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  isShared_eq?: boolean | null;
  isShared_ne?: boolean | null;
  isShared_in?: (boolean | null)[] | null;
  isShared_nin?: (boolean | null)[] | null;
  level_eq?: number | null;
  level_ne?: number | null;
  level_in?: (number | null)[] | null;
  level_nin?: (number | null)[] | null;
  level_gt?: number | null;
  level_gte?: number | null;
  level_lt?: number | null;
  level_lte?: number | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  unit_exists?: boolean | null;
  unit_eq?: Units8WhereInput | null;
  parent_exists?: boolean | null;
  parent_eq?: Folders8WhereInput | null;
  folders_some?: Folders8WhereInput | null;
  pins_some?: Pins8WhereInput | null;
  AND?: (Folders8WhereInput | null)[] | null;
  NOT?: Folders8WhereInput | null;
  OR?: (Folders8WhereInput | null)[] | null;
}

export interface Folders8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  isShared_eq?: boolean | null;
  isShared_ne?: boolean | null;
  isShared_in?: (boolean | null)[] | null;
  isShared_nin?: (boolean | null)[] | null;
  level_eq?: number | null;
  level_ne?: number | null;
  level_in?: (number | null)[] | null;
  level_nin?: (number | null)[] | null;
  level_gt?: number | null;
  level_gte?: number | null;
  level_lt?: number | null;
  level_lte?: number | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface PinFromFolderNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  photoId_eq?: string | null;
}

export interface Pins3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  photoId_eq?: string | null;
  photoId_ne?: string | null;
  photoId_in?: (string | null)[] | null;
  photoId_nin?: (string | null)[] | null;
  photoId_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  folder_eq?: Folders4WhereInput | null;
  AND?: (Pins4WhereInput | null)[] | null;
  NOT?: Pins4WhereInput | null;
  OR?: (Pins4WhereInput | null)[] | null;
}

export interface Pins4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  photoId_eq?: string | null;
  photoId_ne?: string | null;
  photoId_in?: (string | null)[] | null;
  photoId_nin?: (string | null)[] | null;
  photoId_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  folder_eq?: Folders5WhereInput | null;
  AND?: (Pins5WhereInput | null)[] | null;
  NOT?: Pins5WhereInput | null;
  OR?: (Pins5WhereInput | null)[] | null;
}

export interface Pins5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  photoId_eq?: string | null;
  photoId_ne?: string | null;
  photoId_in?: (string | null)[] | null;
  photoId_nin?: (string | null)[] | null;
  photoId_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  folder_eq?: Folders6WhereInput | null;
  AND?: (Pins6WhereInput | null)[] | null;
  NOT?: Pins6WhereInput | null;
  OR?: (Pins6WhereInput | null)[] | null;
}

export interface Pins6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  photoId_eq?: string | null;
  photoId_ne?: string | null;
  photoId_in?: (string | null)[] | null;
  photoId_nin?: (string | null)[] | null;
  photoId_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  folder_eq?: Folders7WhereInput | null;
  AND?: (Pins7WhereInput | null)[] | null;
  NOT?: Pins7WhereInput | null;
  OR?: (Pins7WhereInput | null)[] | null;
}

export interface Pins7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  photoId_eq?: string | null;
  photoId_ne?: string | null;
  photoId_in?: (string | null)[] | null;
  photoId_nin?: (string | null)[] | null;
  photoId_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  folder_eq?: Folders8WhereInput | null;
  AND?: (Pins8WhereInput | null)[] | null;
  NOT?: Pins8WhereInput | null;
  OR?: (Pins8WhereInput | null)[] | null;
}

export interface Pins8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  photoId_eq?: string | null;
  photoId_ne?: string | null;
  photoId_in?: (string | null)[] | null;
  photoId_nin?: (string | null)[] | null;
  photoId_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface PrintHeadingFromPrintHeadingNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  printIssue_eq?: PrintIssue1NodeSelectionInput | null;
  legacyId_eq?: number | null;
}

export interface PrintHeadingFromPrintIssueNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  legacyId_eq?: number | null;
}

export interface PrintHeadingNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  printIssue_eq?: PrintIssue1NodeSelectionInput | null;
  legacyId_eq?: number | null;
}

export interface PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface PrintHeadingPrintTemplateNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface PrintHeadingPrintTemplates3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  active_eq?: boolean | null;
  active_ne?: boolean | null;
  active_in?: (boolean | null)[] | null;
  active_nin?: (boolean | null)[] | null;
  active_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printHeading_eq?: PrintHeadings4WhereInput | null;
  printTemplate_eq?: PrintTemplates4WhereInput | null;
  AND?: (PrintHeadingPrintTemplates4WhereInput | null)[] | null;
  NOT?: PrintHeadingPrintTemplates4WhereInput | null;
  OR?: (PrintHeadingPrintTemplates4WhereInput | null)[] | null;
}

export interface PrintHeadingPrintTemplates4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  active_eq?: boolean | null;
  active_ne?: boolean | null;
  active_in?: (boolean | null)[] | null;
  active_nin?: (boolean | null)[] | null;
  active_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printHeading_eq?: PrintHeadings5WhereInput | null;
  printTemplate_eq?: PrintTemplates5WhereInput | null;
  AND?: (PrintHeadingPrintTemplates5WhereInput | null)[] | null;
  NOT?: PrintHeadingPrintTemplates5WhereInput | null;
  OR?: (PrintHeadingPrintTemplates5WhereInput | null)[] | null;
}

export interface PrintHeadingPrintTemplates5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  active_eq?: boolean | null;
  active_ne?: boolean | null;
  active_in?: (boolean | null)[] | null;
  active_nin?: (boolean | null)[] | null;
  active_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printHeading_eq?: PrintHeadings6WhereInput | null;
  printTemplate_eq?: PrintTemplates6WhereInput | null;
  AND?: (PrintHeadingPrintTemplates6WhereInput | null)[] | null;
  NOT?: PrintHeadingPrintTemplates6WhereInput | null;
  OR?: (PrintHeadingPrintTemplates6WhereInput | null)[] | null;
}

export interface PrintHeadingPrintTemplates6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  active_eq?: boolean | null;
  active_ne?: boolean | null;
  active_in?: (boolean | null)[] | null;
  active_nin?: (boolean | null)[] | null;
  active_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printHeading_eq?: PrintHeadings7WhereInput | null;
  printTemplate_eq?: PrintTemplates7WhereInput | null;
  AND?: (PrintHeadingPrintTemplates7WhereInput | null)[] | null;
  NOT?: PrintHeadingPrintTemplates7WhereInput | null;
  OR?: (PrintHeadingPrintTemplates7WhereInput | null)[] | null;
}

export interface PrintHeadingPrintTemplates7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  active_eq?: boolean | null;
  active_ne?: boolean | null;
  active_in?: (boolean | null)[] | null;
  active_nin?: (boolean | null)[] | null;
  active_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printHeading_eq?: PrintHeadings8WhereInput | null;
  printTemplate_eq?: PrintTemplates8WhereInput | null;
  AND?: (PrintHeadingPrintTemplates8WhereInput | null)[] | null;
  NOT?: PrintHeadingPrintTemplates8WhereInput | null;
  OR?: (PrintHeadingPrintTemplates8WhereInput | null)[] | null;
}

export interface PrintHeadingPrintTemplates8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  active_eq?: boolean | null;
  active_ne?: boolean | null;
  active_in?: (boolean | null)[] | null;
  active_nin?: (boolean | null)[] | null;
  active_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface PrintHeadings2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  hasAutomaticSubject_eq?: boolean | null;
  hasAutomaticSubject_ne?: boolean | null;
  hasAutomaticSubject_in?: (boolean | null)[] | null;
  hasAutomaticSubject_nin?: (boolean | null)[] | null;
  hasAutomaticSubject_exists?: boolean | null;
  autoPrototype_eq?: boolean | null;
  autoPrototype_ne?: boolean | null;
  autoPrototype_in?: (boolean | null)[] | null;
  autoPrototype_nin?: (boolean | null)[] | null;
  autoPrototype_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printIssue_eq?: PrintIssues3WhereInput | null;
  assignments_some?: Assignments3WhereInput | null;
  flatAssignment_some?: FlatAssignments3WhereInput | null;
  PrintTemplate_some?: PrintHeadingPrintTemplates3WhereInput | null;
  AND?: (PrintHeadings3WhereInput | null)[] | null;
  NOT?: PrintHeadings3WhereInput | null;
  OR?: (PrintHeadings3WhereInput | null)[] | null;
}

export interface PrintHeadings3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  hasAutomaticSubject_eq?: boolean | null;
  hasAutomaticSubject_ne?: boolean | null;
  hasAutomaticSubject_in?: (boolean | null)[] | null;
  hasAutomaticSubject_nin?: (boolean | null)[] | null;
  hasAutomaticSubject_exists?: boolean | null;
  autoPrototype_eq?: boolean | null;
  autoPrototype_ne?: boolean | null;
  autoPrototype_in?: (boolean | null)[] | null;
  autoPrototype_nin?: (boolean | null)[] | null;
  autoPrototype_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printIssue_eq?: PrintIssues4WhereInput | null;
  assignments_some?: Assignments4WhereInput | null;
  flatAssignment_some?: FlatAssignments4WhereInput | null;
  PrintTemplate_some?: PrintHeadingPrintTemplates4WhereInput | null;
  AND?: (PrintHeadings4WhereInput | null)[] | null;
  NOT?: PrintHeadings4WhereInput | null;
  OR?: (PrintHeadings4WhereInput | null)[] | null;
}

export interface PrintHeadings4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  hasAutomaticSubject_eq?: boolean | null;
  hasAutomaticSubject_ne?: boolean | null;
  hasAutomaticSubject_in?: (boolean | null)[] | null;
  hasAutomaticSubject_nin?: (boolean | null)[] | null;
  hasAutomaticSubject_exists?: boolean | null;
  autoPrototype_eq?: boolean | null;
  autoPrototype_ne?: boolean | null;
  autoPrototype_in?: (boolean | null)[] | null;
  autoPrototype_nin?: (boolean | null)[] | null;
  autoPrototype_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printIssue_eq?: PrintIssues5WhereInput | null;
  assignments_some?: Assignments5WhereInput | null;
  flatAssignment_some?: FlatAssignments5WhereInput | null;
  PrintTemplate_some?: PrintHeadingPrintTemplates5WhereInput | null;
  AND?: (PrintHeadings5WhereInput | null)[] | null;
  NOT?: PrintHeadings5WhereInput | null;
  OR?: (PrintHeadings5WhereInput | null)[] | null;
}

export interface PrintHeadings5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  hasAutomaticSubject_eq?: boolean | null;
  hasAutomaticSubject_ne?: boolean | null;
  hasAutomaticSubject_in?: (boolean | null)[] | null;
  hasAutomaticSubject_nin?: (boolean | null)[] | null;
  hasAutomaticSubject_exists?: boolean | null;
  autoPrototype_eq?: boolean | null;
  autoPrototype_ne?: boolean | null;
  autoPrototype_in?: (boolean | null)[] | null;
  autoPrototype_nin?: (boolean | null)[] | null;
  autoPrototype_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printIssue_eq?: PrintIssues6WhereInput | null;
  assignments_some?: Assignments6WhereInput | null;
  flatAssignment_some?: FlatAssignments6WhereInput | null;
  PrintTemplate_some?: PrintHeadingPrintTemplates6WhereInput | null;
  AND?: (PrintHeadings6WhereInput | null)[] | null;
  NOT?: PrintHeadings6WhereInput | null;
  OR?: (PrintHeadings6WhereInput | null)[] | null;
}

export interface PrintHeadings6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  hasAutomaticSubject_eq?: boolean | null;
  hasAutomaticSubject_ne?: boolean | null;
  hasAutomaticSubject_in?: (boolean | null)[] | null;
  hasAutomaticSubject_nin?: (boolean | null)[] | null;
  hasAutomaticSubject_exists?: boolean | null;
  autoPrototype_eq?: boolean | null;
  autoPrototype_ne?: boolean | null;
  autoPrototype_in?: (boolean | null)[] | null;
  autoPrototype_nin?: (boolean | null)[] | null;
  autoPrototype_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printIssue_eq?: PrintIssues7WhereInput | null;
  assignments_some?: Assignments7WhereInput | null;
  flatAssignment_some?: FlatAssignments7WhereInput | null;
  PrintTemplate_some?: PrintHeadingPrintTemplates7WhereInput | null;
  AND?: (PrintHeadings7WhereInput | null)[] | null;
  NOT?: PrintHeadings7WhereInput | null;
  OR?: (PrintHeadings7WhereInput | null)[] | null;
}

export interface PrintHeadings7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  hasAutomaticSubject_eq?: boolean | null;
  hasAutomaticSubject_ne?: boolean | null;
  hasAutomaticSubject_in?: (boolean | null)[] | null;
  hasAutomaticSubject_nin?: (boolean | null)[] | null;
  hasAutomaticSubject_exists?: boolean | null;
  autoPrototype_eq?: boolean | null;
  autoPrototype_ne?: boolean | null;
  autoPrototype_in?: (boolean | null)[] | null;
  autoPrototype_nin?: (boolean | null)[] | null;
  autoPrototype_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printIssue_eq?: PrintIssues8WhereInput | null;
  assignments_some?: Assignments8WhereInput | null;
  flatAssignment_some?: FlatAssignments8WhereInput | null;
  PrintTemplate_some?: PrintHeadingPrintTemplates8WhereInput | null;
  AND?: (PrintHeadings8WhereInput | null)[] | null;
  NOT?: PrintHeadings8WhereInput | null;
  OR?: (PrintHeadings8WhereInput | null)[] | null;
}

export interface PrintHeadings8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  hasAutomaticSubject_eq?: boolean | null;
  hasAutomaticSubject_ne?: boolean | null;
  hasAutomaticSubject_in?: (boolean | null)[] | null;
  hasAutomaticSubject_nin?: (boolean | null)[] | null;
  hasAutomaticSubject_exists?: boolean | null;
  autoPrototype_eq?: boolean | null;
  autoPrototype_ne?: boolean | null;
  autoPrototype_in?: (boolean | null)[] | null;
  autoPrototype_nin?: (boolean | null)[] | null;
  autoPrototype_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface PrintIssue1NodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface PrintIssueFromPrintIssueNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  printPublication_eq?: PrintPublication1NodeSelectionInput | null;
  legacyId_eq?: number | null;
}

export interface PrintIssueFromPrintPublicationNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  legacyId_eq?: number | null;
}

export interface PrintIssueNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  printPublication_eq?: PrintPublication1NodeSelectionInput | null;
  legacyId_eq?: number | null;
}

export interface PrintIssues2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_eq?: PrintPublications3WhereInput | null;
  assignments_some?: Assignments3WhereInput | null;
  flatAssignment_some?: FlatAssignments3WhereInput | null;
  printHeadings_some?: PrintHeadings3WhereInput | null;
  AND?: (PrintIssues3WhereInput | null)[] | null;
  NOT?: PrintIssues3WhereInput | null;
  OR?: (PrintIssues3WhereInput | null)[] | null;
}

export interface PrintIssues3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_eq?: PrintPublications4WhereInput | null;
  assignments_some?: Assignments4WhereInput | null;
  flatAssignment_some?: FlatAssignments4WhereInput | null;
  printHeadings_some?: PrintHeadings4WhereInput | null;
  AND?: (PrintIssues4WhereInput | null)[] | null;
  NOT?: PrintIssues4WhereInput | null;
  OR?: (PrintIssues4WhereInput | null)[] | null;
}

export interface PrintIssues4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_eq?: PrintPublications5WhereInput | null;
  assignments_some?: Assignments5WhereInput | null;
  flatAssignment_some?: FlatAssignments5WhereInput | null;
  printHeadings_some?: PrintHeadings5WhereInput | null;
  AND?: (PrintIssues5WhereInput | null)[] | null;
  NOT?: PrintIssues5WhereInput | null;
  OR?: (PrintIssues5WhereInput | null)[] | null;
}

export interface PrintIssues5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_eq?: PrintPublications6WhereInput | null;
  assignments_some?: Assignments6WhereInput | null;
  flatAssignment_some?: FlatAssignments6WhereInput | null;
  printHeadings_some?: PrintHeadings6WhereInput | null;
  AND?: (PrintIssues6WhereInput | null)[] | null;
  NOT?: PrintIssues6WhereInput | null;
  OR?: (PrintIssues6WhereInput | null)[] | null;
}

export interface PrintIssues6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_eq?: PrintPublications7WhereInput | null;
  assignments_some?: Assignments7WhereInput | null;
  flatAssignment_some?: FlatAssignments7WhereInput | null;
  printHeadings_some?: PrintHeadings7WhereInput | null;
  AND?: (PrintIssues7WhereInput | null)[] | null;
  NOT?: PrintIssues7WhereInput | null;
  OR?: (PrintIssues7WhereInput | null)[] | null;
}

export interface PrintIssues7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  printPublication_eq?: PrintPublications8WhereInput | null;
  assignments_some?: Assignments8WhereInput | null;
  flatAssignment_some?: FlatAssignments8WhereInput | null;
  printHeadings_some?: PrintHeadings8WhereInput | null;
  AND?: (PrintIssues8WhereInput | null)[] | null;
  NOT?: PrintIssues8WhereInput | null;
  OR?: (PrintIssues8WhereInput | null)[] | null;
}

export interface PrintIssues8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface PrintPublication1NodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  key_eq?: string | null;
}

export interface PrintPublicationFromBrandNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  key_eq?: string | null;
  legacyId_eq?: number | null;
}

export interface PrintPublicationFromPrintPublicationNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  brand_eq?: Brand1NodeSelectionInput | null;
  key_eq?: string | null;
  legacyId_eq?: number | null;
}

export interface PrintPublicationNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  brand_eq?: Brand1NodeSelectionInput | null;
  key_eq?: string | null;
  legacyId_eq?: number | null;
}

export interface PrintPublications1WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands2WhereInput | null;
  assignments_some?: Assignments2WhereInput | null;
  flatAssignment_some?: FlatAssignments2WhereInput | null;
  printIssues_some?: PrintIssues2WhereInput | null;
  AND?: (PrintPublications2WhereInput | null)[] | null;
  NOT?: PrintPublications2WhereInput | null;
  OR?: (PrintPublications2WhereInput | null)[] | null;
}

export interface PrintPublications2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands3WhereInput | null;
  assignments_some?: Assignments3WhereInput | null;
  flatAssignment_some?: FlatAssignments3WhereInput | null;
  printIssues_some?: PrintIssues3WhereInput | null;
  AND?: (PrintPublications3WhereInput | null)[] | null;
  NOT?: PrintPublications3WhereInput | null;
  OR?: (PrintPublications3WhereInput | null)[] | null;
}

export interface PrintPublications3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands4WhereInput | null;
  assignments_some?: Assignments4WhereInput | null;
  flatAssignment_some?: FlatAssignments4WhereInput | null;
  printIssues_some?: PrintIssues4WhereInput | null;
  AND?: (PrintPublications4WhereInput | null)[] | null;
  NOT?: PrintPublications4WhereInput | null;
  OR?: (PrintPublications4WhereInput | null)[] | null;
}

export interface PrintPublications4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands5WhereInput | null;
  assignments_some?: Assignments5WhereInput | null;
  flatAssignment_some?: FlatAssignments5WhereInput | null;
  printIssues_some?: PrintIssues5WhereInput | null;
  AND?: (PrintPublications5WhereInput | null)[] | null;
  NOT?: PrintPublications5WhereInput | null;
  OR?: (PrintPublications5WhereInput | null)[] | null;
}

export interface PrintPublications5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands6WhereInput | null;
  assignments_some?: Assignments6WhereInput | null;
  flatAssignment_some?: FlatAssignments6WhereInput | null;
  printIssues_some?: PrintIssues6WhereInput | null;
  AND?: (PrintPublications6WhereInput | null)[] | null;
  NOT?: PrintPublications6WhereInput | null;
  OR?: (PrintPublications6WhereInput | null)[] | null;
}

export interface PrintPublications6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands7WhereInput | null;
  assignments_some?: Assignments7WhereInput | null;
  flatAssignment_some?: FlatAssignments7WhereInput | null;
  printIssues_some?: PrintIssues7WhereInput | null;
  AND?: (PrintPublications7WhereInput | null)[] | null;
  NOT?: PrintPublications7WhereInput | null;
  OR?: (PrintPublications7WhereInput | null)[] | null;
}

export interface PrintPublications7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands8WhereInput | null;
  assignments_some?: Assignments8WhereInput | null;
  flatAssignment_some?: FlatAssignments8WhereInput | null;
  printIssues_some?: PrintIssues8WhereInput | null;
  AND?: (PrintPublications8WhereInput | null)[] | null;
  NOT?: PrintPublications8WhereInput | null;
  OR?: (PrintPublications8WhereInput | null)[] | null;
}

export interface PrintPublications8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface PrintTemplateDraftFieldsDataType {
  id: number;
  value: string;
}

export interface PrintTemplateFromPrintTemplateNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface PrintTemplateNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface PrintTemplates2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  S3ObjectId_eq?: string | null;
  S3ObjectId_ne?: string | null;
  S3ObjectId_in?: (string | null)[] | null;
  S3ObjectId_nin?: (string | null)[] | null;
  S3ObjectId_contains?: string | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  type_eq?: TemplateType | null;
  type_ne?: TemplateType | null;
  type_in?: (TemplateType | null)[] | null;
  type_nin?: (TemplateType | null)[] | null;
  type_exists?: boolean | null;
  pageCount_eq?: number | null;
  pageCount_ne?: number | null;
  pageCount_in?: (number | null)[] | null;
  pageCount_nin?: (number | null)[] | null;
  pageCount_gt?: number | null;
  pageCount_gte?: number | null;
  pageCount_lt?: number | null;
  pageCount_lte?: number | null;
  pageCount_exists?: boolean | null;
  extVersion_eq?: string | null;
  extVersion_ne?: string | null;
  extVersion_in?: (string | null)[] | null;
  extVersion_nin?: (string | null)[] | null;
  extVersion_contains?: string | null;
  extVersion_exists?: boolean | null;
  data_eq?: string | null;
  data_ne?: string | null;
  data_in?: (string | null)[] | null;
  data_nin?: (string | null)[] | null;
  data_contains?: string | null;
  data_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  articleTemplates_some?: ArticleTemplates3WhereInput | null;
  assignments_some?: Assignments3WhereInput | null;
  flatAssignment_some?: FlatAssignments3WhereInput | null;
  PrintHeading_some?: PrintHeadingPrintTemplates3WhereInput | null;
  AND?: (PrintTemplates3WhereInput | null)[] | null;
  NOT?: PrintTemplates3WhereInput | null;
  OR?: (PrintTemplates3WhereInput | null)[] | null;
}

export interface PrintTemplates3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  S3ObjectId_eq?: string | null;
  S3ObjectId_ne?: string | null;
  S3ObjectId_in?: (string | null)[] | null;
  S3ObjectId_nin?: (string | null)[] | null;
  S3ObjectId_contains?: string | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  type_eq?: TemplateType | null;
  type_ne?: TemplateType | null;
  type_in?: (TemplateType | null)[] | null;
  type_nin?: (TemplateType | null)[] | null;
  type_exists?: boolean | null;
  pageCount_eq?: number | null;
  pageCount_ne?: number | null;
  pageCount_in?: (number | null)[] | null;
  pageCount_nin?: (number | null)[] | null;
  pageCount_gt?: number | null;
  pageCount_gte?: number | null;
  pageCount_lt?: number | null;
  pageCount_lte?: number | null;
  pageCount_exists?: boolean | null;
  extVersion_eq?: string | null;
  extVersion_ne?: string | null;
  extVersion_in?: (string | null)[] | null;
  extVersion_nin?: (string | null)[] | null;
  extVersion_contains?: string | null;
  extVersion_exists?: boolean | null;
  data_eq?: string | null;
  data_ne?: string | null;
  data_in?: (string | null)[] | null;
  data_nin?: (string | null)[] | null;
  data_contains?: string | null;
  data_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  articleTemplates_some?: ArticleTemplates4WhereInput | null;
  assignments_some?: Assignments4WhereInput | null;
  flatAssignment_some?: FlatAssignments4WhereInput | null;
  PrintHeading_some?: PrintHeadingPrintTemplates4WhereInput | null;
  AND?: (PrintTemplates4WhereInput | null)[] | null;
  NOT?: PrintTemplates4WhereInput | null;
  OR?: (PrintTemplates4WhereInput | null)[] | null;
}

export interface PrintTemplates4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  S3ObjectId_eq?: string | null;
  S3ObjectId_ne?: string | null;
  S3ObjectId_in?: (string | null)[] | null;
  S3ObjectId_nin?: (string | null)[] | null;
  S3ObjectId_contains?: string | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  type_eq?: TemplateType | null;
  type_ne?: TemplateType | null;
  type_in?: (TemplateType | null)[] | null;
  type_nin?: (TemplateType | null)[] | null;
  type_exists?: boolean | null;
  pageCount_eq?: number | null;
  pageCount_ne?: number | null;
  pageCount_in?: (number | null)[] | null;
  pageCount_nin?: (number | null)[] | null;
  pageCount_gt?: number | null;
  pageCount_gte?: number | null;
  pageCount_lt?: number | null;
  pageCount_lte?: number | null;
  pageCount_exists?: boolean | null;
  extVersion_eq?: string | null;
  extVersion_ne?: string | null;
  extVersion_in?: (string | null)[] | null;
  extVersion_nin?: (string | null)[] | null;
  extVersion_contains?: string | null;
  extVersion_exists?: boolean | null;
  data_eq?: string | null;
  data_ne?: string | null;
  data_in?: (string | null)[] | null;
  data_nin?: (string | null)[] | null;
  data_contains?: string | null;
  data_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  articleTemplates_some?: ArticleTemplates5WhereInput | null;
  assignments_some?: Assignments5WhereInput | null;
  flatAssignment_some?: FlatAssignments5WhereInput | null;
  PrintHeading_some?: PrintHeadingPrintTemplates5WhereInput | null;
  AND?: (PrintTemplates5WhereInput | null)[] | null;
  NOT?: PrintTemplates5WhereInput | null;
  OR?: (PrintTemplates5WhereInput | null)[] | null;
}

export interface PrintTemplates5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  S3ObjectId_eq?: string | null;
  S3ObjectId_ne?: string | null;
  S3ObjectId_in?: (string | null)[] | null;
  S3ObjectId_nin?: (string | null)[] | null;
  S3ObjectId_contains?: string | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  type_eq?: TemplateType | null;
  type_ne?: TemplateType | null;
  type_in?: (TemplateType | null)[] | null;
  type_nin?: (TemplateType | null)[] | null;
  type_exists?: boolean | null;
  pageCount_eq?: number | null;
  pageCount_ne?: number | null;
  pageCount_in?: (number | null)[] | null;
  pageCount_nin?: (number | null)[] | null;
  pageCount_gt?: number | null;
  pageCount_gte?: number | null;
  pageCount_lt?: number | null;
  pageCount_lte?: number | null;
  pageCount_exists?: boolean | null;
  extVersion_eq?: string | null;
  extVersion_ne?: string | null;
  extVersion_in?: (string | null)[] | null;
  extVersion_nin?: (string | null)[] | null;
  extVersion_contains?: string | null;
  extVersion_exists?: boolean | null;
  data_eq?: string | null;
  data_ne?: string | null;
  data_in?: (string | null)[] | null;
  data_nin?: (string | null)[] | null;
  data_contains?: string | null;
  data_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  articleTemplates_some?: ArticleTemplates6WhereInput | null;
  assignments_some?: Assignments6WhereInput | null;
  flatAssignment_some?: FlatAssignments6WhereInput | null;
  PrintHeading_some?: PrintHeadingPrintTemplates6WhereInput | null;
  AND?: (PrintTemplates6WhereInput | null)[] | null;
  NOT?: PrintTemplates6WhereInput | null;
  OR?: (PrintTemplates6WhereInput | null)[] | null;
}

export interface PrintTemplates6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  S3ObjectId_eq?: string | null;
  S3ObjectId_ne?: string | null;
  S3ObjectId_in?: (string | null)[] | null;
  S3ObjectId_nin?: (string | null)[] | null;
  S3ObjectId_contains?: string | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  type_eq?: TemplateType | null;
  type_ne?: TemplateType | null;
  type_in?: (TemplateType | null)[] | null;
  type_nin?: (TemplateType | null)[] | null;
  type_exists?: boolean | null;
  pageCount_eq?: number | null;
  pageCount_ne?: number | null;
  pageCount_in?: (number | null)[] | null;
  pageCount_nin?: (number | null)[] | null;
  pageCount_gt?: number | null;
  pageCount_gte?: number | null;
  pageCount_lt?: number | null;
  pageCount_lte?: number | null;
  pageCount_exists?: boolean | null;
  extVersion_eq?: string | null;
  extVersion_ne?: string | null;
  extVersion_in?: (string | null)[] | null;
  extVersion_nin?: (string | null)[] | null;
  extVersion_contains?: string | null;
  extVersion_exists?: boolean | null;
  data_eq?: string | null;
  data_ne?: string | null;
  data_in?: (string | null)[] | null;
  data_nin?: (string | null)[] | null;
  data_contains?: string | null;
  data_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  articleTemplates_some?: ArticleTemplates7WhereInput | null;
  assignments_some?: Assignments7WhereInput | null;
  flatAssignment_some?: FlatAssignments7WhereInput | null;
  PrintHeading_some?: PrintHeadingPrintTemplates7WhereInput | null;
  AND?: (PrintTemplates7WhereInput | null)[] | null;
  NOT?: PrintTemplates7WhereInput | null;
  OR?: (PrintTemplates7WhereInput | null)[] | null;
}

export interface PrintTemplates7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  S3ObjectId_eq?: string | null;
  S3ObjectId_ne?: string | null;
  S3ObjectId_in?: (string | null)[] | null;
  S3ObjectId_nin?: (string | null)[] | null;
  S3ObjectId_contains?: string | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  type_eq?: TemplateType | null;
  type_ne?: TemplateType | null;
  type_in?: (TemplateType | null)[] | null;
  type_nin?: (TemplateType | null)[] | null;
  type_exists?: boolean | null;
  pageCount_eq?: number | null;
  pageCount_ne?: number | null;
  pageCount_in?: (number | null)[] | null;
  pageCount_nin?: (number | null)[] | null;
  pageCount_gt?: number | null;
  pageCount_gte?: number | null;
  pageCount_lt?: number | null;
  pageCount_lte?: number | null;
  pageCount_exists?: boolean | null;
  extVersion_eq?: string | null;
  extVersion_ne?: string | null;
  extVersion_in?: (string | null)[] | null;
  extVersion_nin?: (string | null)[] | null;
  extVersion_contains?: string | null;
  extVersion_exists?: boolean | null;
  data_eq?: string | null;
  data_ne?: string | null;
  data_in?: (string | null)[] | null;
  data_nin?: (string | null)[] | null;
  data_contains?: string | null;
  data_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  articleTemplates_some?: ArticleTemplates8WhereInput | null;
  assignments_some?: Assignments8WhereInput | null;
  flatAssignment_some?: FlatAssignments8WhereInput | null;
  PrintHeading_some?: PrintHeadingPrintTemplates8WhereInput | null;
  AND?: (PrintTemplates8WhereInput | null)[] | null;
  NOT?: PrintTemplates8WhereInput | null;
  OR?: (PrintTemplates8WhereInput | null)[] | null;
}

export interface PrintTemplates8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  S3ObjectId_eq?: string | null;
  S3ObjectId_ne?: string | null;
  S3ObjectId_in?: (string | null)[] | null;
  S3ObjectId_nin?: (string | null)[] | null;
  S3ObjectId_contains?: string | null;
  label_eq?: string | null;
  label_ne?: string | null;
  label_in?: (string | null)[] | null;
  label_nin?: (string | null)[] | null;
  label_contains?: string | null;
  filename_eq?: string | null;
  filename_ne?: string | null;
  filename_in?: (string | null)[] | null;
  filename_nin?: (string | null)[] | null;
  filename_contains?: string | null;
  filesize_eq?: number | null;
  filesize_ne?: number | null;
  filesize_in?: (number | null)[] | null;
  filesize_nin?: (number | null)[] | null;
  filesize_gt?: number | null;
  filesize_gte?: number | null;
  filesize_lt?: number | null;
  filesize_lte?: number | null;
  type_eq?: TemplateType | null;
  type_ne?: TemplateType | null;
  type_in?: (TemplateType | null)[] | null;
  type_nin?: (TemplateType | null)[] | null;
  type_exists?: boolean | null;
  pageCount_eq?: number | null;
  pageCount_ne?: number | null;
  pageCount_in?: (number | null)[] | null;
  pageCount_nin?: (number | null)[] | null;
  pageCount_gt?: number | null;
  pageCount_gte?: number | null;
  pageCount_lt?: number | null;
  pageCount_lte?: number | null;
  pageCount_exists?: boolean | null;
  extVersion_eq?: string | null;
  extVersion_ne?: string | null;
  extVersion_in?: (string | null)[] | null;
  extVersion_nin?: (string | null)[] | null;
  extVersion_contains?: string | null;
  extVersion_exists?: boolean | null;
  data_eq?: string | null;
  data_ne?: string | null;
  data_in?: (string | null)[] | null;
  data_nin?: (string | null)[] | null;
  data_contains?: string | null;
  data_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface RawArticle1NodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface RawArticleFromRawArticleNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface RawArticleNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface RawArticleVersion1NodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface RawArticleVersionNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  previousVersion_eq?: RawArticleVersion1NodeSelectionInput | null;
}

export interface RawArticleVersions3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  editorId_eq?: string | null;
  editorId_ne?: string | null;
  editorId_in?: (string | null)[] | null;
  editorId_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  lead_eq?: string | null;
  lead_ne?: string | null;
  lead_in?: (string | null)[] | null;
  lead_nin?: (string | null)[] | null;
  lead_contains?: string | null;
  lead_exists?: boolean | null;
  body_eq?: string | null;
  body_ne?: string | null;
  body_in?: (string | null)[] | null;
  body_nin?: (string | null)[] | null;
  body_contains?: string | null;
  body_exists?: boolean | null;
  signature_eq?: string | null;
  signature_ne?: string | null;
  signature_in?: (string | null)[] | null;
  signature_nin?: (string | null)[] | null;
  signature_contains?: string | null;
  signature_exists?: boolean | null;
  status_eq?: RawArticleStatus | null;
  status_ne?: RawArticleStatus | null;
  status_in?: (RawArticleStatus | null)[] | null;
  status_nin?: (RawArticleStatus | null)[] | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  leftOver_eq?: string | null;
  leftOver_ne?: string | null;
  leftOver_in?: (string | null)[] | null;
  leftOver_nin?: (string | null)[] | null;
  leftOver_contains?: string | null;
  leftOver_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  rawArticle_eq?: RawArticles4WhereInput | null;
  previousVersion_exists?: boolean | null;
  previousVersion_eq?: RawArticleVersions4WhereInput | null;
  forkOf_exists?: boolean | null;
  forkOf_eq?: RawArticleVersions4WhereInput | null;
  nextVersion_exists?: boolean | null;
  nextVersion_eq?: RawArticleVersions4WhereInput | null;
  rawArticleVersions_some?: RawArticleVersions4WhereInput | null;
  AND?: (RawArticleVersions4WhereInput | null)[] | null;
  NOT?: RawArticleVersions4WhereInput | null;
  OR?: (RawArticleVersions4WhereInput | null)[] | null;
}

export interface RawArticleVersions4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  editorId_eq?: string | null;
  editorId_ne?: string | null;
  editorId_in?: (string | null)[] | null;
  editorId_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  lead_eq?: string | null;
  lead_ne?: string | null;
  lead_in?: (string | null)[] | null;
  lead_nin?: (string | null)[] | null;
  lead_contains?: string | null;
  lead_exists?: boolean | null;
  body_eq?: string | null;
  body_ne?: string | null;
  body_in?: (string | null)[] | null;
  body_nin?: (string | null)[] | null;
  body_contains?: string | null;
  body_exists?: boolean | null;
  signature_eq?: string | null;
  signature_ne?: string | null;
  signature_in?: (string | null)[] | null;
  signature_nin?: (string | null)[] | null;
  signature_contains?: string | null;
  signature_exists?: boolean | null;
  status_eq?: RawArticleStatus | null;
  status_ne?: RawArticleStatus | null;
  status_in?: (RawArticleStatus | null)[] | null;
  status_nin?: (RawArticleStatus | null)[] | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  leftOver_eq?: string | null;
  leftOver_ne?: string | null;
  leftOver_in?: (string | null)[] | null;
  leftOver_nin?: (string | null)[] | null;
  leftOver_contains?: string | null;
  leftOver_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  rawArticle_eq?: RawArticles5WhereInput | null;
  previousVersion_exists?: boolean | null;
  previousVersion_eq?: RawArticleVersions5WhereInput | null;
  forkOf_exists?: boolean | null;
  forkOf_eq?: RawArticleVersions5WhereInput | null;
  nextVersion_exists?: boolean | null;
  nextVersion_eq?: RawArticleVersions5WhereInput | null;
  rawArticleVersions_some?: RawArticleVersions5WhereInput | null;
  AND?: (RawArticleVersions5WhereInput | null)[] | null;
  NOT?: RawArticleVersions5WhereInput | null;
  OR?: (RawArticleVersions5WhereInput | null)[] | null;
}

export interface RawArticleVersions5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  editorId_eq?: string | null;
  editorId_ne?: string | null;
  editorId_in?: (string | null)[] | null;
  editorId_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  lead_eq?: string | null;
  lead_ne?: string | null;
  lead_in?: (string | null)[] | null;
  lead_nin?: (string | null)[] | null;
  lead_contains?: string | null;
  lead_exists?: boolean | null;
  body_eq?: string | null;
  body_ne?: string | null;
  body_in?: (string | null)[] | null;
  body_nin?: (string | null)[] | null;
  body_contains?: string | null;
  body_exists?: boolean | null;
  signature_eq?: string | null;
  signature_ne?: string | null;
  signature_in?: (string | null)[] | null;
  signature_nin?: (string | null)[] | null;
  signature_contains?: string | null;
  signature_exists?: boolean | null;
  status_eq?: RawArticleStatus | null;
  status_ne?: RawArticleStatus | null;
  status_in?: (RawArticleStatus | null)[] | null;
  status_nin?: (RawArticleStatus | null)[] | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  leftOver_eq?: string | null;
  leftOver_ne?: string | null;
  leftOver_in?: (string | null)[] | null;
  leftOver_nin?: (string | null)[] | null;
  leftOver_contains?: string | null;
  leftOver_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  rawArticle_eq?: RawArticles6WhereInput | null;
  previousVersion_exists?: boolean | null;
  previousVersion_eq?: RawArticleVersions6WhereInput | null;
  forkOf_exists?: boolean | null;
  forkOf_eq?: RawArticleVersions6WhereInput | null;
  nextVersion_exists?: boolean | null;
  nextVersion_eq?: RawArticleVersions6WhereInput | null;
  rawArticleVersions_some?: RawArticleVersions6WhereInput | null;
  AND?: (RawArticleVersions6WhereInput | null)[] | null;
  NOT?: RawArticleVersions6WhereInput | null;
  OR?: (RawArticleVersions6WhereInput | null)[] | null;
}

export interface RawArticleVersions6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  editorId_eq?: string | null;
  editorId_ne?: string | null;
  editorId_in?: (string | null)[] | null;
  editorId_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  lead_eq?: string | null;
  lead_ne?: string | null;
  lead_in?: (string | null)[] | null;
  lead_nin?: (string | null)[] | null;
  lead_contains?: string | null;
  lead_exists?: boolean | null;
  body_eq?: string | null;
  body_ne?: string | null;
  body_in?: (string | null)[] | null;
  body_nin?: (string | null)[] | null;
  body_contains?: string | null;
  body_exists?: boolean | null;
  signature_eq?: string | null;
  signature_ne?: string | null;
  signature_in?: (string | null)[] | null;
  signature_nin?: (string | null)[] | null;
  signature_contains?: string | null;
  signature_exists?: boolean | null;
  status_eq?: RawArticleStatus | null;
  status_ne?: RawArticleStatus | null;
  status_in?: (RawArticleStatus | null)[] | null;
  status_nin?: (RawArticleStatus | null)[] | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  leftOver_eq?: string | null;
  leftOver_ne?: string | null;
  leftOver_in?: (string | null)[] | null;
  leftOver_nin?: (string | null)[] | null;
  leftOver_contains?: string | null;
  leftOver_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  rawArticle_eq?: RawArticles7WhereInput | null;
  previousVersion_exists?: boolean | null;
  previousVersion_eq?: RawArticleVersions7WhereInput | null;
  forkOf_exists?: boolean | null;
  forkOf_eq?: RawArticleVersions7WhereInput | null;
  nextVersion_exists?: boolean | null;
  nextVersion_eq?: RawArticleVersions7WhereInput | null;
  rawArticleVersions_some?: RawArticleVersions7WhereInput | null;
  AND?: (RawArticleVersions7WhereInput | null)[] | null;
  NOT?: RawArticleVersions7WhereInput | null;
  OR?: (RawArticleVersions7WhereInput | null)[] | null;
}

export interface RawArticleVersions7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  editorId_eq?: string | null;
  editorId_ne?: string | null;
  editorId_in?: (string | null)[] | null;
  editorId_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  lead_eq?: string | null;
  lead_ne?: string | null;
  lead_in?: (string | null)[] | null;
  lead_nin?: (string | null)[] | null;
  lead_contains?: string | null;
  lead_exists?: boolean | null;
  body_eq?: string | null;
  body_ne?: string | null;
  body_in?: (string | null)[] | null;
  body_nin?: (string | null)[] | null;
  body_contains?: string | null;
  body_exists?: boolean | null;
  signature_eq?: string | null;
  signature_ne?: string | null;
  signature_in?: (string | null)[] | null;
  signature_nin?: (string | null)[] | null;
  signature_contains?: string | null;
  signature_exists?: boolean | null;
  status_eq?: RawArticleStatus | null;
  status_ne?: RawArticleStatus | null;
  status_in?: (RawArticleStatus | null)[] | null;
  status_nin?: (RawArticleStatus | null)[] | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  leftOver_eq?: string | null;
  leftOver_ne?: string | null;
  leftOver_in?: (string | null)[] | null;
  leftOver_nin?: (string | null)[] | null;
  leftOver_contains?: string | null;
  leftOver_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  rawArticle_eq?: RawArticles8WhereInput | null;
  previousVersion_exists?: boolean | null;
  previousVersion_eq?: RawArticleVersions8WhereInput | null;
  forkOf_exists?: boolean | null;
  forkOf_eq?: RawArticleVersions8WhereInput | null;
  nextVersion_exists?: boolean | null;
  nextVersion_eq?: RawArticleVersions8WhereInput | null;
  rawArticleVersions_some?: RawArticleVersions8WhereInput | null;
  AND?: (RawArticleVersions8WhereInput | null)[] | null;
  NOT?: RawArticleVersions8WhereInput | null;
  OR?: (RawArticleVersions8WhereInput | null)[] | null;
}

export interface RawArticleVersions8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  editorId_eq?: string | null;
  editorId_ne?: string | null;
  editorId_in?: (string | null)[] | null;
  editorId_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  lead_eq?: string | null;
  lead_ne?: string | null;
  lead_in?: (string | null)[] | null;
  lead_nin?: (string | null)[] | null;
  lead_contains?: string | null;
  lead_exists?: boolean | null;
  body_eq?: string | null;
  body_ne?: string | null;
  body_in?: (string | null)[] | null;
  body_nin?: (string | null)[] | null;
  body_contains?: string | null;
  body_exists?: boolean | null;
  signature_eq?: string | null;
  signature_ne?: string | null;
  signature_in?: (string | null)[] | null;
  signature_nin?: (string | null)[] | null;
  signature_contains?: string | null;
  signature_exists?: boolean | null;
  status_eq?: RawArticleStatus | null;
  status_ne?: RawArticleStatus | null;
  status_in?: (RawArticleStatus | null)[] | null;
  status_nin?: (RawArticleStatus | null)[] | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  leftOver_eq?: string | null;
  leftOver_ne?: string | null;
  leftOver_in?: (string | null)[] | null;
  leftOver_nin?: (string | null)[] | null;
  leftOver_contains?: string | null;
  leftOver_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
}

export interface RawArticles2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments3WhereInput | null;
  flatAssignment_exists?: boolean | null;
  flatAssignment_eq?: FlatAssignments3WhereInput | null;
  versions_some?: RawArticleVersions3WhereInput | null;
  AND?: (RawArticles3WhereInput | null)[] | null;
  NOT?: RawArticles3WhereInput | null;
  OR?: (RawArticles3WhereInput | null)[] | null;
}

export interface RawArticles3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments4WhereInput | null;
  flatAssignment_exists?: boolean | null;
  flatAssignment_eq?: FlatAssignments4WhereInput | null;
  versions_some?: RawArticleVersions4WhereInput | null;
  AND?: (RawArticles4WhereInput | null)[] | null;
  NOT?: RawArticles4WhereInput | null;
  OR?: (RawArticles4WhereInput | null)[] | null;
}

export interface RawArticles4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments5WhereInput | null;
  flatAssignment_exists?: boolean | null;
  flatAssignment_eq?: FlatAssignments5WhereInput | null;
  versions_some?: RawArticleVersions5WhereInput | null;
  AND?: (RawArticles5WhereInput | null)[] | null;
  NOT?: RawArticles5WhereInput | null;
  OR?: (RawArticles5WhereInput | null)[] | null;
}

export interface RawArticles5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments6WhereInput | null;
  flatAssignment_exists?: boolean | null;
  flatAssignment_eq?: FlatAssignments6WhereInput | null;
  versions_some?: RawArticleVersions6WhereInput | null;
  AND?: (RawArticles6WhereInput | null)[] | null;
  NOT?: RawArticles6WhereInput | null;
  OR?: (RawArticles6WhereInput | null)[] | null;
}

export interface RawArticles6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments7WhereInput | null;
  flatAssignment_exists?: boolean | null;
  flatAssignment_eq?: FlatAssignments7WhereInput | null;
  versions_some?: RawArticleVersions7WhereInput | null;
  AND?: (RawArticles7WhereInput | null)[] | null;
  NOT?: RawArticles7WhereInput | null;
  OR?: (RawArticles7WhereInput | null)[] | null;
}

export interface RawArticles7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  assignment_exists?: boolean | null;
  assignment_eq?: Assignments8WhereInput | null;
  flatAssignment_exists?: boolean | null;
  flatAssignment_eq?: FlatAssignments8WhereInput | null;
  versions_some?: RawArticleVersions8WhereInput | null;
  AND?: (RawArticles8WhereInput | null)[] | null;
  NOT?: RawArticles8WhereInput | null;
  OR?: (RawArticles8WhereInput | null)[] | null;
}

export interface RawArticles8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface SubSubjectFromSubjectNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
}

export interface SubSubjects1WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects2WhereInput | null;
  AND?: (SubSubjects2WhereInput | null)[] | null;
  NOT?: SubSubjects2WhereInput | null;
  OR?: (SubSubjects2WhereInput | null)[] | null;
}

export interface SubSubjects2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects3WhereInput | null;
  AND?: (SubSubjects3WhereInput | null)[] | null;
  NOT?: SubSubjects3WhereInput | null;
  OR?: (SubSubjects3WhereInput | null)[] | null;
}

export interface SubSubjects3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects4WhereInput | null;
  AND?: (SubSubjects4WhereInput | null)[] | null;
  NOT?: SubSubjects4WhereInput | null;
  OR?: (SubSubjects4WhereInput | null)[] | null;
}

export interface SubSubjects4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects5WhereInput | null;
  AND?: (SubSubjects5WhereInput | null)[] | null;
  NOT?: SubSubjects5WhereInput | null;
  OR?: (SubSubjects5WhereInput | null)[] | null;
}

export interface SubSubjects5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects6WhereInput | null;
  AND?: (SubSubjects6WhereInput | null)[] | null;
  NOT?: SubSubjects6WhereInput | null;
  OR?: (SubSubjects6WhereInput | null)[] | null;
}

export interface SubSubjects6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects7WhereInput | null;
  AND?: (SubSubjects7WhereInput | null)[] | null;
  NOT?: SubSubjects7WhereInput | null;
  OR?: (SubSubjects7WhereInput | null)[] | null;
}

export interface SubSubjects7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects8WhereInput | null;
  AND?: (SubSubjects8WhereInput | null)[] | null;
  NOT?: SubSubjects8WhereInput | null;
  OR?: (SubSubjects8WhereInput | null)[] | null;
}

export interface SubSubjects8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface Subject1NodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface SubjectCategories1WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  parent_exists?: boolean | null;
  parent_eq?: SubjectCategories2WhereInput | null;
  unit_eq?: Units2WhereInput | null;
  subjects_some?: Subjects2WhereInput | null;
  children_some?: SubjectCategories2WhereInput | null;
  AND?: (SubjectCategories2WhereInput | null)[] | null;
  NOT?: SubjectCategories2WhereInput | null;
  OR?: (SubjectCategories2WhereInput | null)[] | null;
}

export interface SubjectCategories2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  parent_exists?: boolean | null;
  parent_eq?: SubjectCategories3WhereInput | null;
  unit_eq?: Units3WhereInput | null;
  subjects_some?: Subjects3WhereInput | null;
  children_some?: SubjectCategories3WhereInput | null;
  AND?: (SubjectCategories3WhereInput | null)[] | null;
  NOT?: SubjectCategories3WhereInput | null;
  OR?: (SubjectCategories3WhereInput | null)[] | null;
}

export interface SubjectCategories3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  parent_exists?: boolean | null;
  parent_eq?: SubjectCategories4WhereInput | null;
  unit_eq?: Units4WhereInput | null;
  subjects_some?: Subjects4WhereInput | null;
  children_some?: SubjectCategories4WhereInput | null;
  AND?: (SubjectCategories4WhereInput | null)[] | null;
  NOT?: SubjectCategories4WhereInput | null;
  OR?: (SubjectCategories4WhereInput | null)[] | null;
}

export interface SubjectCategories4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  parent_exists?: boolean | null;
  parent_eq?: SubjectCategories5WhereInput | null;
  unit_eq?: Units5WhereInput | null;
  subjects_some?: Subjects5WhereInput | null;
  children_some?: SubjectCategories5WhereInput | null;
  AND?: (SubjectCategories5WhereInput | null)[] | null;
  NOT?: SubjectCategories5WhereInput | null;
  OR?: (SubjectCategories5WhereInput | null)[] | null;
}

export interface SubjectCategories5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  parent_exists?: boolean | null;
  parent_eq?: SubjectCategories6WhereInput | null;
  unit_eq?: Units6WhereInput | null;
  subjects_some?: Subjects6WhereInput | null;
  children_some?: SubjectCategories6WhereInput | null;
  AND?: (SubjectCategories6WhereInput | null)[] | null;
  NOT?: SubjectCategories6WhereInput | null;
  OR?: (SubjectCategories6WhereInput | null)[] | null;
}

export interface SubjectCategories6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  parent_exists?: boolean | null;
  parent_eq?: SubjectCategories7WhereInput | null;
  unit_eq?: Units7WhereInput | null;
  subjects_some?: Subjects7WhereInput | null;
  children_some?: SubjectCategories7WhereInput | null;
  AND?: (SubjectCategories7WhereInput | null)[] | null;
  NOT?: SubjectCategories7WhereInput | null;
  OR?: (SubjectCategories7WhereInput | null)[] | null;
}

export interface SubjectCategories7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  parent_exists?: boolean | null;
  parent_eq?: SubjectCategories8WhereInput | null;
  unit_eq?: Units8WhereInput | null;
  subjects_some?: Subjects8WhereInput | null;
  children_some?: SubjectCategories8WhereInput | null;
  AND?: (SubjectCategories8WhereInput | null)[] | null;
  NOT?: SubjectCategories8WhereInput | null;
  OR?: (SubjectCategories8WhereInput | null)[] | null;
}

export interface SubjectCategories8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface SubjectCategoryFromParentNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface SubjectCategoryFromSubjectCategoryNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface SubjectCategoryFromUnitNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface SubjectCategoryNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface SubjectFromSubjectCategoryNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  unit_eq?: Unit1NodeSelectionInput | null;
  legacyId_eq?: number | null;
}

export interface SubjectFromSubjectNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  unit_eq?: Unit1NodeSelectionInput | null;
  legacyId_eq?: number | null;
}

export interface SubjectFromUnitNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  legacyId_eq?: number | null;
}

export interface SubjectNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  unit_eq?: Unit1NodeSelectionInput | null;
  legacyId_eq?: number | null;
}

export interface SubjectSubjectTagFromSubjectNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface SubjectSubjectTags1WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  order_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects2WhereInput | null;
  subjectTag_eq?: SubjectTags2WhereInput | null;
  AND?: (SubjectSubjectTags2WhereInput | null)[] | null;
  NOT?: SubjectSubjectTags2WhereInput | null;
  OR?: (SubjectSubjectTags2WhereInput | null)[] | null;
}

export interface SubjectSubjectTags2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  order_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects3WhereInput | null;
  subjectTag_eq?: SubjectTags3WhereInput | null;
  AND?: (SubjectSubjectTags3WhereInput | null)[] | null;
  NOT?: SubjectSubjectTags3WhereInput | null;
  OR?: (SubjectSubjectTags3WhereInput | null)[] | null;
}

export interface SubjectSubjectTags3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  order_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects4WhereInput | null;
  subjectTag_eq?: SubjectTags4WhereInput | null;
  AND?: (SubjectSubjectTags4WhereInput | null)[] | null;
  NOT?: SubjectSubjectTags4WhereInput | null;
  OR?: (SubjectSubjectTags4WhereInput | null)[] | null;
}

export interface SubjectSubjectTags4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  order_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects5WhereInput | null;
  subjectTag_eq?: SubjectTags5WhereInput | null;
  AND?: (SubjectSubjectTags5WhereInput | null)[] | null;
  NOT?: SubjectSubjectTags5WhereInput | null;
  OR?: (SubjectSubjectTags5WhereInput | null)[] | null;
}

export interface SubjectSubjectTags5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  order_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects6WhereInput | null;
  subjectTag_eq?: SubjectTags6WhereInput | null;
  AND?: (SubjectSubjectTags6WhereInput | null)[] | null;
  NOT?: SubjectSubjectTags6WhereInput | null;
  OR?: (SubjectSubjectTags6WhereInput | null)[] | null;
}

export interface SubjectSubjectTags6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  order_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects7WhereInput | null;
  subjectTag_eq?: SubjectTags7WhereInput | null;
  AND?: (SubjectSubjectTags7WhereInput | null)[] | null;
  NOT?: SubjectSubjectTags7WhereInput | null;
  OR?: (SubjectSubjectTags7WhereInput | null)[] | null;
}

export interface SubjectSubjectTags7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  order_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects8WhereInput | null;
  subjectTag_eq?: SubjectTags8WhereInput | null;
  AND?: (SubjectSubjectTags8WhereInput | null)[] | null;
  NOT?: SubjectSubjectTags8WhereInput | null;
  OR?: (SubjectSubjectTags8WhereInput | null)[] | null;
}

export interface SubjectSubjectTags8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  order_eq?: number | null;
  order_ne?: number | null;
  order_in?: (number | null)[] | null;
  order_nin?: (number | null)[] | null;
  order_gt?: number | null;
  order_gte?: number | null;
  order_lt?: number | null;
  order_lte?: number | null;
  order_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface SubjectTagFromSubjectTagNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface SubjectTagNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface SubjectTags2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  slug_eq?: string | null;
  slug_ne?: string | null;
  slug_in?: (string | null)[] | null;
  slug_nin?: (string | null)[] | null;
  slug_contains?: string | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjects_some?: SubjectSubjectTags3WhereInput | null;
  AND?: (SubjectTags3WhereInput | null)[] | null;
  NOT?: SubjectTags3WhereInput | null;
  OR?: (SubjectTags3WhereInput | null)[] | null;
}

export interface SubjectTags3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  slug_eq?: string | null;
  slug_ne?: string | null;
  slug_in?: (string | null)[] | null;
  slug_nin?: (string | null)[] | null;
  slug_contains?: string | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjects_some?: SubjectSubjectTags4WhereInput | null;
  AND?: (SubjectTags4WhereInput | null)[] | null;
  NOT?: SubjectTags4WhereInput | null;
  OR?: (SubjectTags4WhereInput | null)[] | null;
}

export interface SubjectTags4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  slug_eq?: string | null;
  slug_ne?: string | null;
  slug_in?: (string | null)[] | null;
  slug_nin?: (string | null)[] | null;
  slug_contains?: string | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjects_some?: SubjectSubjectTags5WhereInput | null;
  AND?: (SubjectTags5WhereInput | null)[] | null;
  NOT?: SubjectTags5WhereInput | null;
  OR?: (SubjectTags5WhereInput | null)[] | null;
}

export interface SubjectTags5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  slug_eq?: string | null;
  slug_ne?: string | null;
  slug_in?: (string | null)[] | null;
  slug_nin?: (string | null)[] | null;
  slug_contains?: string | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjects_some?: SubjectSubjectTags6WhereInput | null;
  AND?: (SubjectTags6WhereInput | null)[] | null;
  NOT?: SubjectTags6WhereInput | null;
  OR?: (SubjectTags6WhereInput | null)[] | null;
}

export interface SubjectTags6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  slug_eq?: string | null;
  slug_ne?: string | null;
  slug_in?: (string | null)[] | null;
  slug_nin?: (string | null)[] | null;
  slug_contains?: string | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjects_some?: SubjectSubjectTags7WhereInput | null;
  AND?: (SubjectTags7WhereInput | null)[] | null;
  NOT?: SubjectTags7WhereInput | null;
  OR?: (SubjectTags7WhereInput | null)[] | null;
}

export interface SubjectTags7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  slug_eq?: string | null;
  slug_ne?: string | null;
  slug_in?: (string | null)[] | null;
  slug_nin?: (string | null)[] | null;
  slug_contains?: string | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjects_some?: SubjectSubjectTags8WhereInput | null;
  AND?: (SubjectTags8WhereInput | null)[] | null;
  NOT?: SubjectTags8WhereInput | null;
  OR?: (SubjectTags8WhereInput | null)[] | null;
}

export interface SubjectTags8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  slug_eq?: string | null;
  slug_ne?: string | null;
  slug_in?: (string | null)[] | null;
  slug_nin?: (string | null)[] | null;
  slug_contains?: string | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface SubjectUserFromSubjectNodeSelectionInput {
  userId_eq: string;
}

export interface SubjectUsers1WhereInput {
  userId_eq?: string | null;
  userId_ne?: string | null;
  userId_in?: (string | null)[] | null;
  userId_nin?: (string | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects2WhereInput | null;
  AND?: (SubjectUsers2WhereInput | null)[] | null;
  NOT?: SubjectUsers2WhereInput | null;
  OR?: (SubjectUsers2WhereInput | null)[] | null;
}

export interface SubjectUsers2WhereInput {
  userId_eq?: string | null;
  userId_ne?: string | null;
  userId_in?: (string | null)[] | null;
  userId_nin?: (string | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects3WhereInput | null;
  AND?: (SubjectUsers3WhereInput | null)[] | null;
  NOT?: SubjectUsers3WhereInput | null;
  OR?: (SubjectUsers3WhereInput | null)[] | null;
}

export interface SubjectUsers3WhereInput {
  userId_eq?: string | null;
  userId_ne?: string | null;
  userId_in?: (string | null)[] | null;
  userId_nin?: (string | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects4WhereInput | null;
  AND?: (SubjectUsers4WhereInput | null)[] | null;
  NOT?: SubjectUsers4WhereInput | null;
  OR?: (SubjectUsers4WhereInput | null)[] | null;
}

export interface SubjectUsers4WhereInput {
  userId_eq?: string | null;
  userId_ne?: string | null;
  userId_in?: (string | null)[] | null;
  userId_nin?: (string | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects5WhereInput | null;
  AND?: (SubjectUsers5WhereInput | null)[] | null;
  NOT?: SubjectUsers5WhereInput | null;
  OR?: (SubjectUsers5WhereInput | null)[] | null;
}

export interface SubjectUsers5WhereInput {
  userId_eq?: string | null;
  userId_ne?: string | null;
  userId_in?: (string | null)[] | null;
  userId_nin?: (string | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects6WhereInput | null;
  AND?: (SubjectUsers6WhereInput | null)[] | null;
  NOT?: SubjectUsers6WhereInput | null;
  OR?: (SubjectUsers6WhereInput | null)[] | null;
}

export interface SubjectUsers6WhereInput {
  userId_eq?: string | null;
  userId_ne?: string | null;
  userId_in?: (string | null)[] | null;
  userId_nin?: (string | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects7WhereInput | null;
  AND?: (SubjectUsers7WhereInput | null)[] | null;
  NOT?: SubjectUsers7WhereInput | null;
  OR?: (SubjectUsers7WhereInput | null)[] | null;
}

export interface SubjectUsers7WhereInput {
  userId_eq?: string | null;
  userId_ne?: string | null;
  userId_in?: (string | null)[] | null;
  userId_nin?: (string | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subject_eq?: Subjects8WhereInput | null;
  AND?: (SubjectUsers8WhereInput | null)[] | null;
  NOT?: SubjectUsers8WhereInput | null;
  OR?: (SubjectUsers8WhereInput | null)[] | null;
}

export interface SubjectUsers8WhereInput {
  userId_eq?: string | null;
  userId_ne?: string | null;
  userId_in?: (string | null)[] | null;
  userId_nin?: (string | null)[] | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface Subjects1WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  synopsis_eq?: string | null;
  synopsis_ne?: string | null;
  synopsis_in?: (string | null)[] | null;
  synopsis_nin?: (string | null)[] | null;
  synopsis_contains?: string | null;
  synopsis_exists?: boolean | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  mediaRequest_eq?: string | null;
  mediaRequest_ne?: string | null;
  mediaRequest_in?: (string | null)[] | null;
  mediaRequest_nin?: (string | null)[] | null;
  mediaRequest_contains?: string | null;
  mediaRequest_exists?: boolean | null;
  isClassified_eq?: boolean | null;
  isClassified_ne?: boolean | null;
  isClassified_in?: (boolean | null)[] | null;
  isClassified_nin?: (boolean | null)[] | null;
  isClassified_exists?: boolean | null;
  isAuto_eq?: boolean | null;
  isAuto_ne?: boolean | null;
  isAuto_in?: (boolean | null)[] | null;
  isAuto_nin?: (boolean | null)[] | null;
  isAuto_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjectCategory_exists?: boolean | null;
  subjectCategory_eq?: SubjectCategories2WhereInput | null;
  unit_eq?: Units2WhereInput | null;
  assignments_some?: Assignments2WhereInput | null;
  attachments_some?: Attachments2WhereInput | null;
  flatAssignment_some?: FlatAssignments2WhereInput | null;
  subSubjects_some?: SubSubjects2WhereInput | null;
  subjectTags_some?: SubjectSubjectTags2WhereInput | null;
  subjectUsers_some?: SubjectUsers2WhereInput | null;
  AND?: (Subjects2WhereInput | null)[] | null;
  NOT?: Subjects2WhereInput | null;
  OR?: (Subjects2WhereInput | null)[] | null;
}

export interface Subjects2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  synopsis_eq?: string | null;
  synopsis_ne?: string | null;
  synopsis_in?: (string | null)[] | null;
  synopsis_nin?: (string | null)[] | null;
  synopsis_contains?: string | null;
  synopsis_exists?: boolean | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  mediaRequest_eq?: string | null;
  mediaRequest_ne?: string | null;
  mediaRequest_in?: (string | null)[] | null;
  mediaRequest_nin?: (string | null)[] | null;
  mediaRequest_contains?: string | null;
  mediaRequest_exists?: boolean | null;
  isClassified_eq?: boolean | null;
  isClassified_ne?: boolean | null;
  isClassified_in?: (boolean | null)[] | null;
  isClassified_nin?: (boolean | null)[] | null;
  isClassified_exists?: boolean | null;
  isAuto_eq?: boolean | null;
  isAuto_ne?: boolean | null;
  isAuto_in?: (boolean | null)[] | null;
  isAuto_nin?: (boolean | null)[] | null;
  isAuto_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjectCategory_exists?: boolean | null;
  subjectCategory_eq?: SubjectCategories3WhereInput | null;
  unit_eq?: Units3WhereInput | null;
  assignments_some?: Assignments3WhereInput | null;
  attachments_some?: Attachments3WhereInput | null;
  flatAssignment_some?: FlatAssignments3WhereInput | null;
  subSubjects_some?: SubSubjects3WhereInput | null;
  subjectTags_some?: SubjectSubjectTags3WhereInput | null;
  subjectUsers_some?: SubjectUsers3WhereInput | null;
  AND?: (Subjects3WhereInput | null)[] | null;
  NOT?: Subjects3WhereInput | null;
  OR?: (Subjects3WhereInput | null)[] | null;
}

export interface Subjects3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  synopsis_eq?: string | null;
  synopsis_ne?: string | null;
  synopsis_in?: (string | null)[] | null;
  synopsis_nin?: (string | null)[] | null;
  synopsis_contains?: string | null;
  synopsis_exists?: boolean | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  mediaRequest_eq?: string | null;
  mediaRequest_ne?: string | null;
  mediaRequest_in?: (string | null)[] | null;
  mediaRequest_nin?: (string | null)[] | null;
  mediaRequest_contains?: string | null;
  mediaRequest_exists?: boolean | null;
  isClassified_eq?: boolean | null;
  isClassified_ne?: boolean | null;
  isClassified_in?: (boolean | null)[] | null;
  isClassified_nin?: (boolean | null)[] | null;
  isClassified_exists?: boolean | null;
  isAuto_eq?: boolean | null;
  isAuto_ne?: boolean | null;
  isAuto_in?: (boolean | null)[] | null;
  isAuto_nin?: (boolean | null)[] | null;
  isAuto_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjectCategory_exists?: boolean | null;
  subjectCategory_eq?: SubjectCategories4WhereInput | null;
  unit_eq?: Units4WhereInput | null;
  assignments_some?: Assignments4WhereInput | null;
  attachments_some?: Attachments4WhereInput | null;
  flatAssignment_some?: FlatAssignments4WhereInput | null;
  subSubjects_some?: SubSubjects4WhereInput | null;
  subjectTags_some?: SubjectSubjectTags4WhereInput | null;
  subjectUsers_some?: SubjectUsers4WhereInput | null;
  AND?: (Subjects4WhereInput | null)[] | null;
  NOT?: Subjects4WhereInput | null;
  OR?: (Subjects4WhereInput | null)[] | null;
}

export interface Subjects4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  synopsis_eq?: string | null;
  synopsis_ne?: string | null;
  synopsis_in?: (string | null)[] | null;
  synopsis_nin?: (string | null)[] | null;
  synopsis_contains?: string | null;
  synopsis_exists?: boolean | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  mediaRequest_eq?: string | null;
  mediaRequest_ne?: string | null;
  mediaRequest_in?: (string | null)[] | null;
  mediaRequest_nin?: (string | null)[] | null;
  mediaRequest_contains?: string | null;
  mediaRequest_exists?: boolean | null;
  isClassified_eq?: boolean | null;
  isClassified_ne?: boolean | null;
  isClassified_in?: (boolean | null)[] | null;
  isClassified_nin?: (boolean | null)[] | null;
  isClassified_exists?: boolean | null;
  isAuto_eq?: boolean | null;
  isAuto_ne?: boolean | null;
  isAuto_in?: (boolean | null)[] | null;
  isAuto_nin?: (boolean | null)[] | null;
  isAuto_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjectCategory_exists?: boolean | null;
  subjectCategory_eq?: SubjectCategories5WhereInput | null;
  unit_eq?: Units5WhereInput | null;
  assignments_some?: Assignments5WhereInput | null;
  attachments_some?: Attachments5WhereInput | null;
  flatAssignment_some?: FlatAssignments5WhereInput | null;
  subSubjects_some?: SubSubjects5WhereInput | null;
  subjectTags_some?: SubjectSubjectTags5WhereInput | null;
  subjectUsers_some?: SubjectUsers5WhereInput | null;
  AND?: (Subjects5WhereInput | null)[] | null;
  NOT?: Subjects5WhereInput | null;
  OR?: (Subjects5WhereInput | null)[] | null;
}

export interface Subjects5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  synopsis_eq?: string | null;
  synopsis_ne?: string | null;
  synopsis_in?: (string | null)[] | null;
  synopsis_nin?: (string | null)[] | null;
  synopsis_contains?: string | null;
  synopsis_exists?: boolean | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  mediaRequest_eq?: string | null;
  mediaRequest_ne?: string | null;
  mediaRequest_in?: (string | null)[] | null;
  mediaRequest_nin?: (string | null)[] | null;
  mediaRequest_contains?: string | null;
  mediaRequest_exists?: boolean | null;
  isClassified_eq?: boolean | null;
  isClassified_ne?: boolean | null;
  isClassified_in?: (boolean | null)[] | null;
  isClassified_nin?: (boolean | null)[] | null;
  isClassified_exists?: boolean | null;
  isAuto_eq?: boolean | null;
  isAuto_ne?: boolean | null;
  isAuto_in?: (boolean | null)[] | null;
  isAuto_nin?: (boolean | null)[] | null;
  isAuto_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjectCategory_exists?: boolean | null;
  subjectCategory_eq?: SubjectCategories6WhereInput | null;
  unit_eq?: Units6WhereInput | null;
  assignments_some?: Assignments6WhereInput | null;
  attachments_some?: Attachments6WhereInput | null;
  flatAssignment_some?: FlatAssignments6WhereInput | null;
  subSubjects_some?: SubSubjects6WhereInput | null;
  subjectTags_some?: SubjectSubjectTags6WhereInput | null;
  subjectUsers_some?: SubjectUsers6WhereInput | null;
  AND?: (Subjects6WhereInput | null)[] | null;
  NOT?: Subjects6WhereInput | null;
  OR?: (Subjects6WhereInput | null)[] | null;
}

export interface Subjects6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  synopsis_eq?: string | null;
  synopsis_ne?: string | null;
  synopsis_in?: (string | null)[] | null;
  synopsis_nin?: (string | null)[] | null;
  synopsis_contains?: string | null;
  synopsis_exists?: boolean | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  mediaRequest_eq?: string | null;
  mediaRequest_ne?: string | null;
  mediaRequest_in?: (string | null)[] | null;
  mediaRequest_nin?: (string | null)[] | null;
  mediaRequest_contains?: string | null;
  mediaRequest_exists?: boolean | null;
  isClassified_eq?: boolean | null;
  isClassified_ne?: boolean | null;
  isClassified_in?: (boolean | null)[] | null;
  isClassified_nin?: (boolean | null)[] | null;
  isClassified_exists?: boolean | null;
  isAuto_eq?: boolean | null;
  isAuto_ne?: boolean | null;
  isAuto_in?: (boolean | null)[] | null;
  isAuto_nin?: (boolean | null)[] | null;
  isAuto_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjectCategory_exists?: boolean | null;
  subjectCategory_eq?: SubjectCategories7WhereInput | null;
  unit_eq?: Units7WhereInput | null;
  assignments_some?: Assignments7WhereInput | null;
  attachments_some?: Attachments7WhereInput | null;
  flatAssignment_some?: FlatAssignments7WhereInput | null;
  subSubjects_some?: SubSubjects7WhereInput | null;
  subjectTags_some?: SubjectSubjectTags7WhereInput | null;
  subjectUsers_some?: SubjectUsers7WhereInput | null;
  AND?: (Subjects7WhereInput | null)[] | null;
  NOT?: Subjects7WhereInput | null;
  OR?: (Subjects7WhereInput | null)[] | null;
}

export interface Subjects7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  synopsis_eq?: string | null;
  synopsis_ne?: string | null;
  synopsis_in?: (string | null)[] | null;
  synopsis_nin?: (string | null)[] | null;
  synopsis_contains?: string | null;
  synopsis_exists?: boolean | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  mediaRequest_eq?: string | null;
  mediaRequest_ne?: string | null;
  mediaRequest_in?: (string | null)[] | null;
  mediaRequest_nin?: (string | null)[] | null;
  mediaRequest_contains?: string | null;
  mediaRequest_exists?: boolean | null;
  isClassified_eq?: boolean | null;
  isClassified_ne?: boolean | null;
  isClassified_in?: (boolean | null)[] | null;
  isClassified_nin?: (boolean | null)[] | null;
  isClassified_exists?: boolean | null;
  isAuto_eq?: boolean | null;
  isAuto_ne?: boolean | null;
  isAuto_in?: (boolean | null)[] | null;
  isAuto_nin?: (boolean | null)[] | null;
  isAuto_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjectCategory_exists?: boolean | null;
  subjectCategory_eq?: SubjectCategories8WhereInput | null;
  unit_eq?: Units8WhereInput | null;
  assignments_some?: Assignments8WhereInput | null;
  attachments_some?: Attachments8WhereInput | null;
  flatAssignment_some?: FlatAssignments8WhereInput | null;
  subSubjects_some?: SubSubjects8WhereInput | null;
  subjectTags_some?: SubjectSubjectTags8WhereInput | null;
  subjectUsers_some?: SubjectUsers8WhereInput | null;
  AND?: (Subjects8WhereInput | null)[] | null;
  NOT?: Subjects8WhereInput | null;
  OR?: (Subjects8WhereInput | null)[] | null;
}

export interface Subjects8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  synopsis_eq?: string | null;
  synopsis_ne?: string | null;
  synopsis_in?: (string | null)[] | null;
  synopsis_nin?: (string | null)[] | null;
  synopsis_contains?: string | null;
  synopsis_exists?: boolean | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  mediaRequest_eq?: string | null;
  mediaRequest_ne?: string | null;
  mediaRequest_in?: (string | null)[] | null;
  mediaRequest_nin?: (string | null)[] | null;
  mediaRequest_contains?: string | null;
  mediaRequest_exists?: boolean | null;
  isClassified_eq?: boolean | null;
  isClassified_ne?: boolean | null;
  isClassified_in?: (boolean | null)[] | null;
  isClassified_nin?: (boolean | null)[] | null;
  isClassified_exists?: boolean | null;
  isAuto_eq?: boolean | null;
  isAuto_ne?: boolean | null;
  isAuto_in?: (boolean | null)[] | null;
  isAuto_nin?: (boolean | null)[] | null;
  isAuto_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface SubjectsWhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  comment_eq?: string | null;
  comment_ne?: string | null;
  comment_in?: (string | null)[] | null;
  comment_nin?: (string | null)[] | null;
  comment_contains?: string | null;
  comment_exists?: boolean | null;
  synopsis_eq?: string | null;
  synopsis_ne?: string | null;
  synopsis_in?: (string | null)[] | null;
  synopsis_nin?: (string | null)[] | null;
  synopsis_contains?: string | null;
  synopsis_exists?: boolean | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  mediaRequest_eq?: string | null;
  mediaRequest_ne?: string | null;
  mediaRequest_in?: (string | null)[] | null;
  mediaRequest_nin?: (string | null)[] | null;
  mediaRequest_contains?: string | null;
  mediaRequest_exists?: boolean | null;
  isClassified_eq?: boolean | null;
  isClassified_ne?: boolean | null;
  isClassified_in?: (boolean | null)[] | null;
  isClassified_nin?: (boolean | null)[] | null;
  isClassified_exists?: boolean | null;
  isAuto_eq?: boolean | null;
  isAuto_ne?: boolean | null;
  isAuto_in?: (boolean | null)[] | null;
  isAuto_nin?: (boolean | null)[] | null;
  isAuto_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  subjectCategory_exists?: boolean | null;
  subjectCategory_eq?: SubjectCategories1WhereInput | null;
  unit_eq?: Units1WhereInput | null;
  assignments_some?: Assignments1WhereInput | null;
  attachments_some?: Attachments1WhereInput | null;
  flatAssignment_some?: FlatAssignments1WhereInput | null;
  subSubjects_some?: SubSubjects1WhereInput | null;
  subjectTags_some?: SubjectSubjectTags1WhereInput | null;
  subjectUsers_some?: SubjectUsers1WhereInput | null;
  AND?: (Subjects1WhereInput | null)[] | null;
  NOT?: Subjects1WhereInput | null;
  OR?: (Subjects1WhereInput | null)[] | null;
}

export interface Unit1NodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface UnitFromUnitNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface UnitNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
}

export interface Units1WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brands_some?: Brands2WhereInput | null;
  folders_some?: Folders2WhereInput | null;
  subjects_some?: Subjects2WhereInput | null;
  subjectCategories_some?: SubjectCategories2WhereInput | null;
  AND?: (Units2WhereInput | null)[] | null;
  NOT?: Units2WhereInput | null;
  OR?: (Units2WhereInput | null)[] | null;
}

export interface Units2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brands_some?: Brands3WhereInput | null;
  folders_some?: Folders3WhereInput | null;
  subjects_some?: Subjects3WhereInput | null;
  subjectCategories_some?: SubjectCategories3WhereInput | null;
  AND?: (Units3WhereInput | null)[] | null;
  NOT?: Units3WhereInput | null;
  OR?: (Units3WhereInput | null)[] | null;
}

export interface Units3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brands_some?: Brands4WhereInput | null;
  folders_some?: Folders4WhereInput | null;
  subjects_some?: Subjects4WhereInput | null;
  subjectCategories_some?: SubjectCategories4WhereInput | null;
  AND?: (Units4WhereInput | null)[] | null;
  NOT?: Units4WhereInput | null;
  OR?: (Units4WhereInput | null)[] | null;
}

export interface Units4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brands_some?: Brands5WhereInput | null;
  folders_some?: Folders5WhereInput | null;
  subjects_some?: Subjects5WhereInput | null;
  subjectCategories_some?: SubjectCategories5WhereInput | null;
  AND?: (Units5WhereInput | null)[] | null;
  NOT?: Units5WhereInput | null;
  OR?: (Units5WhereInput | null)[] | null;
}

export interface Units5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brands_some?: Brands6WhereInput | null;
  folders_some?: Folders6WhereInput | null;
  subjects_some?: Subjects6WhereInput | null;
  subjectCategories_some?: SubjectCategories6WhereInput | null;
  AND?: (Units6WhereInput | null)[] | null;
  NOT?: Units6WhereInput | null;
  OR?: (Units6WhereInput | null)[] | null;
}

export interface Units6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brands_some?: Brands7WhereInput | null;
  folders_some?: Folders7WhereInput | null;
  subjects_some?: Subjects7WhereInput | null;
  subjectCategories_some?: SubjectCategories7WhereInput | null;
  AND?: (Units7WhereInput | null)[] | null;
  NOT?: Units7WhereInput | null;
  OR?: (Units7WhereInput | null)[] | null;
}

export interface Units7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brands_some?: Brands8WhereInput | null;
  folders_some?: Folders8WhereInput | null;
  subjects_some?: Subjects8WhereInput | null;
  subjectCategories_some?: SubjectCategories8WhereInput | null;
  AND?: (Units8WhereInput | null)[] | null;
  NOT?: Units8WhereInput | null;
  OR?: (Units8WhereInput | null)[] | null;
}

export interface Units8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

export interface UpdateArticleTemplateFromArticleTemplateAssignments1DataInput {
  label?: string | null;
  block?: string | null;
  printTemplate?: UpdateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate1DataInput | null;
}

export interface UpdateArticleTemplateFromArticleTemplateAssignments1Input {
  data: UpdateArticleTemplateFromArticleTemplateAssignments1DataInput;
  where: ArticleTemplateFromArticleTemplateNodeSelectionInput;
}

export interface UpdateArticleTemplateFromArticleTemplateAssignments2DataInput {
  label?: string | null;
  block?: string | null;
  printTemplate?: UpdateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate2DataInput | null;
}

export interface UpdateArticleTemplateFromArticleTemplateAssignments2Input {
  data: UpdateArticleTemplateFromArticleTemplateAssignments2DataInput;
  where: ArticleTemplateFromArticleTemplateNodeSelectionInput;
}

export interface UpdateArticleTemplateFromArticleTemplateAssignments3DataInput {
  label?: string | null;
  block?: string | null;
  printTemplate?: UpdateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate3DataInput | null;
}

export interface UpdateArticleTemplateFromArticleTemplateAssignments3Input {
  data: UpdateArticleTemplateFromArticleTemplateAssignments3DataInput;
  where: ArticleTemplateFromArticleTemplateNodeSelectionInput;
}

export interface UpdateArticleTemplateFromArticleTemplateAssignments4DataInput {
  label?: string | null;
  block?: string | null;
  printTemplate?: UpdateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate4DataInput | null;
}

export interface UpdateArticleTemplateFromArticleTemplateAssignments4Input {
  data: UpdateArticleTemplateFromArticleTemplateAssignments4DataInput;
  where: ArticleTemplateFromArticleTemplateNodeSelectionInput;
}

export interface UpdateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface UpdateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface UpdateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface UpdateArticleTemplateFromAssignmentArticleTemplateNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateArticleTemplateFromPrintTemplateArticleTemplates1DataInput {
  label?: string | null;
  block?: string | null;
  assignments?: UpdateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments1Input | null;
}

export interface UpdateArticleTemplateFromPrintTemplateArticleTemplates1Input {
  data: UpdateArticleTemplateFromPrintTemplateArticleTemplates1DataInput;
  where: ArticleTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdateArticleTemplateFromPrintTemplateArticleTemplates3DataInput {
  label?: string | null;
  block?: string | null;
  assignments?: UpdateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments3Input | null;
}

export interface UpdateArticleTemplateFromPrintTemplateArticleTemplates3Input {
  data: UpdateArticleTemplateFromPrintTemplateArticleTemplates3DataInput;
  where: ArticleTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdateArticleTemplateFromPrintTemplateArticleTemplates4DataInput {
  label?: string | null;
  block?: string | null;
  assignments?: UpdateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments4Input | null;
}

export interface UpdateArticleTemplateFromPrintTemplateArticleTemplates4Input {
  data: UpdateArticleTemplateFromPrintTemplateArticleTemplates4DataInput;
  where: ArticleTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments1Input {
  connect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  create?: CreateAssignmentFromArticleTemplateAssignments2Input[] | null;
  delete?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromArticleTemplateAssignments2Input[] | null;
  upsert?: UpsertAssignmentFromArticleTemplateAssignments2Input[] | null;
}

export interface UpdateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments3Input {
  connect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  create?: CreateAssignmentFromArticleTemplateAssignments4Input[] | null;
  delete?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromArticleTemplateAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromArticleTemplateAssignments4Input[] | null;
}

export interface UpdateArticleTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments4Input {
  connect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  delete?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromArticleTemplateNodeSelectionInput[] | null;
}

export interface UpdateAssignmentDataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentNestedActionsForPrintPublicationDataInput | null;
  printIssue?: UpdateAssignmentNestedActionsForPrintIssueDataInput | null;
  printHeading?: UpdateAssignmentNestedActionsForPrintHeadingDataInput | null;
  website?: UpdateAssignmentNestedActionsForWebsiteDataInput | null;
  rawArticle?: UpdateAssignmentNestedActionsForRawArticleDataInput | null;
  subject?: UpdateAssignmentNestedActionsForSubjectDataInput | null;
  articleTemplate?: UpdateAssignmentNestedActionsForArticleTemplateDataInput | null;
  printTemplate?: UpdateAssignmentNestedActionsForPrintTemplateDataInput | null;
  flatAssignment?: UpdateAssignmentNestedActionsForFlatAssignmentInput | null;
}

export interface UpdateAssignmentFromArticleTemplateAssignments2DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintPublication2DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintIssue2DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintHeading2DataInput | null;
  website?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForWebsite2DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForRawArticle2DataInput | null;
  subject?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForSubject2DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintTemplate2DataInput | null;
  flatAssignment?: UpdateAssignmentFromArticleTemplateAssignmentsNestedActionsForFlatAssignment2Input | null;
}

export interface UpdateAssignmentFromArticleTemplateAssignments2Input {
  data: UpdateAssignmentFromArticleTemplateAssignments2DataInput;
  where: AssignmentFromArticleTemplateNodeSelectionInput;
}

export interface UpdateAssignmentFromArticleTemplateAssignments4DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintPublication4DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintIssue4DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintHeading4DataInput | null;
  website?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForWebsite4DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForRawArticle4DataInput | null;
  subject?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForSubject4DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintTemplate4DataInput | null;
}

export interface UpdateAssignmentFromArticleTemplateAssignments4Input {
  data: UpdateAssignmentFromArticleTemplateAssignments4DataInput;
  where: AssignmentFromArticleTemplateNodeSelectionInput;
}

export interface UpdateAssignmentFromArticleTemplateAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment3Input[] | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentArticleTemplateNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentFlatAssignment2DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication2DataInput | null;
  printIssue?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue2DataInput | null;
  printHeading?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading2DataInput | null;
  website?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite2DataInput | null;
  rawArticle?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle2DataInput | null;
  subject?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject2DataInput | null;
  articleTemplate?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate2DataInput | null;
  printTemplate?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate2DataInput | null;
}

export interface UpdateAssignmentFromAssignmentFlatAssignment2Input {
  data: UpdateAssignmentFromAssignmentFlatAssignment2DataInput;
  where: AssignmentFromAssignmentNodeSelectionInput;
}

export interface UpdateAssignmentFromAssignmentFlatAssignment3DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication3DataInput | null;
  printIssue?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue3DataInput | null;
  printHeading?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading3DataInput | null;
  website?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite3DataInput | null;
  rawArticle?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle3DataInput | null;
  subject?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject3DataInput | null;
  articleTemplate?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate3DataInput | null;
}

export interface UpdateAssignmentFromAssignmentFlatAssignment3Input {
  data: UpdateAssignmentFromAssignmentFlatAssignment3DataInput;
  where: AssignmentFromAssignmentNodeSelectionInput;
}

export interface UpdateAssignmentFromAssignmentFlatAssignment4DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication4DataInput | null;
  printIssue?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue4DataInput | null;
  printHeading?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading4DataInput | null;
  website?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite4DataInput | null;
  rawArticle?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle4DataInput | null;
  subject?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject4DataInput | null;
  articleTemplate?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate4DataInput | null;
  printTemplate?: UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate4DataInput | null;
}

export interface UpdateAssignmentFromAssignmentFlatAssignment4Input {
  data: UpdateAssignmentFromAssignmentFlatAssignment4DataInput;
  where: AssignmentFromAssignmentNodeSelectionInput;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate2DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments3Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate2DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments3Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate2DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments3Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentRawArticleNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentRawArticleNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentRawArticleNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentRawArticleNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentRawArticleNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentRawArticleNestedActionsForSubject1DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments2Input | null;
  update?: UpdateSubjectFromSubjectAssignments2Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentRawArticleNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate1DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments2Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForRawArticle1DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment2Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment2Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForWebsite1DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments2Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments2Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentSubjectNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromAssignmentWebsiteNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate2DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments3Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments3Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate3DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments4Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments4Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForArticleTemplate4DataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle2DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment3Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment3Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle3DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleFlatAssignment4Input | null;
  upsert?: UpsertRawArticleFromRawArticleFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForRawArticle4DataInput {
  connect?: RawArticleNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject2DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments3Input | null;
  update?: UpdateSubjectFromSubjectAssignments3Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments3Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject3DataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectFlatAssignment4Input | null;
  update?: UpdateSubjectFromSubjectFlatAssignment4Input | null;
  upsert?: UpsertSubjectFromSubjectFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForSubject4DataInput {
  connect?: SubjectNodeSelectionInput | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite2DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments3Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments3Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite3DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteFlatAssignment4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteFlatAssignment4Input | null;
  upsert?: UpsertWebsiteFromWebsiteFlatAssignment4Input | null;
}

export interface UpdateAssignmentFromFlatAssignmentAssignmentNestedActionsForWebsite4DataInput {
  connect?: WebsiteNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateAssignmentFromPrintHeadingAssignments1DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication1DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue1DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite1DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle1DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject1DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate1DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate1DataInput | null;
  flatAssignment?: UpdateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface UpdateAssignmentFromPrintHeadingAssignments1Input {
  data: UpdateAssignmentFromPrintHeadingAssignments1DataInput;
  where: AssignmentFromPrintHeadingNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintHeadingAssignments2DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication2DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue2DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite2DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle2DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject2DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate2DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate2DataInput | null;
  flatAssignment?: UpdateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment2Input | null;
}

export interface UpdateAssignmentFromPrintHeadingAssignments2Input {
  data: UpdateAssignmentFromPrintHeadingAssignments2DataInput;
  where: AssignmentFromPrintHeadingNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintHeadingAssignments3DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication3DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue3DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite3DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle3DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject3DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate3DataInput | null;
  flatAssignment?: UpdateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface UpdateAssignmentFromPrintHeadingAssignments3Input {
  data: UpdateAssignmentFromPrintHeadingAssignments3DataInput;
  where: AssignmentFromPrintHeadingNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintHeadingAssignments4DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintPublication4DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintIssue4DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForWebsite4DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForRawArticle4DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForSubject4DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForArticleTemplate4DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentPrintHeadingNestedActionsForPrintTemplate4DataInput | null;
}

export interface UpdateAssignmentFromPrintHeadingAssignments4Input {
  data: UpdateAssignmentFromPrintHeadingAssignments4DataInput;
  where: AssignmentFromPrintHeadingNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface UpdateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment3Input[] | null;
}

export interface UpdateAssignmentFromPrintHeadingAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment4Input[] | null;
}

export interface UpdateAssignmentFromPrintIssueAssignments1DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication1DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading1DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite1DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle1DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForSubject1DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate1DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate1DataInput | null;
  flatAssignment?: UpdateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface UpdateAssignmentFromPrintIssueAssignments1Input {
  data: UpdateAssignmentFromPrintIssueAssignments1DataInput;
  where: AssignmentFromPrintIssueNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintIssueAssignments2DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication2DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading2DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite2DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle2DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForSubject2DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate2DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate2DataInput | null;
  flatAssignment?: UpdateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment2Input | null;
}

export interface UpdateAssignmentFromPrintIssueAssignments2Input {
  data: UpdateAssignmentFromPrintIssueAssignments2DataInput;
  where: AssignmentFromPrintIssueNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintIssueAssignments3DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication3DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading3DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite3DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle3DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForSubject3DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate3DataInput | null;
  flatAssignment?: UpdateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface UpdateAssignmentFromPrintIssueAssignments3Input {
  data: UpdateAssignmentFromPrintIssueAssignments3DataInput;
  where: AssignmentFromPrintIssueNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintIssueAssignments4DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintPublication4DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintHeading4DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForWebsite4DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForRawArticle4DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForSubject4DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForArticleTemplate4DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentPrintIssueNestedActionsForPrintTemplate4DataInput | null;
}

export interface UpdateAssignmentFromPrintIssueAssignments4Input {
  data: UpdateAssignmentFromPrintIssueAssignments4DataInput;
  where: AssignmentFromPrintIssueNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface UpdateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment3Input[] | null;
}

export interface UpdateAssignmentFromPrintIssueAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment4Input[] | null;
}

export interface UpdateAssignmentFromPrintPublicationAssignments1DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printIssue?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintIssue1DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintHeading1DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForWebsite1DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForRawArticle1DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForSubject1DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForArticleTemplate1DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintTemplate1DataInput | null;
  flatAssignment?: UpdateAssignmentFromPrintPublicationAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface UpdateAssignmentFromPrintPublicationAssignments1Input {
  data: UpdateAssignmentFromPrintPublicationAssignments1DataInput;
  where: AssignmentFromPrintPublicationNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintPublicationAssignments3DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printIssue?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintIssue3DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintHeading3DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForWebsite3DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForRawArticle3DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForSubject3DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentPrintPublicationNestedActionsForPrintTemplate3DataInput | null;
  flatAssignment?: UpdateAssignmentFromPrintPublicationAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface UpdateAssignmentFromPrintPublicationAssignments3Input {
  data: UpdateAssignmentFromPrintPublicationAssignments3DataInput;
  where: AssignmentFromPrintPublicationNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintPublicationAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface UpdateAssignmentFromPrintPublicationAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment4Input[] | null;
}

export interface UpdateAssignmentFromPrintTemplateAssignments1DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication1DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue1DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading1DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite1DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle1DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject1DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate1DataInput | null;
  flatAssignment?: UpdateAssignmentFromPrintTemplateAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface UpdateAssignmentFromPrintTemplateAssignments1Input {
  data: UpdateAssignmentFromPrintTemplateAssignments1DataInput;
  where: AssignmentFromPrintTemplateNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintTemplateAssignments2DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication2DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue2DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading2DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite2DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle2DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject2DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate2DataInput | null;
  flatAssignment?: UpdateAssignmentFromPrintTemplateAssignmentsNestedActionsForFlatAssignment2Input | null;
}

export interface UpdateAssignmentFromPrintTemplateAssignments2Input {
  data: UpdateAssignmentFromPrintTemplateAssignments2DataInput;
  where: AssignmentFromPrintTemplateNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintTemplateAssignments4DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintPublication4DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintIssue4DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForPrintHeading4DataInput | null;
  website?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForWebsite4DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForRawArticle4DataInput | null;
  subject?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForSubject4DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentPrintTemplateNestedActionsForArticleTemplate4DataInput | null;
}

export interface UpdateAssignmentFromPrintTemplateAssignments4Input {
  data: UpdateAssignmentFromPrintTemplateAssignments4DataInput;
  where: AssignmentFromPrintTemplateNodeSelectionInput;
}

export interface UpdateAssignmentFromPrintTemplateAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface UpdateAssignmentFromPrintTemplateAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment3Input[] | null;
}

export interface UpdateAssignmentFromRawArticleAssignment1DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentRawArticleNestedActionsForPrintPublication1DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentRawArticleNestedActionsForPrintIssue1DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentRawArticleNestedActionsForPrintHeading1DataInput | null;
  website?: UpdateAssignmentFromAssignmentRawArticleNestedActionsForWebsite1DataInput | null;
  subject?: UpdateAssignmentFromAssignmentRawArticleNestedActionsForSubject1DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentRawArticleNestedActionsForArticleTemplate1DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentRawArticleNestedActionsForPrintTemplate1DataInput | null;
  flatAssignment?: UpdateAssignmentFromRawArticleAssignmentNestedActionsForFlatAssignment1Input | null;
}

export interface UpdateAssignmentFromRawArticleAssignment1Input {
  data: UpdateAssignmentFromRawArticleAssignment1DataInput;
  where: AssignmentFromRawArticleNodeSelectionInput;
}

export interface UpdateAssignmentFromRawArticleAssignmentNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface UpdateAssignmentFromSubjectAssignments1DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication1DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue1DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading1DataInput | null;
  website?: UpdateAssignmentFromAssignmentSubjectNestedActionsForWebsite1DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentSubjectNestedActionsForRawArticle1DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate1DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate1DataInput | null;
  flatAssignment?: UpdateAssignmentFromSubjectAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface UpdateAssignmentFromSubjectAssignments1Input {
  data: UpdateAssignmentFromSubjectAssignments1DataInput;
  where: AssignmentFromSubjectNodeSelectionInput;
}

export interface UpdateAssignmentFromSubjectAssignments3DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication3DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue3DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading3DataInput | null;
  website?: UpdateAssignmentFromAssignmentSubjectNestedActionsForWebsite3DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentSubjectNestedActionsForRawArticle3DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate3DataInput | null;
  flatAssignment?: UpdateAssignmentFromSubjectAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface UpdateAssignmentFromSubjectAssignments3Input {
  data: UpdateAssignmentFromSubjectAssignments3DataInput;
  where: AssignmentFromSubjectNodeSelectionInput;
}

export interface UpdateAssignmentFromSubjectAssignments4DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintPublication4DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintIssue4DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintHeading4DataInput | null;
  website?: UpdateAssignmentFromAssignmentSubjectNestedActionsForWebsite4DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentSubjectNestedActionsForRawArticle4DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentSubjectNestedActionsForArticleTemplate4DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentSubjectNestedActionsForPrintTemplate4DataInput | null;
}

export interface UpdateAssignmentFromSubjectAssignments4Input {
  data: UpdateAssignmentFromSubjectAssignments4DataInput;
  where: AssignmentFromSubjectNodeSelectionInput;
}

export interface UpdateAssignmentFromSubjectAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment2Input[] | null;
}

export interface UpdateAssignmentFromSubjectAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment4Input[] | null;
}

export interface UpdateAssignmentFromWebsiteAssignments3DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintPublication3DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintIssue3DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintHeading3DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForRawArticle3DataInput | null;
  subject?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForSubject3DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForArticleTemplate3DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintTemplate3DataInput | null;
  flatAssignment?: UpdateAssignmentFromWebsiteAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface UpdateAssignmentFromWebsiteAssignments3Input {
  data: UpdateAssignmentFromWebsiteAssignments3DataInput;
  where: AssignmentFromWebsiteNodeSelectionInput;
}

export interface UpdateAssignmentFromWebsiteAssignments4DataInput {
  mediaSearchStatus?: MediaSearchStatus | null;
  legacyId?: number | null;
  pageNumber?: number | null;
  printPublication?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintPublication4DataInput | null;
  printIssue?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintIssue4DataInput | null;
  printHeading?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintHeading4DataInput | null;
  rawArticle?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForRawArticle4DataInput | null;
  subject?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForSubject4DataInput | null;
  articleTemplate?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForArticleTemplate4DataInput | null;
  printTemplate?: UpdateAssignmentFromAssignmentWebsiteNestedActionsForPrintTemplate4DataInput | null;
}

export interface UpdateAssignmentFromWebsiteAssignments4Input {
  data: UpdateAssignmentFromWebsiteAssignments4DataInput;
  where: AssignmentFromWebsiteNodeSelectionInput;
}

export interface UpdateAssignmentFromWebsiteAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment4Input[] | null;
}

export interface UpdateAssignmentNestedActionsForArticleTemplateDataInput {
  connect?: ArticleTemplateNodeSelectionInput | null;
  create?: CreateArticleTemplateFromArticleTemplateAssignments1Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateArticleTemplateFromArticleTemplateAssignments1Input | null;
  upsert?: UpsertArticleTemplateFromArticleTemplateAssignments1Input | null;
}

export interface UpdateAssignmentNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromAssignmentFlatAssignment1Input[] | null;
}

export interface UpdateAssignmentNestedActionsForPrintHeadingDataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments1Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments1Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments1Input | null;
}

export interface UpdateAssignmentNestedActionsForPrintIssueDataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments1Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments1Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments1Input | null;
}

export interface UpdateAssignmentNestedActionsForPrintPublicationDataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments1Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments1Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments1Input | null;
}

export interface UpdateAssignmentNestedActionsForPrintTemplateDataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates1Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates1Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates1Input | null;
}

export interface UpdateAssignmentNestedActionsForRawArticleDataInput {
  connect?: RawArticleNodeSelectionInput | null;
  create?: CreateRawArticleFromRawArticleAssignment1Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateRawArticleFromRawArticleAssignment1Input | null;
  upsert?: UpsertRawArticleFromRawArticleAssignment1Input | null;
}

export interface UpdateAssignmentNestedActionsForSubjectDataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments1Input | null;
  update?: UpdateSubjectFromSubjectAssignments1Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments1Input | null;
}

export interface UpdateAssignmentNestedActionsForWebsiteDataInput {
  connect?: WebsiteNodeSelectionInput | null;
  create?: CreateWebsiteFromWebsiteAssignments1Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateWebsiteFromWebsiteAssignments1Input | null;
  upsert?: UpsertWebsiteFromWebsiteAssignments1Input | null;
}

export interface UpdateAttachmentDataInput {
  filename?: string | null;
  filesize?: number | null;
  contentType?: string | null;
  etag?: string | null;
  versionId?: string | null;
  isUploaded?: boolean | null;
  subject?: UpdateAttachmentNestedActionsForSubjectDataInput | null;
}

export interface UpdateAttachmentFromSubjectAttachments1DataInput {
  filename?: string | null;
  filesize?: number | null;
  contentType?: string | null;
  etag?: string | null;
  versionId?: string | null;
  isUploaded?: boolean | null;
}

export interface UpdateAttachmentFromSubjectAttachments1Input {
  data: UpdateAttachmentFromSubjectAttachments1DataInput;
  where: AttachmentFromSubjectNodeSelectionInput;
}

export interface UpdateAttachmentFromSubjectAttachments2DataInput {
  filename?: string | null;
  filesize?: number | null;
  contentType?: string | null;
  etag?: string | null;
  versionId?: string | null;
  isUploaded?: boolean | null;
}

export interface UpdateAttachmentFromSubjectAttachments2Input {
  data: UpdateAttachmentFromSubjectAttachments2DataInput;
  where: AttachmentFromSubjectNodeSelectionInput;
}

export interface UpdateAttachmentFromSubjectAttachments3DataInput {
  filename?: string | null;
  filesize?: number | null;
  contentType?: string | null;
  etag?: string | null;
  versionId?: string | null;
  isUploaded?: boolean | null;
}

export interface UpdateAttachmentFromSubjectAttachments3Input {
  data: UpdateAttachmentFromSubjectAttachments3DataInput;
  where: AttachmentFromSubjectNodeSelectionInput;
}

export interface UpdateAttachmentFromSubjectAttachments4DataInput {
  filename?: string | null;
  filesize?: number | null;
  contentType?: string | null;
  etag?: string | null;
  versionId?: string | null;
  isUploaded?: boolean | null;
}

export interface UpdateAttachmentFromSubjectAttachments4Input {
  data: UpdateAttachmentFromSubjectAttachments4DataInput;
  where: AttachmentFromSubjectNodeSelectionInput;
}

export interface UpdateAttachmentNestedActionsForSubjectDataInput {
  connect?: SubjectNodeSelectionInput | null;
  create?: CreateSubjectFromSubjectAssignments1Input | null;
  update?: UpdateSubjectFromSubjectAssignments1Input | null;
  upsert?: UpsertSubjectFromSubjectAssignments1Input | null;
}

export interface UpdateBrandFromBrandFlatAssignment1DataInput {
  title?: string | null;
  unit?: UpdateBrandFromFlatAssignmentBrandNestedActionsForUnit1DataInput | null;
  printPublications?: UpdateBrandFromBrandFlatAssignmentNestedActionsForPrintPublications1Input | null;
  websites?: UpdateBrandFromBrandFlatAssignmentNestedActionsForWebsites1Input | null;
}

export interface UpdateBrandFromBrandFlatAssignment1Input {
  data: UpdateBrandFromBrandFlatAssignment1DataInput;
  where: BrandFromBrandNodeSelectionInput;
}

export interface UpdateBrandFromBrandFlatAssignment3DataInput {
  title?: string | null;
  unit?: UpdateBrandFromFlatAssignmentBrandNestedActionsForUnit3DataInput | null;
  printPublications?: UpdateBrandFromBrandFlatAssignmentNestedActionsForPrintPublications3Input | null;
  websites?: UpdateBrandFromBrandFlatAssignmentNestedActionsForWebsites3Input | null;
}

export interface UpdateBrandFromBrandFlatAssignment3Input {
  data: UpdateBrandFromBrandFlatAssignment3DataInput;
  where: BrandFromBrandNodeSelectionInput;
}

export interface UpdateBrandFromBrandFlatAssignmentNestedActionsForPrintPublications1Input {
  connect?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  create?: CreatePrintPublicationFromBrandPrintPublications2Input[] | null;
  delete?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  update?: UpdatePrintPublicationFromBrandPrintPublications2Input[] | null;
  upsert?: UpsertPrintPublicationFromBrandPrintPublications2Input[] | null;
}

export interface UpdateBrandFromBrandFlatAssignmentNestedActionsForPrintPublications3Input {
  connect?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  create?: CreatePrintPublicationFromBrandPrintPublications4Input[] | null;
  delete?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  update?: UpdatePrintPublicationFromBrandPrintPublications4Input[] | null;
  upsert?: UpsertPrintPublicationFromBrandPrintPublications4Input[] | null;
}

export interface UpdateBrandFromBrandFlatAssignmentNestedActionsForWebsites1Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  create?: CreateWebsiteFromBrandWebsites2Input[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
  update?: UpdateWebsiteFromBrandWebsites2Input[] | null;
  upsert?: UpsertWebsiteFromBrandWebsites2Input[] | null;
}

export interface UpdateBrandFromBrandFlatAssignmentNestedActionsForWebsites3Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  create?: CreateWebsiteFromBrandWebsites4Input[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
  update?: UpdateWebsiteFromBrandWebsites4Input[] | null;
  upsert?: UpsertWebsiteFromBrandWebsites4Input[] | null;
}

export interface UpdateBrandFromBrandPrintPublications2DataInput {
  title?: string | null;
  unit?: UpdateBrandFromPrintPublicationBrandNestedActionsForUnit2DataInput | null;
  flatAssignment?: UpdateBrandFromBrandPrintPublicationsNestedActionsForFlatAssignment2Input | null;
  websites?: UpdateBrandFromBrandPrintPublicationsNestedActionsForWebsites2Input | null;
}

export interface UpdateBrandFromBrandPrintPublications2Input {
  data: UpdateBrandFromBrandPrintPublications2DataInput;
  where: BrandFromBrandNodeSelectionInput;
}

export interface UpdateBrandFromBrandPrintPublications4DataInput {
  title?: string | null;
  unit?: UpdateBrandFromPrintPublicationBrandNestedActionsForUnit4DataInput | null;
  websites?: UpdateBrandFromBrandPrintPublicationsNestedActionsForWebsites4Input | null;
}

export interface UpdateBrandFromBrandPrintPublications4Input {
  data: UpdateBrandFromBrandPrintPublications4DataInput;
  where: BrandFromBrandNodeSelectionInput;
}

export interface UpdateBrandFromBrandPrintPublicationsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromBrandFlatAssignment3Input[] | null;
}

export interface UpdateBrandFromBrandPrintPublicationsNestedActionsForWebsites2Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  create?: CreateWebsiteFromBrandWebsites3Input[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
  update?: UpdateWebsiteFromBrandWebsites3Input[] | null;
  upsert?: UpsertWebsiteFromBrandWebsites3Input[] | null;
}

export interface UpdateBrandFromBrandPrintPublicationsNestedActionsForWebsites4Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
}

export interface UpdateBrandFromFlatAssignmentBrandNestedActionsForUnit1DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects2Input | null;
  update?: UpdateUnitFromUnitSubjects2Input | null;
  upsert?: UpsertUnitFromUnitSubjects2Input | null;
}

export interface UpdateBrandFromFlatAssignmentBrandNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface UpdateBrandFromPrintPublicationBrandNestedActionsForUnit2DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects3Input | null;
  update?: UpdateUnitFromUnitSubjects3Input | null;
  upsert?: UpsertUnitFromUnitSubjects3Input | null;
}

export interface UpdateBrandFromPrintPublicationBrandNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface UpdateBrandFromUnitBrands3DataInput {
  title?: string | null;
  flatAssignment?: UpdateBrandFromUnitBrandsNestedActionsForFlatAssignment3Input | null;
  printPublications?: UpdateBrandFromUnitBrandsNestedActionsForPrintPublications3Input | null;
  websites?: UpdateBrandFromUnitBrandsNestedActionsForWebsites3Input | null;
}

export interface UpdateBrandFromUnitBrands3Input {
  data: UpdateBrandFromUnitBrands3DataInput;
  where: BrandFromUnitNodeSelectionInput;
}

export interface UpdateBrandFromUnitBrands4DataInput {
  title?: string | null;
  printPublications?: UpdateBrandFromUnitBrandsNestedActionsForPrintPublications4Input | null;
  websites?: UpdateBrandFromUnitBrandsNestedActionsForWebsites4Input | null;
}

export interface UpdateBrandFromUnitBrands4Input {
  data: UpdateBrandFromUnitBrands4DataInput;
  where: BrandFromUnitNodeSelectionInput;
}

export interface UpdateBrandFromUnitBrandsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromBrandFlatAssignment4Input[] | null;
}

export interface UpdateBrandFromUnitBrandsNestedActionsForPrintPublications3Input {
  connect?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  create?: CreatePrintPublicationFromBrandPrintPublications4Input[] | null;
  delete?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  update?: UpdatePrintPublicationFromBrandPrintPublications4Input[] | null;
  upsert?: UpsertPrintPublicationFromBrandPrintPublications4Input[] | null;
}

export interface UpdateBrandFromUnitBrandsNestedActionsForPrintPublications4Input {
  connect?: PrintPublicationFromBrandNodeSelectionInput[] | null;
  delete?: PrintPublicationFromBrandNodeSelectionInput[] | null;
}

export interface UpdateBrandFromUnitBrandsNestedActionsForWebsites3Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  create?: CreateWebsiteFromBrandWebsites4Input[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
  update?: UpdateWebsiteFromBrandWebsites4Input[] | null;
  upsert?: UpsertWebsiteFromBrandWebsites4Input[] | null;
}

export interface UpdateBrandFromUnitBrandsNestedActionsForWebsites4Input {
  connect?: WebsiteFromBrandNodeSelectionInput[] | null;
  delete?: WebsiteFromBrandNodeSelectionInput[] | null;
}

export interface UpdateFolderFromFolderFolders3DataInput {
  title?: string | null;
  isShared?: boolean | null;
  level?: number | null;
  unit?: UpdateFolderFromFolderParentNestedActionsForUnit3DataInput | null;
  pins?: UpdateFolderFromFolderFoldersNestedActionsForPins3Input | null;
}

export interface UpdateFolderFromFolderFolders3Input {
  data: UpdateFolderFromFolderFolders3DataInput;
  where: FolderFromParentNodeSelectionInput;
}

export interface UpdateFolderFromFolderFolders4DataInput {
  title?: string | null;
  isShared?: boolean | null;
  level?: number | null;
  unit?: UpdateFolderFromFolderParentNestedActionsForUnit4DataInput | null;
  pins?: UpdateFolderFromFolderFoldersNestedActionsForPins4Input | null;
}

export interface UpdateFolderFromFolderFolders4Input {
  data: UpdateFolderFromFolderFolders4DataInput;
  where: FolderFromParentNodeSelectionInput;
}

export interface UpdateFolderFromFolderFoldersNestedActionsForPins3Input {
  connect?: PinFromFolderNodeSelectionInput[] | null;
  create?: CreatePinFromFolderPins4Input[] | null;
  delete?: PinFromFolderNodeSelectionInput[] | null;
  disconnect?: PinFromFolderNodeSelectionInput[] | null;
  update?: UpdatePinFromFolderPins4Input[] | null;
  upsert?: UpsertPinFromFolderPins4Input[] | null;
}

export interface UpdateFolderFromFolderFoldersNestedActionsForPins4Input {
  connect?: PinFromFolderNodeSelectionInput[] | null;
  delete?: PinFromFolderNodeSelectionInput[] | null;
  disconnect?: PinFromFolderNodeSelectionInput[] | null;
}

export interface UpdateFolderFromFolderParentNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface UpdateFolderFromFolderParentNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateFolderFromFolderUnitNestedActionsForParent2DataInput {
  connect?: FolderNodeSelectionInput | null;
  create?: CreateFolderFromFolderFolders3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateFolderFromFolderFolders3Input | null;
  upsert?: UpsertFolderFromFolderFolders3Input | null;
}

export interface UpdateFolderFromFolderUnitNestedActionsForParent3DataInput {
  connect?: FolderNodeSelectionInput | null;
  create?: CreateFolderFromFolderFolders4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateFolderFromFolderFolders4Input | null;
  upsert?: UpsertFolderFromFolderFolders4Input | null;
}

export interface UpdateFolderFromFolderUnitNestedActionsForParent4DataInput {
  connect?: FolderNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateFolderFromUnitFolders2DataInput {
  title?: string | null;
  isShared?: boolean | null;
  level?: number | null;
  parent?: UpdateFolderFromFolderUnitNestedActionsForParent2DataInput | null;
  folders?: UpdateFolderFromUnitFoldersNestedActionsForFolders2Input | null;
  pins?: UpdateFolderFromUnitFoldersNestedActionsForPins2Input | null;
}

export interface UpdateFolderFromUnitFolders2Input {
  data: UpdateFolderFromUnitFolders2DataInput;
  where: FolderFromUnitNodeSelectionInput;
}

export interface UpdateFolderFromUnitFolders3DataInput {
  title?: string | null;
  isShared?: boolean | null;
  level?: number | null;
  parent?: UpdateFolderFromFolderUnitNestedActionsForParent3DataInput | null;
  folders?: UpdateFolderFromUnitFoldersNestedActionsForFolders3Input | null;
  pins?: UpdateFolderFromUnitFoldersNestedActionsForPins3Input | null;
}

export interface UpdateFolderFromUnitFolders3Input {
  data: UpdateFolderFromUnitFolders3DataInput;
  where: FolderFromUnitNodeSelectionInput;
}

export interface UpdateFolderFromUnitFolders4DataInput {
  title?: string | null;
  isShared?: boolean | null;
  level?: number | null;
  parent?: UpdateFolderFromFolderUnitNestedActionsForParent4DataInput | null;
  folders?: UpdateFolderFromUnitFoldersNestedActionsForFolders4Input | null;
  pins?: UpdateFolderFromUnitFoldersNestedActionsForPins4Input | null;
}

export interface UpdateFolderFromUnitFolders4Input {
  data: UpdateFolderFromUnitFolders4DataInput;
  where: FolderFromUnitNodeSelectionInput;
}

export interface UpdateFolderFromUnitFoldersNestedActionsForFolders2Input {
  connect?: FolderFromParentNodeSelectionInput[] | null;
  create?: CreateFolderFromFolderFolders3Input[] | null;
  delete?: FolderFromParentNodeSelectionInput[] | null;
  disconnect?: FolderFromParentNodeSelectionInput[] | null;
  update?: UpdateFolderFromFolderFolders3Input[] | null;
  upsert?: UpsertFolderFromFolderFolders3Input[] | null;
}

export interface UpdateFolderFromUnitFoldersNestedActionsForFolders3Input {
  connect?: FolderFromParentNodeSelectionInput[] | null;
  create?: CreateFolderFromFolderFolders4Input[] | null;
  delete?: FolderFromParentNodeSelectionInput[] | null;
  disconnect?: FolderFromParentNodeSelectionInput[] | null;
  update?: UpdateFolderFromFolderFolders4Input[] | null;
  upsert?: UpsertFolderFromFolderFolders4Input[] | null;
}

export interface UpdateFolderFromUnitFoldersNestedActionsForFolders4Input {
  connect?: FolderFromParentNodeSelectionInput[] | null;
  delete?: FolderFromParentNodeSelectionInput[] | null;
  disconnect?: FolderFromParentNodeSelectionInput[] | null;
}

export interface UpdateFolderFromUnitFoldersNestedActionsForPins2Input {
  connect?: PinFromFolderNodeSelectionInput[] | null;
  create?: CreatePinFromFolderPins3Input[] | null;
  delete?: PinFromFolderNodeSelectionInput[] | null;
  disconnect?: PinFromFolderNodeSelectionInput[] | null;
  update?: UpdatePinFromFolderPins3Input[] | null;
  upsert?: UpsertPinFromFolderPins3Input[] | null;
}

export interface UpdateFolderFromUnitFoldersNestedActionsForPins3Input {
  connect?: PinFromFolderNodeSelectionInput[] | null;
  create?: CreatePinFromFolderPins4Input[] | null;
  delete?: PinFromFolderNodeSelectionInput[] | null;
  disconnect?: PinFromFolderNodeSelectionInput[] | null;
  update?: UpdatePinFromFolderPins4Input[] | null;
  upsert?: UpsertPinFromFolderPins4Input[] | null;
}

export interface UpdateFolderFromUnitFoldersNestedActionsForPins4Input {
  connect?: PinFromFolderNodeSelectionInput[] | null;
  delete?: PinFromFolderNodeSelectionInput[] | null;
  disconnect?: PinFromFolderNodeSelectionInput[] | null;
}

export interface UpdatePinFromFolderPins3DataInput {
  order?: number | null;
  photoId?: string | null;
}

export interface UpdatePinFromFolderPins3Input {
  data: UpdatePinFromFolderPins3DataInput;
  where: PinFromFolderNodeSelectionInput;
}

export interface UpdatePinFromFolderPins4DataInput {
  order?: number | null;
  photoId?: string | null;
}

export interface UpdatePinFromFolderPins4Input {
  data: UpdatePinFromFolderPins4DataInput;
  where: PinFromFolderNodeSelectionInput;
}

export interface UpdatePrintHeadingDataInput {
  title?: string | null;
  order?: number | null;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  printIssue?: UpdatePrintHeadingNestedActionsForPrintIssueDataInput | null;
  assignments?: UpdatePrintHeadingNestedActionsForAssignmentsInput | null;
  flatAssignment?: UpdatePrintHeadingNestedActionsForFlatAssignmentInput | null;
  PrintTemplate?: UpdatePrintHeadingNestedActionsForPrintTemplateInput | null;
}

export interface UpdatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue1DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments2Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments2Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments2Input | null;
}

export interface UpdatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue2DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments3Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments3Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments3Input | null;
}

export interface UpdatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue3DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  update?: UpdatePrintIssueFromPrintIssuePrintHeadings4Input | null;
  upsert?: UpsertPrintIssueFromPrintIssuePrintHeadings4Input | null;
}

export interface UpdatePrintHeadingFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue4DataInput {
  connect?: PrintIssueNodeSelectionInput | null;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignments1DataInput {
  title?: string | null;
  order?: number | null;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  printIssue?: UpdatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue1DataInput | null;
  flatAssignment?: UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment1Input | null;
  PrintTemplate?: UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate1Input | null;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignments1Input {
  data: UpdatePrintHeadingFromPrintHeadingAssignments1DataInput;
  where: PrintHeadingFromPrintHeadingNodeSelectionInput;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignments2DataInput {
  title?: string | null;
  order?: number | null;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  printIssue?: UpdatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue2DataInput | null;
  flatAssignment?: UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment2Input | null;
  PrintTemplate?: UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate2Input | null;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignments2Input {
  data: UpdatePrintHeadingFromPrintHeadingAssignments2DataInput;
  where: PrintHeadingFromPrintHeadingNodeSelectionInput;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignments3DataInput {
  title?: string | null;
  order?: number | null;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  printIssue?: UpdatePrintHeadingFromAssignmentPrintHeadingNestedActionsForPrintIssue3DataInput | null;
  flatAssignment?: UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment3Input | null;
  PrintTemplate?: UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate3Input | null;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignments3Input {
  data: UpdatePrintHeadingFromPrintHeadingAssignments3DataInput;
  where: PrintHeadingFromPrintHeadingNodeSelectionInput;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment2Input[] | null;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment3Input[] | null;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment4Input[] | null;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate1Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate2Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
}

export interface UpdatePrintHeadingFromPrintHeadingAssignmentsNestedActionsForPrintTemplate3Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
}

export interface UpdatePrintHeadingFromPrintHeadingFlatAssignment4DataInput {
  title?: string | null;
  order?: number | null;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  printIssue?: UpdatePrintHeadingFromFlatAssignmentPrintHeadingNestedActionsForPrintIssue4DataInput | null;
  assignments?: UpdatePrintHeadingFromPrintHeadingFlatAssignmentNestedActionsForAssignments4Input | null;
  PrintTemplate?: UpdatePrintHeadingFromPrintHeadingFlatAssignmentNestedActionsForPrintTemplate4Input | null;
}

export interface UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input {
  data: UpdatePrintHeadingFromPrintHeadingFlatAssignment4DataInput;
  where: PrintHeadingFromPrintHeadingNodeSelectionInput;
}

export interface UpdatePrintHeadingFromPrintHeadingFlatAssignmentNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
}

export interface UpdatePrintHeadingFromPrintHeadingFlatAssignmentNestedActionsForPrintTemplate4Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadings1DataInput {
  title?: string | null;
  order?: number | null;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  assignments?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments1Input | null;
  flatAssignment?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment1Input | null;
  PrintTemplate?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate1Input | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadings1Input {
  data: UpdatePrintHeadingFromPrintIssuePrintHeadings1DataInput;
  where: PrintHeadingFromPrintIssueNodeSelectionInput;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadings2DataInput {
  title?: string | null;
  order?: number | null;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  assignments?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments2Input | null;
  flatAssignment?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment2Input | null;
  PrintTemplate?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate2Input | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadings2Input {
  data: UpdatePrintHeadingFromPrintIssuePrintHeadings2DataInput;
  where: PrintHeadingFromPrintIssueNodeSelectionInput;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadings3DataInput {
  title?: string | null;
  order?: number | null;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  assignments?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments3Input | null;
  flatAssignment?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment3Input | null;
  PrintTemplate?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate3Input | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadings3Input {
  data: UpdatePrintHeadingFromPrintIssuePrintHeadings3DataInput;
  where: PrintHeadingFromPrintIssueNodeSelectionInput;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadings4DataInput {
  title?: string | null;
  order?: number | null;
  legacyId?: number | null;
  hasAutomaticSubject?: boolean | null;
  autoPrototype?: boolean | null;
  assignments?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments4Input | null;
  PrintTemplate?: UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate4Input | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadings4Input {
  data: UpdatePrintHeadingFromPrintIssuePrintHeadings4DataInput;
  where: PrintHeadingFromPrintIssueNodeSelectionInput;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments1Input {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintHeadingAssignments2Input[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintHeadingAssignments2Input[] | null;
  upsert?: UpsertAssignmentFromPrintHeadingAssignments2Input[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments2Input {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintHeadingAssignments3Input[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintHeadingAssignments3Input[] | null;
  upsert?: UpsertAssignmentFromPrintHeadingAssignments3Input[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments3Input {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintHeadingAssignments4Input[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintHeadingAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromPrintHeadingAssignments4Input[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment2Input[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment3Input[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment4Input[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate1Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate2Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate3Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input[] | null;
}

export interface UpdatePrintHeadingFromPrintIssuePrintHeadingsNestedActionsForPrintTemplate4Input {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
}

export interface UpdatePrintHeadingNestedActionsForAssignmentsInput {
  connect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintHeadingAssignments1Input[] | null;
  delete?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintHeadingAssignments1Input[] | null;
  upsert?: UpsertAssignmentFromPrintHeadingAssignments1Input[] | null;
}

export interface UpdatePrintHeadingNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromPrintHeadingFlatAssignment1Input[] | null;
}

export interface UpdatePrintHeadingNestedActionsForPrintIssueDataInput {
  connect?: PrintIssueNodeSelectionInput | null;
  create?: CreatePrintIssueFromPrintIssueAssignments1Input | null;
  update?: UpdatePrintIssueFromPrintIssueAssignments1Input | null;
  upsert?: UpsertPrintIssueFromPrintIssueAssignments1Input | null;
}

export interface UpdatePrintHeadingNestedActionsForPrintTemplateInput {
  connect?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1Input[] | null;
}

export interface UpdatePrintHeadingPrintTemplateDataInput {
  active?: boolean | null;
  printHeading?: UpdatePrintHeadingPrintTemplateNestedActionsForPrintHeadingDataInput | null;
  printTemplate?: UpdatePrintHeadingPrintTemplateNestedActionsForPrintTemplateDataInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1DataInput {
  active?: boolean | null;
  printTemplate?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate1DataInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1Input {
  data: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1DataInput;
  where: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2DataInput {
  active?: boolean | null;
  printTemplate?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate2DataInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input {
  data: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2DataInput;
  where: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3DataInput {
  active?: boolean | null;
  printTemplate?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate3DataInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input {
  data: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3DataInput;
  where: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4DataInput {
  active?: boolean | null;
  printTemplate?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate4DataInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input {
  data: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4DataInput;
  where: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate1DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateAssignments2Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateAssignments2Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateAssignments2Input | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate2DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate3DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintHeadingNestedActionsForPrintTemplate4DataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading1DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments2Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments2Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments2Input | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading2DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments3Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments3Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments3Input | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading3DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingFlatAssignment4Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading4DataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1DataInput {
  active?: boolean | null;
  printHeading?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading1DataInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1Input {
  data: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1DataInput;
  where: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2DataInput {
  active?: boolean | null;
  printHeading?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading2DataInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2Input {
  data: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2DataInput;
  where: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3DataInput {
  active?: boolean | null;
  printHeading?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading3DataInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3Input {
  data: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3DataInput;
  where: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4DataInput {
  active?: boolean | null;
  printHeading?: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplatePrintTemplateNestedActionsForPrintHeading4DataInput | null;
}

export interface UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4Input {
  data: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4DataInput;
  where: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdatePrintHeadingPrintTemplateNestedActionsForPrintHeadingDataInput {
  connect?: PrintHeadingNodeSelectionInput | null;
  create?: CreatePrintHeadingFromPrintHeadingAssignments1Input | null;
  update?: UpdatePrintHeadingFromPrintHeadingAssignments1Input | null;
  upsert?: UpsertPrintHeadingFromPrintHeadingAssignments1Input | null;
}

export interface UpdatePrintHeadingPrintTemplateNestedActionsForPrintTemplateDataInput {
  connect?: PrintTemplateNodeSelectionInput | null;
  create?: CreatePrintTemplateFromPrintTemplateArticleTemplates1Input | null;
  update?: UpdatePrintTemplateFromPrintTemplateArticleTemplates1Input | null;
  upsert?: UpsertPrintTemplateFromPrintTemplateArticleTemplates1Input | null;
}

export interface UpdatePrintIssueDataInput {
  title?: string | null;
  legacyId?: number | null;
  printPublication?: UpdatePrintIssueNestedActionsForPrintPublicationDataInput | null;
  assignments?: UpdatePrintIssueNestedActionsForAssignmentsInput | null;
  flatAssignment?: UpdatePrintIssueNestedActionsForFlatAssignmentInput | null;
  printHeadings?: UpdatePrintIssueNestedActionsForPrintHeadingsInput | null;
}

export interface UpdatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication1DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments2Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments2Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments2Input | null;
}

export interface UpdatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication2DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments3Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments3Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments3Input | null;
}

export interface UpdatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication3DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationPrintIssues4Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationPrintIssues4Input | null;
}

export interface UpdatePrintIssueFromPrintHeadingPrintIssueNestedActionsForPrintPublication4DataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
}

export interface UpdatePrintIssueFromPrintIssueAssignments1DataInput {
  title?: string | null;
  legacyId?: number | null;
  printPublication?: UpdatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication1DataInput | null;
  flatAssignment?: UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment1Input | null;
  printHeadings?: UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings1Input | null;
}

export interface UpdatePrintIssueFromPrintIssueAssignments1Input {
  data: UpdatePrintIssueFromPrintIssueAssignments1DataInput;
  where: PrintIssueFromPrintIssueNodeSelectionInput;
}

export interface UpdatePrintIssueFromPrintIssueAssignments2DataInput {
  title?: string | null;
  legacyId?: number | null;
  printPublication?: UpdatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication2DataInput | null;
  flatAssignment?: UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment2Input | null;
  printHeadings?: UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings2Input | null;
}

export interface UpdatePrintIssueFromPrintIssueAssignments2Input {
  data: UpdatePrintIssueFromPrintIssueAssignments2DataInput;
  where: PrintIssueFromPrintIssueNodeSelectionInput;
}

export interface UpdatePrintIssueFromPrintIssueAssignments3DataInput {
  title?: string | null;
  legacyId?: number | null;
  printPublication?: UpdatePrintIssueFromAssignmentPrintIssueNestedActionsForPrintPublication3DataInput | null;
  flatAssignment?: UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment3Input | null;
  printHeadings?: UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings3Input | null;
}

export interface UpdatePrintIssueFromPrintIssueAssignments3Input {
  data: UpdatePrintIssueFromPrintIssueAssignments3DataInput;
  where: PrintIssueFromPrintIssueNodeSelectionInput;
}

export interface UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment2Input[] | null;
}

export interface UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment3Input[] | null;
}

export interface UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment4Input[] | null;
}

export interface UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings1Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
}

export interface UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings2Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
}

export interface UpdatePrintIssueFromPrintIssueAssignmentsNestedActionsForPrintHeadings3Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
}

export interface UpdatePrintIssueFromPrintIssuePrintHeadings4DataInput {
  title?: string | null;
  legacyId?: number | null;
  printPublication?: UpdatePrintIssueFromPrintHeadingPrintIssueNestedActionsForPrintPublication4DataInput | null;
  assignments?: UpdatePrintIssueFromPrintIssuePrintHeadingsNestedActionsForAssignments4Input | null;
}

export interface UpdatePrintIssueFromPrintIssuePrintHeadings4Input {
  data: UpdatePrintIssueFromPrintIssuePrintHeadings4DataInput;
  where: PrintIssueFromPrintIssueNodeSelectionInput;
}

export interface UpdatePrintIssueFromPrintIssuePrintHeadingsNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssues1DataInput {
  title?: string | null;
  legacyId?: number | null;
  assignments?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments1Input | null;
  flatAssignment?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment1Input | null;
  printHeadings?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings1Input | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssues1Input {
  data: UpdatePrintIssueFromPrintPublicationPrintIssues1DataInput;
  where: PrintIssueFromPrintPublicationNodeSelectionInput;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssues2DataInput {
  title?: string | null;
  legacyId?: number | null;
  assignments?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments2Input | null;
  flatAssignment?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment2Input | null;
  printHeadings?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings2Input | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssues2Input {
  data: UpdatePrintIssueFromPrintPublicationPrintIssues2DataInput;
  where: PrintIssueFromPrintPublicationNodeSelectionInput;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssues3DataInput {
  title?: string | null;
  legacyId?: number | null;
  assignments?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments3Input | null;
  flatAssignment?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment3Input | null;
  printHeadings?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings3Input | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssues3Input {
  data: UpdatePrintIssueFromPrintPublicationPrintIssues3DataInput;
  where: PrintIssueFromPrintPublicationNodeSelectionInput;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssues4DataInput {
  title?: string | null;
  legacyId?: number | null;
  assignments?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments4Input | null;
  printHeadings?: UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings4Input | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssues4Input {
  data: UpdatePrintIssueFromPrintPublicationPrintIssues4DataInput;
  where: PrintIssueFromPrintPublicationNodeSelectionInput;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments1Input {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintIssueAssignments2Input[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintIssueAssignments2Input[] | null;
  upsert?: UpsertAssignmentFromPrintIssueAssignments2Input[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments2Input {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintIssueAssignments3Input[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintIssueAssignments3Input[] | null;
  upsert?: UpsertAssignmentFromPrintIssueAssignments3Input[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments3Input {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintIssueAssignments4Input[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintIssueAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromPrintIssueAssignments4Input[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment2Input[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment3Input[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment4Input[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings1Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings2Input[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings2Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings3Input[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings3Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings4Input[] | null;
}

export interface UpdatePrintIssueFromPrintPublicationPrintIssuesNestedActionsForPrintHeadings4Input {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
}

export interface UpdatePrintIssueNestedActionsForAssignmentsInput {
  connect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintIssueAssignments1Input[] | null;
  delete?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintIssueAssignments1Input[] | null;
  upsert?: UpsertAssignmentFromPrintIssueAssignments1Input[] | null;
}

export interface UpdatePrintIssueNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromPrintIssueFlatAssignment1Input[] | null;
}

export interface UpdatePrintIssueNestedActionsForPrintHeadingsInput {
  connect?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  create?: CreatePrintHeadingFromPrintIssuePrintHeadings1Input[] | null;
  delete?: PrintHeadingFromPrintIssueNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingFromPrintIssuePrintHeadings1Input[] | null;
  upsert?: UpsertPrintHeadingFromPrintIssuePrintHeadings1Input[] | null;
}

export interface UpdatePrintIssueNestedActionsForPrintPublicationDataInput {
  connect?: PrintPublicationNodeSelectionInput | null;
  create?: CreatePrintPublicationFromPrintPublicationAssignments1Input | null;
  update?: UpdatePrintPublicationFromPrintPublicationAssignments1Input | null;
  upsert?: UpsertPrintPublicationFromPrintPublicationAssignments1Input | null;
}

export interface UpdatePrintPublicationDataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  brand?: UpdatePrintPublicationNestedActionsForBrandDataInput | null;
  assignments?: UpdatePrintPublicationNestedActionsForAssignmentsInput | null;
  flatAssignment?: UpdatePrintPublicationNestedActionsForFlatAssignmentInput | null;
  printIssues?: UpdatePrintPublicationNestedActionsForPrintIssuesInput | null;
}

export interface UpdatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface UpdatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface UpdatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface UpdatePrintPublicationFromBrandPrintPublications2DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  assignments?: UpdatePrintPublicationFromBrandPrintPublicationsNestedActionsForAssignments2Input | null;
  flatAssignment?: UpdatePrintPublicationFromBrandPrintPublicationsNestedActionsForFlatAssignment2Input | null;
  printIssues?: UpdatePrintPublicationFromBrandPrintPublicationsNestedActionsForPrintIssues2Input | null;
}

export interface UpdatePrintPublicationFromBrandPrintPublications2Input {
  data: UpdatePrintPublicationFromBrandPrintPublications2DataInput;
  where: PrintPublicationFromBrandNodeSelectionInput;
}

export interface UpdatePrintPublicationFromBrandPrintPublications4DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  assignments?: UpdatePrintPublicationFromBrandPrintPublicationsNestedActionsForAssignments4Input | null;
  printIssues?: UpdatePrintPublicationFromBrandPrintPublicationsNestedActionsForPrintIssues4Input | null;
}

export interface UpdatePrintPublicationFromBrandPrintPublications4Input {
  data: UpdatePrintPublicationFromBrandPrintPublications4DataInput;
  where: PrintPublicationFromBrandNodeSelectionInput;
}

export interface UpdatePrintPublicationFromBrandPrintPublicationsNestedActionsForAssignments2Input {
  connect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintPublicationAssignments3Input[] | null;
  delete?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintPublicationAssignments3Input[] | null;
  upsert?: UpsertAssignmentFromPrintPublicationAssignments3Input[] | null;
}

export interface UpdatePrintPublicationFromBrandPrintPublicationsNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
}

export interface UpdatePrintPublicationFromBrandPrintPublicationsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintPublicationFlatAssignment3Input[] | null;
}

export interface UpdatePrintPublicationFromBrandPrintPublicationsNestedActionsForPrintIssues2Input {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreatePrintIssueFromPrintPublicationPrintIssues3Input[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdatePrintIssueFromPrintPublicationPrintIssues3Input[] | null;
  upsert?: UpsertPrintIssueFromPrintPublicationPrintIssues3Input[] | null;
}

export interface UpdatePrintPublicationFromBrandPrintPublicationsNestedActionsForPrintIssues4Input {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
}

export interface UpdatePrintPublicationFromPrintIssuePrintPublicationNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignments1DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  brand?: UpdatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand1DataInput | null;
  flatAssignment?: UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment1Input | null;
  printIssues?: UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues1Input | null;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignments1Input {
  data: UpdatePrintPublicationFromPrintPublicationAssignments1DataInput;
  where: PrintPublicationFromPrintPublicationNodeSelectionInput;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignments2DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  brand?: UpdatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand2DataInput | null;
  flatAssignment?: UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment2Input | null;
  printIssues?: UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues2Input | null;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignments2Input {
  data: UpdatePrintPublicationFromPrintPublicationAssignments2DataInput;
  where: PrintPublicationFromPrintPublicationNodeSelectionInput;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignments3DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  brand?: UpdatePrintPublicationFromAssignmentPrintPublicationNestedActionsForBrand3DataInput | null;
  flatAssignment?: UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment3Input | null;
  printIssues?: UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues3Input | null;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignments3Input {
  data: UpdatePrintPublicationFromPrintPublicationAssignments3DataInput;
  where: PrintPublicationFromPrintPublicationNodeSelectionInput;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintPublicationFlatAssignment2Input[] | null;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintPublicationFlatAssignment3Input[] | null;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromPrintPublicationFlatAssignment4Input[] | null;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues1Input {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreatePrintIssueFromPrintPublicationPrintIssues2Input[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdatePrintIssueFromPrintPublicationPrintIssues2Input[] | null;
  upsert?: UpsertPrintIssueFromPrintPublicationPrintIssues2Input[] | null;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues2Input {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreatePrintIssueFromPrintPublicationPrintIssues3Input[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdatePrintIssueFromPrintPublicationPrintIssues3Input[] | null;
  upsert?: UpsertPrintIssueFromPrintPublicationPrintIssues3Input[] | null;
}

export interface UpdatePrintPublicationFromPrintPublicationAssignmentsNestedActionsForPrintIssues3Input {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreatePrintIssueFromPrintPublicationPrintIssues4Input[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdatePrintIssueFromPrintPublicationPrintIssues4Input[] | null;
  upsert?: UpsertPrintIssueFromPrintPublicationPrintIssues4Input[] | null;
}

export interface UpdatePrintPublicationFromPrintPublicationPrintIssues4DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  brand?: UpdatePrintPublicationFromPrintIssuePrintPublicationNestedActionsForBrand4DataInput | null;
  assignments?: UpdatePrintPublicationFromPrintPublicationPrintIssuesNestedActionsForAssignments4Input | null;
}

export interface UpdatePrintPublicationFromPrintPublicationPrintIssues4Input {
  data: UpdatePrintPublicationFromPrintPublicationPrintIssues4DataInput;
  where: PrintPublicationFromPrintPublicationNodeSelectionInput;
}

export interface UpdatePrintPublicationFromPrintPublicationPrintIssuesNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
}

export interface UpdatePrintPublicationNestedActionsForAssignmentsInput {
  connect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintPublicationAssignments1Input[] | null;
  delete?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintPublicationAssignments1Input[] | null;
  upsert?: UpsertAssignmentFromPrintPublicationAssignments1Input[] | null;
}

export interface UpdatePrintPublicationNestedActionsForBrandDataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment1Input | null;
  update?: UpdateBrandFromBrandFlatAssignment1Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment1Input | null;
}

export interface UpdatePrintPublicationNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromPrintPublicationFlatAssignment1Input[] | null;
}

export interface UpdatePrintPublicationNestedActionsForPrintIssuesInput {
  connect?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  create?: CreatePrintIssueFromPrintPublicationPrintIssues1Input[] | null;
  delete?: PrintIssueFromPrintPublicationNodeSelectionInput[] | null;
  update?: UpdatePrintIssueFromPrintPublicationPrintIssues1Input[] | null;
  upsert?: UpsertPrintIssueFromPrintPublicationPrintIssues1Input[] | null;
}

export interface UpdatePrintTemplateDataInput {
  S3ObjectId?: string | null;
  label?: string | null;
  filename?: string | null;
  filesize?: number | null;
  type?: TemplateType | null;
  articleTemplates?: UpdatePrintTemplateNestedActionsForArticleTemplatesInput | null;
  assignments?: UpdatePrintTemplateNestedActionsForAssignmentsInput | null;
  flatAssignment?: UpdatePrintTemplateNestedActionsForFlatAssignmentInput | null;
  PrintHeading?: UpdatePrintTemplateNestedActionsForPrintHeadingInput | null;
}

export interface UpdatePrintTemplateFromPrintTemplateArticleTemplates1DataInput {
  S3ObjectId?: string | null;
  label?: string | null;
  filename?: string | null;
  filesize?: number | null;
  type?: TemplateType | null;
  assignments?: UpdatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments1Input | null;
  flatAssignment?: UpdatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForFlatAssignment1Input | null;
  PrintHeading?: UpdatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForPrintHeading1Input | null;
}

export interface UpdatePrintTemplateFromPrintTemplateArticleTemplates1Input {
  data: UpdatePrintTemplateFromPrintTemplateArticleTemplates1DataInput;
  where: PrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdatePrintTemplateFromPrintTemplateArticleTemplates4DataInput {
  S3ObjectId?: string | null;
  label?: string | null;
  filename?: string | null;
  filesize?: number | null;
  type?: TemplateType | null;
  assignments?: UpdatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments4Input | null;
  PrintHeading?: UpdatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForPrintHeading4Input | null;
}

export interface UpdatePrintTemplateFromPrintTemplateArticleTemplates4Input {
  data: UpdatePrintTemplateFromPrintTemplateArticleTemplates4DataInput;
  where: PrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments1Input {
  connect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintTemplateAssignments2Input[] | null;
  delete?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintTemplateAssignments2Input[] | null;
  upsert?: UpsertAssignmentFromPrintTemplateAssignments2Input[] | null;
}

export interface UpdatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForAssignments4Input {
  connect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  delete?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
}

export interface UpdatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromPrintTemplateFlatAssignment2Input[] | null;
}

export interface UpdatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForPrintHeading1Input {
  connect?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading2Input[] | null;
}

export interface UpdatePrintTemplateFromPrintTemplateArticleTemplatesNestedActionsForPrintHeading4Input {
  connect?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
}

export interface UpdatePrintTemplateFromPrintTemplateAssignments2DataInput {
  S3ObjectId?: string | null;
  label?: string | null;
  filename?: string | null;
  filesize?: number | null;
  type?: TemplateType | null;
  articleTemplates?: UpdatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForArticleTemplates2Input | null;
  flatAssignment?: UpdatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForFlatAssignment2Input | null;
  PrintHeading?: UpdatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForPrintHeading2Input | null;
}

export interface UpdatePrintTemplateFromPrintTemplateAssignments2Input {
  data: UpdatePrintTemplateFromPrintTemplateAssignments2DataInput;
  where: PrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForArticleTemplates2Input {
  connect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateArticleTemplateFromPrintTemplateArticleTemplates3Input[] | null;
  delete?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateArticleTemplateFromPrintTemplateArticleTemplates3Input[] | null;
  upsert?: UpsertArticleTemplateFromPrintTemplateArticleTemplates3Input[] | null;
}

export interface UpdatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromPrintTemplateFlatAssignment3Input[] | null;
}

export interface UpdatePrintTemplateFromPrintTemplateAssignmentsNestedActionsForPrintHeading2Input {
  connect?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading3Input[] | null;
}

export interface UpdatePrintTemplateFromPrintTemplateFlatAssignment3DataInput {
  S3ObjectId?: string | null;
  label?: string | null;
  filename?: string | null;
  filesize?: number | null;
  type?: TemplateType | null;
  articleTemplates?: UpdatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForArticleTemplates3Input | null;
  assignments?: UpdatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForAssignments3Input | null;
  PrintHeading?: UpdatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForPrintHeading3Input | null;
}

export interface UpdatePrintTemplateFromPrintTemplateFlatAssignment3Input {
  data: UpdatePrintTemplateFromPrintTemplateFlatAssignment3DataInput;
  where: PrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpdatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForArticleTemplates3Input {
  connect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateArticleTemplateFromPrintTemplateArticleTemplates4Input[] | null;
  delete?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateArticleTemplateFromPrintTemplateArticleTemplates4Input[] | null;
  upsert?: UpsertArticleTemplateFromPrintTemplateArticleTemplates4Input[] | null;
}

export interface UpdatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForAssignments3Input {
  connect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintTemplateAssignments4Input[] | null;
  delete?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintTemplateAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromPrintTemplateAssignments4Input[] | null;
}

export interface UpdatePrintTemplateFromPrintTemplateFlatAssignmentNestedActionsForPrintHeading3Input {
  connect?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading4Input[] | null;
}

export interface UpdatePrintTemplateNestedActionsForArticleTemplatesInput {
  connect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateArticleTemplateFromPrintTemplateArticleTemplates1Input[] | null;
  delete?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: ArticleTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateArticleTemplateFromPrintTemplateArticleTemplates1Input[] | null;
  upsert?: UpsertArticleTemplateFromPrintTemplateArticleTemplates1Input[] | null;
}

export interface UpdatePrintTemplateNestedActionsForAssignmentsInput {
  connect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreateAssignmentFromPrintTemplateAssignments1Input[] | null;
  delete?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  disconnect?: AssignmentFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromPrintTemplateAssignments1Input[] | null;
  upsert?: UpsertAssignmentFromPrintTemplateAssignments1Input[] | null;
}

export interface UpdatePrintTemplateNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromPrintTemplateFlatAssignment1Input[] | null;
}

export interface UpdatePrintTemplateNestedActionsForPrintHeadingInput {
  connect?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  create?: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1Input[] | null;
  delete?: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput[] | null;
  update?: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1Input[] | null;
  upsert?: UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading1Input[] | null;
}

export interface UpdateRawArticleDataInput {
  legacyId?: number | null;
  assignment?: UpdateRawArticleNestedActionsForAssignmentInput | null;
  flatAssignment?: UpdateRawArticleNestedActionsForFlatAssignmentInput | null;
  versions?: UpdateRawArticleNestedActionsForVersionsInput | null;
}

export interface UpdateRawArticleFromRawArticleAssignment1DataInput {
  legacyId?: number | null;
  flatAssignment?: UpdateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment1Input | null;
  versions?: UpdateRawArticleFromRawArticleAssignmentNestedActionsForVersions1Input | null;
}

export interface UpdateRawArticleFromRawArticleAssignment1Input {
  data: UpdateRawArticleFromRawArticleAssignment1DataInput;
  where: RawArticleFromRawArticleNodeSelectionInput;
}

export interface UpdateRawArticleFromRawArticleAssignment2DataInput {
  legacyId?: number | null;
  flatAssignment?: UpdateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment2Input | null;
  versions?: UpdateRawArticleFromRawArticleAssignmentNestedActionsForVersions2Input | null;
}

export interface UpdateRawArticleFromRawArticleAssignment2Input {
  data: UpdateRawArticleFromRawArticleAssignment2DataInput;
  where: RawArticleFromRawArticleNodeSelectionInput;
}

export interface UpdateRawArticleFromRawArticleAssignment3DataInput {
  legacyId?: number | null;
  flatAssignment?: UpdateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment3Input | null;
  versions?: UpdateRawArticleFromRawArticleAssignmentNestedActionsForVersions3Input | null;
}

export interface UpdateRawArticleFromRawArticleAssignment3Input {
  data: UpdateRawArticleFromRawArticleAssignment3DataInput;
  where: RawArticleFromRawArticleNodeSelectionInput;
}

export interface UpdateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromRawArticleFlatAssignment2Input | null;
}

export interface UpdateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromRawArticleFlatAssignment3Input | null;
}

export interface UpdateRawArticleFromRawArticleAssignmentNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromRawArticleFlatAssignment4Input | null;
}

export interface UpdateRawArticleFromRawArticleAssignmentNestedActionsForVersions1Input {
  create?: CreateRawArticleVersionFromRawArticleVersions2Input[] | null;
}

export interface UpdateRawArticleFromRawArticleAssignmentNestedActionsForVersions2Input {
  create?: CreateRawArticleVersionFromRawArticleVersions3Input[] | null;
}

export interface UpdateRawArticleFromRawArticleAssignmentNestedActionsForVersions3Input {
  create?: CreateRawArticleVersionFromRawArticleVersions4Input[] | null;
}

export interface UpdateRawArticleFromRawArticleFlatAssignment4DataInput {
  legacyId?: number | null;
  assignment?: UpdateRawArticleFromRawArticleFlatAssignmentNestedActionsForAssignment4Input | null;
}

export interface UpdateRawArticleFromRawArticleFlatAssignment4Input {
  data: UpdateRawArticleFromRawArticleFlatAssignment4DataInput;
  where: RawArticleFromRawArticleNodeSelectionInput;
}

export interface UpdateRawArticleFromRawArticleFlatAssignmentNestedActionsForAssignment4Input {
  connect?: AssignmentFromRawArticleNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateRawArticleNestedActionsForAssignmentInput {
  connect?: AssignmentFromRawArticleNodeSelectionInput | null;
  create?: CreateAssignmentFromRawArticleAssignment1Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateAssignmentFromRawArticleAssignment1Input | null;
  upsert?: UpsertAssignmentFromRawArticleAssignment1Input | null;
}

export interface UpdateRawArticleNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromRawArticleFlatAssignment1Input | null;
}

export interface UpdateRawArticleNestedActionsForVersionsInput {
  create?: CreateRawArticleVersionFromRawArticleVersions1Input[] | null;
}

export interface UpdateSubSubjectFromSubjectSubSubjects1DataInput {
  title?: string | null;
}

export interface UpdateSubSubjectFromSubjectSubSubjects1Input {
  data: UpdateSubSubjectFromSubjectSubSubjects1DataInput;
  where: SubSubjectFromSubjectNodeSelectionInput;
}

export interface UpdateSubSubjectFromSubjectSubSubjects2DataInput {
  title?: string | null;
}

export interface UpdateSubSubjectFromSubjectSubSubjects2Input {
  data: UpdateSubSubjectFromSubjectSubSubjects2DataInput;
  where: SubSubjectFromSubjectNodeSelectionInput;
}

export interface UpdateSubSubjectFromSubjectSubSubjects3DataInput {
  title?: string | null;
}

export interface UpdateSubSubjectFromSubjectSubSubjects3Input {
  data: UpdateSubSubjectFromSubjectSubSubjects3DataInput;
  where: SubSubjectFromSubjectNodeSelectionInput;
}

export interface UpdateSubSubjectFromSubjectSubSubjects4DataInput {
  title?: string | null;
}

export interface UpdateSubSubjectFromSubjectSubSubjects4Input {
  data: UpdateSubSubjectFromSubjectSubSubjects4DataInput;
  where: SubSubjectFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromSubjectCategoryChildren2DataInput {
  title?: string | null;
  legacyId?: number | null;
  unit?: UpdateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit2DataInput | null;
  subjects?: UpdateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects2Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryChildren2Input {
  data: UpdateSubjectCategoryFromSubjectCategoryChildren2DataInput;
  where: SubjectCategoryFromParentNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromSubjectCategoryChildren3DataInput {
  title?: string | null;
  legacyId?: number | null;
  unit?: UpdateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit3DataInput | null;
  subjects?: UpdateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects3Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryChildren3Input {
  data: UpdateSubjectCategoryFromSubjectCategoryChildren3DataInput;
  where: SubjectCategoryFromParentNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromSubjectCategoryChildren4DataInput {
  title?: string | null;
  legacyId?: number | null;
  unit?: UpdateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit4DataInput | null;
  subjects?: UpdateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects4Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryChildren4Input {
  data: UpdateSubjectCategoryFromSubjectCategoryChildren4DataInput;
  where: SubjectCategoryFromParentNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects2Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  create?: CreateSubjectFromSubjectCategorySubjects3Input[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  update?: UpdateSubjectFromSubjectCategorySubjects3Input[] | null;
  upsert?: UpsertSubjectFromSubjectCategorySubjects3Input[] | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects3Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  create?: CreateSubjectFromSubjectCategorySubjects4Input[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  update?: UpdateSubjectFromSubjectCategorySubjects4Input[] | null;
  upsert?: UpsertSubjectFromSubjectCategorySubjects4Input[] | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryChildrenNestedActionsForSubjects4Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit2DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects3Input | null;
  update?: UpdateUnitFromUnitSubjects3Input | null;
  upsert?: UpsertUnitFromUnitSubjects3Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryParentNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjects1DataInput {
  title?: string | null;
  legacyId?: number | null;
  parent?: UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent1DataInput | null;
  unit?: UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit1DataInput | null;
  children?: UpdateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren1Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjects1Input {
  data: UpdateSubjectCategoryFromSubjectCategorySubjects1DataInput;
  where: SubjectCategoryFromSubjectCategoryNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjects2DataInput {
  title?: string | null;
  legacyId?: number | null;
  parent?: UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent2DataInput | null;
  unit?: UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit2DataInput | null;
  children?: UpdateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren2Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjects2Input {
  data: UpdateSubjectCategoryFromSubjectCategorySubjects2DataInput;
  where: SubjectCategoryFromSubjectCategoryNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjects3DataInput {
  title?: string | null;
  legacyId?: number | null;
  parent?: UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent3DataInput | null;
  unit?: UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit3DataInput | null;
  children?: UpdateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren3Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjects3Input {
  data: UpdateSubjectCategoryFromSubjectCategorySubjects3DataInput;
  where: SubjectCategoryFromSubjectCategoryNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjects4DataInput {
  title?: string | null;
  legacyId?: number | null;
  parent?: UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent4DataInput | null;
  unit?: UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit4DataInput | null;
  children?: UpdateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren4Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjects4Input {
  data: UpdateSubjectCategoryFromSubjectCategorySubjects4DataInput;
  where: SubjectCategoryFromSubjectCategoryNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren1Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren2Input[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren2Input[] | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren2Input[] | null;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren2Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren3Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
}

export interface UpdateSubjectCategoryFromSubjectCategorySubjectsNestedActionsForChildren4Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent2DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren3Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren3Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent3DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren4Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren4Input | null;
}

export interface UpdateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent4DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent1DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren2Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren2Input | null;
}

export interface UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent2DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren3Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren3Input | null;
}

export interface UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent3DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren4Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren4Input | null;
}

export interface UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForParent4DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit1DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects2Input | null;
  update?: UpdateUnitFromUnitSubjects2Input | null;
  upsert?: UpsertUnitFromUnitSubjects2Input | null;
}

export interface UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit2DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects3Input | null;
  update?: UpdateUnitFromUnitSubjects3Input | null;
  upsert?: UpsertUnitFromUnitSubjects3Input | null;
}

export interface UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface UpdateSubjectCategoryFromSubjectSubjectCategoryNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategories2DataInput {
  title?: string | null;
  legacyId?: number | null;
  parent?: UpdateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent2DataInput | null;
  subjects?: UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects2Input | null;
  children?: UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren2Input | null;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategories2Input {
  data: UpdateSubjectCategoryFromUnitSubjectCategories2DataInput;
  where: SubjectCategoryFromUnitNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategories3DataInput {
  title?: string | null;
  legacyId?: number | null;
  parent?: UpdateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent3DataInput | null;
  subjects?: UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects3Input | null;
  children?: UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren3Input | null;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategories3Input {
  data: UpdateSubjectCategoryFromUnitSubjectCategories3DataInput;
  where: SubjectCategoryFromUnitNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategories4DataInput {
  title?: string | null;
  legacyId?: number | null;
  parent?: UpdateSubjectCategoryFromSubjectCategoryUnitNestedActionsForParent4DataInput | null;
  subjects?: UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects4Input | null;
  children?: UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren4Input | null;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategories4Input {
  data: UpdateSubjectCategoryFromUnitSubjectCategories4DataInput;
  where: SubjectCategoryFromUnitNodeSelectionInput;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren2Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren3Input[] | null;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren3Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategoryChildren4Input[] | null;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForChildren4Input {
  connect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  delete?: SubjectCategoryFromParentNodeSelectionInput[] | null;
  disconnect?: SubjectCategoryFromParentNodeSelectionInput[] | null;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects2Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  create?: CreateSubjectFromSubjectCategorySubjects3Input[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  update?: UpdateSubjectFromSubjectCategorySubjects3Input[] | null;
  upsert?: UpsertSubjectFromSubjectCategorySubjects3Input[] | null;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects3Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  create?: CreateSubjectFromSubjectCategorySubjects4Input[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  update?: UpdateSubjectFromSubjectCategorySubjects4Input[] | null;
  upsert?: UpsertSubjectFromSubjectCategorySubjects4Input[] | null;
}

export interface UpdateSubjectCategoryFromUnitSubjectCategoriesNestedActionsForSubjects4Input {
  connect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  delete?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
  disconnect?: SubjectFromSubjectCategoryNodeSelectionInput[] | null;
}

export interface UpdateSubjectDataInput {
  title?: string | null;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  subjectCategory?: UpdateSubjectNestedActionsForSubjectCategoryDataInput | null;
  unit?: UpdateSubjectNestedActionsForUnitDataInput | null;
  assignments?: UpdateSubjectNestedActionsForAssignmentsInput | null;
  attachments?: UpdateSubjectNestedActionsForAttachmentsInput | null;
  flatAssignment?: UpdateSubjectNestedActionsForFlatAssignmentInput | null;
  subSubjects?: UpdateSubjectNestedActionsForSubSubjectsInput | null;
  subjectTags?: UpdateSubjectNestedActionsForSubjectTagsInput | null;
  subjectUsers?: UpdateSubjectNestedActionsForSubjectUsersInput | null;
}

export interface UpdateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory1DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategorySubjects2Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateSubjectCategoryFromSubjectCategorySubjects2Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategorySubjects2Input | null;
}

export interface UpdateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory2DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategorySubjects3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateSubjectCategoryFromSubjectCategorySubjects3Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategorySubjects3Input | null;
}

export interface UpdateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory3DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategorySubjects4Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateSubjectCategoryFromSubjectCategorySubjects4Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategorySubjects4Input | null;
}

export interface UpdateSubjectFromAssignmentSubjectNestedActionsForUnit1DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects2Input | null;
  update?: UpdateUnitFromUnitSubjects2Input | null;
  upsert?: UpsertUnitFromUnitSubjects2Input | null;
}

export interface UpdateSubjectFromAssignmentSubjectNestedActionsForUnit2DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects3Input | null;
  update?: UpdateUnitFromUnitSubjects3Input | null;
  upsert?: UpsertUnitFromUnitSubjects3Input | null;
}

export interface UpdateSubjectFromAssignmentSubjectNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface UpdateSubjectFromFlatAssignmentSubjectNestedActionsForSubjectCategory4DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
}

export interface UpdateSubjectFromFlatAssignmentSubjectNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface UpdateSubjectFromSubjectAssignments1DataInput {
  title?: string | null;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  subjectCategory?: UpdateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory1DataInput | null;
  unit?: UpdateSubjectFromAssignmentSubjectNestedActionsForUnit1DataInput | null;
  attachments?: UpdateSubjectFromSubjectAssignmentsNestedActionsForAttachments1Input | null;
  flatAssignment?: UpdateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment1Input | null;
  subSubjects?: UpdateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects1Input | null;
  subjectTags?: UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags1Input | null;
  subjectUsers?: UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers1Input | null;
}

export interface UpdateSubjectFromSubjectAssignments1Input {
  data: UpdateSubjectFromSubjectAssignments1DataInput;
  where: SubjectFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectFromSubjectAssignments2DataInput {
  title?: string | null;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  subjectCategory?: UpdateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory2DataInput | null;
  unit?: UpdateSubjectFromAssignmentSubjectNestedActionsForUnit2DataInput | null;
  attachments?: UpdateSubjectFromSubjectAssignmentsNestedActionsForAttachments2Input | null;
  flatAssignment?: UpdateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment2Input | null;
  subSubjects?: UpdateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects2Input | null;
  subjectTags?: UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags2Input | null;
  subjectUsers?: UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers2Input | null;
}

export interface UpdateSubjectFromSubjectAssignments2Input {
  data: UpdateSubjectFromSubjectAssignments2DataInput;
  where: SubjectFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectFromSubjectAssignments3DataInput {
  title?: string | null;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  subjectCategory?: UpdateSubjectFromAssignmentSubjectNestedActionsForSubjectCategory3DataInput | null;
  unit?: UpdateSubjectFromAssignmentSubjectNestedActionsForUnit3DataInput | null;
  attachments?: UpdateSubjectFromSubjectAssignmentsNestedActionsForAttachments3Input | null;
  flatAssignment?: UpdateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment3Input | null;
  subSubjects?: UpdateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects3Input | null;
  subjectTags?: UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags3Input | null;
  subjectUsers?: UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers3Input | null;
}

export interface UpdateSubjectFromSubjectAssignments3Input {
  data: UpdateSubjectFromSubjectAssignments3DataInput;
  where: SubjectFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForAttachments1Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments2Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments2Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments2Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForAttachments2Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments3Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments3Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments3Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForAttachments3Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments4Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments4Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments4Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment2Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment3Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment4Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects1Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects2Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects2Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects2Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects2Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects3Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects3Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects3Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForSubSubjects3Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects4Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects4Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects4Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags1Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags2Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags2Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags2Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags2Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectTags3Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers1Input {
  create?: CreateSubjectUserFromSubjectSubjectUsers2Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers2Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers2Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers2Input {
  create?: CreateSubjectUserFromSubjectSubjectUsers3Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers3Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers3Input[] | null;
}

export interface UpdateSubjectFromSubjectAssignmentsNestedActionsForSubjectUsers3Input {
  create?: CreateSubjectUserFromSubjectSubjectUsers4Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers4Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers4Input[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjects3DataInput {
  title?: string | null;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  unit?: UpdateSubjectFromSubjectSubjectCategoryNestedActionsForUnit3DataInput | null;
  assignments?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForAssignments3Input | null;
  attachments?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForAttachments3Input | null;
  flatAssignment?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForFlatAssignment3Input | null;
  subSubjects?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubSubjects3Input | null;
  subjectTags?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectTags3Input | null;
  subjectUsers?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectUsers3Input | null;
}

export interface UpdateSubjectFromSubjectCategorySubjects3Input {
  data: UpdateSubjectFromSubjectCategorySubjects3DataInput;
  where: SubjectFromSubjectCategoryNodeSelectionInput;
}

export interface UpdateSubjectFromSubjectCategorySubjects4DataInput {
  title?: string | null;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  unit?: UpdateSubjectFromSubjectSubjectCategoryNestedActionsForUnit4DataInput | null;
  assignments?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForAssignments4Input | null;
  attachments?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForAttachments4Input | null;
  subSubjects?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubSubjects4Input | null;
  subjectTags?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectTags4Input | null;
  subjectUsers?: UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectUsers4Input | null;
}

export interface UpdateSubjectFromSubjectCategorySubjects4Input {
  data: UpdateSubjectFromSubjectCategorySubjects4DataInput;
  where: SubjectFromSubjectCategoryNodeSelectionInput;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForAssignments3Input {
  connect?: AssignmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAssignmentFromSubjectAssignments4Input[] | null;
  delete?: AssignmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromSubjectAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromSubjectAssignments4Input[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForAssignments4Input {
  connect?: AssignmentFromSubjectNodeSelectionInput[] | null;
  delete?: AssignmentFromSubjectNodeSelectionInput[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForAttachments3Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments4Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments4Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments4Input[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForAttachments4Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment4Input[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubSubjects3Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects4Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects4Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects4Input[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubSubjects4Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectTags3Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags4Input[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectTags4Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectUsers3Input {
  create?: CreateSubjectUserFromSubjectSubjectUsers4Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers4Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers4Input[] | null;
}

export interface UpdateSubjectFromSubjectCategorySubjectsNestedActionsForSubjectUsers4Input {
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
}

export interface UpdateSubjectFromSubjectFlatAssignment4DataInput {
  title?: string | null;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  subjectCategory?: UpdateSubjectFromFlatAssignmentSubjectNestedActionsForSubjectCategory4DataInput | null;
  unit?: UpdateSubjectFromFlatAssignmentSubjectNestedActionsForUnit4DataInput | null;
  assignments?: UpdateSubjectFromSubjectFlatAssignmentNestedActionsForAssignments4Input | null;
  attachments?: UpdateSubjectFromSubjectFlatAssignmentNestedActionsForAttachments4Input | null;
  subSubjects?: UpdateSubjectFromSubjectFlatAssignmentNestedActionsForSubSubjects4Input | null;
  subjectTags?: UpdateSubjectFromSubjectFlatAssignmentNestedActionsForSubjectTags4Input | null;
  subjectUsers?: UpdateSubjectFromSubjectFlatAssignmentNestedActionsForSubjectUsers4Input | null;
}

export interface UpdateSubjectFromSubjectFlatAssignment4Input {
  data: UpdateSubjectFromSubjectFlatAssignment4DataInput;
  where: SubjectFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectFromSubjectFlatAssignmentNestedActionsForAssignments4Input {
  connect?: AssignmentFromSubjectNodeSelectionInput[] | null;
  delete?: AssignmentFromSubjectNodeSelectionInput[] | null;
}

export interface UpdateSubjectFromSubjectFlatAssignmentNestedActionsForAttachments4Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
}

export interface UpdateSubjectFromSubjectFlatAssignmentNestedActionsForSubSubjects4Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
}

export interface UpdateSubjectFromSubjectFlatAssignmentNestedActionsForSubjectTags4Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
}

export interface UpdateSubjectFromSubjectFlatAssignmentNestedActionsForSubjectUsers4Input {
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
}

export interface UpdateSubjectFromSubjectSubjectCategoryNestedActionsForUnit3DataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitSubjects4Input | null;
  update?: UpdateUnitFromUnitSubjects4Input | null;
  upsert?: UpsertUnitFromUnitSubjects4Input | null;
}

export interface UpdateSubjectFromSubjectSubjectCategoryNestedActionsForUnit4DataInput {
  connect?: UnitNodeSelectionInput | null;
}

export interface UpdateSubjectFromSubjectUnitNestedActionsForSubjectCategory2DataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategorySubjects3Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateSubjectCategoryFromSubjectCategorySubjects3Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategorySubjects3Input | null;
}

export interface UpdateSubjectFromUnitSubjects2DataInput {
  title?: string | null;
  comment?: string | null;
  synopsis?: string | null;
  legacyId?: number | null;
  mediaRequest?: string | null;
  isClassified?: boolean | null;
  isAuto?: boolean | null;
  subjectCategory?: UpdateSubjectFromSubjectUnitNestedActionsForSubjectCategory2DataInput | null;
  assignments?: UpdateSubjectFromUnitSubjectsNestedActionsForAssignments2Input | null;
  attachments?: UpdateSubjectFromUnitSubjectsNestedActionsForAttachments2Input | null;
  flatAssignment?: UpdateSubjectFromUnitSubjectsNestedActionsForFlatAssignment2Input | null;
  subSubjects?: UpdateSubjectFromUnitSubjectsNestedActionsForSubSubjects2Input | null;
  subjectTags?: UpdateSubjectFromUnitSubjectsNestedActionsForSubjectTags2Input | null;
  subjectUsers?: UpdateSubjectFromUnitSubjectsNestedActionsForSubjectUsers2Input | null;
}

export interface UpdateSubjectFromUnitSubjects2Input {
  data: UpdateSubjectFromUnitSubjects2DataInput;
  where: SubjectFromUnitNodeSelectionInput;
}

export interface UpdateSubjectFromUnitSubjectsNestedActionsForAssignments2Input {
  connect?: AssignmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAssignmentFromSubjectAssignments3Input[] | null;
  delete?: AssignmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromSubjectAssignments3Input[] | null;
  upsert?: UpsertAssignmentFromSubjectAssignments3Input[] | null;
}

export interface UpdateSubjectFromUnitSubjectsNestedActionsForAttachments2Input {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments3Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments3Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments3Input[] | null;
}

export interface UpdateSubjectFromUnitSubjectsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment3Input[] | null;
}

export interface UpdateSubjectFromUnitSubjectsNestedActionsForSubSubjects2Input {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects3Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects3Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects3Input[] | null;
}

export interface UpdateSubjectFromUnitSubjectsNestedActionsForSubjectTags2Input {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags3Input[] | null;
}

export interface UpdateSubjectFromUnitSubjectsNestedActionsForSubjectUsers2Input {
  create?: CreateSubjectUserFromSubjectSubjectUsers3Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers3Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers3Input[] | null;
}

export interface UpdateSubjectNestedActionsForAssignmentsInput {
  connect?: AssignmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAssignmentFromSubjectAssignments1Input[] | null;
  delete?: AssignmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromSubjectAssignments1Input[] | null;
  upsert?: UpsertAssignmentFromSubjectAssignments1Input[] | null;
}

export interface UpdateSubjectNestedActionsForAttachmentsInput {
  connect?: AttachmentFromSubjectNodeSelectionInput[] | null;
  create?: CreateAttachmentFromSubjectAttachments1Input[] | null;
  delete?: AttachmentFromSubjectNodeSelectionInput[] | null;
  update?: UpdateAttachmentFromSubjectAttachments1Input[] | null;
  upsert?: UpsertAttachmentFromSubjectAttachments1Input[] | null;
}

export interface UpdateSubjectNestedActionsForFlatAssignmentInput {
  create?: CreateFlatAssignmentFromSubjectFlatAssignment1Input[] | null;
}

export interface UpdateSubjectNestedActionsForSubSubjectsInput {
  connect?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubSubjectFromSubjectSubSubjects1Input[] | null;
  delete?: SubSubjectFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubSubjectFromSubjectSubSubjects1Input[] | null;
  upsert?: UpsertSubSubjectFromSubjectSubSubjects1Input[] | null;
}

export interface UpdateSubjectNestedActionsForSubjectCategoryDataInput {
  connect?: SubjectCategoryNodeSelectionInput | null;
  create?: CreateSubjectCategoryFromSubjectCategorySubjects1Input | null;
  delete?: boolean | null;
  disconnect?: boolean | null;
  update?: UpdateSubjectCategoryFromSubjectCategorySubjects1Input | null;
  upsert?: UpsertSubjectCategoryFromSubjectCategorySubjects1Input | null;
}

export interface UpdateSubjectNestedActionsForSubjectTagsInput {
  connect?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  create?: CreateSubjectSubjectTagFromSubjectSubjectTags1Input[] | null;
  delete?: SubjectSubjectTagFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectSubjectTagFromSubjectSubjectTags1Input[] | null;
  upsert?: UpsertSubjectSubjectTagFromSubjectSubjectTags1Input[] | null;
}

export interface UpdateSubjectNestedActionsForSubjectUsersInput {
  create?: CreateSubjectUserFromSubjectSubjectUsers1Input[] | null;
  delete?: SubjectUserFromSubjectNodeSelectionInput[] | null;
  update?: UpdateSubjectUserFromSubjectSubjectUsers1Input[] | null;
  upsert?: UpsertSubjectUserFromSubjectSubjectUsers1Input[] | null;
}

export interface UpdateSubjectNestedActionsForUnitDataInput {
  connect?: UnitNodeSelectionInput | null;
  create?: CreateUnitFromUnitBrands1Input | null;
  update?: UpdateUnitFromUnitBrands1Input | null;
  upsert?: UpsertUnitFromUnitBrands1Input | null;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag1DataInput {
  connect?: SubjectTagNodeSelectionInput | null;
  create?: CreateSubjectTagFromSubjectTagSubjects2Input | null;
  update?: UpdateSubjectTagFromSubjectTagSubjects2Input | null;
  upsert?: UpsertSubjectTagFromSubjectTagSubjects2Input | null;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag2DataInput {
  connect?: SubjectTagNodeSelectionInput | null;
  create?: CreateSubjectTagFromSubjectTagSubjects3Input | null;
  update?: UpdateSubjectTagFromSubjectTagSubjects3Input | null;
  upsert?: UpsertSubjectTagFromSubjectTagSubjects3Input | null;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag3DataInput {
  connect?: SubjectTagNodeSelectionInput | null;
  create?: CreateSubjectTagFromSubjectTagSubjects4Input | null;
  update?: UpdateSubjectTagFromSubjectTagSubjects4Input | null;
  upsert?: UpsertSubjectTagFromSubjectTagSubjects4Input | null;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag4DataInput {
  connect?: SubjectTagNodeSelectionInput | null;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTags1DataInput {
  order?: number | null;
  subjectTag?: UpdateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag1DataInput | null;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTags1Input {
  data: UpdateSubjectSubjectTagFromSubjectSubjectTags1DataInput;
  where: SubjectSubjectTagFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTags2DataInput {
  order?: number | null;
  subjectTag?: UpdateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag2DataInput | null;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTags2Input {
  data: UpdateSubjectSubjectTagFromSubjectSubjectTags2DataInput;
  where: SubjectSubjectTagFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTags3DataInput {
  order?: number | null;
  subjectTag?: UpdateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag3DataInput | null;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTags3Input {
  data: UpdateSubjectSubjectTagFromSubjectSubjectTags3DataInput;
  where: SubjectSubjectTagFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTags4DataInput {
  order?: number | null;
  subjectTag?: UpdateSubjectSubjectTagFromSubjectSubjectTagSubjectNestedActionsForSubjectTag4DataInput | null;
}

export interface UpdateSubjectSubjectTagFromSubjectSubjectTags4Input {
  data: UpdateSubjectSubjectTagFromSubjectSubjectTags4DataInput;
  where: SubjectSubjectTagFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectTagFromSubjectTagSubjects2DataInput {
  slug?: string | null;
  title?: string | null;
}

export interface UpdateSubjectTagFromSubjectTagSubjects2Input {
  data: UpdateSubjectTagFromSubjectTagSubjects2DataInput;
  where: SubjectTagFromSubjectTagNodeSelectionInput;
}

export interface UpdateSubjectTagFromSubjectTagSubjects3DataInput {
  slug?: string | null;
  title?: string | null;
}

export interface UpdateSubjectTagFromSubjectTagSubjects3Input {
  data: UpdateSubjectTagFromSubjectTagSubjects3DataInput;
  where: SubjectTagFromSubjectTagNodeSelectionInput;
}

export interface UpdateSubjectTagFromSubjectTagSubjects4DataInput {
  slug?: string | null;
  title?: string | null;
}

export interface UpdateSubjectTagFromSubjectTagSubjects4Input {
  data: UpdateSubjectTagFromSubjectTagSubjects4DataInput;
  where: SubjectTagFromSubjectTagNodeSelectionInput;
}

export interface UpdateSubjectUserFromSubjectSubjectUsers1Input {
  data: boolean;
  where: SubjectUserFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectUserFromSubjectSubjectUsers2Input {
  data: boolean;
  where: SubjectUserFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectUserFromSubjectSubjectUsers3Input {
  data: boolean;
  where: SubjectUserFromSubjectNodeSelectionInput;
}

export interface UpdateSubjectUserFromSubjectSubjectUsers4Input {
  data: boolean;
  where: SubjectUserFromSubjectNodeSelectionInput;
}

export interface UpdateUnitFromUnitBrands1DataInput {
  title?: string | null;
  folders?: UpdateUnitFromUnitBrandsNestedActionsForFolders1Input | null;
  subjects?: UpdateUnitFromUnitBrandsNestedActionsForSubjects1Input | null;
  subjectCategories?: UpdateUnitFromUnitBrandsNestedActionsForSubjectCategories1Input | null;
}

export interface UpdateUnitFromUnitBrands1Input {
  data: UpdateUnitFromUnitBrands1DataInput;
  where: UnitFromUnitNodeSelectionInput;
}

export interface UpdateUnitFromUnitBrandsNestedActionsForFolders1Input {
  connect?: FolderFromUnitNodeSelectionInput[] | null;
  create?: CreateFolderFromUnitFolders2Input[] | null;
  delete?: FolderFromUnitNodeSelectionInput[] | null;
  disconnect?: FolderFromUnitNodeSelectionInput[] | null;
  update?: UpdateFolderFromUnitFolders2Input[] | null;
  upsert?: UpsertFolderFromUnitFolders2Input[] | null;
}

export interface UpdateUnitFromUnitBrandsNestedActionsForSubjectCategories1Input {
  connect?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromUnitSubjectCategories2Input[] | null;
  delete?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromUnitSubjectCategories2Input[] | null;
  upsert?: UpsertSubjectCategoryFromUnitSubjectCategories2Input[] | null;
}

export interface UpdateUnitFromUnitBrandsNestedActionsForSubjects1Input {
  connect?: SubjectFromUnitNodeSelectionInput[] | null;
  create?: CreateSubjectFromUnitSubjects2Input[] | null;
  delete?: SubjectFromUnitNodeSelectionInput[] | null;
  update?: UpdateSubjectFromUnitSubjects2Input[] | null;
  upsert?: UpsertSubjectFromUnitSubjects2Input[] | null;
}

export interface UpdateUnitFromUnitSubjects2DataInput {
  title?: string | null;
  brands?: UpdateUnitFromUnitSubjectsNestedActionsForBrands2Input | null;
  folders?: UpdateUnitFromUnitSubjectsNestedActionsForFolders2Input | null;
  subjectCategories?: UpdateUnitFromUnitSubjectsNestedActionsForSubjectCategories2Input | null;
}

export interface UpdateUnitFromUnitSubjects2Input {
  data: UpdateUnitFromUnitSubjects2DataInput;
  where: UnitFromUnitNodeSelectionInput;
}

export interface UpdateUnitFromUnitSubjects3DataInput {
  title?: string | null;
  brands?: UpdateUnitFromUnitSubjectsNestedActionsForBrands3Input | null;
  folders?: UpdateUnitFromUnitSubjectsNestedActionsForFolders3Input | null;
  subjectCategories?: UpdateUnitFromUnitSubjectsNestedActionsForSubjectCategories3Input | null;
}

export interface UpdateUnitFromUnitSubjects3Input {
  data: UpdateUnitFromUnitSubjects3DataInput;
  where: UnitFromUnitNodeSelectionInput;
}

export interface UpdateUnitFromUnitSubjects4DataInput {
  title?: string | null;
  brands?: UpdateUnitFromUnitSubjectsNestedActionsForBrands4Input | null;
  folders?: UpdateUnitFromUnitSubjectsNestedActionsForFolders4Input | null;
  subjectCategories?: UpdateUnitFromUnitSubjectsNestedActionsForSubjectCategories4Input | null;
}

export interface UpdateUnitFromUnitSubjects4Input {
  data: UpdateUnitFromUnitSubjects4DataInput;
  where: UnitFromUnitNodeSelectionInput;
}

export interface UpdateUnitFromUnitSubjectsNestedActionsForBrands2Input {
  connect?: BrandFromUnitNodeSelectionInput[] | null;
  create?: CreateBrandFromUnitBrands3Input[] | null;
  delete?: BrandFromUnitNodeSelectionInput[] | null;
  update?: UpdateBrandFromUnitBrands3Input[] | null;
  upsert?: UpsertBrandFromUnitBrands3Input[] | null;
}

export interface UpdateUnitFromUnitSubjectsNestedActionsForBrands3Input {
  connect?: BrandFromUnitNodeSelectionInput[] | null;
  create?: CreateBrandFromUnitBrands4Input[] | null;
  delete?: BrandFromUnitNodeSelectionInput[] | null;
  update?: UpdateBrandFromUnitBrands4Input[] | null;
  upsert?: UpsertBrandFromUnitBrands4Input[] | null;
}

export interface UpdateUnitFromUnitSubjectsNestedActionsForBrands4Input {
  connect?: BrandFromUnitNodeSelectionInput[] | null;
  delete?: BrandFromUnitNodeSelectionInput[] | null;
}

export interface UpdateUnitFromUnitSubjectsNestedActionsForFolders2Input {
  connect?: FolderFromUnitNodeSelectionInput[] | null;
  create?: CreateFolderFromUnitFolders3Input[] | null;
  delete?: FolderFromUnitNodeSelectionInput[] | null;
  disconnect?: FolderFromUnitNodeSelectionInput[] | null;
  update?: UpdateFolderFromUnitFolders3Input[] | null;
  upsert?: UpsertFolderFromUnitFolders3Input[] | null;
}

export interface UpdateUnitFromUnitSubjectsNestedActionsForFolders3Input {
  connect?: FolderFromUnitNodeSelectionInput[] | null;
  create?: CreateFolderFromUnitFolders4Input[] | null;
  delete?: FolderFromUnitNodeSelectionInput[] | null;
  disconnect?: FolderFromUnitNodeSelectionInput[] | null;
  update?: UpdateFolderFromUnitFolders4Input[] | null;
  upsert?: UpsertFolderFromUnitFolders4Input[] | null;
}

export interface UpdateUnitFromUnitSubjectsNestedActionsForFolders4Input {
  connect?: FolderFromUnitNodeSelectionInput[] | null;
  delete?: FolderFromUnitNodeSelectionInput[] | null;
  disconnect?: FolderFromUnitNodeSelectionInput[] | null;
}

export interface UpdateUnitFromUnitSubjectsNestedActionsForSubjectCategories2Input {
  connect?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromUnitSubjectCategories3Input[] | null;
  delete?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromUnitSubjectCategories3Input[] | null;
  upsert?: UpsertSubjectCategoryFromUnitSubjectCategories3Input[] | null;
}

export interface UpdateUnitFromUnitSubjectsNestedActionsForSubjectCategories3Input {
  connect?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  create?: CreateSubjectCategoryFromUnitSubjectCategories4Input[] | null;
  delete?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  update?: UpdateSubjectCategoryFromUnitSubjectCategories4Input[] | null;
  upsert?: UpsertSubjectCategoryFromUnitSubjectCategories4Input[] | null;
}

export interface UpdateUnitFromUnitSubjectsNestedActionsForSubjectCategories4Input {
  connect?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
  delete?: SubjectCategoryFromUnitNodeSelectionInput[] | null;
}

export interface UpdateWebsiteFromAssignmentWebsiteNestedActionsForBrand1DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications2Input | null;
  update?: UpdateBrandFromBrandPrintPublications2Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications2Input | null;
}

export interface UpdateWebsiteFromAssignmentWebsiteNestedActionsForBrand2DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandFlatAssignment3Input | null;
  update?: UpdateBrandFromBrandFlatAssignment3Input | null;
  upsert?: UpsertBrandFromBrandFlatAssignment3Input | null;
}

export interface UpdateWebsiteFromAssignmentWebsiteNestedActionsForBrand3DataInput {
  connect?: BrandNodeSelectionInput | null;
  create?: CreateBrandFromBrandPrintPublications4Input | null;
  update?: UpdateBrandFromBrandPrintPublications4Input | null;
  upsert?: UpsertBrandFromBrandPrintPublications4Input | null;
}

export interface UpdateWebsiteFromBrandWebsites2DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  assignments?: UpdateWebsiteFromBrandWebsitesNestedActionsForAssignments2Input | null;
  flatAssignment?: UpdateWebsiteFromBrandWebsitesNestedActionsForFlatAssignment2Input | null;
}

export interface UpdateWebsiteFromBrandWebsites2Input {
  data: UpdateWebsiteFromBrandWebsites2DataInput;
  where: WebsiteFromBrandNodeSelectionInput;
}

export interface UpdateWebsiteFromBrandWebsites3DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  assignments?: UpdateWebsiteFromBrandWebsitesNestedActionsForAssignments3Input | null;
  flatAssignment?: UpdateWebsiteFromBrandWebsitesNestedActionsForFlatAssignment3Input | null;
}

export interface UpdateWebsiteFromBrandWebsites3Input {
  data: UpdateWebsiteFromBrandWebsites3DataInput;
  where: WebsiteFromBrandNodeSelectionInput;
}

export interface UpdateWebsiteFromBrandWebsites4DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  assignments?: UpdateWebsiteFromBrandWebsitesNestedActionsForAssignments4Input | null;
}

export interface UpdateWebsiteFromBrandWebsites4Input {
  data: UpdateWebsiteFromBrandWebsites4DataInput;
  where: WebsiteFromBrandNodeSelectionInput;
}

export interface UpdateWebsiteFromBrandWebsitesNestedActionsForAssignments2Input {
  connect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  create?: CreateAssignmentFromWebsiteAssignments3Input[] | null;
  delete?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  disconnect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromWebsiteAssignments3Input[] | null;
  upsert?: UpsertAssignmentFromWebsiteAssignments3Input[] | null;
}

export interface UpdateWebsiteFromBrandWebsitesNestedActionsForAssignments3Input {
  connect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  create?: CreateAssignmentFromWebsiteAssignments4Input[] | null;
  delete?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  disconnect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  update?: UpdateAssignmentFromWebsiteAssignments4Input[] | null;
  upsert?: UpsertAssignmentFromWebsiteAssignments4Input[] | null;
}

export interface UpdateWebsiteFromBrandWebsitesNestedActionsForAssignments4Input {
  connect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  delete?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  disconnect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
}

export interface UpdateWebsiteFromBrandWebsitesNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromWebsiteFlatAssignment3Input[] | null;
}

export interface UpdateWebsiteFromBrandWebsitesNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromWebsiteFlatAssignment4Input[] | null;
}

export interface UpdateWebsiteFromFlatAssignmentWebsiteNestedActionsForBrand4DataInput {
  connect?: BrandNodeSelectionInput | null;
}

export interface UpdateWebsiteFromWebsiteAssignments1DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  brand?: UpdateWebsiteFromAssignmentWebsiteNestedActionsForBrand1DataInput | null;
  flatAssignment?: UpdateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment1Input | null;
}

export interface UpdateWebsiteFromWebsiteAssignments1Input {
  data: UpdateWebsiteFromWebsiteAssignments1DataInput;
  where: WebsiteFromWebsiteNodeSelectionInput;
}

export interface UpdateWebsiteFromWebsiteAssignments2DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  brand?: UpdateWebsiteFromAssignmentWebsiteNestedActionsForBrand2DataInput | null;
  flatAssignment?: UpdateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment2Input | null;
}

export interface UpdateWebsiteFromWebsiteAssignments2Input {
  data: UpdateWebsiteFromWebsiteAssignments2DataInput;
  where: WebsiteFromWebsiteNodeSelectionInput;
}

export interface UpdateWebsiteFromWebsiteAssignments3DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  brand?: UpdateWebsiteFromAssignmentWebsiteNestedActionsForBrand3DataInput | null;
  flatAssignment?: UpdateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment3Input | null;
}

export interface UpdateWebsiteFromWebsiteAssignments3Input {
  data: UpdateWebsiteFromWebsiteAssignments3DataInput;
  where: WebsiteFromWebsiteNodeSelectionInput;
}

export interface UpdateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment1Input {
  create?: CreateFlatAssignmentFromWebsiteFlatAssignment2Input[] | null;
}

export interface UpdateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment2Input {
  create?: CreateFlatAssignmentFromWebsiteFlatAssignment3Input[] | null;
}

export interface UpdateWebsiteFromWebsiteAssignmentsNestedActionsForFlatAssignment3Input {
  create?: CreateFlatAssignmentFromWebsiteFlatAssignment4Input[] | null;
}

export interface UpdateWebsiteFromWebsiteFlatAssignment4DataInput {
  title?: string | null;
  key?: string | null;
  legacyId?: number | null;
  brand?: UpdateWebsiteFromFlatAssignmentWebsiteNestedActionsForBrand4DataInput | null;
  assignments?: UpdateWebsiteFromWebsiteFlatAssignmentNestedActionsForAssignments4Input | null;
}

export interface UpdateWebsiteFromWebsiteFlatAssignment4Input {
  data: UpdateWebsiteFromWebsiteFlatAssignment4DataInput;
  where: WebsiteFromWebsiteNodeSelectionInput;
}

export interface UpdateWebsiteFromWebsiteFlatAssignmentNestedActionsForAssignments4Input {
  connect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  delete?: AssignmentFromWebsiteNodeSelectionInput[] | null;
  disconnect?: AssignmentFromWebsiteNodeSelectionInput[] | null;
}

export interface UpsertArticleTemplateFromArticleTemplateAssignments1Input {
  create: CreateArticleTemplateFromArticleTemplateAssignments1DataInput;
  update: UpdateArticleTemplateFromArticleTemplateAssignments1DataInput;
  where: ArticleTemplateFromArticleTemplateNodeSelectionInput;
}

export interface UpsertArticleTemplateFromArticleTemplateAssignments2Input {
  create: CreateArticleTemplateFromArticleTemplateAssignments2DataInput;
  update: UpdateArticleTemplateFromArticleTemplateAssignments2DataInput;
  where: ArticleTemplateFromArticleTemplateNodeSelectionInput;
}

export interface UpsertArticleTemplateFromArticleTemplateAssignments3Input {
  create: CreateArticleTemplateFromArticleTemplateAssignments3DataInput;
  update: UpdateArticleTemplateFromArticleTemplateAssignments3DataInput;
  where: ArticleTemplateFromArticleTemplateNodeSelectionInput;
}

export interface UpsertArticleTemplateFromArticleTemplateAssignments4Input {
  create: CreateArticleTemplateFromArticleTemplateAssignments4DataInput;
  update: UpdateArticleTemplateFromArticleTemplateAssignments4DataInput;
  where: ArticleTemplateFromArticleTemplateNodeSelectionInput;
}

export interface UpsertArticleTemplateFromPrintTemplateArticleTemplates1Input {
  create: CreateArticleTemplateFromPrintTemplateArticleTemplates1DataInput;
  update: UpdateArticleTemplateFromPrintTemplateArticleTemplates1DataInput;
  where: ArticleTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertArticleTemplateFromPrintTemplateArticleTemplates3Input {
  create: CreateArticleTemplateFromPrintTemplateArticleTemplates3DataInput;
  update: UpdateArticleTemplateFromPrintTemplateArticleTemplates3DataInput;
  where: ArticleTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertArticleTemplateFromPrintTemplateArticleTemplates4Input {
  create: CreateArticleTemplateFromPrintTemplateArticleTemplates4DataInput;
  update: UpdateArticleTemplateFromPrintTemplateArticleTemplates4DataInput;
  where: ArticleTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertAssignmentFromArticleTemplateAssignments2Input {
  create: CreateAssignmentFromArticleTemplateAssignments2DataInput;
  update: UpdateAssignmentFromArticleTemplateAssignments2DataInput;
  where: AssignmentFromArticleTemplateNodeSelectionInput;
}

export interface UpsertAssignmentFromArticleTemplateAssignments4Input {
  create: CreateAssignmentFromArticleTemplateAssignments4DataInput;
  update: UpdateAssignmentFromArticleTemplateAssignments4DataInput;
  where: AssignmentFromArticleTemplateNodeSelectionInput;
}

export interface UpsertAssignmentFromAssignmentFlatAssignment2Input {
  create: CreateAssignmentFromAssignmentFlatAssignment2DataInput;
  update: UpdateAssignmentFromAssignmentFlatAssignment2DataInput;
  where: AssignmentFromAssignmentNodeSelectionInput;
}

export interface UpsertAssignmentFromAssignmentFlatAssignment3Input {
  create: CreateAssignmentFromAssignmentFlatAssignment3DataInput;
  update: UpdateAssignmentFromAssignmentFlatAssignment3DataInput;
  where: AssignmentFromAssignmentNodeSelectionInput;
}

export interface UpsertAssignmentFromAssignmentFlatAssignment4Input {
  create: CreateAssignmentFromAssignmentFlatAssignment4DataInput;
  update: UpdateAssignmentFromAssignmentFlatAssignment4DataInput;
  where: AssignmentFromAssignmentNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintHeadingAssignments1Input {
  create: CreateAssignmentFromPrintHeadingAssignments1DataInput;
  update: UpdateAssignmentFromPrintHeadingAssignments1DataInput;
  where: AssignmentFromPrintHeadingNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintHeadingAssignments2Input {
  create: CreateAssignmentFromPrintHeadingAssignments2DataInput;
  update: UpdateAssignmentFromPrintHeadingAssignments2DataInput;
  where: AssignmentFromPrintHeadingNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintHeadingAssignments3Input {
  create: CreateAssignmentFromPrintHeadingAssignments3DataInput;
  update: UpdateAssignmentFromPrintHeadingAssignments3DataInput;
  where: AssignmentFromPrintHeadingNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintHeadingAssignments4Input {
  create: CreateAssignmentFromPrintHeadingAssignments4DataInput;
  update: UpdateAssignmentFromPrintHeadingAssignments4DataInput;
  where: AssignmentFromPrintHeadingNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintIssueAssignments1Input {
  create: CreateAssignmentFromPrintIssueAssignments1DataInput;
  update: UpdateAssignmentFromPrintIssueAssignments1DataInput;
  where: AssignmentFromPrintIssueNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintIssueAssignments2Input {
  create: CreateAssignmentFromPrintIssueAssignments2DataInput;
  update: UpdateAssignmentFromPrintIssueAssignments2DataInput;
  where: AssignmentFromPrintIssueNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintIssueAssignments3Input {
  create: CreateAssignmentFromPrintIssueAssignments3DataInput;
  update: UpdateAssignmentFromPrintIssueAssignments3DataInput;
  where: AssignmentFromPrintIssueNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintIssueAssignments4Input {
  create: CreateAssignmentFromPrintIssueAssignments4DataInput;
  update: UpdateAssignmentFromPrintIssueAssignments4DataInput;
  where: AssignmentFromPrintIssueNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintPublicationAssignments1Input {
  create: CreateAssignmentFromPrintPublicationAssignments1DataInput;
  update: UpdateAssignmentFromPrintPublicationAssignments1DataInput;
  where: AssignmentFromPrintPublicationNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintPublicationAssignments3Input {
  create: CreateAssignmentFromPrintPublicationAssignments3DataInput;
  update: UpdateAssignmentFromPrintPublicationAssignments3DataInput;
  where: AssignmentFromPrintPublicationNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintTemplateAssignments1Input {
  create: CreateAssignmentFromPrintTemplateAssignments1DataInput;
  update: UpdateAssignmentFromPrintTemplateAssignments1DataInput;
  where: AssignmentFromPrintTemplateNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintTemplateAssignments2Input {
  create: CreateAssignmentFromPrintTemplateAssignments2DataInput;
  update: UpdateAssignmentFromPrintTemplateAssignments2DataInput;
  where: AssignmentFromPrintTemplateNodeSelectionInput;
}

export interface UpsertAssignmentFromPrintTemplateAssignments4Input {
  create: CreateAssignmentFromPrintTemplateAssignments4DataInput;
  update: UpdateAssignmentFromPrintTemplateAssignments4DataInput;
  where: AssignmentFromPrintTemplateNodeSelectionInput;
}

export interface UpsertAssignmentFromRawArticleAssignment1Input {
  create: CreateAssignmentFromRawArticleAssignment1DataInput;
  update: UpdateAssignmentFromRawArticleAssignment1DataInput;
  where: AssignmentFromRawArticleNodeSelectionInput;
}

export interface UpsertAssignmentFromSubjectAssignments1Input {
  create: CreateAssignmentFromSubjectAssignments1DataInput;
  update: UpdateAssignmentFromSubjectAssignments1DataInput;
  where: AssignmentFromSubjectNodeSelectionInput;
}

export interface UpsertAssignmentFromSubjectAssignments3Input {
  create: CreateAssignmentFromSubjectAssignments3DataInput;
  update: UpdateAssignmentFromSubjectAssignments3DataInput;
  where: AssignmentFromSubjectNodeSelectionInput;
}

export interface UpsertAssignmentFromSubjectAssignments4Input {
  create: CreateAssignmentFromSubjectAssignments4DataInput;
  update: UpdateAssignmentFromSubjectAssignments4DataInput;
  where: AssignmentFromSubjectNodeSelectionInput;
}

export interface UpsertAssignmentFromWebsiteAssignments3Input {
  create: CreateAssignmentFromWebsiteAssignments3DataInput;
  update: UpdateAssignmentFromWebsiteAssignments3DataInput;
  where: AssignmentFromWebsiteNodeSelectionInput;
}

export interface UpsertAssignmentFromWebsiteAssignments4Input {
  create: CreateAssignmentFromWebsiteAssignments4DataInput;
  update: UpdateAssignmentFromWebsiteAssignments4DataInput;
  where: AssignmentFromWebsiteNodeSelectionInput;
}

export interface UpsertAttachmentFromSubjectAttachments1Input {
  create: CreateAttachmentFromSubjectAttachments1DataInput;
  update: UpdateAttachmentFromSubjectAttachments1DataInput;
  where: AttachmentFromSubjectNodeSelectionInput;
}

export interface UpsertAttachmentFromSubjectAttachments2Input {
  create: CreateAttachmentFromSubjectAttachments2DataInput;
  update: UpdateAttachmentFromSubjectAttachments2DataInput;
  where: AttachmentFromSubjectNodeSelectionInput;
}

export interface UpsertAttachmentFromSubjectAttachments3Input {
  create: CreateAttachmentFromSubjectAttachments3DataInput;
  update: UpdateAttachmentFromSubjectAttachments3DataInput;
  where: AttachmentFromSubjectNodeSelectionInput;
}

export interface UpsertAttachmentFromSubjectAttachments4Input {
  create: CreateAttachmentFromSubjectAttachments4DataInput;
  update: UpdateAttachmentFromSubjectAttachments4DataInput;
  where: AttachmentFromSubjectNodeSelectionInput;
}

export interface UpsertBrandFromBrandFlatAssignment1Input {
  create: CreateBrandFromBrandFlatAssignment1DataInput;
  update: UpdateBrandFromBrandFlatAssignment1DataInput;
  where: BrandFromBrandNodeSelectionInput;
}

export interface UpsertBrandFromBrandFlatAssignment3Input {
  create: CreateBrandFromBrandFlatAssignment3DataInput;
  update: UpdateBrandFromBrandFlatAssignment3DataInput;
  where: BrandFromBrandNodeSelectionInput;
}

export interface UpsertBrandFromBrandPrintPublications2Input {
  create: CreateBrandFromBrandPrintPublications2DataInput;
  update: UpdateBrandFromBrandPrintPublications2DataInput;
  where: BrandFromBrandNodeSelectionInput;
}

export interface UpsertBrandFromBrandPrintPublications4Input {
  create: CreateBrandFromBrandPrintPublications4DataInput;
  update: UpdateBrandFromBrandPrintPublications4DataInput;
  where: BrandFromBrandNodeSelectionInput;
}

export interface UpsertBrandFromUnitBrands3Input {
  create: CreateBrandFromUnitBrands3DataInput;
  update: UpdateBrandFromUnitBrands3DataInput;
  where: BrandFromUnitNodeSelectionInput;
}

export interface UpsertBrandFromUnitBrands4Input {
  create: CreateBrandFromUnitBrands4DataInput;
  update: UpdateBrandFromUnitBrands4DataInput;
  where: BrandFromUnitNodeSelectionInput;
}

export interface UpsertFolderFromFolderFolders3Input {
  create: CreateFolderFromFolderFolders3DataInput;
  update: UpdateFolderFromFolderFolders3DataInput;
  where: FolderFromParentNodeSelectionInput;
}

export interface UpsertFolderFromFolderFolders4Input {
  create: CreateFolderFromFolderFolders4DataInput;
  update: UpdateFolderFromFolderFolders4DataInput;
  where: FolderFromParentNodeSelectionInput;
}

export interface UpsertFolderFromUnitFolders2Input {
  create: CreateFolderFromUnitFolders2DataInput;
  update: UpdateFolderFromUnitFolders2DataInput;
  where: FolderFromUnitNodeSelectionInput;
}

export interface UpsertFolderFromUnitFolders3Input {
  create: CreateFolderFromUnitFolders3DataInput;
  update: UpdateFolderFromUnitFolders3DataInput;
  where: FolderFromUnitNodeSelectionInput;
}

export interface UpsertFolderFromUnitFolders4Input {
  create: CreateFolderFromUnitFolders4DataInput;
  update: UpdateFolderFromUnitFolders4DataInput;
  where: FolderFromUnitNodeSelectionInput;
}

export interface UpsertPinFromFolderPins3Input {
  create: CreatePinFromFolderPins3DataInput;
  update: UpdatePinFromFolderPins3DataInput;
  where: PinFromFolderNodeSelectionInput;
}

export interface UpsertPinFromFolderPins4Input {
  create: CreatePinFromFolderPins4DataInput;
  update: UpdatePinFromFolderPins4DataInput;
  where: PinFromFolderNodeSelectionInput;
}

export interface UpsertPrintHeadingFromPrintHeadingAssignments1Input {
  create: CreatePrintHeadingFromPrintHeadingAssignments1DataInput;
  update: UpdatePrintHeadingFromPrintHeadingAssignments1DataInput;
  where: PrintHeadingFromPrintHeadingNodeSelectionInput;
}

export interface UpsertPrintHeadingFromPrintHeadingAssignments2Input {
  create: CreatePrintHeadingFromPrintHeadingAssignments2DataInput;
  update: UpdatePrintHeadingFromPrintHeadingAssignments2DataInput;
  where: PrintHeadingFromPrintHeadingNodeSelectionInput;
}

export interface UpsertPrintHeadingFromPrintHeadingAssignments3Input {
  create: CreatePrintHeadingFromPrintHeadingAssignments3DataInput;
  update: UpdatePrintHeadingFromPrintHeadingAssignments3DataInput;
  where: PrintHeadingFromPrintHeadingNodeSelectionInput;
}

export interface UpsertPrintHeadingFromPrintHeadingFlatAssignment4Input {
  create: CreatePrintHeadingFromPrintHeadingFlatAssignment4DataInput;
  update: UpdatePrintHeadingFromPrintHeadingFlatAssignment4DataInput;
  where: PrintHeadingFromPrintHeadingNodeSelectionInput;
}

export interface UpsertPrintHeadingFromPrintIssuePrintHeadings1Input {
  create: CreatePrintHeadingFromPrintIssuePrintHeadings1DataInput;
  update: UpdatePrintHeadingFromPrintIssuePrintHeadings1DataInput;
  where: PrintHeadingFromPrintIssueNodeSelectionInput;
}

export interface UpsertPrintHeadingFromPrintIssuePrintHeadings2Input {
  create: CreatePrintHeadingFromPrintIssuePrintHeadings2DataInput;
  update: UpdatePrintHeadingFromPrintIssuePrintHeadings2DataInput;
  where: PrintHeadingFromPrintIssueNodeSelectionInput;
}

export interface UpsertPrintHeadingFromPrintIssuePrintHeadings3Input {
  create: CreatePrintHeadingFromPrintIssuePrintHeadings3DataInput;
  update: UpdatePrintHeadingFromPrintIssuePrintHeadings3DataInput;
  where: PrintHeadingFromPrintIssueNodeSelectionInput;
}

export interface UpsertPrintHeadingFromPrintIssuePrintHeadings4Input {
  create: CreatePrintHeadingFromPrintIssuePrintHeadings4DataInput;
  update: UpdatePrintHeadingFromPrintIssuePrintHeadings4DataInput;
  where: PrintHeadingFromPrintIssueNodeSelectionInput;
}

export interface UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1Input {
  create: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1DataInput;
  update: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate1DataInput;
  where: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput;
}

export interface UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2Input {
  create: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2DataInput;
  update: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate2DataInput;
  where: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput;
}

export interface UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3Input {
  create: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3DataInput;
  update: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate3DataInput;
  where: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput;
}

export interface UpsertPrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4Input {
  create: CreatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4DataInput;
  update: UpdatePrintHeadingPrintTemplateFromPrintHeadingPrintTemplate4DataInput;
  where: PrintHeadingPrintTemplateFromPrintHeadingNodeSelectionInput;
}

export interface UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading1Input {
  create: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1DataInput;
  update: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading1DataInput;
  where: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading2Input {
  create: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2DataInput;
  update: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading2DataInput;
  where: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading3Input {
  create: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3DataInput;
  update: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading3DataInput;
  where: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertPrintHeadingPrintTemplateFromPrintTemplatePrintHeading4Input {
  create: CreatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4DataInput;
  update: UpdatePrintHeadingPrintTemplateFromPrintTemplatePrintHeading4DataInput;
  where: PrintHeadingPrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertPrintIssueFromPrintIssueAssignments1Input {
  create: CreatePrintIssueFromPrintIssueAssignments1DataInput;
  update: UpdatePrintIssueFromPrintIssueAssignments1DataInput;
  where: PrintIssueFromPrintIssueNodeSelectionInput;
}

export interface UpsertPrintIssueFromPrintIssueAssignments2Input {
  create: CreatePrintIssueFromPrintIssueAssignments2DataInput;
  update: UpdatePrintIssueFromPrintIssueAssignments2DataInput;
  where: PrintIssueFromPrintIssueNodeSelectionInput;
}

export interface UpsertPrintIssueFromPrintIssueAssignments3Input {
  create: CreatePrintIssueFromPrintIssueAssignments3DataInput;
  update: UpdatePrintIssueFromPrintIssueAssignments3DataInput;
  where: PrintIssueFromPrintIssueNodeSelectionInput;
}

export interface UpsertPrintIssueFromPrintIssuePrintHeadings4Input {
  create: CreatePrintIssueFromPrintIssuePrintHeadings4DataInput;
  update: UpdatePrintIssueFromPrintIssuePrintHeadings4DataInput;
  where: PrintIssueFromPrintIssueNodeSelectionInput;
}

export interface UpsertPrintIssueFromPrintPublicationPrintIssues1Input {
  create: CreatePrintIssueFromPrintPublicationPrintIssues1DataInput;
  update: UpdatePrintIssueFromPrintPublicationPrintIssues1DataInput;
  where: PrintIssueFromPrintPublicationNodeSelectionInput;
}

export interface UpsertPrintIssueFromPrintPublicationPrintIssues2Input {
  create: CreatePrintIssueFromPrintPublicationPrintIssues2DataInput;
  update: UpdatePrintIssueFromPrintPublicationPrintIssues2DataInput;
  where: PrintIssueFromPrintPublicationNodeSelectionInput;
}

export interface UpsertPrintIssueFromPrintPublicationPrintIssues3Input {
  create: CreatePrintIssueFromPrintPublicationPrintIssues3DataInput;
  update: UpdatePrintIssueFromPrintPublicationPrintIssues3DataInput;
  where: PrintIssueFromPrintPublicationNodeSelectionInput;
}

export interface UpsertPrintIssueFromPrintPublicationPrintIssues4Input {
  create: CreatePrintIssueFromPrintPublicationPrintIssues4DataInput;
  update: UpdatePrintIssueFromPrintPublicationPrintIssues4DataInput;
  where: PrintIssueFromPrintPublicationNodeSelectionInput;
}

export interface UpsertPrintPublicationFromBrandPrintPublications2Input {
  create: CreatePrintPublicationFromBrandPrintPublications2DataInput;
  update: UpdatePrintPublicationFromBrandPrintPublications2DataInput;
  where: PrintPublicationFromBrandNodeSelectionInput;
}

export interface UpsertPrintPublicationFromBrandPrintPublications4Input {
  create: CreatePrintPublicationFromBrandPrintPublications4DataInput;
  update: UpdatePrintPublicationFromBrandPrintPublications4DataInput;
  where: PrintPublicationFromBrandNodeSelectionInput;
}

export interface UpsertPrintPublicationFromPrintPublicationAssignments1Input {
  create: CreatePrintPublicationFromPrintPublicationAssignments1DataInput;
  update: UpdatePrintPublicationFromPrintPublicationAssignments1DataInput;
  where: PrintPublicationFromPrintPublicationNodeSelectionInput;
}

export interface UpsertPrintPublicationFromPrintPublicationAssignments2Input {
  create: CreatePrintPublicationFromPrintPublicationAssignments2DataInput;
  update: UpdatePrintPublicationFromPrintPublicationAssignments2DataInput;
  where: PrintPublicationFromPrintPublicationNodeSelectionInput;
}

export interface UpsertPrintPublicationFromPrintPublicationAssignments3Input {
  create: CreatePrintPublicationFromPrintPublicationAssignments3DataInput;
  update: UpdatePrintPublicationFromPrintPublicationAssignments3DataInput;
  where: PrintPublicationFromPrintPublicationNodeSelectionInput;
}

export interface UpsertPrintPublicationFromPrintPublicationPrintIssues4Input {
  create: CreatePrintPublicationFromPrintPublicationPrintIssues4DataInput;
  update: UpdatePrintPublicationFromPrintPublicationPrintIssues4DataInput;
  where: PrintPublicationFromPrintPublicationNodeSelectionInput;
}

export interface UpsertPrintTemplateFromPrintTemplateArticleTemplates1Input {
  create: CreatePrintTemplateFromPrintTemplateArticleTemplates1DataInput;
  update: UpdatePrintTemplateFromPrintTemplateArticleTemplates1DataInput;
  where: PrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertPrintTemplateFromPrintTemplateArticleTemplates4Input {
  create: CreatePrintTemplateFromPrintTemplateArticleTemplates4DataInput;
  update: UpdatePrintTemplateFromPrintTemplateArticleTemplates4DataInput;
  where: PrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertPrintTemplateFromPrintTemplateAssignments2Input {
  create: CreatePrintTemplateFromPrintTemplateAssignments2DataInput;
  update: UpdatePrintTemplateFromPrintTemplateAssignments2DataInput;
  where: PrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertPrintTemplateFromPrintTemplateFlatAssignment3Input {
  create: CreatePrintTemplateFromPrintTemplateFlatAssignment3DataInput;
  update: UpdatePrintTemplateFromPrintTemplateFlatAssignment3DataInput;
  where: PrintTemplateFromPrintTemplateNodeSelectionInput;
}

export interface UpsertRawArticleFromRawArticleAssignment1Input {
  create: CreateRawArticleFromRawArticleAssignment1DataInput;
  update: UpdateRawArticleFromRawArticleAssignment1DataInput;
  where: RawArticleFromRawArticleNodeSelectionInput;
}

export interface UpsertRawArticleFromRawArticleAssignment2Input {
  create: CreateRawArticleFromRawArticleAssignment2DataInput;
  update: UpdateRawArticleFromRawArticleAssignment2DataInput;
  where: RawArticleFromRawArticleNodeSelectionInput;
}

export interface UpsertRawArticleFromRawArticleAssignment3Input {
  create: CreateRawArticleFromRawArticleAssignment3DataInput;
  update: UpdateRawArticleFromRawArticleAssignment3DataInput;
  where: RawArticleFromRawArticleNodeSelectionInput;
}

export interface UpsertRawArticleFromRawArticleFlatAssignment4Input {
  create: CreateRawArticleFromRawArticleFlatAssignment4DataInput;
  update: UpdateRawArticleFromRawArticleFlatAssignment4DataInput;
  where: RawArticleFromRawArticleNodeSelectionInput;
}

export interface UpsertSubSubjectFromSubjectSubSubjects1Input {
  create: CreateSubSubjectFromSubjectSubSubjects1DataInput;
  update: UpdateSubSubjectFromSubjectSubSubjects1DataInput;
  where: SubSubjectFromSubjectNodeSelectionInput;
}

export interface UpsertSubSubjectFromSubjectSubSubjects2Input {
  create: CreateSubSubjectFromSubjectSubSubjects2DataInput;
  update: UpdateSubSubjectFromSubjectSubSubjects2DataInput;
  where: SubSubjectFromSubjectNodeSelectionInput;
}

export interface UpsertSubSubjectFromSubjectSubSubjects3Input {
  create: CreateSubSubjectFromSubjectSubSubjects3DataInput;
  update: UpdateSubSubjectFromSubjectSubSubjects3DataInput;
  where: SubSubjectFromSubjectNodeSelectionInput;
}

export interface UpsertSubSubjectFromSubjectSubSubjects4Input {
  create: CreateSubSubjectFromSubjectSubSubjects4DataInput;
  update: UpdateSubSubjectFromSubjectSubSubjects4DataInput;
  where: SubSubjectFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectCategoryFromSubjectCategoryChildren2Input {
  create: CreateSubjectCategoryFromSubjectCategoryChildren2DataInput;
  update: UpdateSubjectCategoryFromSubjectCategoryChildren2DataInput;
  where: SubjectCategoryFromParentNodeSelectionInput;
}

export interface UpsertSubjectCategoryFromSubjectCategoryChildren3Input {
  create: CreateSubjectCategoryFromSubjectCategoryChildren3DataInput;
  update: UpdateSubjectCategoryFromSubjectCategoryChildren3DataInput;
  where: SubjectCategoryFromParentNodeSelectionInput;
}

export interface UpsertSubjectCategoryFromSubjectCategoryChildren4Input {
  create: CreateSubjectCategoryFromSubjectCategoryChildren4DataInput;
  update: UpdateSubjectCategoryFromSubjectCategoryChildren4DataInput;
  where: SubjectCategoryFromParentNodeSelectionInput;
}

export interface UpsertSubjectCategoryFromSubjectCategorySubjects1Input {
  create: CreateSubjectCategoryFromSubjectCategorySubjects1DataInput;
  update: UpdateSubjectCategoryFromSubjectCategorySubjects1DataInput;
  where: SubjectCategoryFromSubjectCategoryNodeSelectionInput;
}

export interface UpsertSubjectCategoryFromSubjectCategorySubjects2Input {
  create: CreateSubjectCategoryFromSubjectCategorySubjects2DataInput;
  update: UpdateSubjectCategoryFromSubjectCategorySubjects2DataInput;
  where: SubjectCategoryFromSubjectCategoryNodeSelectionInput;
}

export interface UpsertSubjectCategoryFromSubjectCategorySubjects3Input {
  create: CreateSubjectCategoryFromSubjectCategorySubjects3DataInput;
  update: UpdateSubjectCategoryFromSubjectCategorySubjects3DataInput;
  where: SubjectCategoryFromSubjectCategoryNodeSelectionInput;
}

export interface UpsertSubjectCategoryFromSubjectCategorySubjects4Input {
  create: CreateSubjectCategoryFromSubjectCategorySubjects4DataInput;
  update: UpdateSubjectCategoryFromSubjectCategorySubjects4DataInput;
  where: SubjectCategoryFromSubjectCategoryNodeSelectionInput;
}

export interface UpsertSubjectCategoryFromUnitSubjectCategories2Input {
  create: CreateSubjectCategoryFromUnitSubjectCategories2DataInput;
  update: UpdateSubjectCategoryFromUnitSubjectCategories2DataInput;
  where: SubjectCategoryFromUnitNodeSelectionInput;
}

export interface UpsertSubjectCategoryFromUnitSubjectCategories3Input {
  create: CreateSubjectCategoryFromUnitSubjectCategories3DataInput;
  update: UpdateSubjectCategoryFromUnitSubjectCategories3DataInput;
  where: SubjectCategoryFromUnitNodeSelectionInput;
}

export interface UpsertSubjectCategoryFromUnitSubjectCategories4Input {
  create: CreateSubjectCategoryFromUnitSubjectCategories4DataInput;
  update: UpdateSubjectCategoryFromUnitSubjectCategories4DataInput;
  where: SubjectCategoryFromUnitNodeSelectionInput;
}

export interface UpsertSubjectFromSubjectAssignments1Input {
  create: CreateSubjectFromSubjectAssignments1DataInput;
  update: UpdateSubjectFromSubjectAssignments1DataInput;
  where: SubjectFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectFromSubjectAssignments2Input {
  create: CreateSubjectFromSubjectAssignments2DataInput;
  update: UpdateSubjectFromSubjectAssignments2DataInput;
  where: SubjectFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectFromSubjectAssignments3Input {
  create: CreateSubjectFromSubjectAssignments3DataInput;
  update: UpdateSubjectFromSubjectAssignments3DataInput;
  where: SubjectFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectFromSubjectCategorySubjects3Input {
  create: CreateSubjectFromSubjectCategorySubjects3DataInput;
  update: UpdateSubjectFromSubjectCategorySubjects3DataInput;
  where: SubjectFromSubjectCategoryNodeSelectionInput;
}

export interface UpsertSubjectFromSubjectCategorySubjects4Input {
  create: CreateSubjectFromSubjectCategorySubjects4DataInput;
  update: UpdateSubjectFromSubjectCategorySubjects4DataInput;
  where: SubjectFromSubjectCategoryNodeSelectionInput;
}

export interface UpsertSubjectFromSubjectFlatAssignment4Input {
  create: CreateSubjectFromSubjectFlatAssignment4DataInput;
  update: UpdateSubjectFromSubjectFlatAssignment4DataInput;
  where: SubjectFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectFromUnitSubjects2Input {
  create: CreateSubjectFromUnitSubjects2DataInput;
  update: UpdateSubjectFromUnitSubjects2DataInput;
  where: SubjectFromUnitNodeSelectionInput;
}

export interface UpsertSubjectSubjectTagFromSubjectSubjectTags1Input {
  create: CreateSubjectSubjectTagFromSubjectSubjectTags1DataInput;
  update: UpdateSubjectSubjectTagFromSubjectSubjectTags1DataInput;
  where: SubjectSubjectTagFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectSubjectTagFromSubjectSubjectTags2Input {
  create: CreateSubjectSubjectTagFromSubjectSubjectTags2DataInput;
  update: UpdateSubjectSubjectTagFromSubjectSubjectTags2DataInput;
  where: SubjectSubjectTagFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectSubjectTagFromSubjectSubjectTags3Input {
  create: CreateSubjectSubjectTagFromSubjectSubjectTags3DataInput;
  update: UpdateSubjectSubjectTagFromSubjectSubjectTags3DataInput;
  where: SubjectSubjectTagFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectSubjectTagFromSubjectSubjectTags4Input {
  create: CreateSubjectSubjectTagFromSubjectSubjectTags4DataInput;
  update: UpdateSubjectSubjectTagFromSubjectSubjectTags4DataInput;
  where: SubjectSubjectTagFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectTagFromSubjectTagSubjects2Input {
  create: CreateSubjectTagFromSubjectTagSubjects2DataInput;
  update: UpdateSubjectTagFromSubjectTagSubjects2DataInput;
  where: SubjectTagFromSubjectTagNodeSelectionInput;
}

export interface UpsertSubjectTagFromSubjectTagSubjects3Input {
  create: CreateSubjectTagFromSubjectTagSubjects3DataInput;
  update: UpdateSubjectTagFromSubjectTagSubjects3DataInput;
  where: SubjectTagFromSubjectTagNodeSelectionInput;
}

export interface UpsertSubjectTagFromSubjectTagSubjects4Input {
  create: CreateSubjectTagFromSubjectTagSubjects4DataInput;
  update: UpdateSubjectTagFromSubjectTagSubjects4DataInput;
  where: SubjectTagFromSubjectTagNodeSelectionInput;
}

export interface UpsertSubjectUserFromSubjectSubjectUsers1Input {
  create: CreateSubjectUserFromSubjectSubjectUsers1DataInput;
  update: boolean;
  where: SubjectUserFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectUserFromSubjectSubjectUsers2Input {
  create: CreateSubjectUserFromSubjectSubjectUsers2DataInput;
  update: boolean;
  where: SubjectUserFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectUserFromSubjectSubjectUsers3Input {
  create: CreateSubjectUserFromSubjectSubjectUsers3DataInput;
  update: boolean;
  where: SubjectUserFromSubjectNodeSelectionInput;
}

export interface UpsertSubjectUserFromSubjectSubjectUsers4Input {
  create: CreateSubjectUserFromSubjectSubjectUsers4DataInput;
  update: boolean;
  where: SubjectUserFromSubjectNodeSelectionInput;
}

export interface UpsertUnitFromUnitBrands1Input {
  create: CreateUnitFromUnitBrands1DataInput;
  update: UpdateUnitFromUnitBrands1DataInput;
  where: UnitFromUnitNodeSelectionInput;
}

export interface UpsertUnitFromUnitSubjects2Input {
  create: CreateUnitFromUnitSubjects2DataInput;
  update: UpdateUnitFromUnitSubjects2DataInput;
  where: UnitFromUnitNodeSelectionInput;
}

export interface UpsertUnitFromUnitSubjects3Input {
  create: CreateUnitFromUnitSubjects3DataInput;
  update: UpdateUnitFromUnitSubjects3DataInput;
  where: UnitFromUnitNodeSelectionInput;
}

export interface UpsertUnitFromUnitSubjects4Input {
  create: CreateUnitFromUnitSubjects4DataInput;
  update: UpdateUnitFromUnitSubjects4DataInput;
  where: UnitFromUnitNodeSelectionInput;
}

export interface UpsertWebsiteFromBrandWebsites2Input {
  create: CreateWebsiteFromBrandWebsites2DataInput;
  update: UpdateWebsiteFromBrandWebsites2DataInput;
  where: WebsiteFromBrandNodeSelectionInput;
}

export interface UpsertWebsiteFromBrandWebsites3Input {
  create: CreateWebsiteFromBrandWebsites3DataInput;
  update: UpdateWebsiteFromBrandWebsites3DataInput;
  where: WebsiteFromBrandNodeSelectionInput;
}

export interface UpsertWebsiteFromBrandWebsites4Input {
  create: CreateWebsiteFromBrandWebsites4DataInput;
  update: UpdateWebsiteFromBrandWebsites4DataInput;
  where: WebsiteFromBrandNodeSelectionInput;
}

export interface UpsertWebsiteFromWebsiteAssignments1Input {
  create: CreateWebsiteFromWebsiteAssignments1DataInput;
  update: UpdateWebsiteFromWebsiteAssignments1DataInput;
  where: WebsiteFromWebsiteNodeSelectionInput;
}

export interface UpsertWebsiteFromWebsiteAssignments2Input {
  create: CreateWebsiteFromWebsiteAssignments2DataInput;
  update: UpdateWebsiteFromWebsiteAssignments2DataInput;
  where: WebsiteFromWebsiteNodeSelectionInput;
}

export interface UpsertWebsiteFromWebsiteAssignments3Input {
  create: CreateWebsiteFromWebsiteAssignments3DataInput;
  update: UpdateWebsiteFromWebsiteAssignments3DataInput;
  where: WebsiteFromWebsiteNodeSelectionInput;
}

export interface UpsertWebsiteFromWebsiteFlatAssignment4Input {
  create: CreateWebsiteFromWebsiteFlatAssignment4DataInput;
  update: UpdateWebsiteFromWebsiteFlatAssignment4DataInput;
  where: WebsiteFromWebsiteNodeSelectionInput;
}

export interface WebsiteFromBrandNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  key_eq?: string | null;
  legacyId_eq?: number | null;
}

export interface WebsiteFromWebsiteNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  brand_eq?: Brand1NodeSelectionInput | null;
  key_eq?: string | null;
  legacyId_eq?: number | null;
}

export interface WebsiteNodeSelectionInput {
  _id_eq?: number | null;
  id_eq?: string | null;
  title_eq?: string | null;
  brand_eq?: Brand1NodeSelectionInput | null;
  key_eq?: string | null;
  legacyId_eq?: number | null;
}

export interface Websites1WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands2WhereInput | null;
  assignments_some?: Assignments2WhereInput | null;
  flatAssignment_some?: FlatAssignments2WhereInput | null;
  AND?: (Websites2WhereInput | null)[] | null;
  NOT?: Websites2WhereInput | null;
  OR?: (Websites2WhereInput | null)[] | null;
}

export interface Websites2WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands3WhereInput | null;
  assignments_some?: Assignments3WhereInput | null;
  flatAssignment_some?: FlatAssignments3WhereInput | null;
  AND?: (Websites3WhereInput | null)[] | null;
  NOT?: Websites3WhereInput | null;
  OR?: (Websites3WhereInput | null)[] | null;
}

export interface Websites3WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands4WhereInput | null;
  assignments_some?: Assignments4WhereInput | null;
  flatAssignment_some?: FlatAssignments4WhereInput | null;
  AND?: (Websites4WhereInput | null)[] | null;
  NOT?: Websites4WhereInput | null;
  OR?: (Websites4WhereInput | null)[] | null;
}

export interface Websites4WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands5WhereInput | null;
  assignments_some?: Assignments5WhereInput | null;
  flatAssignment_some?: FlatAssignments5WhereInput | null;
  AND?: (Websites5WhereInput | null)[] | null;
  NOT?: Websites5WhereInput | null;
  OR?: (Websites5WhereInput | null)[] | null;
}

export interface Websites5WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands6WhereInput | null;
  assignments_some?: Assignments6WhereInput | null;
  flatAssignment_some?: FlatAssignments6WhereInput | null;
  AND?: (Websites6WhereInput | null)[] | null;
  NOT?: Websites6WhereInput | null;
  OR?: (Websites6WhereInput | null)[] | null;
}

export interface Websites6WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands7WhereInput | null;
  assignments_some?: Assignments7WhereInput | null;
  flatAssignment_some?: FlatAssignments7WhereInput | null;
  AND?: (Websites7WhereInput | null)[] | null;
  NOT?: Websites7WhereInput | null;
  OR?: (Websites7WhereInput | null)[] | null;
}

export interface Websites7WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
  brand_eq?: Brands8WhereInput | null;
  assignments_some?: Assignments8WhereInput | null;
  flatAssignment_some?: FlatAssignments8WhereInput | null;
  AND?: (Websites8WhereInput | null)[] | null;
  NOT?: Websites8WhereInput | null;
  OR?: (Websites8WhereInput | null)[] | null;
}

export interface Websites8WhereInput {
  _id_eq?: number | null;
  _id_ne?: number | null;
  _id_in?: (number | null)[] | null;
  _id_nin?: (number | null)[] | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  id_eq?: string | null;
  id_ne?: string | null;
  id_in?: (string | null)[] | null;
  id_nin?: (string | null)[] | null;
  title_eq?: string | null;
  title_ne?: string | null;
  title_in?: (string | null)[] | null;
  title_nin?: (string | null)[] | null;
  title_contains?: string | null;
  key_eq?: string | null;
  key_ne?: string | null;
  key_in?: (string | null)[] | null;
  key_nin?: (string | null)[] | null;
  key_contains?: string | null;
  legacyId_eq?: number | null;
  legacyId_ne?: number | null;
  legacyId_in?: (number | null)[] | null;
  legacyId_nin?: (number | null)[] | null;
  legacyId_gt?: number | null;
  legacyId_gte?: number | null;
  legacyId_lt?: number | null;
  legacyId_lte?: number | null;
  legacyId_exists?: boolean | null;
  createdAt_eq?: GraphQL$DateTime | null;
  createdAt_ne?: GraphQL$DateTime | null;
  createdAt_in?: (GraphQL$DateTime | null)[] | null;
  createdAt_nin?: (GraphQL$DateTime | null)[] | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  updatedAt_eq?: GraphQL$DateTime | null;
  updatedAt_ne?: GraphQL$DateTime | null;
  updatedAt_in?: (GraphQL$DateTime | null)[] | null;
  updatedAt_nin?: (GraphQL$DateTime | null)[] | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  creatorId_eq?: string | null;
  creatorId_ne?: string | null;
  creatorId_in?: (string | null)[] | null;
  creatorId_nin?: (string | null)[] | null;
  lastOperatorId_eq?: string | null;
  lastOperatorId_ne?: string | null;
  lastOperatorId_in?: (string | null)[] | null;
  lastOperatorId_nin?: (string | null)[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
